webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(60);
	__webpack_require__(173);
	module.exports = __webpack_require__(194);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _router = __webpack_require__(2);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _header = __webpack_require__(55);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(59);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Vendor imports
	// import $ from './lib/jquery.init'; //jQuery is being included on footer_UI.isml
	
	// Custom imports
	window.BORN = window.BORN || {
		'$body': $(document.body)
	};
	
	__webpack_require__.p = window.Urls.staticPath + 'js/';
	
	(0, _router2.default)();
	(0, _header2.default)();
	(0, _footer2.default)();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		applyFns(_bornModules2.default);
		applyFns(_pages2.default);
	};
	
	var _bornModules = __webpack_require__(3);
	
	var _bornModules2 = _interopRequireDefault(_bornModules);
	
	var _pages = __webpack_require__(26);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This very simple function loops through lists of objects and runs their 'init' method if the 'default' or the *key* query matches an element on the page. 
	 * @param  {[Object]} obj 
	 */
	function applyFns(obj) {
		for (var key in obj) {
			var query = obj[key].default || key;
	
			if (document.querySelector(query)) {
				obj[key].init(query);
			}
		}
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _selectric = __webpack_require__(4);
	
	var _selectric2 = _interopRequireDefault(_selectric);
	
	var _select = __webpack_require__(6);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _onscreen = __webpack_require__(9);
	
	var _onscreen2 = _interopRequireDefault(_onscreen);
	
	var _born = __webpack_require__(10);
	
	var Utils = _interopRequireWildcard(_born);
	
	var _module = __webpack_require__(11);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _module3 = __webpack_require__(16);
	
	var _module4 = _interopRequireDefault(_module3);
	
	var _module5 = __webpack_require__(17);
	
	var _module6 = _interopRequireDefault(_module5);
	
	var _module7 = __webpack_require__(19);
	
	var _module8 = _interopRequireDefault(_module7);
	
	var _module9 = __webpack_require__(20);
	
	var _module10 = _interopRequireDefault(_module9);
	
	var _module11 = __webpack_require__(21);
	
	var _module12 = _interopRequireDefault(_module11);
	
	var _module13 = __webpack_require__(18);
	
	var _module14 = _interopRequireDefault(_module13);
	
	var _module15 = __webpack_require__(24);
	
	var _module16 = _interopRequireDefault(_module15);
	
	var _module17 = __webpack_require__(25);
	
	var _module18 = _interopRequireDefault(_module17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [Modules] Reusable methods shared across the site. Typically, methods defined here _should_ be used across several pages.
	 * As opposed to Utils, these methods are ran on document ready if its query is available.
	 */
	
	var Modules = {
		carousel: {
			default: '[data-slick]',
			init: function init(query) {
				var carousel = new _module2.default(query || this.default);return carousel;
			}
		},
	
		gridViewType: {
			default: '[data-view-props]',
			init: function init(query) {
				var views = new _module4.default(query || this.default);
			}
		},
	
		video: {
			default: '[data-video]',
			init: function init(query) {
				var videos = new _module6.default(query || this.default);
			}
		},
	
		trackingLayer: {
			default: '[data-tracking], video',
			init: function init(query) {
				var trackedElements = new _module14.default(query || this.default);
			}
		},
	
		/**
	  * Series of methods to handle hidden content on the page
	  * Basic usage is:
	  * <span class="content-trigger" data-toggle-target=".target-content">Click me!</span>, where:
	  * data-parent : (optional) selector to the trigger's parent. Defaults to parentNode.
	  * data-toggle-target : selector to the trigger's content.
	  */
		toggle: {
			default: '[data-toggle-target]',
			init: function init(query) {
				var toggles = new _module16.default(query || this.default);
			}
		},
	
		overlayToggle: {
			default: '[data-toggle-overlay]',
			init: function init(query) {
				var toggles = new _module8.default(query || this.default);
			}
		},
	
		/**
	  * [Simple modal toggle using born.modals]
	  */
		modalToggle: {
			default: '[data-modal]',
			init: function init(query) {
				var selector = query || this.default,
				    toggles = document.querySelectorAll(selector + ':not([data-initialized])');
	
				[].forEach.call(toggles, this.setToggles.bind(this));
			},
	
			setToggles: function setToggles(toggle) {
				var randId = Math.floor(new Date().getTime() * Math.random());
	
				toggle.modalToggle = {};
				toggle.modalToggle.options = this.getSettings(toggle);
	
				toggle.modalToggle.options.modalID = toggle.modalToggle.options.modalID || randId;
	
				if (toggle.modalToggle.options.auto) {
					this.openModal.call(toggle);
				} else {
					toggle.addEventListener('click', this.openModal);
				}
	
				toggle.setAttribute('data-initialized', true);
			},
	
			getSettings: function getSettings(toggle) {
				var options = toggle.getAttribute('data-modal');
	
				return options ? JSON.parse(options) : {};
			},
	
			openModal: function openModal() {
				var ToggledModal = new _module10.default({
					modalID: this.modalToggle.options.modalID,
					overlayClass: this.modalToggle.options.overlayClass || 'generic-overlay',
					modalClass: this.modalToggle.options.modalClass || 'modal--fluid',
					modalContent: document.querySelector(this.modalToggle.options.content) || ''
				});
			}
		},
	
		/**
	  * Handles up/down quantity value.
	  * Useful to make up for certain browsers that
	  * don't have a built-in spinner for this.
	  * Also fires custom events for easy action hooks (like add/update/delete from cart, for example).
	  */
		qtyControl: {
			default: '[data-qty-control]',
			init: function init(query) {
				var self = this,
				    selector = query || this.default,
				    controls = document.querySelectorAll(selector + ':not([data-initialized])');
	
				[].forEach.call(controls, function (control) {
					self.setupControls.call(self, control);
				});
			},
	
			setupControls: function setupControls(control) {
	
				var scope = this,
				    $qtyControl = $(control),
				    $inputBox = $qtyControl.find('.value'),
				    $ctrlBtns = $qtyControl.find('.plus, .minus'),
				    downInterval,
				    downTimeout,
				    clickEvtDown = window.outerWidth < Utils.breakpoints.mobile ? 'touchstart' : 'mousedown',
				    clickEvtUp = window.outerWidth < Utils.breakpoints.mobile ? 'touchend' : 'mouseup',
				    debouncedChange = _lodash2.default.debounce(this.triggerChange, 400);
				// prevValue = parseInt($inputBox.val());
	
				$qtyControl.attr('data-initialized', true);
	
				$inputBox.on('keydown', function (evt) {
					var keys = Utils.allowedNumInput(evt);
	
					if (keys.upDown) {
						evt.preventDefault();
						scope.updateQty($(this), evt, debouncedChange);
					}
	
					if (!keys.allowed) {
						evt.preventDefault();
						return false;
					}
				});
	
				// $inputBox.on('input', function(evt){
				//     var $currInput = $(this);
	
				//     if(parseInt($currInput.val()) > parseInt($currInput.attr('max'))){
				//         $currInput.val(prevValue);
				//     }
	
				//     prevValue = parseInt($currInput.val());
				// });
	
				$ctrlBtns.on(clickEvtDown, function (evt) {
					scope.updateQty($inputBox, evt, debouncedChange);
	
					//Increase qty continously until user releases click/tap
					downTimeout = setTimeout(function () {
						downInterval = setInterval(function () {
							scope.updateQty($inputBox, evt, debouncedChange);
						}, 100);
					}, 275);
				});
	
				$ctrlBtns.on(clickEvtUp + ' mouseleave', function () {
					clearTimeout(downTimeout);
					clearInterval(downInterval);
				});
	
				$inputBox.on('input', debouncedChange);
			},
	
			triggerChange: function triggerChange() {
				$(this).trigger('change');
			},
	
			updateQty: function updateQty($input, evt, updateCallback) {
				if ($input.prop('readonly')) {
					return false;
				}
	
				var parsedVal = parseInt($input.val()),
				    currVal = parsedVal === 0 || parsedVal ? parsedVal : 0,
				    newVal = currVal,
				    minVal = parseInt($input.attr('min')) || 0;
	
				if ($(evt.target).hasClass('plus') || evt.keyCode == 38) {
					newVal = currVal + 1;
				} else if (currVal > minVal) {
					newVal = currVal - 1;
				}
	
				if (newVal !== currVal) {
					$input.val(newVal);
					$input.trigger('input');
					updateCallback.call($input);
				}
				var quickViewDetObj = $('.pdp__actions--extra__button a');
				if (quickViewDetObj.length == 1) {
					this.appendQuantity(quickViewDetObj, newVal);
				}
			},
			appendQuantity: function appendQuantity(obj, qtyValue) {
				var qtyKey = 'Quantity';
				var uri = obj.attr('href');
				var qtyReg = new RegExp("([?|&])" + qtyKey + "=.*?(&|$)", "i");
				var separator = uri.indexOf('?') !== -1 ? "&" : "?";
				if (uri.match(qtyReg)) {
					uri = uri.replace(qtyReg, '$1' + qtyKey + "=" + qtyValue + '$2');
				} else {
					uri = uri + separator + qtyKey + "=" + qtyValue;
				}
				obj.attr('href', uri);
			}
		},
	
		/**
	  * Handles quantity selector events
	  */
		qtySelect: {
			default: '[data-qty-select]',
			init: function init(query) {
				var self = this,
				    selector = query || this.default,
				    controls = $(selector + ':not([data-initialized])');
	
				[].forEach.call(controls, function (control) {
					self.setupControls.call(self, control);
				});
			},
			setupControls: function setupControls(control) {
				var self = this,
				    $qtyControl = $(control);
	
				$qtyControl.attr('data-initialized', true);
	
				$qtyControl.on('change', function () {});
			}
		},
	
		/**
	  * Prevents outer scrolling when scrolling on a overflowed container
	  */
		cancelScroll: {
			default: '[data-cancel-scroll]',
			init: function init(query) {
				//We don't need this on mobile
				if (window.innerWidth <= Utils.breakpoints.mobile) {
					return;
				}
	
				var scope = this,
				    selector = query || this.default,
				    $scrollables = $(selector + ':not([data-initialized])');
	
				$scrollables.attr('data-initialized', true);
	
				$scrollables.on('DOMMouseScroll mousewheel', function (evt) {
					scope.scrollEvent.call(scope, evt, this);
				});
			},
	
			scrollEvent: function scrollEvent(evt, scrolledElement) {
				var $scrolledElement = $(scrolledElement),
				    scrollTop = scrolledElement.scrollTop,
				    scrollHeight = scrolledElement.scrollHeight,
				    height = $scrolledElement.innerHeight(),
				    delta = evt.originalEvent.wheelDelta,
				    goingUp = delta > 0;
	
				if (!goingUp && -delta > scrollHeight - height - scrollTop) {
					$scrolledElement.scrollTop(scrollHeight);
	
					return this.preventOuterScroll(evt);
				} else if (goingUp && delta > scrollTop) {
					$scrolledElement.scrollTop(0);
	
					return this.preventOuterScroll(evt);
				}
			},
	
			preventOuterScroll: function preventOuterScroll(evt) {
				evt.stopPropagation();
				evt.preventDefault();
				evt.returnValue = false;
	
				return false;
			}
		},
	
		jumpTo: {
			default: '[data-jumpto]',
			init: function init(query) {
				$(query || this.default).on('click', function (e) {
					e.preventDefault();
					Utils.jumpTo.call(this, this.getAttribute('data-jumpto'));
				});
			}
		},
	
		/**
	  * Simple method to allow anchor elements to navigate back/forward in history.
	  * data-history: [default: "back"] -> "back" or "forward"
	  */
		history: {
			default: '[data-history]',
			init: function init(query) {
				var navItems = document.querySelectorAll(query + ':not([data-initialized])');
	
				[].forEach.call(navItems, this.setHandler.bind(this));
			},
	
			setHandler: function setHandler(item) {
				item.addEventListener('click', this.navigate);
			},
	
			navigate: function navigate(e) {
				var direction = this.getAttribute('data-history');
	
				e.preventDefault();
	
				if (direction === 'forward') {
					window.history.forward();
				} else {
					window.history.back();
				}
			}
		},
	
		/**
	  * Very basic lazy loading logic
	  * called data-born-lazy to avoid conflicts
	  */
		bornLazy: {
			default: '[data-born-lazy]',
			init: function init(query) {
				var selector = query || this.default,
				    OS = new _onscreen2.default({ tolerance: -900, debounce: 0 });
	
				OS.on('enter', selector, this.lazyRender);
			},
			lazyRender: function lazyRender(el) {
				if (el.classList.contains('born-lazy-loaded')) {
					return;
				}
	
				var imgSrc = el.getAttribute('data-born-lazy');
	
				if (el.nodeName === 'IMG') {
					el.src = imgSrc;
				} else {
					el.style.backgroundImage = 'url("' + imgSrc + '")';
				}
	
				$(el).imagesLoaded({ background: true }, function () {
					el.removeAttribute('data-born-lazy');
					el.classList.add('born-lazy-loaded');
				});
			}
		},
	
		selectTags: {
			default: 'select',
			init: function init(query) {
				var scope = this,
				    selector = query || this.default,
				    selectEls = document.querySelectorAll(selector + ':not([data-initialized])');
	
				if (selectEls.length) {
					//Loops cause we need to check individual items for special class
					[].forEach.call(selectEls, function (selectEl) {
						var $selectEl = $(selectEl);
						if ($selectEl.hasClass('select2-option')) {
							$selectEl.select2({
								sorter: function sorter(data) {
									var defOption = false;
									if (data.length > 0) {
										defOption = data.splice(data.findIndex(function (e) {
											return e.id === "";
										}), 1);
										if (defOption && defOption.length > 0) {
											defOption = defOption[0];
										} else {
											defOption = false;
										}
									}
									var optionData = data.sort(function (a, b) {
										return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
									});
									if (defOption) {
										optionData.unshift(defOption);
									}
									return optionData;
								}
							});
							$selectEl.on('select2:open', function () {
								var $searchField = $('.select2-container.select2-container--open').find('.select2-search__field');
								$searchField.attr('placeholder', Resources.SELECT2_SEARCH + '...');
							});
						} else {
							selectEl.selOptions = selectEl.hasAttribute('data-select-options') ? JSON.parse(selectEl.getAttribute('data-select-options')) : false;
	
							$selectEl.on('change', scope.refreshSelectric);
	
							$selectEl.selectric({
								customClass: {
									prefix: (selectEl.selOptions && selectEl.selOptions.elClass ? selectEl.selOptions.elClass + ' ' : '') + 'selectric'
								},
								responsive: true,
								disableOnMobile: false,
								arrowButtonMarkup: '<span class="selectric__arrow icon--angle-down"></span>',
								onBeforeOpen: function onBeforeOpen() {
									$(window).on('scroll.closeSelectric', scope.closeOnScroll.bind(this));
								},
								onBeforeClose: function onBeforeClose() {
									$(window).off('.closeSelectric');
								},
								//Selectric is stupid.
								onChange: function onChange() {
									$selectEl.trigger('change');
									$selectEl.trigger('blur');
								},
								optionsItemBuilder: scope.renderItem.bind(selectEl),
								labelBuilder: scope.renderItem.bind(selectEl)
							});
						}
					});
				}
			},
	
			renderItem: function renderItem(itemData) {
				var output = itemData.text;
	
				if (this.selOptions) {
					var customClass = this.selOptions.itemClass ? this.selOptions.itemClass : 'select--decoration',
					    mappedAttr = this.selOptions.optionAttrMap ? this.selOptions.optionAttrMap : '';
	
					output = '<span class="' + customClass + ' ' + itemData.element[0].getAttribute(mappedAttr).toLowerCase() + '"></span>' + output;
				}
	
				return output;
			},
	
			//Mainly used to refresh selectric displayed element when autocomplete is fired/original element is changed without being trigger.
			refreshSelectric: function refreshSelectric() {
				$(this).selectric('refresh');
			},
	
			//Closes the selectric dropdown if user scrolls
			closeOnScroll: function closeOnScroll() {
				$(this).selectric('close');
			}
		},
	
		/**
	  * Scrolls window to first error field coming from BE.
	  */
		formrowError: {
			default: '.form-row.error',
			init: function init(query) {
				window.scrollTo(0, $(query || this.default).offset().top - 20);
			}
		},
	
		/**
	  * Validation for international phone input fields.
	  */
		telInputs: {
			default: 'input.phone',
			init: function init(query) {
				var telInputs = new _module12.default(query || this.default);
			}
		},
	
		//Opens target URL on a new popup window (if it can).
		openWindow: {
			default: '[data-openwindow]',
			init: function init(query) {
				var links = document.querySelectorAll(query || this.default);
	
				[].forEach.call(links, this.setHandler);
			},
	
			setHandler: function setHandler(link) {
				if (link.href) {
					link.addEventListener('click', function (evt) {
						evt.preventDefault();
						window.open(this.href, '_blank', "menubar=yes,location=0,width=768,height=600,resizable=yes,scrollbars=yes,status=yes");
					});
				}
			}
		},
		showMoreSwatches: {
			init: function init(query) {
				var _this = this;
	
				var showMoreQuery = query !== undefined ? query : '.swatch-variation-wrap';
				var showMoreLinkEl = $(showMoreQuery).find('.show-more-link');
				var swatchItem = $(showMoreQuery).find('.swatch-variation');
				var selectedSwatchItem = $(showMoreQuery).find('.swatches__item.selected');
				var swatchesItems = $(showMoreQuery).find('.swatches__item');
				var contentWidth = swatchesItems.width() + parseFloat(swatchesItems.css('margin-right'));
				var containerWidth = swatchItem.width();
				var noOfItemsVisible = parseInt(containerWidth / contentWidth) * 2;
				var masterId = $('#pdpMain').data('pid');
				this.toggleShowMoreLink(showMoreLinkEl, noOfItemsVisible, swatchesItems.length);
				$(window).on('resize', function () {
					containerWidth = swatchItem.width();
					noOfItemsVisible = parseInt(containerWidth / contentWidth) * 2;
					_this.toggleShowMoreLink(showMoreLinkEl, noOfItemsVisible, swatchesItems.length);
				});
				$(window).on('unload', function () {
					sessionStorage.removeItem('show-more-expand');
				});
				if (selectedSwatchItem.length > 0) {
					var sessionData;
					try {
						sessionData = JSON.parse(sessionStorage['show-more-expand']);
					} catch (err) {
						sessionData = null;
					}
					if (sessionData && sessionData.pid == masterId && sessionData.open) {
						this.toggleSwatches.call(showMoreLinkEl);
					} else {
						sessionStorage['show-more-expand'] = JSON.stringify({ pid: masterId, open: false });
					}
				}
				if (showMoreLinkEl.length > 0) {
					showMoreLinkEl.off('click').on('click', this.toggleSwatches.bind(showMoreLinkEl));
				}
			},
			toggleSwatches: function toggleSwatches(el) {
				var showMoreLinkEl = $(this);
				var swatchItem = showMoreLinkEl.closest('.swatch-variation-wrap').find('.swatch-variation');
				var masterId = $('#pdpMain').data('pid');
				if (swatchItem.length > 0) {
					if (swatchItem.hasClass('color-height')) {
						swatchItem.removeClass('color-height');
						showMoreLinkEl.html(Resources.QUICK_VIEW_LESS_VIEW).addClass('toggle--active');
						sessionStorage['show-more-expand'] = JSON.stringify({ pid: masterId, open: true });
					} else {
						swatchItem.addClass('color-height');
						showMoreLinkEl.html(Resources.QUICK_VIEW_MORE_VIEW).removeClass('toggle--active');
						sessionStorage['show-more-expand'] = JSON.stringify({ pid: masterId, open: false });
					}
				}
			},
			toggleShowMoreLink: function toggleShowMoreLink(showMoreLinkEl, noOfItemsVisible, totalSwatches) {
				if (noOfItemsVisible >= totalSwatches) {
					showMoreLinkEl.addClass('hidden');
				} else {
					showMoreLinkEl.removeClass('hidden');
				}
			}
		},
		productRating: {
			default: '[data-rating]',
			init: function init(query) {
				var productRating = new _module18.default(query || this.default);return productRating;
			}
		}
	};
	
	// Modules
	exports.default = Modules;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!
	 * Select2 4.0.13
	 * https://select2.github.io
	 *
	 * Released under the MIT license
	 * https://github.com/select2/select2/blob/master/LICENSE.md
	 */
	;(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node/CommonJS
	    module.exports = function (root, jQuery) {
	      if (jQuery === undefined) {
	        // require('jQuery') returns a factory that requires window to
	        // build a jQuery instance, we normalize how we use modules
	        // that require this pattern but the window provided is a noop
	        // if it's defined (how jquery works)
	        if (typeof window !== 'undefined') {
	          jQuery = require('jquery');
	        }
	        else {
	          jQuery = require('jquery')(root);
	        }
	      }
	      factory(jQuery);
	      return jQuery;
	    };
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	} (function (jQuery) {
	  // This is needed so we can catch the AMD loader configuration and use it
	  // The inner file should be wrapped (by `banner.start.js`) in a function that
	  // returns the AMD loader references.
	  var S2 =(function () {
	  // Restore the Select2 AMD loader so it can be used
	  // Needed mostly in the language files, where the loader is not inserted
	  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
	    var S2 = jQuery.fn.select2.amd;
	  }
	var S2;(function () { if (!S2 || !S2.requirejs) {
	if (!S2) { S2 = {}; } else { require = S2; }
	/**
	 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
	 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
	 */
	//Going sloppy to avoid 'use strict' string cost, but strict practices should
	//be followed.
	/*global setTimeout: false */
	
	var requirejs, require, define;
	(function (undef) {
	    var main, req, makeMap, handlers,
	        defined = {},
	        waiting = {},
	        config = {},
	        defining = {},
	        hasOwn = Object.prototype.hasOwnProperty,
	        aps = [].slice,
	        jsSuffixRegExp = /\.js$/;
	
	    function hasProp(obj, prop) {
	        return hasOwn.call(obj, prop);
	    }
	
	    /**
	     * Given a relative module name, like ./something, normalize it to
	     * a real name that can be mapped to a path.
	     * @param {String} name the relative name
	     * @param {String} baseName a real name that the name arg is relative
	     * to.
	     * @returns {String} normalized name
	     */
	    function normalize(name, baseName) {
	        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
	            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
	            baseParts = baseName && baseName.split("/"),
	            map = config.map,
	            starMap = (map && map['*']) || {};
	
	        //Adjust any relative paths.
	        if (name) {
	            name = name.split('/');
	            lastIndex = name.length - 1;
	
	            // If wanting node ID compatibility, strip .js from end
	            // of IDs. Have to do this here, and not in nameToUrl
	            // because node allows either .js or non .js to map
	            // to same file.
	            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
	                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
	            }
	
	            // Starts with a '.' so need the baseName
	            if (name[0].charAt(0) === '.' && baseParts) {
	                //Convert baseName to array, and lop off the last part,
	                //so that . matches that 'directory' and not name of the baseName's
	                //module. For instance, baseName of 'one/two/three', maps to
	                //'one/two/three.js', but we want the directory, 'one/two' for
	                //this normalization.
	                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
	                name = normalizedBaseParts.concat(name);
	            }
	
	            //start trimDots
	            for (i = 0; i < name.length; i++) {
	                part = name[i];
	                if (part === '.') {
	                    name.splice(i, 1);
	                    i -= 1;
	                } else if (part === '..') {
	                    // If at the start, or previous value is still ..,
	                    // keep them so that when converted to a path it may
	                    // still work when converted to a path, even though
	                    // as an ID it is less than ideal. In larger point
	                    // releases, may be better to just kick out an error.
	                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
	                        continue;
	                    } else if (i > 0) {
	                        name.splice(i - 1, 2);
	                        i -= 2;
	                    }
	                }
	            }
	            //end trimDots
	
	            name = name.join('/');
	        }
	
	        //Apply map config if available.
	        if ((baseParts || starMap) && map) {
	            nameParts = name.split('/');
	
	            for (i = nameParts.length; i > 0; i -= 1) {
	                nameSegment = nameParts.slice(0, i).join("/");
	
	                if (baseParts) {
	                    //Find the longest baseName segment match in the config.
	                    //So, do joins on the biggest to smallest lengths of baseParts.
	                    for (j = baseParts.length; j > 0; j -= 1) {
	                        mapValue = map[baseParts.slice(0, j).join('/')];
	
	                        //baseName segment has  config, find if it has one for
	                        //this name.
	                        if (mapValue) {
	                            mapValue = mapValue[nameSegment];
	                            if (mapValue) {
	                                //Match, update name to the new value.
	                                foundMap = mapValue;
	                                foundI = i;
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (foundMap) {
	                    break;
	                }
	
	                //Check for a star map match, but just hold on to it,
	                //if there is a shorter segment match later in a matching
	                //config, then favor over this star map.
	                if (!foundStarMap && starMap && starMap[nameSegment]) {
	                    foundStarMap = starMap[nameSegment];
	                    starI = i;
	                }
	            }
	
	            if (!foundMap && foundStarMap) {
	                foundMap = foundStarMap;
	                foundI = starI;
	            }
	
	            if (foundMap) {
	                nameParts.splice(0, foundI, foundMap);
	                name = nameParts.join('/');
	            }
	        }
	
	        return name;
	    }
	
	    function makeRequire(relName, forceSync) {
	        return function () {
	            //A version of a require function that passes a moduleName
	            //value for items that may need to
	            //look up paths relative to the moduleName
	            var args = aps.call(arguments, 0);
	
	            //If first arg is not require('string'), and there is only
	            //one arg, it is the array form without a callback. Insert
	            //a null so that the following concat is correct.
	            if (typeof args[0] !== 'string' && args.length === 1) {
	                args.push(null);
	            }
	            return req.apply(undef, args.concat([relName, forceSync]));
	        };
	    }
	
	    function makeNormalize(relName) {
	        return function (name) {
	            return normalize(name, relName);
	        };
	    }
	
	    function makeLoad(depName) {
	        return function (value) {
	            defined[depName] = value;
	        };
	    }
	
	    function callDep(name) {
	        if (hasProp(waiting, name)) {
	            var args = waiting[name];
	            delete waiting[name];
	            defining[name] = true;
	            main.apply(undef, args);
	        }
	
	        if (!hasProp(defined, name) && !hasProp(defining, name)) {
	            throw new Error('No ' + name);
	        }
	        return defined[name];
	    }
	
	    //Turns a plugin!resource to [plugin, resource]
	    //with the plugin being undefined if the name
	    //did not have a plugin prefix.
	    function splitPrefix(name) {
	        var prefix,
	            index = name ? name.indexOf('!') : -1;
	        if (index > -1) {
	            prefix = name.substring(0, index);
	            name = name.substring(index + 1, name.length);
	        }
	        return [prefix, name];
	    }
	
	    //Creates a parts array for a relName where first part is plugin ID,
	    //second part is resource ID. Assumes relName has already been normalized.
	    function makeRelParts(relName) {
	        return relName ? splitPrefix(relName) : [];
	    }
	
	    /**
	     * Makes a name map, normalizing the name, and using a plugin
	     * for normalization if necessary. Grabs a ref to plugin
	     * too, as an optimization.
	     */
	    makeMap = function (name, relParts) {
	        var plugin,
	            parts = splitPrefix(name),
	            prefix = parts[0],
	            relResourceName = relParts[1];
	
	        name = parts[1];
	
	        if (prefix) {
	            prefix = normalize(prefix, relResourceName);
	            plugin = callDep(prefix);
	        }
	
	        //Normalize according
	        if (prefix) {
	            if (plugin && plugin.normalize) {
	                name = plugin.normalize(name, makeNormalize(relResourceName));
	            } else {
	                name = normalize(name, relResourceName);
	            }
	        } else {
	            name = normalize(name, relResourceName);
	            parts = splitPrefix(name);
	            prefix = parts[0];
	            name = parts[1];
	            if (prefix) {
	                plugin = callDep(prefix);
	            }
	        }
	
	        //Using ridiculous property names for space reasons
	        return {
	            f: prefix ? prefix + '!' + name : name, //fullName
	            n: name,
	            pr: prefix,
	            p: plugin
	        };
	    };
	
	    function makeConfig(name) {
	        return function () {
	            return (config && config.config && config.config[name]) || {};
	        };
	    }
	
	    handlers = {
	        require: function (name) {
	            return makeRequire(name);
	        },
	        exports: function (name) {
	            var e = defined[name];
	            if (typeof e !== 'undefined') {
	                return e;
	            } else {
	                return (defined[name] = {});
	            }
	        },
	        module: function (name) {
	            return {
	                id: name,
	                uri: '',
	                exports: defined[name],
	                config: makeConfig(name)
	            };
	        }
	    };
	
	    main = function (name, deps, callback, relName) {
	        var cjsModule, depName, ret, map, i, relParts,
	            args = [],
	            callbackType = typeof callback,
	            usingExports;
	
	        //Use name if no relName
	        relName = relName || name;
	        relParts = makeRelParts(relName);
	
	        //Call the callback to define the module, if necessary.
	        if (callbackType === 'undefined' || callbackType === 'function') {
	            //Pull out the defined dependencies and pass the ordered
	            //values to the callback.
	            //Default to [require, exports, module] if no deps
	            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
	            for (i = 0; i < deps.length; i += 1) {
	                map = makeMap(deps[i], relParts);
	                depName = map.f;
	
	                //Fast path CommonJS standard dependencies.
	                if (depName === "require") {
	                    args[i] = handlers.require(name);
	                } else if (depName === "exports") {
	                    //CommonJS module spec 1.1
	                    args[i] = handlers.exports(name);
	                    usingExports = true;
	                } else if (depName === "module") {
	                    //CommonJS module spec 1.1
	                    cjsModule = args[i] = handlers.module(name);
	                } else if (hasProp(defined, depName) ||
	                           hasProp(waiting, depName) ||
	                           hasProp(defining, depName)) {
	                    args[i] = callDep(depName);
	                } else if (map.p) {
	                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
	                    args[i] = defined[depName];
	                } else {
	                    throw new Error(name + ' missing ' + depName);
	                }
	            }
	
	            ret = callback ? callback.apply(defined[name], args) : undefined;
	
	            if (name) {
	                //If setting exports via "module" is in play,
	                //favor that over return value and exports. After that,
	                //favor a non-undefined return value over exports use.
	                if (cjsModule && cjsModule.exports !== undef &&
	                        cjsModule.exports !== defined[name]) {
	                    defined[name] = cjsModule.exports;
	                } else if (ret !== undef || !usingExports) {
	                    //Use the return value from the function.
	                    defined[name] = ret;
	                }
	            }
	        } else if (name) {
	            //May just be an object definition for the module. Only
	            //worry about defining if have a module name.
	            defined[name] = callback;
	        }
	    };
	
	    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
	        if (typeof deps === "string") {
	            if (handlers[deps]) {
	                //callback in this case is really relName
	                return handlers[deps](callback);
	            }
	            //Just return the module wanted. In this scenario, the
	            //deps arg is the module name, and second arg (if passed)
	            //is just the relName.
	            //Normalize module name, if it contains . or ..
	            return callDep(makeMap(deps, makeRelParts(callback)).f);
	        } else if (!deps.splice) {
	            //deps is a config object, not an array.
	            config = deps;
	            if (config.deps) {
	                req(config.deps, config.callback);
	            }
	            if (!callback) {
	                return;
	            }
	
	            if (callback.splice) {
	                //callback is an array, which means it is a dependency list.
	                //Adjust args if there are dependencies
	                deps = callback;
	                callback = relName;
	                relName = null;
	            } else {
	                deps = undef;
	            }
	        }
	
	        //Support require(['a'])
	        callback = callback || function () {};
	
	        //If relName is a function, it is an errback handler,
	        //so remove it.
	        if (typeof relName === 'function') {
	            relName = forceSync;
	            forceSync = alt;
	        }
	
	        //Simulate async callback;
	        if (forceSync) {
	            main(undef, deps, callback, relName);
	        } else {
	            //Using a non-zero value because of concern for what old browsers
	            //do, and latest browsers "upgrade" to 4 if lower value is used:
	            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
	            //If want a value immediately, use require('id') instead -- something
	            //that works in almond on the global level, but not guaranteed and
	            //unlikely to work in other AMD implementations.
	            setTimeout(function () {
	                main(undef, deps, callback, relName);
	            }, 4);
	        }
	
	        return req;
	    };
	
	    /**
	     * Just drops the config on the floor, but returns req in case
	     * the config return value is used.
	     */
	    req.config = function (cfg) {
	        return req(cfg);
	    };
	
	    /**
	     * Expose module registry for debugging and tooling
	     */
	    requirejs._defined = defined;
	
	    define = function (name, deps, callback) {
	        if (typeof name !== 'string') {
	            throw new Error('See almond README: incorrect module build, no module name');
	        }
	
	        //This module may not have dependencies
	        if (!deps.splice) {
	            //deps is not an array, so probably means
	            //an object literal or factory function for
	            //the value. Adjust args.
	            callback = deps;
	            deps = [];
	        }
	
	        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
	            waiting[name] = [name, deps, callback];
	        }
	    };
	
	    define.amd = {
	        jQuery: true
	    };
	}());
	
	S2.requirejs = requirejs;S2.require = require;S2.define = define;
	}
	}());
	S2.define("almond", function(){});
	
	/* global jQuery:false, $:false */
	S2.define('jquery',[],function () {
	  var _$ = jQuery || $;
	
	  if (_$ == null && console && console.error) {
	    console.error(
	      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
	      'found. Make sure that you are including jQuery before Select2 on your ' +
	      'web page.'
	    );
	  }
	
	  return _$;
	});
	
	S2.define('select2/utils',[
	  'jquery'
	], function ($) {
	  var Utils = {};
	
	  Utils.Extend = function (ChildClass, SuperClass) {
	    var __hasProp = {}.hasOwnProperty;
	
	    function BaseConstructor () {
	      this.constructor = ChildClass;
	    }
	
	    for (var key in SuperClass) {
	      if (__hasProp.call(SuperClass, key)) {
	        ChildClass[key] = SuperClass[key];
	      }
	    }
	
	    BaseConstructor.prototype = SuperClass.prototype;
	    ChildClass.prototype = new BaseConstructor();
	    ChildClass.__super__ = SuperClass.prototype;
	
	    return ChildClass;
	  };
	
	  function getMethods (theClass) {
	    var proto = theClass.prototype;
	
	    var methods = [];
	
	    for (var methodName in proto) {
	      var m = proto[methodName];
	
	      if (typeof m !== 'function') {
	        continue;
	      }
	
	      if (methodName === 'constructor') {
	        continue;
	      }
	
	      methods.push(methodName);
	    }
	
	    return methods;
	  }
	
	  Utils.Decorate = function (SuperClass, DecoratorClass) {
	    var decoratedMethods = getMethods(DecoratorClass);
	    var superMethods = getMethods(SuperClass);
	
	    function DecoratedClass () {
	      var unshift = Array.prototype.unshift;
	
	      var argCount = DecoratorClass.prototype.constructor.length;
	
	      var calledConstructor = SuperClass.prototype.constructor;
	
	      if (argCount > 0) {
	        unshift.call(arguments, SuperClass.prototype.constructor);
	
	        calledConstructor = DecoratorClass.prototype.constructor;
	      }
	
	      calledConstructor.apply(this, arguments);
	    }
	
	    DecoratorClass.displayName = SuperClass.displayName;
	
	    function ctr () {
	      this.constructor = DecoratedClass;
	    }
	
	    DecoratedClass.prototype = new ctr();
	
	    for (var m = 0; m < superMethods.length; m++) {
	      var superMethod = superMethods[m];
	
	      DecoratedClass.prototype[superMethod] =
	        SuperClass.prototype[superMethod];
	    }
	
	    var calledMethod = function (methodName) {
	      // Stub out the original method if it's not decorating an actual method
	      var originalMethod = function () {};
	
	      if (methodName in DecoratedClass.prototype) {
	        originalMethod = DecoratedClass.prototype[methodName];
	      }
	
	      var decoratedMethod = DecoratorClass.prototype[methodName];
	
	      return function () {
	        var unshift = Array.prototype.unshift;
	
	        unshift.call(arguments, originalMethod);
	
	        return decoratedMethod.apply(this, arguments);
	      };
	    };
	
	    for (var d = 0; d < decoratedMethods.length; d++) {
	      var decoratedMethod = decoratedMethods[d];
	
	      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
	    }
	
	    return DecoratedClass;
	  };
	
	  var Observable = function () {
	    this.listeners = {};
	  };
	
	  Observable.prototype.on = function (event, callback) {
	    this.listeners = this.listeners || {};
	
	    if (event in this.listeners) {
	      this.listeners[event].push(callback);
	    } else {
	      this.listeners[event] = [callback];
	    }
	  };
	
	  Observable.prototype.trigger = function (event) {
	    var slice = Array.prototype.slice;
	    var params = slice.call(arguments, 1);
	
	    this.listeners = this.listeners || {};
	
	    // Params should always come in as an array
	    if (params == null) {
	      params = [];
	    }
	
	    // If there are no arguments to the event, use a temporary object
	    if (params.length === 0) {
	      params.push({});
	    }
	
	    // Set the `_type` of the first object to the event
	    params[0]._type = event;
	
	    if (event in this.listeners) {
	      this.invoke(this.listeners[event], slice.call(arguments, 1));
	    }
	
	    if ('*' in this.listeners) {
	      this.invoke(this.listeners['*'], arguments);
	    }
	  };
	
	  Observable.prototype.invoke = function (listeners, params) {
	    for (var i = 0, len = listeners.length; i < len; i++) {
	      listeners[i].apply(this, params);
	    }
	  };
	
	  Utils.Observable = Observable;
	
	  Utils.generateChars = function (length) {
	    var chars = '';
	
	    for (var i = 0; i < length; i++) {
	      var randomChar = Math.floor(Math.random() * 36);
	      chars += randomChar.toString(36);
	    }
	
	    return chars;
	  };
	
	  Utils.bind = function (func, context) {
	    return function () {
	      func.apply(context, arguments);
	    };
	  };
	
	  Utils._convertData = function (data) {
	    for (var originalKey in data) {
	      var keys = originalKey.split('-');
	
	      var dataLevel = data;
	
	      if (keys.length === 1) {
	        continue;
	      }
	
	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k];
	
	        // Lowercase the first letter
	        // By default, dash-separated becomes camelCase
	        key = key.substring(0, 1).toLowerCase() + key.substring(1);
	
	        if (!(key in dataLevel)) {
	          dataLevel[key] = {};
	        }
	
	        if (k == keys.length - 1) {
	          dataLevel[key] = data[originalKey];
	        }
	
	        dataLevel = dataLevel[key];
	      }
	
	      delete data[originalKey];
	    }
	
	    return data;
	  };
	
	  Utils.hasScroll = function (index, el) {
	    // Adapted from the function created by @ShadowScripter
	    // and adapted by @BillBarry on the Stack Exchange Code Review website.
	    // The original code can be found at
	    // http://codereview.stackexchange.com/q/13338
	    // and was designed to be used with the Sizzle selector engine.
	
	    var $el = $(el);
	    var overflowX = el.style.overflowX;
	    var overflowY = el.style.overflowY;
	
	    //Check both x and y declarations
	    if (overflowX === overflowY &&
	        (overflowY === 'hidden' || overflowY === 'visible')) {
	      return false;
	    }
	
	    if (overflowX === 'scroll' || overflowY === 'scroll') {
	      return true;
	    }
	
	    return ($el.innerHeight() < el.scrollHeight ||
	      $el.innerWidth() < el.scrollWidth);
	  };
	
	  Utils.escapeMarkup = function (markup) {
	    var replaceMap = {
	      '\\': '&#92;',
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      '\'': '&#39;',
	      '/': '&#47;'
	    };
	
	    // Do not try to escape the markup if it's not a string
	    if (typeof markup !== 'string') {
	      return markup;
	    }
	
	    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	      return replaceMap[match];
	    });
	  };
	
	  // Append an array of jQuery nodes to a given element.
	  Utils.appendMany = function ($element, $nodes) {
	    // jQuery 1.7.x does not support $.fn.append() with an array
	    // Fall back to a jQuery object collection using $.fn.add()
	    if ($.fn.jquery.substr(0, 3) === '1.7') {
	      var $jqNodes = $();
	
	      $.map($nodes, function (node) {
	        $jqNodes = $jqNodes.add(node);
	      });
	
	      $nodes = $jqNodes;
	    }
	
	    $element.append($nodes);
	  };
	
	  // Cache objects in Utils.__cache instead of $.data (see #4346)
	  Utils.__cache = {};
	
	  var id = 0;
	  Utils.GetUniqueElementId = function (element) {
	    // Get a unique element Id. If element has no id,
	    // creates a new unique number, stores it in the id
	    // attribute and returns the new id.
	    // If an id already exists, it simply returns it.
	
	    var select2Id = element.getAttribute('data-select2-id');
	    if (select2Id == null) {
	      // If element has id, use it.
	      if (element.id) {
	        select2Id = element.id;
	        element.setAttribute('data-select2-id', select2Id);
	      } else {
	        element.setAttribute('data-select2-id', ++id);
	        select2Id = id.toString();
	      }
	    }
	    return select2Id;
	  };
	
	  Utils.StoreData = function (element, name, value) {
	    // Stores an item in the cache for a specified element.
	    // name is the cache key.
	    var id = Utils.GetUniqueElementId(element);
	    if (!Utils.__cache[id]) {
	      Utils.__cache[id] = {};
	    }
	
	    Utils.__cache[id][name] = value;
	  };
	
	  Utils.GetData = function (element, name) {
	    // Retrieves a value from the cache by its key (name)
	    // name is optional. If no name specified, return
	    // all cache items for the specified element.
	    // and for a specified element.
	    var id = Utils.GetUniqueElementId(element);
	    if (name) {
	      if (Utils.__cache[id]) {
	        if (Utils.__cache[id][name] != null) {
	          return Utils.__cache[id][name];
	        }
	        return $(element).data(name); // Fallback to HTML5 data attribs.
	      }
	      return $(element).data(name); // Fallback to HTML5 data attribs.
	    } else {
	      return Utils.__cache[id];
	    }
	  };
	
	  Utils.RemoveData = function (element) {
	    // Removes all cached items for a specified element.
	    var id = Utils.GetUniqueElementId(element);
	    if (Utils.__cache[id] != null) {
	      delete Utils.__cache[id];
	    }
	
	    element.removeAttribute('data-select2-id');
	  };
	
	  return Utils;
	});
	
	S2.define('select2/results',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Results ($element, options, dataAdapter) {
	    this.$element = $element;
	    this.data = dataAdapter;
	    this.options = options;
	
	    Results.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Results, Utils.Observable);
	
	  Results.prototype.render = function () {
	    var $results = $(
	      '<ul class="select2-results__options" role="listbox"></ul>'
	    );
	
	    if (this.options.get('multiple')) {
	      $results.attr('aria-multiselectable', 'true');
	    }
	
	    this.$results = $results;
	
	    return $results;
	  };
	
	  Results.prototype.clear = function () {
	    this.$results.empty();
	  };
	
	  Results.prototype.displayMessage = function (params) {
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    this.clear();
	    this.hideLoading();
	
	    var $message = $(
	      '<li role="alert" aria-live="assertive"' +
	      ' class="select2-results__option"></li>'
	    );
	
	    var message = this.options.get('translations').get(params.message);
	
	    $message.append(
	      escapeMarkup(
	        message(params.args)
	      )
	    );
	
	    $message[0].className += ' select2-results__message';
	
	    this.$results.append($message);
	  };
	
	  Results.prototype.hideMessages = function () {
	    this.$results.find('.select2-results__message').remove();
	  };
	
	  Results.prototype.append = function (data) {
	    this.hideLoading();
	
	    var $options = [];
	
	    if (data.results == null || data.results.length === 0) {
	      if (this.$results.children().length === 0) {
	        this.trigger('results:message', {
	          message: 'noResults'
	        });
	      }
	
	      return;
	    }
	
	    data.results = this.sort(data.results);
	
	    for (var d = 0; d < data.results.length; d++) {
	      var item = data.results[d];
	
	      var $option = this.option(item);
	
	      $options.push($option);
	    }
	
	    this.$results.append($options);
	  };
	
	  Results.prototype.position = function ($results, $dropdown) {
	    var $resultsContainer = $dropdown.find('.select2-results');
	    $resultsContainer.append($results);
	  };
	
	  Results.prototype.sort = function (data) {
	    var sorter = this.options.get('sorter');
	
	    return sorter(data);
	  };
	
	  Results.prototype.highlightFirstItem = function () {
	    var $options = this.$results
	      .find('.select2-results__option[aria-selected]');
	
	    var $selected = $options.filter('[aria-selected=true]');
	
	    // Check if there are any selected options
	    if ($selected.length > 0) {
	      // If there are selected options, highlight the first
	      $selected.first().trigger('mouseenter');
	    } else {
	      // If there are no selected options, highlight the first option
	      // in the dropdown
	      $options.first().trigger('mouseenter');
	    }
	
	    this.ensureHighlightVisible();
	  };
	
	  Results.prototype.setClasses = function () {
	    var self = this;
	
	    this.data.current(function (selected) {
	      var selectedIds = $.map(selected, function (s) {
	        return s.id.toString();
	      });
	
	      var $options = self.$results
	        .find('.select2-results__option[aria-selected]');
	
	      $options.each(function () {
	        var $option = $(this);
	
	        var item = Utils.GetData(this, 'data');
	
	        // id needs to be converted to a string when comparing
	        var id = '' + item.id;
	
	        if ((item.element != null && item.element.selected) ||
	            (item.element == null && $.inArray(id, selectedIds) > -1)) {
	          $option.attr('aria-selected', 'true');
	        } else {
	          $option.attr('aria-selected', 'false');
	        }
	      });
	
	    });
	  };
	
	  Results.prototype.showLoading = function (params) {
	    this.hideLoading();
	
	    var loadingMore = this.options.get('translations').get('searching');
	
	    var loading = {
	      disabled: true,
	      loading: true,
	      text: loadingMore(params)
	    };
	    var $loading = this.option(loading);
	    $loading.className += ' loading-results';
	
	    this.$results.prepend($loading);
	  };
	
	  Results.prototype.hideLoading = function () {
	    this.$results.find('.loading-results').remove();
	  };
	
	  Results.prototype.option = function (data) {
	    var option = document.createElement('li');
	    option.className = 'select2-results__option';
	
	    var attrs = {
	      'role': 'option',
	      'aria-selected': 'false'
	    };
	
	    var matches = window.Element.prototype.matches ||
	      window.Element.prototype.msMatchesSelector ||
	      window.Element.prototype.webkitMatchesSelector;
	
	    if ((data.element != null && matches.call(data.element, ':disabled')) ||
	        (data.element == null && data.disabled)) {
	      delete attrs['aria-selected'];
	      attrs['aria-disabled'] = 'true';
	    }
	
	    if (data.id == null) {
	      delete attrs['aria-selected'];
	    }
	
	    if (data._resultId != null) {
	      option.id = data._resultId;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    if (data.children) {
	      attrs.role = 'group';
	      attrs['aria-label'] = data.text;
	      delete attrs['aria-selected'];
	    }
	
	    for (var attr in attrs) {
	      var val = attrs[attr];
	
	      option.setAttribute(attr, val);
	    }
	
	    if (data.children) {
	      var $option = $(option);
	
	      var label = document.createElement('strong');
	      label.className = 'select2-results__group';
	
	      var $label = $(label);
	      this.template(data, label);
	
	      var $children = [];
	
	      for (var c = 0; c < data.children.length; c++) {
	        var child = data.children[c];
	
	        var $child = this.option(child);
	
	        $children.push($child);
	      }
	
	      var $childrenContainer = $('<ul></ul>', {
	        'class': 'select2-results__options select2-results__options--nested'
	      });
	
	      $childrenContainer.append($children);
	
	      $option.append(label);
	      $option.append($childrenContainer);
	    } else {
	      this.template(data, option);
	    }
	
	    Utils.StoreData(option, 'data', data);
	
	    return option;
	  };
	
	  Results.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-results';
	
	    this.$results.attr('id', id);
	
	    container.on('results:all', function (params) {
	      self.clear();
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('results:append', function (params) {
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	      }
	    });
	
	    container.on('query', function (params) {
	      self.hideMessages();
	      self.showLoading(params);
	    });
	
	    container.on('select', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	
	      if (self.options.get('scrollAfterSelect')) {
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('unselect', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	
	      if (self.options.get('scrollAfterSelect')) {
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expended="true"
	      self.$results.attr('aria-expanded', 'true');
	      self.$results.attr('aria-hidden', 'false');
	
	      self.setClasses();
	      self.ensureHighlightVisible();
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expended="false"
	      self.$results.attr('aria-expanded', 'false');
	      self.$results.attr('aria-hidden', 'true');
	      self.$results.removeAttr('aria-activedescendant');
	    });
	
	    container.on('results:toggle', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      $highlighted.trigger('mouseup');
	    });
	
	    container.on('results:select', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      var data = Utils.GetData($highlighted[0], 'data');
	
	      if ($highlighted.attr('aria-selected') == 'true') {
	        self.trigger('close', {});
	      } else {
	        self.trigger('select', {
	          data: data
	        });
	      }
	    });
	
	    container.on('results:previous', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      // If we are already at the top, don't move further
	      // If no options, currentIndex will be -1
	      if (currentIndex <= 0) {
	        return;
	      }
	
	      var nextIndex = currentIndex - 1;
	
	      // If none are highlighted, highlight the first
	      if ($highlighted.length === 0) {
	        nextIndex = 0;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top;
	      var nextTop = $next.offset().top;
	      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextTop - currentOffset < 0) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:next', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      var nextIndex = currentIndex + 1;
	
	      // If we are at the last option, stay there
	      if (nextIndex >= $options.length) {
	        return;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var nextBottom = $next.offset().top + $next.outerHeight(false);
	      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextBottom > currentOffset) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      params.element.addClass('select2-results__option--highlighted');
	    });
	
	    container.on('results:message', function (params) {
	      self.displayMessage(params);
	    });
	
	    if ($.fn.mousewheel) {
	      this.$results.on('mousewheel', function (e) {
	        var top = self.$results.scrollTop();
	
	        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
	
	        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
	        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
	
	        if (isAtTop) {
	          self.$results.scrollTop(0);
	
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (isAtBottom) {
	          self.$results.scrollTop(
	            self.$results.get(0).scrollHeight - self.$results.height()
	          );
	
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      });
	    }
	
	    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var $this = $(this);
	
	      var data = Utils.GetData(this, 'data');
	
	      if ($this.attr('aria-selected') === 'true') {
	        if (self.options.get('multiple')) {
	          self.trigger('unselect', {
	            originalEvent: evt,
	            data: data
	          });
	        } else {
	          self.trigger('close', {});
	        }
	
	        return;
	      }
	
	      self.trigger('select', {
	        originalEvent: evt,
	        data: data
	      });
	    });
	
	    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var data = Utils.GetData(this, 'data');
	
	      self.getHighlightedResults()
	          .removeClass('select2-results__option--highlighted');
	
	      self.trigger('results:focus', {
	        data: data,
	        element: $(this)
	      });
	    });
	  };
	
	  Results.prototype.getHighlightedResults = function () {
	    var $highlighted = this.$results
	    .find('.select2-results__option--highlighted');
	
	    return $highlighted;
	  };
	
	  Results.prototype.destroy = function () {
	    this.$results.remove();
	  };
	
	  Results.prototype.ensureHighlightVisible = function () {
	    var $highlighted = this.getHighlightedResults();
	
	    if ($highlighted.length === 0) {
	      return;
	    }
	
	    var $options = this.$results.find('[aria-selected]');
	
	    var currentIndex = $options.index($highlighted);
	
	    var currentOffset = this.$results.offset().top;
	    var nextTop = $highlighted.offset().top;
	    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
	
	    var offsetDelta = nextTop - currentOffset;
	    nextOffset -= $highlighted.outerHeight(false) * 2;
	
	    if (currentIndex <= 2) {
	      this.$results.scrollTop(0);
	    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
	      this.$results.scrollTop(nextOffset);
	    }
	  };
	
	  Results.prototype.template = function (result, container) {
	    var template = this.options.get('templateResult');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    var content = template(result, container);
	
	    if (content == null) {
	      container.style.display = 'none';
	    } else if (typeof content === 'string') {
	      container.innerHTML = escapeMarkup(content);
	    } else {
	      $(container).append(content);
	    }
	  };
	
	  return Results;
	});
	
	S2.define('select2/keys',[
	
	], function () {
	  var KEYS = {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    ESC: 27,
	    SPACE: 32,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	  };
	
	  return KEYS;
	});
	
	S2.define('select2/selection/base',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function BaseSelection ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    BaseSelection.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseSelection, Utils.Observable);
	
	  BaseSelection.prototype.render = function () {
	    var $selection = $(
	      '<span class="select2-selection" role="combobox" ' +
	      ' aria-haspopup="true" aria-expanded="false">' +
	      '</span>'
	    );
	
	    this._tabindex = 0;
	
	    if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
	      this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
	    } else if (this.$element.attr('tabindex') != null) {
	      this._tabindex = this.$element.attr('tabindex');
	    }
	
	    $selection.attr('title', this.$element.attr('title'));
	    $selection.attr('tabindex', this._tabindex);
	    $selection.attr('aria-disabled', 'false');
	
	    this.$selection = $selection;
	
	    return $selection;
	  };
	
	  BaseSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    this.container = container;
	
	    this.$selection.on('focus', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('blur', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      if (evt.which === KEYS.SPACE) {
	        evt.preventDefault();
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      self.$selection.attr('aria-activedescendant', params.data._resultId);
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expanded="true"
	      self.$selection.attr('aria-expanded', 'true');
	      self.$selection.attr('aria-owns', resultsId);
	
	      self._attachCloseHandler(container);
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expanded="false"
	      self.$selection.attr('aria-expanded', 'false');
	      self.$selection.removeAttr('aria-activedescendant');
	      self.$selection.removeAttr('aria-owns');
	
	      self.$selection.trigger('focus');
	
	      self._detachCloseHandler(container);
	    });
	
	    container.on('enable', function () {
	      self.$selection.attr('tabindex', self._tabindex);
	      self.$selection.attr('aria-disabled', 'false');
	    });
	
	    container.on('disable', function () {
	      self.$selection.attr('tabindex', '-1');
	      self.$selection.attr('aria-disabled', 'true');
	    });
	  };
	
	  BaseSelection.prototype._handleBlur = function (evt) {
	    var self = this;
	
	    // This needs to be delayed as the active element is the body when the tab
	    // key is pressed, possibly along with others.
	    window.setTimeout(function () {
	      // Don't trigger `blur` if the focus is still in the selection
	      if (
	        (document.activeElement == self.$selection[0]) ||
	        ($.contains(self.$selection[0], document.activeElement))
	      ) {
	        return;
	      }
	
	      self.trigger('blur', evt);
	    }, 1);
	  };
	
	  BaseSelection.prototype._attachCloseHandler = function (container) {
	
	    $(document.body).on('mousedown.select2.' + container.id, function (e) {
	      var $target = $(e.target);
	
	      var $select = $target.closest('.select2');
	
	      var $all = $('.select2.select2-container--open');
	
	      $all.each(function () {
	        if (this == $select[0]) {
	          return;
	        }
	
	        var $element = Utils.GetData(this, 'element');
	
	        $element.select2('close');
	      });
	    });
	  };
	
	  BaseSelection.prototype._detachCloseHandler = function (container) {
	    $(document.body).off('mousedown.select2.' + container.id);
	  };
	
	  BaseSelection.prototype.position = function ($selection, $container) {
	    var $selectionContainer = $container.find('.selection');
	    $selectionContainer.append($selection);
	  };
	
	  BaseSelection.prototype.destroy = function () {
	    this._detachCloseHandler(this.container);
	  };
	
	  BaseSelection.prototype.update = function (data) {
	    throw new Error('The `update` method must be defined in child classes.');
	  };
	
	  /**
	   * Helper method to abstract the "enabled" (not "disabled") state of this
	   * object.
	   *
	   * @return {true} if the instance is not disabled.
	   * @return {false} if the instance is disabled.
	   */
	  BaseSelection.prototype.isEnabled = function () {
	    return !this.isDisabled();
	  };
	
	  /**
	   * Helper method to abstract the "disabled" state of this object.
	   *
	   * @return {true} if the disabled option is true.
	   * @return {false} if the disabled option is false.
	   */
	  BaseSelection.prototype.isDisabled = function () {
	    return this.options.get('disabled');
	  };
	
	  return BaseSelection;
	});
	
	S2.define('select2/selection/single',[
	  'jquery',
	  './base',
	  '../utils',
	  '../keys'
	], function ($, BaseSelection, Utils, KEYS) {
	  function SingleSelection () {
	    SingleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(SingleSelection, BaseSelection);
	
	  SingleSelection.prototype.render = function () {
	    var $selection = SingleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--single');
	
	    $selection.html(
	      '<span class="select2-selection__rendered"></span>' +
	      '<span class="select2-selection__arrow" role="presentation">' +
	        '<b role="presentation"></b>' +
	      '</span>'
	    );
	
	    return $selection;
	  };
	
	  SingleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    SingleSelection.__super__.bind.apply(this, arguments);
	
	    var id = container.id + '-container';
	
	    this.$selection.find('.select2-selection__rendered')
	      .attr('id', id)
	      .attr('role', 'textbox')
	      .attr('aria-readonly', 'true');
	    this.$selection.attr('aria-labelledby', id);
	
	    this.$selection.on('mousedown', function (evt) {
	      // Only respond to left clicks
	      if (evt.which !== 1) {
	        return;
	      }
	
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on('focus', function (evt) {
	      // User focuses on the container
	    });
	
	    this.$selection.on('blur', function (evt) {
	      // User exits the container
	    });
	
	    container.on('focus', function (evt) {
	      if (!container.isOpen()) {
	        self.$selection.trigger('focus');
	      }
	    });
	  };
	
	  SingleSelection.prototype.clear = function () {
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    $rendered.empty();
	    $rendered.removeAttr('title'); // clear tooltip on empty
	  };
	
	  SingleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  SingleSelection.prototype.selectionContainer = function () {
	    return $('<span></span>');
	  };
	
	  SingleSelection.prototype.update = function (data) {
	    if (data.length === 0) {
	      this.clear();
	      return;
	    }
	
	    var selection = data[0];
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    var formatted = this.display(selection, $rendered);
	
	    $rendered.empty().append(formatted);
	
	    var title = selection.title || selection.text;
	
	    if (title) {
	      $rendered.attr('title', title);
	    } else {
	      $rendered.removeAttr('title');
	    }
	  };
	
	  return SingleSelection;
	});
	
	S2.define('select2/selection/multiple',[
	  'jquery',
	  './base',
	  '../utils'
	], function ($, BaseSelection, Utils) {
	  function MultipleSelection ($element, options) {
	    MultipleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(MultipleSelection, BaseSelection);
	
	  MultipleSelection.prototype.render = function () {
	    var $selection = MultipleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--multiple');
	
	    $selection.html(
	      '<ul class="select2-selection__rendered"></ul>'
	    );
	
	    return $selection;
	  };
	
	  MultipleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    MultipleSelection.__super__.bind.apply(this, arguments);
	
	    this.$selection.on('click', function (evt) {
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on(
	      'click',
	      '.select2-selection__choice__remove',
	      function (evt) {
	        // Ignore the event if it is disabled
	        if (self.isDisabled()) {
	          return;
	        }
	
	        var $remove = $(this);
	        var $selection = $remove.parent();
	
	        var data = Utils.GetData($selection[0], 'data');
	
	        self.trigger('unselect', {
	          originalEvent: evt,
	          data: data
	        });
	      }
	    );
	  };
	
	  MultipleSelection.prototype.clear = function () {
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    $rendered.empty();
	    $rendered.removeAttr('title');
	  };
	
	  MultipleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  MultipleSelection.prototype.selectionContainer = function () {
	    var $container = $(
	      '<li class="select2-selection__choice">' +
	        '<span class="select2-selection__choice__remove" role="presentation">' +
	          '&times;' +
	        '</span>' +
	      '</li>'
	    );
	
	    return $container;
	  };
	
	  MultipleSelection.prototype.update = function (data) {
	    this.clear();
	
	    if (data.length === 0) {
	      return;
	    }
	
	    var $selections = [];
	
	    for (var d = 0; d < data.length; d++) {
	      var selection = data[d];
	
	      var $selection = this.selectionContainer();
	      var formatted = this.display(selection, $selection);
	
	      $selection.append(formatted);
	
	      var title = selection.title || selection.text;
	
	      if (title) {
	        $selection.attr('title', title);
	      }
	
	      Utils.StoreData($selection[0], 'data', selection);
	
	      $selections.push($selection);
	    }
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	
	    Utils.appendMany($rendered, $selections);
	  };
	
	  return MultipleSelection;
	});
	
	S2.define('select2/selection/placeholder',[
	  '../utils'
	], function (Utils) {
	  function Placeholder (decorated, $element, options) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options);
	  }
	
	  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
	    var $placeholder = this.selectionContainer();
	
	    $placeholder.html(this.display(placeholder));
	    $placeholder.addClass('select2-selection__placeholder')
	                .removeClass('select2-selection__choice');
	
	    return $placeholder;
	  };
	
	  Placeholder.prototype.update = function (decorated, data) {
	    var singlePlaceholder = (
	      data.length == 1 && data[0].id != this.placeholder.id
	    );
	    var multipleSelections = data.length > 1;
	
	    if (multipleSelections || singlePlaceholder) {
	      return decorated.call(this, data);
	    }
	
	    this.clear();
	
	    var $placeholder = this.createPlaceholder(this.placeholder);
	
	    this.$selection.find('.select2-selection__rendered').append($placeholder);
	  };
	
	  return Placeholder;
	});
	
	S2.define('select2/selection/allowClear',[
	  'jquery',
	  '../keys',
	  '../utils'
	], function ($, KEYS, Utils) {
	  function AllowClear () { }
	
	  AllowClear.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    if (this.placeholder == null) {
	      if (this.options.get('debug') && window.console && console.error) {
	        console.error(
	          'Select2: The `allowClear` option should be used in combination ' +
	          'with the `placeholder` option.'
	        );
	      }
	    }
	
	    this.$selection.on('mousedown', '.select2-selection__clear',
	      function (evt) {
	        self._handleClear(evt);
	    });
	
	    container.on('keypress', function (evt) {
	      self._handleKeyboardClear(evt, container);
	    });
	  };
	
	  AllowClear.prototype._handleClear = function (_, evt) {
	    // Ignore the event if it is disabled
	    if (this.isDisabled()) {
	      return;
	    }
	
	    var $clear = this.$selection.find('.select2-selection__clear');
	
	    // Ignore the event if nothing has been selected
	    if ($clear.length === 0) {
	      return;
	    }
	
	    evt.stopPropagation();
	
	    var data = Utils.GetData($clear[0], 'data');
	
	    var previousVal = this.$element.val();
	    this.$element.val(this.placeholder.id);
	
	    var unselectData = {
	      data: data
	    };
	    this.trigger('clear', unselectData);
	    if (unselectData.prevented) {
	      this.$element.val(previousVal);
	      return;
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      unselectData = {
	        data: data[d]
	      };
	
	      // Trigger the `unselect` event, so people can prevent it from being
	      // cleared.
	      this.trigger('unselect', unselectData);
	
	      // If the event was prevented, don't clear it out.
	      if (unselectData.prevented) {
	        this.$element.val(previousVal);
	        return;
	      }
	    }
	
	    this.$element.trigger('input').trigger('change');
	
	    this.trigger('toggle', {});
	  };
	
	  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
	    if (container.isOpen()) {
	      return;
	    }
	
	    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
	      this._handleClear(evt);
	    }
	  };
	
	  AllowClear.prototype.update = function (decorated, data) {
	    decorated.call(this, data);
	
	    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
	        data.length === 0) {
	      return;
	    }
	
	    var removeAll = this.options.get('translations').get('removeAllItems');
	
	    var $remove = $(
	      '<span class="select2-selection__clear" title="' + removeAll() +'">' +
	        '&times;' +
	      '</span>'
	    );
	    Utils.StoreData($remove[0], 'data', data);
	
	    this.$selection.find('.select2-selection__rendered').prepend($remove);
	  };
	
	  return AllowClear;
	});
	
	S2.define('select2/selection/search',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function Search (decorated, $element, options) {
	    decorated.call(this, $element, options);
	  }
	
	  Search.prototype.render = function (decorated) {
	    var $search = $(
	      '<li class="select2-search select2-search--inline">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
	        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
	      '</li>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    var $rendered = decorated.call(this);
	
	    this._transferTabIndex();
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self.$search.attr('aria-controls', resultsId);
	      self.$search.trigger('focus');
	    });
	
	    container.on('close', function () {
	      self.$search.val('');
	      self.$search.removeAttr('aria-controls');
	      self.$search.removeAttr('aria-activedescendant');
	      self.$search.trigger('focus');
	    });
	
	    container.on('enable', function () {
	      self.$search.prop('disabled', false);
	
	      self._transferTabIndex();
	    });
	
	    container.on('disable', function () {
	      self.$search.prop('disabled', true);
	    });
	
	    container.on('focus', function (evt) {
	      self.$search.trigger('focus');
	    });
	
	    container.on('results:focus', function (params) {
	      if (params.data._resultId) {
	        self.$search.attr('aria-activedescendant', params.data._resultId);
	      } else {
	        self.$search.removeAttr('aria-activedescendant');
	      }
	    });
	
	    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
	      evt.stopPropagation();
	
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	
	      var key = evt.which;
	
	      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
	        var $previousChoice = self.$searchContainer
	          .prev('.select2-selection__choice');
	
	        if ($previousChoice.length > 0) {
	          var item = Utils.GetData($previousChoice[0], 'data');
	
	          self.searchRemoveChoice(item);
	
	          evt.preventDefault();
	        }
	      }
	    });
	
	    this.$selection.on('click', '.select2-search--inline', function (evt) {
	      if (self.$search.val()) {
	        evt.stopPropagation();
	      }
	    });
	
	    // Try to detect the IE version should the `documentMode` property that
	    // is stored on the document. This is only implemented in IE and is
	    // slightly cleaner than doing a user agent check.
	    // This property is not available in Edge, but Edge also doesn't have
	    // this bug.
	    var msie = document.documentMode;
	    var disableInputEvents = msie && msie <= 11;
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$selection.on(
	      'input.searchcheck',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents) {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        // Unbind the duplicated `keyup` event
	        self.$selection.off('keyup.search');
	      }
	    );
	
	    this.$selection.on(
	      'keyup.search input.search',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents && evt.type === 'input') {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        var key = evt.which;
	
	        // We can freely ignore events from modifier keys
	        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
	          return;
	        }
	
	        // Tabbing will be handled during the `keydown` phase
	        if (key == KEYS.TAB) {
	          return;
	        }
	
	        self.handleSearch(evt);
	      }
	    );
	  };
	
	  /**
	   * This method will transfer the tabindex attribute from the rendered
	   * selection to the search box. This allows for the search box to be used as
	   * the primary focus instead of the selection container.
	   *
	   * @private
	   */
	  Search.prototype._transferTabIndex = function (decorated) {
	    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
	    this.$selection.attr('tabindex', '-1');
	  };
	
	  Search.prototype.createPlaceholder = function (decorated, placeholder) {
	    this.$search.attr('placeholder', placeholder.text);
	  };
	
	  Search.prototype.update = function (decorated, data) {
	    var searchHadFocus = this.$search[0] == document.activeElement;
	
	    this.$search.attr('placeholder', '');
	
	    decorated.call(this, data);
	
	    this.$selection.find('.select2-selection__rendered')
	                   .append(this.$searchContainer);
	
	    this.resizeSearch();
	    if (searchHadFocus) {
	      this.$search.trigger('focus');
	    }
	  };
	
	  Search.prototype.handleSearch = function () {
	    this.resizeSearch();
	
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.searchRemoveChoice = function (decorated, item) {
	    this.trigger('unselect', {
	      data: item
	    });
	
	    this.$search.val(item.text);
	    this.handleSearch();
	  };
	
	  Search.prototype.resizeSearch = function () {
	    this.$search.css('width', '25px');
	
	    var width = '';
	
	    if (this.$search.attr('placeholder') !== '') {
	      width = this.$selection.find('.select2-selection__rendered').width();
	    } else {
	      var minimumWidth = this.$search.val().length + 1;
	
	      width = (minimumWidth * 0.75) + 'em';
	    }
	
	    this.$search.css('width', width);
	  };
	
	  return Search;
	});
	
	S2.define('select2/selection/eventRelay',[
	  'jquery'
	], function ($) {
	  function EventRelay () { }
	
	  EventRelay.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	    var relayEvents = [
	      'open', 'opening',
	      'close', 'closing',
	      'select', 'selecting',
	      'unselect', 'unselecting',
	      'clear', 'clearing'
	    ];
	
	    var preventableEvents = [
	      'opening', 'closing', 'selecting', 'unselecting', 'clearing'
	    ];
	
	    decorated.call(this, container, $container);
	
	    container.on('*', function (name, params) {
	      // Ignore events that should not be relayed
	      if ($.inArray(name, relayEvents) === -1) {
	        return;
	      }
	
	      // The parameters should always be an object
	      params = params || {};
	
	      // Generate the jQuery event for the Select2 event
	      var evt = $.Event('select2:' + name, {
	        params: params
	      });
	
	      self.$element.trigger(evt);
	
	      // Only handle preventable events if it was one
	      if ($.inArray(name, preventableEvents) === -1) {
	        return;
	      }
	
	      params.prevented = evt.isDefaultPrevented();
	    });
	  };
	
	  return EventRelay;
	});
	
	S2.define('select2/translation',[
	  'jquery',
	  'require'
	], function ($, require) {
	  function Translation (dict) {
	    this.dict = dict || {};
	  }
	
	  Translation.prototype.all = function () {
	    return this.dict;
	  };
	
	  Translation.prototype.get = function (key) {
	    return this.dict[key];
	  };
	
	  Translation.prototype.extend = function (translation) {
	    this.dict = $.extend({}, translation.all(), this.dict);
	  };
	
	  // Static functions
	
	  Translation._cache = {};
	
	  Translation.loadPath = function (path) {
	    if (!(path in Translation._cache)) {
	      var translations = require(path);
	
	      Translation._cache[path] = translations;
	    }
	
	    return new Translation(Translation._cache[path]);
	  };
	
	  return Translation;
	});
	
	S2.define('select2/diacritics',[
	
	], function () {
	  var diacritics = {
	    '\u24B6': 'A',
	    '\uFF21': 'A',
	    '\u00C0': 'A',
	    '\u00C1': 'A',
	    '\u00C2': 'A',
	    '\u1EA6': 'A',
	    '\u1EA4': 'A',
	    '\u1EAA': 'A',
	    '\u1EA8': 'A',
	    '\u00C3': 'A',
	    '\u0100': 'A',
	    '\u0102': 'A',
	    '\u1EB0': 'A',
	    '\u1EAE': 'A',
	    '\u1EB4': 'A',
	    '\u1EB2': 'A',
	    '\u0226': 'A',
	    '\u01E0': 'A',
	    '\u00C4': 'A',
	    '\u01DE': 'A',
	    '\u1EA2': 'A',
	    '\u00C5': 'A',
	    '\u01FA': 'A',
	    '\u01CD': 'A',
	    '\u0200': 'A',
	    '\u0202': 'A',
	    '\u1EA0': 'A',
	    '\u1EAC': 'A',
	    '\u1EB6': 'A',
	    '\u1E00': 'A',
	    '\u0104': 'A',
	    '\u023A': 'A',
	    '\u2C6F': 'A',
	    '\uA732': 'AA',
	    '\u00C6': 'AE',
	    '\u01FC': 'AE',
	    '\u01E2': 'AE',
	    '\uA734': 'AO',
	    '\uA736': 'AU',
	    '\uA738': 'AV',
	    '\uA73A': 'AV',
	    '\uA73C': 'AY',
	    '\u24B7': 'B',
	    '\uFF22': 'B',
	    '\u1E02': 'B',
	    '\u1E04': 'B',
	    '\u1E06': 'B',
	    '\u0243': 'B',
	    '\u0182': 'B',
	    '\u0181': 'B',
	    '\u24B8': 'C',
	    '\uFF23': 'C',
	    '\u0106': 'C',
	    '\u0108': 'C',
	    '\u010A': 'C',
	    '\u010C': 'C',
	    '\u00C7': 'C',
	    '\u1E08': 'C',
	    '\u0187': 'C',
	    '\u023B': 'C',
	    '\uA73E': 'C',
	    '\u24B9': 'D',
	    '\uFF24': 'D',
	    '\u1E0A': 'D',
	    '\u010E': 'D',
	    '\u1E0C': 'D',
	    '\u1E10': 'D',
	    '\u1E12': 'D',
	    '\u1E0E': 'D',
	    '\u0110': 'D',
	    '\u018B': 'D',
	    '\u018A': 'D',
	    '\u0189': 'D',
	    '\uA779': 'D',
	    '\u01F1': 'DZ',
	    '\u01C4': 'DZ',
	    '\u01F2': 'Dz',
	    '\u01C5': 'Dz',
	    '\u24BA': 'E',
	    '\uFF25': 'E',
	    '\u00C8': 'E',
	    '\u00C9': 'E',
	    '\u00CA': 'E',
	    '\u1EC0': 'E',
	    '\u1EBE': 'E',
	    '\u1EC4': 'E',
	    '\u1EC2': 'E',
	    '\u1EBC': 'E',
	    '\u0112': 'E',
	    '\u1E14': 'E',
	    '\u1E16': 'E',
	    '\u0114': 'E',
	    '\u0116': 'E',
	    '\u00CB': 'E',
	    '\u1EBA': 'E',
	    '\u011A': 'E',
	    '\u0204': 'E',
	    '\u0206': 'E',
	    '\u1EB8': 'E',
	    '\u1EC6': 'E',
	    '\u0228': 'E',
	    '\u1E1C': 'E',
	    '\u0118': 'E',
	    '\u1E18': 'E',
	    '\u1E1A': 'E',
	    '\u0190': 'E',
	    '\u018E': 'E',
	    '\u24BB': 'F',
	    '\uFF26': 'F',
	    '\u1E1E': 'F',
	    '\u0191': 'F',
	    '\uA77B': 'F',
	    '\u24BC': 'G',
	    '\uFF27': 'G',
	    '\u01F4': 'G',
	    '\u011C': 'G',
	    '\u1E20': 'G',
	    '\u011E': 'G',
	    '\u0120': 'G',
	    '\u01E6': 'G',
	    '\u0122': 'G',
	    '\u01E4': 'G',
	    '\u0193': 'G',
	    '\uA7A0': 'G',
	    '\uA77D': 'G',
	    '\uA77E': 'G',
	    '\u24BD': 'H',
	    '\uFF28': 'H',
	    '\u0124': 'H',
	    '\u1E22': 'H',
	    '\u1E26': 'H',
	    '\u021E': 'H',
	    '\u1E24': 'H',
	    '\u1E28': 'H',
	    '\u1E2A': 'H',
	    '\u0126': 'H',
	    '\u2C67': 'H',
	    '\u2C75': 'H',
	    '\uA78D': 'H',
	    '\u24BE': 'I',
	    '\uFF29': 'I',
	    '\u00CC': 'I',
	    '\u00CD': 'I',
	    '\u00CE': 'I',
	    '\u0128': 'I',
	    '\u012A': 'I',
	    '\u012C': 'I',
	    '\u0130': 'I',
	    '\u00CF': 'I',
	    '\u1E2E': 'I',
	    '\u1EC8': 'I',
	    '\u01CF': 'I',
	    '\u0208': 'I',
	    '\u020A': 'I',
	    '\u1ECA': 'I',
	    '\u012E': 'I',
	    '\u1E2C': 'I',
	    '\u0197': 'I',
	    '\u24BF': 'J',
	    '\uFF2A': 'J',
	    '\u0134': 'J',
	    '\u0248': 'J',
	    '\u24C0': 'K',
	    '\uFF2B': 'K',
	    '\u1E30': 'K',
	    '\u01E8': 'K',
	    '\u1E32': 'K',
	    '\u0136': 'K',
	    '\u1E34': 'K',
	    '\u0198': 'K',
	    '\u2C69': 'K',
	    '\uA740': 'K',
	    '\uA742': 'K',
	    '\uA744': 'K',
	    '\uA7A2': 'K',
	    '\u24C1': 'L',
	    '\uFF2C': 'L',
	    '\u013F': 'L',
	    '\u0139': 'L',
	    '\u013D': 'L',
	    '\u1E36': 'L',
	    '\u1E38': 'L',
	    '\u013B': 'L',
	    '\u1E3C': 'L',
	    '\u1E3A': 'L',
	    '\u0141': 'L',
	    '\u023D': 'L',
	    '\u2C62': 'L',
	    '\u2C60': 'L',
	    '\uA748': 'L',
	    '\uA746': 'L',
	    '\uA780': 'L',
	    '\u01C7': 'LJ',
	    '\u01C8': 'Lj',
	    '\u24C2': 'M',
	    '\uFF2D': 'M',
	    '\u1E3E': 'M',
	    '\u1E40': 'M',
	    '\u1E42': 'M',
	    '\u2C6E': 'M',
	    '\u019C': 'M',
	    '\u24C3': 'N',
	    '\uFF2E': 'N',
	    '\u01F8': 'N',
	    '\u0143': 'N',
	    '\u00D1': 'N',
	    '\u1E44': 'N',
	    '\u0147': 'N',
	    '\u1E46': 'N',
	    '\u0145': 'N',
	    '\u1E4A': 'N',
	    '\u1E48': 'N',
	    '\u0220': 'N',
	    '\u019D': 'N',
	    '\uA790': 'N',
	    '\uA7A4': 'N',
	    '\u01CA': 'NJ',
	    '\u01CB': 'Nj',
	    '\u24C4': 'O',
	    '\uFF2F': 'O',
	    '\u00D2': 'O',
	    '\u00D3': 'O',
	    '\u00D4': 'O',
	    '\u1ED2': 'O',
	    '\u1ED0': 'O',
	    '\u1ED6': 'O',
	    '\u1ED4': 'O',
	    '\u00D5': 'O',
	    '\u1E4C': 'O',
	    '\u022C': 'O',
	    '\u1E4E': 'O',
	    '\u014C': 'O',
	    '\u1E50': 'O',
	    '\u1E52': 'O',
	    '\u014E': 'O',
	    '\u022E': 'O',
	    '\u0230': 'O',
	    '\u00D6': 'O',
	    '\u022A': 'O',
	    '\u1ECE': 'O',
	    '\u0150': 'O',
	    '\u01D1': 'O',
	    '\u020C': 'O',
	    '\u020E': 'O',
	    '\u01A0': 'O',
	    '\u1EDC': 'O',
	    '\u1EDA': 'O',
	    '\u1EE0': 'O',
	    '\u1EDE': 'O',
	    '\u1EE2': 'O',
	    '\u1ECC': 'O',
	    '\u1ED8': 'O',
	    '\u01EA': 'O',
	    '\u01EC': 'O',
	    '\u00D8': 'O',
	    '\u01FE': 'O',
	    '\u0186': 'O',
	    '\u019F': 'O',
	    '\uA74A': 'O',
	    '\uA74C': 'O',
	    '\u0152': 'OE',
	    '\u01A2': 'OI',
	    '\uA74E': 'OO',
	    '\u0222': 'OU',
	    '\u24C5': 'P',
	    '\uFF30': 'P',
	    '\u1E54': 'P',
	    '\u1E56': 'P',
	    '\u01A4': 'P',
	    '\u2C63': 'P',
	    '\uA750': 'P',
	    '\uA752': 'P',
	    '\uA754': 'P',
	    '\u24C6': 'Q',
	    '\uFF31': 'Q',
	    '\uA756': 'Q',
	    '\uA758': 'Q',
	    '\u024A': 'Q',
	    '\u24C7': 'R',
	    '\uFF32': 'R',
	    '\u0154': 'R',
	    '\u1E58': 'R',
	    '\u0158': 'R',
	    '\u0210': 'R',
	    '\u0212': 'R',
	    '\u1E5A': 'R',
	    '\u1E5C': 'R',
	    '\u0156': 'R',
	    '\u1E5E': 'R',
	    '\u024C': 'R',
	    '\u2C64': 'R',
	    '\uA75A': 'R',
	    '\uA7A6': 'R',
	    '\uA782': 'R',
	    '\u24C8': 'S',
	    '\uFF33': 'S',
	    '\u1E9E': 'S',
	    '\u015A': 'S',
	    '\u1E64': 'S',
	    '\u015C': 'S',
	    '\u1E60': 'S',
	    '\u0160': 'S',
	    '\u1E66': 'S',
	    '\u1E62': 'S',
	    '\u1E68': 'S',
	    '\u0218': 'S',
	    '\u015E': 'S',
	    '\u2C7E': 'S',
	    '\uA7A8': 'S',
	    '\uA784': 'S',
	    '\u24C9': 'T',
	    '\uFF34': 'T',
	    '\u1E6A': 'T',
	    '\u0164': 'T',
	    '\u1E6C': 'T',
	    '\u021A': 'T',
	    '\u0162': 'T',
	    '\u1E70': 'T',
	    '\u1E6E': 'T',
	    '\u0166': 'T',
	    '\u01AC': 'T',
	    '\u01AE': 'T',
	    '\u023E': 'T',
	    '\uA786': 'T',
	    '\uA728': 'TZ',
	    '\u24CA': 'U',
	    '\uFF35': 'U',
	    '\u00D9': 'U',
	    '\u00DA': 'U',
	    '\u00DB': 'U',
	    '\u0168': 'U',
	    '\u1E78': 'U',
	    '\u016A': 'U',
	    '\u1E7A': 'U',
	    '\u016C': 'U',
	    '\u00DC': 'U',
	    '\u01DB': 'U',
	    '\u01D7': 'U',
	    '\u01D5': 'U',
	    '\u01D9': 'U',
	    '\u1EE6': 'U',
	    '\u016E': 'U',
	    '\u0170': 'U',
	    '\u01D3': 'U',
	    '\u0214': 'U',
	    '\u0216': 'U',
	    '\u01AF': 'U',
	    '\u1EEA': 'U',
	    '\u1EE8': 'U',
	    '\u1EEE': 'U',
	    '\u1EEC': 'U',
	    '\u1EF0': 'U',
	    '\u1EE4': 'U',
	    '\u1E72': 'U',
	    '\u0172': 'U',
	    '\u1E76': 'U',
	    '\u1E74': 'U',
	    '\u0244': 'U',
	    '\u24CB': 'V',
	    '\uFF36': 'V',
	    '\u1E7C': 'V',
	    '\u1E7E': 'V',
	    '\u01B2': 'V',
	    '\uA75E': 'V',
	    '\u0245': 'V',
	    '\uA760': 'VY',
	    '\u24CC': 'W',
	    '\uFF37': 'W',
	    '\u1E80': 'W',
	    '\u1E82': 'W',
	    '\u0174': 'W',
	    '\u1E86': 'W',
	    '\u1E84': 'W',
	    '\u1E88': 'W',
	    '\u2C72': 'W',
	    '\u24CD': 'X',
	    '\uFF38': 'X',
	    '\u1E8A': 'X',
	    '\u1E8C': 'X',
	    '\u24CE': 'Y',
	    '\uFF39': 'Y',
	    '\u1EF2': 'Y',
	    '\u00DD': 'Y',
	    '\u0176': 'Y',
	    '\u1EF8': 'Y',
	    '\u0232': 'Y',
	    '\u1E8E': 'Y',
	    '\u0178': 'Y',
	    '\u1EF6': 'Y',
	    '\u1EF4': 'Y',
	    '\u01B3': 'Y',
	    '\u024E': 'Y',
	    '\u1EFE': 'Y',
	    '\u24CF': 'Z',
	    '\uFF3A': 'Z',
	    '\u0179': 'Z',
	    '\u1E90': 'Z',
	    '\u017B': 'Z',
	    '\u017D': 'Z',
	    '\u1E92': 'Z',
	    '\u1E94': 'Z',
	    '\u01B5': 'Z',
	    '\u0224': 'Z',
	    '\u2C7F': 'Z',
	    '\u2C6B': 'Z',
	    '\uA762': 'Z',
	    '\u24D0': 'a',
	    '\uFF41': 'a',
	    '\u1E9A': 'a',
	    '\u00E0': 'a',
	    '\u00E1': 'a',
	    '\u00E2': 'a',
	    '\u1EA7': 'a',
	    '\u1EA5': 'a',
	    '\u1EAB': 'a',
	    '\u1EA9': 'a',
	    '\u00E3': 'a',
	    '\u0101': 'a',
	    '\u0103': 'a',
	    '\u1EB1': 'a',
	    '\u1EAF': 'a',
	    '\u1EB5': 'a',
	    '\u1EB3': 'a',
	    '\u0227': 'a',
	    '\u01E1': 'a',
	    '\u00E4': 'a',
	    '\u01DF': 'a',
	    '\u1EA3': 'a',
	    '\u00E5': 'a',
	    '\u01FB': 'a',
	    '\u01CE': 'a',
	    '\u0201': 'a',
	    '\u0203': 'a',
	    '\u1EA1': 'a',
	    '\u1EAD': 'a',
	    '\u1EB7': 'a',
	    '\u1E01': 'a',
	    '\u0105': 'a',
	    '\u2C65': 'a',
	    '\u0250': 'a',
	    '\uA733': 'aa',
	    '\u00E6': 'ae',
	    '\u01FD': 'ae',
	    '\u01E3': 'ae',
	    '\uA735': 'ao',
	    '\uA737': 'au',
	    '\uA739': 'av',
	    '\uA73B': 'av',
	    '\uA73D': 'ay',
	    '\u24D1': 'b',
	    '\uFF42': 'b',
	    '\u1E03': 'b',
	    '\u1E05': 'b',
	    '\u1E07': 'b',
	    '\u0180': 'b',
	    '\u0183': 'b',
	    '\u0253': 'b',
	    '\u24D2': 'c',
	    '\uFF43': 'c',
	    '\u0107': 'c',
	    '\u0109': 'c',
	    '\u010B': 'c',
	    '\u010D': 'c',
	    '\u00E7': 'c',
	    '\u1E09': 'c',
	    '\u0188': 'c',
	    '\u023C': 'c',
	    '\uA73F': 'c',
	    '\u2184': 'c',
	    '\u24D3': 'd',
	    '\uFF44': 'd',
	    '\u1E0B': 'd',
	    '\u010F': 'd',
	    '\u1E0D': 'd',
	    '\u1E11': 'd',
	    '\u1E13': 'd',
	    '\u1E0F': 'd',
	    '\u0111': 'd',
	    '\u018C': 'd',
	    '\u0256': 'd',
	    '\u0257': 'd',
	    '\uA77A': 'd',
	    '\u01F3': 'dz',
	    '\u01C6': 'dz',
	    '\u24D4': 'e',
	    '\uFF45': 'e',
	    '\u00E8': 'e',
	    '\u00E9': 'e',
	    '\u00EA': 'e',
	    '\u1EC1': 'e',
	    '\u1EBF': 'e',
	    '\u1EC5': 'e',
	    '\u1EC3': 'e',
	    '\u1EBD': 'e',
	    '\u0113': 'e',
	    '\u1E15': 'e',
	    '\u1E17': 'e',
	    '\u0115': 'e',
	    '\u0117': 'e',
	    '\u00EB': 'e',
	    '\u1EBB': 'e',
	    '\u011B': 'e',
	    '\u0205': 'e',
	    '\u0207': 'e',
	    '\u1EB9': 'e',
	    '\u1EC7': 'e',
	    '\u0229': 'e',
	    '\u1E1D': 'e',
	    '\u0119': 'e',
	    '\u1E19': 'e',
	    '\u1E1B': 'e',
	    '\u0247': 'e',
	    '\u025B': 'e',
	    '\u01DD': 'e',
	    '\u24D5': 'f',
	    '\uFF46': 'f',
	    '\u1E1F': 'f',
	    '\u0192': 'f',
	    '\uA77C': 'f',
	    '\u24D6': 'g',
	    '\uFF47': 'g',
	    '\u01F5': 'g',
	    '\u011D': 'g',
	    '\u1E21': 'g',
	    '\u011F': 'g',
	    '\u0121': 'g',
	    '\u01E7': 'g',
	    '\u0123': 'g',
	    '\u01E5': 'g',
	    '\u0260': 'g',
	    '\uA7A1': 'g',
	    '\u1D79': 'g',
	    '\uA77F': 'g',
	    '\u24D7': 'h',
	    '\uFF48': 'h',
	    '\u0125': 'h',
	    '\u1E23': 'h',
	    '\u1E27': 'h',
	    '\u021F': 'h',
	    '\u1E25': 'h',
	    '\u1E29': 'h',
	    '\u1E2B': 'h',
	    '\u1E96': 'h',
	    '\u0127': 'h',
	    '\u2C68': 'h',
	    '\u2C76': 'h',
	    '\u0265': 'h',
	    '\u0195': 'hv',
	    '\u24D8': 'i',
	    '\uFF49': 'i',
	    '\u00EC': 'i',
	    '\u00ED': 'i',
	    '\u00EE': 'i',
	    '\u0129': 'i',
	    '\u012B': 'i',
	    '\u012D': 'i',
	    '\u00EF': 'i',
	    '\u1E2F': 'i',
	    '\u1EC9': 'i',
	    '\u01D0': 'i',
	    '\u0209': 'i',
	    '\u020B': 'i',
	    '\u1ECB': 'i',
	    '\u012F': 'i',
	    '\u1E2D': 'i',
	    '\u0268': 'i',
	    '\u0131': 'i',
	    '\u24D9': 'j',
	    '\uFF4A': 'j',
	    '\u0135': 'j',
	    '\u01F0': 'j',
	    '\u0249': 'j',
	    '\u24DA': 'k',
	    '\uFF4B': 'k',
	    '\u1E31': 'k',
	    '\u01E9': 'k',
	    '\u1E33': 'k',
	    '\u0137': 'k',
	    '\u1E35': 'k',
	    '\u0199': 'k',
	    '\u2C6A': 'k',
	    '\uA741': 'k',
	    '\uA743': 'k',
	    '\uA745': 'k',
	    '\uA7A3': 'k',
	    '\u24DB': 'l',
	    '\uFF4C': 'l',
	    '\u0140': 'l',
	    '\u013A': 'l',
	    '\u013E': 'l',
	    '\u1E37': 'l',
	    '\u1E39': 'l',
	    '\u013C': 'l',
	    '\u1E3D': 'l',
	    '\u1E3B': 'l',
	    '\u017F': 'l',
	    '\u0142': 'l',
	    '\u019A': 'l',
	    '\u026B': 'l',
	    '\u2C61': 'l',
	    '\uA749': 'l',
	    '\uA781': 'l',
	    '\uA747': 'l',
	    '\u01C9': 'lj',
	    '\u24DC': 'm',
	    '\uFF4D': 'm',
	    '\u1E3F': 'm',
	    '\u1E41': 'm',
	    '\u1E43': 'm',
	    '\u0271': 'm',
	    '\u026F': 'm',
	    '\u24DD': 'n',
	    '\uFF4E': 'n',
	    '\u01F9': 'n',
	    '\u0144': 'n',
	    '\u00F1': 'n',
	    '\u1E45': 'n',
	    '\u0148': 'n',
	    '\u1E47': 'n',
	    '\u0146': 'n',
	    '\u1E4B': 'n',
	    '\u1E49': 'n',
	    '\u019E': 'n',
	    '\u0272': 'n',
	    '\u0149': 'n',
	    '\uA791': 'n',
	    '\uA7A5': 'n',
	    '\u01CC': 'nj',
	    '\u24DE': 'o',
	    '\uFF4F': 'o',
	    '\u00F2': 'o',
	    '\u00F3': 'o',
	    '\u00F4': 'o',
	    '\u1ED3': 'o',
	    '\u1ED1': 'o',
	    '\u1ED7': 'o',
	    '\u1ED5': 'o',
	    '\u00F5': 'o',
	    '\u1E4D': 'o',
	    '\u022D': 'o',
	    '\u1E4F': 'o',
	    '\u014D': 'o',
	    '\u1E51': 'o',
	    '\u1E53': 'o',
	    '\u014F': 'o',
	    '\u022F': 'o',
	    '\u0231': 'o',
	    '\u00F6': 'o',
	    '\u022B': 'o',
	    '\u1ECF': 'o',
	    '\u0151': 'o',
	    '\u01D2': 'o',
	    '\u020D': 'o',
	    '\u020F': 'o',
	    '\u01A1': 'o',
	    '\u1EDD': 'o',
	    '\u1EDB': 'o',
	    '\u1EE1': 'o',
	    '\u1EDF': 'o',
	    '\u1EE3': 'o',
	    '\u1ECD': 'o',
	    '\u1ED9': 'o',
	    '\u01EB': 'o',
	    '\u01ED': 'o',
	    '\u00F8': 'o',
	    '\u01FF': 'o',
	    '\u0254': 'o',
	    '\uA74B': 'o',
	    '\uA74D': 'o',
	    '\u0275': 'o',
	    '\u0153': 'oe',
	    '\u01A3': 'oi',
	    '\u0223': 'ou',
	    '\uA74F': 'oo',
	    '\u24DF': 'p',
	    '\uFF50': 'p',
	    '\u1E55': 'p',
	    '\u1E57': 'p',
	    '\u01A5': 'p',
	    '\u1D7D': 'p',
	    '\uA751': 'p',
	    '\uA753': 'p',
	    '\uA755': 'p',
	    '\u24E0': 'q',
	    '\uFF51': 'q',
	    '\u024B': 'q',
	    '\uA757': 'q',
	    '\uA759': 'q',
	    '\u24E1': 'r',
	    '\uFF52': 'r',
	    '\u0155': 'r',
	    '\u1E59': 'r',
	    '\u0159': 'r',
	    '\u0211': 'r',
	    '\u0213': 'r',
	    '\u1E5B': 'r',
	    '\u1E5D': 'r',
	    '\u0157': 'r',
	    '\u1E5F': 'r',
	    '\u024D': 'r',
	    '\u027D': 'r',
	    '\uA75B': 'r',
	    '\uA7A7': 'r',
	    '\uA783': 'r',
	    '\u24E2': 's',
	    '\uFF53': 's',
	    '\u00DF': 's',
	    '\u015B': 's',
	    '\u1E65': 's',
	    '\u015D': 's',
	    '\u1E61': 's',
	    '\u0161': 's',
	    '\u1E67': 's',
	    '\u1E63': 's',
	    '\u1E69': 's',
	    '\u0219': 's',
	    '\u015F': 's',
	    '\u023F': 's',
	    '\uA7A9': 's',
	    '\uA785': 's',
	    '\u1E9B': 's',
	    '\u24E3': 't',
	    '\uFF54': 't',
	    '\u1E6B': 't',
	    '\u1E97': 't',
	    '\u0165': 't',
	    '\u1E6D': 't',
	    '\u021B': 't',
	    '\u0163': 't',
	    '\u1E71': 't',
	    '\u1E6F': 't',
	    '\u0167': 't',
	    '\u01AD': 't',
	    '\u0288': 't',
	    '\u2C66': 't',
	    '\uA787': 't',
	    '\uA729': 'tz',
	    '\u24E4': 'u',
	    '\uFF55': 'u',
	    '\u00F9': 'u',
	    '\u00FA': 'u',
	    '\u00FB': 'u',
	    '\u0169': 'u',
	    '\u1E79': 'u',
	    '\u016B': 'u',
	    '\u1E7B': 'u',
	    '\u016D': 'u',
	    '\u00FC': 'u',
	    '\u01DC': 'u',
	    '\u01D8': 'u',
	    '\u01D6': 'u',
	    '\u01DA': 'u',
	    '\u1EE7': 'u',
	    '\u016F': 'u',
	    '\u0171': 'u',
	    '\u01D4': 'u',
	    '\u0215': 'u',
	    '\u0217': 'u',
	    '\u01B0': 'u',
	    '\u1EEB': 'u',
	    '\u1EE9': 'u',
	    '\u1EEF': 'u',
	    '\u1EED': 'u',
	    '\u1EF1': 'u',
	    '\u1EE5': 'u',
	    '\u1E73': 'u',
	    '\u0173': 'u',
	    '\u1E77': 'u',
	    '\u1E75': 'u',
	    '\u0289': 'u',
	    '\u24E5': 'v',
	    '\uFF56': 'v',
	    '\u1E7D': 'v',
	    '\u1E7F': 'v',
	    '\u028B': 'v',
	    '\uA75F': 'v',
	    '\u028C': 'v',
	    '\uA761': 'vy',
	    '\u24E6': 'w',
	    '\uFF57': 'w',
	    '\u1E81': 'w',
	    '\u1E83': 'w',
	    '\u0175': 'w',
	    '\u1E87': 'w',
	    '\u1E85': 'w',
	    '\u1E98': 'w',
	    '\u1E89': 'w',
	    '\u2C73': 'w',
	    '\u24E7': 'x',
	    '\uFF58': 'x',
	    '\u1E8B': 'x',
	    '\u1E8D': 'x',
	    '\u24E8': 'y',
	    '\uFF59': 'y',
	    '\u1EF3': 'y',
	    '\u00FD': 'y',
	    '\u0177': 'y',
	    '\u1EF9': 'y',
	    '\u0233': 'y',
	    '\u1E8F': 'y',
	    '\u00FF': 'y',
	    '\u1EF7': 'y',
	    '\u1E99': 'y',
	    '\u1EF5': 'y',
	    '\u01B4': 'y',
	    '\u024F': 'y',
	    '\u1EFF': 'y',
	    '\u24E9': 'z',
	    '\uFF5A': 'z',
	    '\u017A': 'z',
	    '\u1E91': 'z',
	    '\u017C': 'z',
	    '\u017E': 'z',
	    '\u1E93': 'z',
	    '\u1E95': 'z',
	    '\u01B6': 'z',
	    '\u0225': 'z',
	    '\u0240': 'z',
	    '\u2C6C': 'z',
	    '\uA763': 'z',
	    '\u0386': '\u0391',
	    '\u0388': '\u0395',
	    '\u0389': '\u0397',
	    '\u038A': '\u0399',
	    '\u03AA': '\u0399',
	    '\u038C': '\u039F',
	    '\u038E': '\u03A5',
	    '\u03AB': '\u03A5',
	    '\u038F': '\u03A9',
	    '\u03AC': '\u03B1',
	    '\u03AD': '\u03B5',
	    '\u03AE': '\u03B7',
	    '\u03AF': '\u03B9',
	    '\u03CA': '\u03B9',
	    '\u0390': '\u03B9',
	    '\u03CC': '\u03BF',
	    '\u03CD': '\u03C5',
	    '\u03CB': '\u03C5',
	    '\u03B0': '\u03C5',
	    '\u03CE': '\u03C9',
	    '\u03C2': '\u03C3',
	    '\u2019': '\''
	  };
	
	  return diacritics;
	});
	
	S2.define('select2/data/base',[
	  '../utils'
	], function (Utils) {
	  function BaseAdapter ($element, options) {
	    BaseAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseAdapter, Utils.Observable);
	
	  BaseAdapter.prototype.current = function (callback) {
	    throw new Error('The `current` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.query = function (params, callback) {
	    throw new Error('The `query` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.bind = function (container, $container) {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.destroy = function () {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.generateResultId = function (container, data) {
	    var id = container.id + '-result-';
	
	    id += Utils.generateChars(4);
	
	    if (data.id != null) {
	      id += '-' + data.id.toString();
	    } else {
	      id += '-' + Utils.generateChars(4);
	    }
	    return id;
	  };
	
	  return BaseAdapter;
	});
	
	S2.define('select2/data/select',[
	  './base',
	  '../utils',
	  'jquery'
	], function (BaseAdapter, Utils, $) {
	  function SelectAdapter ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    SelectAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(SelectAdapter, BaseAdapter);
	
	  SelectAdapter.prototype.current = function (callback) {
	    var data = [];
	    var self = this;
	
	    this.$element.find(':selected').each(function () {
	      var $option = $(this);
	
	      var option = self.item($option);
	
	      data.push(option);
	    });
	
	    callback(data);
	  };
	
	  SelectAdapter.prototype.select = function (data) {
	    var self = this;
	
	    data.selected = true;
	
	    // If data.element is a DOM node, use it instead
	    if ($(data.element).is('option')) {
	      data.element.selected = true;
	
	      this.$element.trigger('input').trigger('change');
	
	      return;
	    }
	
	    if (this.$element.prop('multiple')) {
	      this.current(function (currentData) {
	        var val = [];
	
	        data = [data];
	        data.push.apply(data, currentData);
	
	        for (var d = 0; d < data.length; d++) {
	          var id = data[d].id;
	
	          if ($.inArray(id, val) === -1) {
	            val.push(id);
	          }
	        }
	
	        self.$element.val(val);
	        self.$element.trigger('input').trigger('change');
	      });
	    } else {
	      var val = data.id;
	
	      this.$element.val(val);
	      this.$element.trigger('input').trigger('change');
	    }
	  };
	
	  SelectAdapter.prototype.unselect = function (data) {
	    var self = this;
	
	    if (!this.$element.prop('multiple')) {
	      return;
	    }
	
	    data.selected = false;
	
	    if ($(data.element).is('option')) {
	      data.element.selected = false;
	
	      this.$element.trigger('input').trigger('change');
	
	      return;
	    }
	
	    this.current(function (currentData) {
	      var val = [];
	
	      for (var d = 0; d < currentData.length; d++) {
	        var id = currentData[d].id;
	
	        if (id !== data.id && $.inArray(id, val) === -1) {
	          val.push(id);
	        }
	      }
	
	      self.$element.val(val);
	
	      self.$element.trigger('input').trigger('change');
	    });
	  };
	
	  SelectAdapter.prototype.bind = function (container, $container) {
	    var self = this;
	
	    this.container = container;
	
	    container.on('select', function (params) {
	      self.select(params.data);
	    });
	
	    container.on('unselect', function (params) {
	      self.unselect(params.data);
	    });
	  };
	
	  SelectAdapter.prototype.destroy = function () {
	    // Remove anything added to child elements
	    this.$element.find('*').each(function () {
	      // Remove any custom data set by Select2
	      Utils.RemoveData(this);
	    });
	  };
	
	  SelectAdapter.prototype.query = function (params, callback) {
	    var data = [];
	    var self = this;
	
	    var $options = this.$element.children();
	
	    $options.each(function () {
	      var $option = $(this);
	
	      if (!$option.is('option') && !$option.is('optgroup')) {
	        return;
	      }
	
	      var option = self.item($option);
	
	      var matches = self.matches(params, option);
	
	      if (matches !== null) {
	        data.push(matches);
	      }
	    });
	
	    callback({
	      results: data
	    });
	  };
	
	  SelectAdapter.prototype.addOptions = function ($options) {
	    Utils.appendMany(this.$element, $options);
	  };
	
	  SelectAdapter.prototype.option = function (data) {
	    var option;
	
	    if (data.children) {
	      option = document.createElement('optgroup');
	      option.label = data.text;
	    } else {
	      option = document.createElement('option');
	
	      if (option.textContent !== undefined) {
	        option.textContent = data.text;
	      } else {
	        option.innerText = data.text;
	      }
	    }
	
	    if (data.id !== undefined) {
	      option.value = data.id;
	    }
	
	    if (data.disabled) {
	      option.disabled = true;
	    }
	
	    if (data.selected) {
	      option.selected = true;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    var $option = $(option);
	
	    var normalizedData = this._normalizeItem(data);
	    normalizedData.element = option;
	
	    // Override the option's data with the combined data
	    Utils.StoreData(option, 'data', normalizedData);
	
	    return $option;
	  };
	
	  SelectAdapter.prototype.item = function ($option) {
	    var data = {};
	
	    data = Utils.GetData($option[0], 'data');
	
	    if (data != null) {
	      return data;
	    }
	
	    if ($option.is('option')) {
	      data = {
	        id: $option.val(),
	        text: $option.text(),
	        disabled: $option.prop('disabled'),
	        selected: $option.prop('selected'),
	        title: $option.prop('title')
	      };
	    } else if ($option.is('optgroup')) {
	      data = {
	        text: $option.prop('label'),
	        children: [],
	        title: $option.prop('title')
	      };
	
	      var $children = $option.children('option');
	      var children = [];
	
	      for (var c = 0; c < $children.length; c++) {
	        var $child = $($children[c]);
	
	        var child = this.item($child);
	
	        children.push(child);
	      }
	
	      data.children = children;
	    }
	
	    data = this._normalizeItem(data);
	    data.element = $option[0];
	
	    Utils.StoreData($option[0], 'data', data);
	
	    return data;
	  };
	
	  SelectAdapter.prototype._normalizeItem = function (item) {
	    if (item !== Object(item)) {
	      item = {
	        id: item,
	        text: item
	      };
	    }
	
	    item = $.extend({}, {
	      text: ''
	    }, item);
	
	    var defaults = {
	      selected: false,
	      disabled: false
	    };
	
	    if (item.id != null) {
	      item.id = item.id.toString();
	    }
	
	    if (item.text != null) {
	      item.text = item.text.toString();
	    }
	
	    if (item._resultId == null && item.id && this.container != null) {
	      item._resultId = this.generateResultId(this.container, item);
	    }
	
	    return $.extend({}, defaults, item);
	  };
	
	  SelectAdapter.prototype.matches = function (params, data) {
	    var matcher = this.options.get('matcher');
	
	    return matcher(params, data);
	  };
	
	  return SelectAdapter;
	});
	
	S2.define('select2/data/array',[
	  './select',
	  '../utils',
	  'jquery'
	], function (SelectAdapter, Utils, $) {
	  function ArrayAdapter ($element, options) {
	    this._dataToConvert = options.get('data') || [];
	
	    ArrayAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(ArrayAdapter, SelectAdapter);
	
	  ArrayAdapter.prototype.bind = function (container, $container) {
	    ArrayAdapter.__super__.bind.call(this, container, $container);
	
	    this.addOptions(this.convertToOptions(this._dataToConvert));
	  };
	
	  ArrayAdapter.prototype.select = function (data) {
	    var $option = this.$element.find('option').filter(function (i, elm) {
	      return elm.value == data.id.toString();
	    });
	
	    if ($option.length === 0) {
	      $option = this.option(data);
	
	      this.addOptions($option);
	    }
	
	    ArrayAdapter.__super__.select.call(this, data);
	  };
	
	  ArrayAdapter.prototype.convertToOptions = function (data) {
	    var self = this;
	
	    var $existing = this.$element.find('option');
	    var existingIds = $existing.map(function () {
	      return self.item($(this)).id;
	    }).get();
	
	    var $options = [];
	
	    // Filter out all items except for the one passed in the argument
	    function onlyItem (item) {
	      return function () {
	        return $(this).val() == item.id;
	      };
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      var item = this._normalizeItem(data[d]);
	
	      // Skip items which were pre-loaded, only merge the data
	      if ($.inArray(item.id, existingIds) >= 0) {
	        var $existingOption = $existing.filter(onlyItem(item));
	
	        var existingData = this.item($existingOption);
	        var newData = $.extend(true, {}, item, existingData);
	
	        var $newOption = this.option(newData);
	
	        $existingOption.replaceWith($newOption);
	
	        continue;
	      }
	
	      var $option = this.option(item);
	
	      if (item.children) {
	        var $children = this.convertToOptions(item.children);
	
	        Utils.appendMany($option, $children);
	      }
	
	      $options.push($option);
	    }
	
	    return $options;
	  };
	
	  return ArrayAdapter;
	});
	
	S2.define('select2/data/ajax',[
	  './array',
	  '../utils',
	  'jquery'
	], function (ArrayAdapter, Utils, $) {
	  function AjaxAdapter ($element, options) {
	    this.ajaxOptions = this._applyDefaults(options.get('ajax'));
	
	    if (this.ajaxOptions.processResults != null) {
	      this.processResults = this.ajaxOptions.processResults;
	    }
	
	    AjaxAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(AjaxAdapter, ArrayAdapter);
	
	  AjaxAdapter.prototype._applyDefaults = function (options) {
	    var defaults = {
	      data: function (params) {
	        return $.extend({}, params, {
	          q: params.term
	        });
	      },
	      transport: function (params, success, failure) {
	        var $request = $.ajax(params);
	
	        $request.then(success);
	        $request.fail(failure);
	
	        return $request;
	      }
	    };
	
	    return $.extend({}, defaults, options, true);
	  };
	
	  AjaxAdapter.prototype.processResults = function (results) {
	    return results;
	  };
	
	  AjaxAdapter.prototype.query = function (params, callback) {
	    var matches = [];
	    var self = this;
	
	    if (this._request != null) {
	      // JSONP requests cannot always be aborted
	      if ($.isFunction(this._request.abort)) {
	        this._request.abort();
	      }
	
	      this._request = null;
	    }
	
	    var options = $.extend({
	      type: 'GET'
	    }, this.ajaxOptions);
	
	    if (typeof options.url === 'function') {
	      options.url = options.url.call(this.$element, params);
	    }
	
	    if (typeof options.data === 'function') {
	      options.data = options.data.call(this.$element, params);
	    }
	
	    function request () {
	      var $request = options.transport(options, function (data) {
	        var results = self.processResults(data, params);
	
	        if (self.options.get('debug') && window.console && console.error) {
	          // Check to make sure that the response included a `results` key.
	          if (!results || !results.results || !$.isArray(results.results)) {
	            console.error(
	              'Select2: The AJAX results did not return an array in the ' +
	              '`results` key of the response.'
	            );
	          }
	        }
	
	        callback(results);
	      }, function () {
	        // Attempt to detect if a request was aborted
	        // Only works if the transport exposes a status property
	        if ('status' in $request &&
	            ($request.status === 0 || $request.status === '0')) {
	          return;
	        }
	
	        self.trigger('results:message', {
	          message: 'errorLoading'
	        });
	      });
	
	      self._request = $request;
	    }
	
	    if (this.ajaxOptions.delay && params.term != null) {
	      if (this._queryTimeout) {
	        window.clearTimeout(this._queryTimeout);
	      }
	
	      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
	    } else {
	      request();
	    }
	  };
	
	  return AjaxAdapter;
	});
	
	S2.define('select2/data/tags',[
	  'jquery'
	], function ($) {
	  function Tags (decorated, $element, options) {
	    var tags = options.get('tags');
	
	    var createTag = options.get('createTag');
	
	    if (createTag !== undefined) {
	      this.createTag = createTag;
	    }
	
	    var insertTag = options.get('insertTag');
	
	    if (insertTag !== undefined) {
	        this.insertTag = insertTag;
	    }
	
	    decorated.call(this, $element, options);
	
	    if ($.isArray(tags)) {
	      for (var t = 0; t < tags.length; t++) {
	        var tag = tags[t];
	        var item = this._normalizeItem(tag);
	
	        var $option = this.option(item);
	
	        this.$element.append($option);
	      }
	    }
	  }
	
	  Tags.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    this._removeOldTags();
	
	    if (params.term == null || params.page != null) {
	      decorated.call(this, params, callback);
	      return;
	    }
	
	    function wrapper (obj, child) {
	      var data = obj.results;
	
	      for (var i = 0; i < data.length; i++) {
	        var option = data[i];
	
	        var checkChildren = (
	          option.children != null &&
	          !wrapper({
	            results: option.children
	          }, true)
	        );
	
	        var optionText = (option.text || '').toUpperCase();
	        var paramsTerm = (params.term || '').toUpperCase();
	
	        var checkText = optionText === paramsTerm;
	
	        if (checkText || checkChildren) {
	          if (child) {
	            return false;
	          }
	
	          obj.data = data;
	          callback(obj);
	
	          return;
	        }
	      }
	
	      if (child) {
	        return true;
	      }
	
	      var tag = self.createTag(params);
	
	      if (tag != null) {
	        var $option = self.option(tag);
	        $option.attr('data-select2-tag', true);
	
	        self.addOptions([$option]);
	
	        self.insertTag(data, tag);
	      }
	
	      obj.results = data;
	
	      callback(obj);
	    }
	
	    decorated.call(this, params, wrapper);
	  };
	
	  Tags.prototype.createTag = function (decorated, params) {
	    var term = $.trim(params.term);
	
	    if (term === '') {
	      return null;
	    }
	
	    return {
	      id: term,
	      text: term
	    };
	  };
	
	  Tags.prototype.insertTag = function (_, data, tag) {
	    data.unshift(tag);
	  };
	
	  Tags.prototype._removeOldTags = function (_) {
	    var $options = this.$element.find('option[data-select2-tag]');
	
	    $options.each(function () {
	      if (this.selected) {
	        return;
	      }
	
	      $(this).remove();
	    });
	  };
	
	  return Tags;
	});
	
	S2.define('select2/data/tokenizer',[
	  'jquery'
	], function ($) {
	  function Tokenizer (decorated, $element, options) {
	    var tokenizer = options.get('tokenizer');
	
	    if (tokenizer !== undefined) {
	      this.tokenizer = tokenizer;
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  Tokenizer.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    this.$search =  container.dropdown.$search || container.selection.$search ||
	      $container.find('.select2-search__field');
	  };
	
	  Tokenizer.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    function createAndSelect (data) {
	      // Normalize the data object so we can use it for checks
	      var item = self._normalizeItem(data);
	
	      // Check if the data object already exists as a tag
	      // Select it if it doesn't
	      var $existingOptions = self.$element.find('option').filter(function () {
	        return $(this).val() === item.id;
	      });
	
	      // If an existing option wasn't found for it, create the option
	      if (!$existingOptions.length) {
	        var $option = self.option(item);
	        $option.attr('data-select2-tag', true);
	
	        self._removeOldTags();
	        self.addOptions([$option]);
	      }
	
	      // Select the item, now that we know there is an option for it
	      select(item);
	    }
	
	    function select (data) {
	      self.trigger('select', {
	        data: data
	      });
	    }
	
	    params.term = params.term || '';
	
	    var tokenData = this.tokenizer(params, this.options, createAndSelect);
	
	    if (tokenData.term !== params.term) {
	      // Replace the search term if we have the search box
	      if (this.$search.length) {
	        this.$search.val(tokenData.term);
	        this.$search.trigger('focus');
	      }
	
	      params.term = tokenData.term;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
	    var separators = options.get('tokenSeparators') || [];
	    var term = params.term;
	    var i = 0;
	
	    var createTag = this.createTag || function (params) {
	      return {
	        id: params.term,
	        text: params.term
	      };
	    };
	
	    while (i < term.length) {
	      var termChar = term[i];
	
	      if ($.inArray(termChar, separators) === -1) {
	        i++;
	
	        continue;
	      }
	
	      var part = term.substr(0, i);
	      var partParams = $.extend({}, params, {
	        term: part
	      });
	
	      var data = createTag(partParams);
	
	      if (data == null) {
	        i++;
	        continue;
	      }
	
	      callback(data);
	
	      // Reset the term to not include the tokenized portion
	      term = term.substr(i + 1) || '';
	      i = 0;
	    }
	
	    return {
	      term: term
	    };
	  };
	
	  return Tokenizer;
	});
	
	S2.define('select2/data/minimumInputLength',[
	
	], function () {
	  function MinimumInputLength (decorated, $e, options) {
	    this.minimumInputLength = options.get('minimumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MinimumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (params.term.length < this.minimumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooShort',
	        args: {
	          minimum: this.minimumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MinimumInputLength;
	});
	
	S2.define('select2/data/maximumInputLength',[
	
	], function () {
	  function MaximumInputLength (decorated, $e, options) {
	    this.maximumInputLength = options.get('maximumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (this.maximumInputLength > 0 &&
	        params.term.length > this.maximumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooLong',
	        args: {
	          maximum: this.maximumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MaximumInputLength;
	});
	
	S2.define('select2/data/maximumSelectionLength',[
	
	], function (){
	  function MaximumSelectionLength (decorated, $e, options) {
	    this.maximumSelectionLength = options.get('maximumSelectionLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumSelectionLength.prototype.bind =
	    function (decorated, container, $container) {
	      var self = this;
	
	      decorated.call(this, container, $container);
	
	      container.on('select', function () {
	        self._checkIfMaximumSelected();
	      });
	  };
	
	  MaximumSelectionLength.prototype.query =
	    function (decorated, params, callback) {
	      var self = this;
	
	      this._checkIfMaximumSelected(function () {
	        decorated.call(self, params, callback);
	      });
	  };
	
	  MaximumSelectionLength.prototype._checkIfMaximumSelected =
	    function (_, successCallback) {
	      var self = this;
	
	      this.current(function (currentData) {
	        var count = currentData != null ? currentData.length : 0;
	        if (self.maximumSelectionLength > 0 &&
	          count >= self.maximumSelectionLength) {
	          self.trigger('results:message', {
	            message: 'maximumSelected',
	            args: {
	              maximum: self.maximumSelectionLength
	            }
	          });
	          return;
	        }
	
	        if (successCallback) {
	          successCallback();
	        }
	      });
	  };
	
	  return MaximumSelectionLength;
	});
	
	S2.define('select2/dropdown',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Dropdown ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    Dropdown.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Dropdown, Utils.Observable);
	
	  Dropdown.prototype.render = function () {
	    var $dropdown = $(
	      '<span class="select2-dropdown">' +
	        '<span class="select2-results"></span>' +
	      '</span>'
	    );
	
	    $dropdown.attr('dir', this.options.get('dir'));
	
	    this.$dropdown = $dropdown;
	
	    return $dropdown;
	  };
	
	  Dropdown.prototype.bind = function () {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.position = function ($dropdown, $container) {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.destroy = function () {
	    // Remove the dropdown from the DOM
	    this.$dropdown.remove();
	  };
	
	  return Dropdown;
	});
	
	S2.define('select2/dropdown/search',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function Search () { }
	
	  Search.prototype.render = function (decorated) {
	    var $rendered = decorated.call(this);
	
	    var $search = $(
	      '<span class="select2-search select2-search--dropdown">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
	        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
	      '</span>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    $rendered.prepend($search);
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    decorated.call(this, container, $container);
	
	    this.$search.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	    });
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$search.on('input', function (evt) {
	      // Unbind the duplicated `keyup` event
	      $(this).off('keyup');
	    });
	
	    this.$search.on('keyup input', function (evt) {
	      self.handleSearch(evt);
	    });
	
	    container.on('open', function () {
	      self.$search.attr('tabindex', 0);
	      self.$search.attr('aria-controls', resultsId);
	
	      self.$search.trigger('focus');
	
	      window.setTimeout(function () {
	        self.$search.trigger('focus');
	      }, 0);
	    });
	
	    container.on('close', function () {
	      self.$search.attr('tabindex', -1);
	      self.$search.removeAttr('aria-controls');
	      self.$search.removeAttr('aria-activedescendant');
	
	      self.$search.val('');
	      self.$search.trigger('blur');
	    });
	
	    container.on('focus', function () {
	      if (!container.isOpen()) {
	        self.$search.trigger('focus');
	      }
	    });
	
	    container.on('results:all', function (params) {
	      if (params.query.term == null || params.query.term === '') {
	        var showSearch = self.showSearch(params);
	
	        if (showSearch) {
	          self.$searchContainer.removeClass('select2-search--hide');
	        } else {
	          self.$searchContainer.addClass('select2-search--hide');
	        }
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      if (params.data._resultId) {
	        self.$search.attr('aria-activedescendant', params.data._resultId);
	      } else {
	        self.$search.removeAttr('aria-activedescendant');
	      }
	    });
	  };
	
	  Search.prototype.handleSearch = function (evt) {
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.showSearch = function (_, params) {
	    return true;
	  };
	
	  return Search;
	});
	
	S2.define('select2/dropdown/hidePlaceholder',[
	
	], function () {
	  function HidePlaceholder (decorated, $element, options, dataAdapter) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  HidePlaceholder.prototype.append = function (decorated, data) {
	    data.results = this.removePlaceholder(data.results);
	
	    decorated.call(this, data);
	  };
	
	  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
	    var modifiedData = data.slice(0);
	
	    for (var d = data.length - 1; d >= 0; d--) {
	      var item = data[d];
	
	      if (this.placeholder.id === item.id) {
	        modifiedData.splice(d, 1);
	      }
	    }
	
	    return modifiedData;
	  };
	
	  return HidePlaceholder;
	});
	
	S2.define('select2/dropdown/infiniteScroll',[
	  'jquery'
	], function ($) {
	  function InfiniteScroll (decorated, $element, options, dataAdapter) {
	    this.lastParams = {};
	
	    decorated.call(this, $element, options, dataAdapter);
	
	    this.$loadingMore = this.createLoadingMore();
	    this.loading = false;
	  }
	
	  InfiniteScroll.prototype.append = function (decorated, data) {
	    this.$loadingMore.remove();
	    this.loading = false;
	
	    decorated.call(this, data);
	
	    if (this.showLoadingMore(data)) {
	      this.$results.append(this.$loadingMore);
	      this.loadMoreIfNeeded();
	    }
	  };
	
	  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('query', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    container.on('query:append', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    this.$results.on('scroll', this.loadMoreIfNeeded.bind(this));
	  };
	
	  InfiniteScroll.prototype.loadMoreIfNeeded = function () {
	    var isLoadMoreVisible = $.contains(
	      document.documentElement,
	      this.$loadingMore[0]
	    );
	
	    if (this.loading || !isLoadMoreVisible) {
	      return;
	    }
	
	    var currentOffset = this.$results.offset().top +
	      this.$results.outerHeight(false);
	    var loadingMoreOffset = this.$loadingMore.offset().top +
	      this.$loadingMore.outerHeight(false);
	
	    if (currentOffset + 50 >= loadingMoreOffset) {
	      this.loadMore();
	    }
	  };
	
	  InfiniteScroll.prototype.loadMore = function () {
	    this.loading = true;
	
	    var params = $.extend({}, {page: 1}, this.lastParams);
	
	    params.page++;
	
	    this.trigger('query:append', params);
	  };
	
	  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
	    return data.pagination && data.pagination.more;
	  };
	
	  InfiniteScroll.prototype.createLoadingMore = function () {
	    var $option = $(
	      '<li ' +
	      'class="select2-results__option select2-results__option--load-more"' +
	      'role="option" aria-disabled="true"></li>'
	    );
	
	    var message = this.options.get('translations').get('loadingMore');
	
	    $option.html(message(this.lastParams));
	
	    return $option;
	  };
	
	  return InfiniteScroll;
	});
	
	S2.define('select2/dropdown/attachBody',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function AttachBody (decorated, $element, options) {
	    this.$dropdownParent = $(options.get('dropdownParent') || document.body);
	
	    decorated.call(this, $element, options);
	  }
	
	  AttachBody.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self._showDropdown();
	      self._attachPositioningHandler(container);
	
	      // Must bind after the results handlers to ensure correct sizing
	      self._bindContainerResultHandlers(container);
	    });
	
	    container.on('close', function () {
	      self._hideDropdown();
	      self._detachPositioningHandler(container);
	    });
	
	    this.$dropdownContainer.on('mousedown', function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  AttachBody.prototype.destroy = function (decorated) {
	    decorated.call(this);
	
	    this.$dropdownContainer.remove();
	  };
	
	  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
	    // Clone all of the container classes
	    $dropdown.attr('class', $container.attr('class'));
	
	    $dropdown.removeClass('select2');
	    $dropdown.addClass('select2-container--open');
	
	    $dropdown.css({
	      position: 'absolute',
	      top: -999999
	    });
	
	    this.$container = $container;
	  };
	
	  AttachBody.prototype.render = function (decorated) {
	    var $container = $('<span></span>');
	
	    var $dropdown = decorated.call(this);
	    $container.append($dropdown);
	
	    this.$dropdownContainer = $container;
	
	    return $container;
	  };
	
	  AttachBody.prototype._hideDropdown = function (decorated) {
	    this.$dropdownContainer.detach();
	  };
	
	  AttachBody.prototype._bindContainerResultHandlers =
	      function (decorated, container) {
	
	    // These should only be bound once
	    if (this._containerResultsHandlersBound) {
	      return;
	    }
	
	    var self = this;
	
	    container.on('results:all', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('results:append', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('results:message', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('select', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('unselect', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    this._containerResultsHandlersBound = true;
	  };
	
	  AttachBody.prototype._attachPositioningHandler =
	      function (decorated, container) {
	    var self = this;
	
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.each(function () {
	      Utils.StoreData(this, 'select2-scroll-position', {
	        x: $(this).scrollLeft(),
	        y: $(this).scrollTop()
	      });
	    });
	
	    $watchers.on(scrollEvent, function (ev) {
	      var position = Utils.GetData(this, 'select2-scroll-position');
	      $(this).scrollTop(position.y);
	    });
	
	    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
	      function (e) {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	  };
	
	  AttachBody.prototype._detachPositioningHandler =
	      function (decorated, container) {
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.off(scrollEvent);
	
	    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
	  };
	
	  AttachBody.prototype._positionDropdown = function () {
	    var $window = $(window);
	
	    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
	    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	
	    var newDirection = null;
	
	    var offset = this.$container.offset();
	
	    offset.bottom = offset.top + this.$container.outerHeight(false);
	
	    var container = {
	      height: this.$container.outerHeight(false)
	    };
	
	    container.top = offset.top;
	    container.bottom = offset.top + container.height;
	
	    var dropdown = {
	      height: this.$dropdown.outerHeight(false)
	    };
	
	    var viewport = {
	      top: $window.scrollTop(),
	      bottom: $window.scrollTop() + $window.height()
	    };
	
	    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
	    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
	
	    var css = {
	      left: offset.left,
	      top: container.bottom
	    };
	
	    // Determine what the parent element is to use for calculating the offset
	    var $offsetParent = this.$dropdownParent;
	
	    // For statically positioned elements, we need to get the element
	    // that is determining the offset
	    if ($offsetParent.css('position') === 'static') {
	      $offsetParent = $offsetParent.offsetParent();
	    }
	
	    var parentOffset = {
	      top: 0,
	      left: 0
	    };
	
	    if (
	      $.contains(document.body, $offsetParent[0]) ||
	      $offsetParent[0].isConnected
	      ) {
	      parentOffset = $offsetParent.offset();
	    }
	
	    css.top -= parentOffset.top;
	    css.left -= parentOffset.left;
	
	    if (!isCurrentlyAbove && !isCurrentlyBelow) {
	      newDirection = 'below';
	    }
	
	    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
	      newDirection = 'above';
	    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
	      newDirection = 'below';
	    }
	
	    if (newDirection == 'above' ||
	      (isCurrentlyAbove && newDirection !== 'below')) {
	      css.top = container.top - parentOffset.top - dropdown.height;
	    }
	
	    if (newDirection != null) {
	      this.$dropdown
	        .removeClass('select2-dropdown--below select2-dropdown--above')
	        .addClass('select2-dropdown--' + newDirection);
	      this.$container
	        .removeClass('select2-container--below select2-container--above')
	        .addClass('select2-container--' + newDirection);
	    }
	
	    this.$dropdownContainer.css(css);
	  };
	
	  AttachBody.prototype._resizeDropdown = function () {
	    var css = {
	      width: this.$container.outerWidth(false) + 'px'
	    };
	
	    if (this.options.get('dropdownAutoWidth')) {
	      css.minWidth = css.width;
	      css.position = 'relative';
	      css.width = 'auto';
	    }
	
	    this.$dropdown.css(css);
	  };
	
	  AttachBody.prototype._showDropdown = function (decorated) {
	    this.$dropdownContainer.appendTo(this.$dropdownParent);
	
	    this._positionDropdown();
	    this._resizeDropdown();
	  };
	
	  return AttachBody;
	});
	
	S2.define('select2/dropdown/minimumResultsForSearch',[
	
	], function () {
	  function countResults (data) {
	    var count = 0;
	
	    for (var d = 0; d < data.length; d++) {
	      var item = data[d];
	
	      if (item.children) {
	        count += countResults(item.children);
	      } else {
	        count++;
	      }
	    }
	
	    return count;
	  }
	
	  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
	    this.minimumResultsForSearch = options.get('minimumResultsForSearch');
	
	    if (this.minimumResultsForSearch < 0) {
	      this.minimumResultsForSearch = Infinity;
	    }
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
	    if (countResults(params.data.results) < this.minimumResultsForSearch) {
	      return false;
	    }
	
	    return decorated.call(this, params);
	  };
	
	  return MinimumResultsForSearch;
	});
	
	S2.define('select2/dropdown/selectOnClose',[
	  '../utils'
	], function (Utils) {
	  function SelectOnClose () { }
	
	  SelectOnClose.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('close', function (params) {
	      self._handleSelectOnClose(params);
	    });
	  };
	
	  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
	    if (params && params.originalSelect2Event != null) {
	      var event = params.originalSelect2Event;
	
	      // Don't select an item if the close event was triggered from a select or
	      // unselect event
	      if (event._type === 'select' || event._type === 'unselect') {
	        return;
	      }
	    }
	
	    var $highlightedResults = this.getHighlightedResults();
	
	    // Only select highlighted results
	    if ($highlightedResults.length < 1) {
	      return;
	    }
	
	    var data = Utils.GetData($highlightedResults[0], 'data');
	
	    // Don't re-select already selected resulte
	    if (
	      (data.element != null && data.element.selected) ||
	      (data.element == null && data.selected)
	    ) {
	      return;
	    }
	
	    this.trigger('select', {
	        data: data
	    });
	  };
	
	  return SelectOnClose;
	});
	
	S2.define('select2/dropdown/closeOnSelect',[
	
	], function () {
	  function CloseOnSelect () { }
	
	  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('select', function (evt) {
	      self._selectTriggered(evt);
	    });
	
	    container.on('unselect', function (evt) {
	      self._selectTriggered(evt);
	    });
	  };
	
	  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
	    var originalEvent = evt.originalEvent;
	
	    // Don't close if the control key is being held
	    if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
	      return;
	    }
	
	    this.trigger('close', {
	      originalEvent: originalEvent,
	      originalSelect2Event: evt
	    });
	  };
	
	  return CloseOnSelect;
	});
	
	S2.define('select2/i18n/en',[],function () {
	  // English
	  return {
	    errorLoading: function () {
	      return 'The results could not be loaded.';
	    },
	    inputTooLong: function (args) {
	      var overChars = args.input.length - args.maximum;
	
	      var message = 'Please delete ' + overChars + ' character';
	
	      if (overChars != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    inputTooShort: function (args) {
	      var remainingChars = args.minimum - args.input.length;
	
	      var message = 'Please enter ' + remainingChars + ' or more characters';
	
	      return message;
	    },
	    loadingMore: function () {
	      return 'Loading more results…';
	    },
	    maximumSelected: function (args) {
	      var message = 'You can only select ' + args.maximum + ' item';
	
	      if (args.maximum != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    noResults: function () {
	      return 'No results found';
	    },
	    searching: function () {
	      return 'Searching…';
	    },
	    removeAllItems: function () {
	      return 'Remove all items';
	    }
	  };
	});
	
	S2.define('select2/defaults',[
	  'jquery',
	  'require',
	
	  './results',
	
	  './selection/single',
	  './selection/multiple',
	  './selection/placeholder',
	  './selection/allowClear',
	  './selection/search',
	  './selection/eventRelay',
	
	  './utils',
	  './translation',
	  './diacritics',
	
	  './data/select',
	  './data/array',
	  './data/ajax',
	  './data/tags',
	  './data/tokenizer',
	  './data/minimumInputLength',
	  './data/maximumInputLength',
	  './data/maximumSelectionLength',
	
	  './dropdown',
	  './dropdown/search',
	  './dropdown/hidePlaceholder',
	  './dropdown/infiniteScroll',
	  './dropdown/attachBody',
	  './dropdown/minimumResultsForSearch',
	  './dropdown/selectOnClose',
	  './dropdown/closeOnSelect',
	
	  './i18n/en'
	], function ($, require,
	
	             ResultsList,
	
	             SingleSelection, MultipleSelection, Placeholder, AllowClear,
	             SelectionSearch, EventRelay,
	
	             Utils, Translation, DIACRITICS,
	
	             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
	             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,
	
	             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
	             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,
	
	             EnglishTranslation) {
	  function Defaults () {
	    this.reset();
	  }
	
	  Defaults.prototype.apply = function (options) {
	    options = $.extend(true, {}, this.defaults, options);
	
	    if (options.dataAdapter == null) {
	      if (options.ajax != null) {
	        options.dataAdapter = AjaxData;
	      } else if (options.data != null) {
	        options.dataAdapter = ArrayData;
	      } else {
	        options.dataAdapter = SelectData;
	      }
	
	      if (options.minimumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MinimumInputLength
	        );
	      }
	
	      if (options.maximumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumInputLength
	        );
	      }
	
	      if (options.maximumSelectionLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumSelectionLength
	        );
	      }
	
	      if (options.tags) {
	        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
	      }
	
	      if (options.tokenSeparators != null || options.tokenizer != null) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Tokenizer
	        );
	      }
	
	      if (options.query != null) {
	        var Query = require(options.amdBase + 'compat/query');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Query
	        );
	      }
	
	      if (options.initSelection != null) {
	        var InitSelection = require(options.amdBase + 'compat/initSelection');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          InitSelection
	        );
	      }
	    }
	
	    if (options.resultsAdapter == null) {
	      options.resultsAdapter = ResultsList;
	
	      if (options.ajax != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          InfiniteScroll
	        );
	      }
	
	      if (options.placeholder != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          HidePlaceholder
	        );
	      }
	
	      if (options.selectOnClose) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          SelectOnClose
	        );
	      }
	    }
	
	    if (options.dropdownAdapter == null) {
	      if (options.multiple) {
	        options.dropdownAdapter = Dropdown;
	      } else {
	        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
	
	        options.dropdownAdapter = SearchableDropdown;
	      }
	
	      if (options.minimumResultsForSearch !== 0) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          MinimumResultsForSearch
	        );
	      }
	
	      if (options.closeOnSelect) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          CloseOnSelect
	        );
	      }
	
	      if (
	        options.dropdownCssClass != null ||
	        options.dropdownCss != null ||
	        options.adaptDropdownCssClass != null
	      ) {
	        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');
	
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          DropdownCSS
	        );
	      }
	
	      options.dropdownAdapter = Utils.Decorate(
	        options.dropdownAdapter,
	        AttachBody
	      );
	    }
	
	    if (options.selectionAdapter == null) {
	      if (options.multiple) {
	        options.selectionAdapter = MultipleSelection;
	      } else {
	        options.selectionAdapter = SingleSelection;
	      }
	
	      // Add the placeholder mixin if a placeholder was specified
	      if (options.placeholder != null) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          Placeholder
	        );
	      }
	
	      if (options.allowClear) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          AllowClear
	        );
	      }
	
	      if (options.multiple) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          SelectionSearch
	        );
	      }
	
	      if (
	        options.containerCssClass != null ||
	        options.containerCss != null ||
	        options.adaptContainerCssClass != null
	      ) {
	        var ContainerCSS = require(options.amdBase + 'compat/containerCss');
	
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          ContainerCSS
	        );
	      }
	
	      options.selectionAdapter = Utils.Decorate(
	        options.selectionAdapter,
	        EventRelay
	      );
	    }
	
	    // If the defaults were not previously applied from an element, it is
	    // possible for the language option to have not been resolved
	    options.language = this._resolveLanguage(options.language);
	
	    // Always fall back to English since it will always be complete
	    options.language.push('en');
	
	    var uniqueLanguages = [];
	
	    for (var l = 0; l < options.language.length; l++) {
	      var language = options.language[l];
	
	      if (uniqueLanguages.indexOf(language) === -1) {
	        uniqueLanguages.push(language);
	      }
	    }
	
	    options.language = uniqueLanguages;
	
	    options.translations = this._processTranslations(
	      options.language,
	      options.debug
	    );
	
	    return options;
	  };
	
	  Defaults.prototype.reset = function () {
	    function stripDiacritics (text) {
	      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	      function match(a) {
	        return DIACRITICS[a] || a;
	      }
	
	      return text.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function matcher (params, data) {
	      // Always return the object if there is nothing to compare
	      if ($.trim(params.term) === '') {
	        return data;
	      }
	
	      // Do a recursive check for options with children
	      if (data.children && data.children.length > 0) {
	        // Clone the data object if there are children
	        // This is required as we modify the object to remove any non-matches
	        var match = $.extend(true, {}, data);
	
	        // Check each child of the option
	        for (var c = data.children.length - 1; c >= 0; c--) {
	          var child = data.children[c];
	
	          var matches = matcher(params, child);
	
	          // If there wasn't a match, remove the object in the array
	          if (matches == null) {
	            match.children.splice(c, 1);
	          }
	        }
	
	        // If any children matched, return the new object
	        if (match.children.length > 0) {
	          return match;
	        }
	
	        // If there were no matching children, check just the plain object
	        return matcher(params, match);
	      }
	
	      var original = stripDiacritics(data.text).toUpperCase();
	      var term = stripDiacritics(params.term).toUpperCase();
	
	      // Check if the text contains the term
	      if (original.indexOf(term) > -1) {
	        return data;
	      }
	
	      // If it doesn't contain the term, don't return anything
	      return null;
	    }
	
	    this.defaults = {
	      amdBase: './',
	      amdLanguageBase: './i18n/',
	      closeOnSelect: true,
	      debug: false,
	      dropdownAutoWidth: false,
	      escapeMarkup: Utils.escapeMarkup,
	      language: {},
	      matcher: matcher,
	      minimumInputLength: 0,
	      maximumInputLength: 0,
	      maximumSelectionLength: 0,
	      minimumResultsForSearch: 0,
	      selectOnClose: false,
	      scrollAfterSelect: false,
	      sorter: function (data) {
	        return data;
	      },
	      templateResult: function (result) {
	        return result.text;
	      },
	      templateSelection: function (selection) {
	        return selection.text;
	      },
	      theme: 'default',
	      width: 'resolve'
	    };
	  };
	
	  Defaults.prototype.applyFromElement = function (options, $element) {
	    var optionLanguage = options.language;
	    var defaultLanguage = this.defaults.language;
	    var elementLanguage = $element.prop('lang');
	    var parentLanguage = $element.closest('[lang]').prop('lang');
	
	    var languages = Array.prototype.concat.call(
	      this._resolveLanguage(elementLanguage),
	      this._resolveLanguage(optionLanguage),
	      this._resolveLanguage(defaultLanguage),
	      this._resolveLanguage(parentLanguage)
	    );
	
	    options.language = languages;
	
	    return options;
	  };
	
	  Defaults.prototype._resolveLanguage = function (language) {
	    if (!language) {
	      return [];
	    }
	
	    if ($.isEmptyObject(language)) {
	      return [];
	    }
	
	    if ($.isPlainObject(language)) {
	      return [language];
	    }
	
	    var languages;
	
	    if (!$.isArray(language)) {
	      languages = [language];
	    } else {
	      languages = language;
	    }
	
	    var resolvedLanguages = [];
	
	    for (var l = 0; l < languages.length; l++) {
	      resolvedLanguages.push(languages[l]);
	
	      if (typeof languages[l] === 'string' && languages[l].indexOf('-') > 0) {
	        // Extract the region information if it is included
	        var languageParts = languages[l].split('-');
	        var baseLanguage = languageParts[0];
	
	        resolvedLanguages.push(baseLanguage);
	      }
	    }
	
	    return resolvedLanguages;
	  };
	
	  Defaults.prototype._processTranslations = function (languages, debug) {
	    var translations = new Translation();
	
	    for (var l = 0; l < languages.length; l++) {
	      var languageData = new Translation();
	
	      var language = languages[l];
	
	      if (typeof language === 'string') {
	        try {
	          // Try to load it with the original name
	          languageData = Translation.loadPath(language);
	        } catch (e) {
	          try {
	            // If we couldn't load it, check if it wasn't the full path
	            language = this.defaults.amdLanguageBase + language;
	            languageData = Translation.loadPath(language);
	          } catch (ex) {
	            // The translation could not be loaded at all. Sometimes this is
	            // because of a configuration problem, other times this can be
	            // because of how Select2 helps load all possible translation files
	            if (debug && window.console && console.warn) {
	              console.warn(
	                'Select2: The language file for "' + language + '" could ' +
	                'not be automatically loaded. A fallback will be used instead.'
	              );
	            }
	          }
	        }
	      } else if ($.isPlainObject(language)) {
	        languageData = new Translation(language);
	      } else {
	        languageData = language;
	      }
	
	      translations.extend(languageData);
	    }
	
	    return translations;
	  };
	
	  Defaults.prototype.set = function (key, value) {
	    var camelKey = $.camelCase(key);
	
	    var data = {};
	    data[camelKey] = value;
	
	    var convertedData = Utils._convertData(data);
	
	    $.extend(true, this.defaults, convertedData);
	  };
	
	  var defaults = new Defaults();
	
	  return defaults;
	});
	
	S2.define('select2/options',[
	  'require',
	  'jquery',
	  './defaults',
	  './utils'
	], function (require, $, Defaults, Utils) {
	  function Options (options, $element) {
	    this.options = options;
	
	    if ($element != null) {
	      this.fromElement($element);
	    }
	
	    if ($element != null) {
	      this.options = Defaults.applyFromElement(this.options, $element);
	    }
	
	    this.options = Defaults.apply(this.options);
	
	    if ($element && $element.is('input')) {
	      var InputCompat = require(this.get('amdBase') + 'compat/inputData');
	
	      this.options.dataAdapter = Utils.Decorate(
	        this.options.dataAdapter,
	        InputCompat
	      );
	    }
	  }
	
	  Options.prototype.fromElement = function ($e) {
	    var excludedData = ['select2'];
	
	    if (this.options.multiple == null) {
	      this.options.multiple = $e.prop('multiple');
	    }
	
	    if (this.options.disabled == null) {
	      this.options.disabled = $e.prop('disabled');
	    }
	
	    if (this.options.dir == null) {
	      if ($e.prop('dir')) {
	        this.options.dir = $e.prop('dir');
	      } else if ($e.closest('[dir]').prop('dir')) {
	        this.options.dir = $e.closest('[dir]').prop('dir');
	      } else {
	        this.options.dir = 'ltr';
	      }
	    }
	
	    $e.prop('disabled', this.options.disabled);
	    $e.prop('multiple', this.options.multiple);
	
	    if (Utils.GetData($e[0], 'select2Tags')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-select2-tags` attribute has been changed to ' +
	          'use the `data-data` and `data-tags="true"` attributes and will be ' +
	          'removed in future versions of Select2.'
	        );
	      }
	
	      Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
	      Utils.StoreData($e[0], 'tags', true);
	    }
	
	    if (Utils.GetData($e[0], 'ajaxUrl')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-ajax-url` attribute has been changed to ' +
	          '`data-ajax--url` and support for the old attribute will be removed' +
	          ' in future versions of Select2.'
	        );
	      }
	
	      $e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
	      Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
	    }
	
	    var dataset = {};
	
	    function upperCaseLetter(_, letter) {
	      return letter.toUpperCase();
	    }
	
	    // Pre-load all of the attributes which are prefixed with `data-`
	    for (var attr = 0; attr < $e[0].attributes.length; attr++) {
	      var attributeName = $e[0].attributes[attr].name;
	      var prefix = 'data-';
	
	      if (attributeName.substr(0, prefix.length) == prefix) {
	        // Get the contents of the attribute after `data-`
	        var dataName = attributeName.substring(prefix.length);
	
	        // Get the data contents from the consistent source
	        // This is more than likely the jQuery data helper
	        var dataValue = Utils.GetData($e[0], dataName);
	
	        // camelCase the attribute name to match the spec
	        var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);
	
	        // Store the data attribute contents into the dataset since
	        dataset[camelDataName] = dataValue;
	      }
	    }
	
	    // Prefer the element's `dataset` attribute if it exists
	    // jQuery 1.x does not correctly handle data attributes with multiple dashes
	    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
	      dataset = $.extend(true, {}, $e[0].dataset, dataset);
	    }
	
	    // Prefer our internal data cache if it exists
	    var data = $.extend(true, {}, Utils.GetData($e[0]), dataset);
	
	    data = Utils._convertData(data);
	
	    for (var key in data) {
	      if ($.inArray(key, excludedData) > -1) {
	        continue;
	      }
	
	      if ($.isPlainObject(this.options[key])) {
	        $.extend(this.options[key], data[key]);
	      } else {
	        this.options[key] = data[key];
	      }
	    }
	
	    return this;
	  };
	
	  Options.prototype.get = function (key) {
	    return this.options[key];
	  };
	
	  Options.prototype.set = function (key, val) {
	    this.options[key] = val;
	  };
	
	  return Options;
	});
	
	S2.define('select2/core',[
	  'jquery',
	  './options',
	  './utils',
	  './keys'
	], function ($, Options, Utils, KEYS) {
	  var Select2 = function ($element, options) {
	    if (Utils.GetData($element[0], 'select2') != null) {
	      Utils.GetData($element[0], 'select2').destroy();
	    }
	
	    this.$element = $element;
	
	    this.id = this._generateId($element);
	
	    options = options || {};
	
	    this.options = new Options(options, $element);
	
	    Select2.__super__.constructor.call(this);
	
	    // Set up the tabindex
	
	    var tabindex = $element.attr('tabindex') || 0;
	    Utils.StoreData($element[0], 'old-tabindex', tabindex);
	    $element.attr('tabindex', '-1');
	
	    // Set up containers and adapters
	
	    var DataAdapter = this.options.get('dataAdapter');
	    this.dataAdapter = new DataAdapter($element, this.options);
	
	    var $container = this.render();
	
	    this._placeContainer($container);
	
	    var SelectionAdapter = this.options.get('selectionAdapter');
	    this.selection = new SelectionAdapter($element, this.options);
	    this.$selection = this.selection.render();
	
	    this.selection.position(this.$selection, $container);
	
	    var DropdownAdapter = this.options.get('dropdownAdapter');
	    this.dropdown = new DropdownAdapter($element, this.options);
	    this.$dropdown = this.dropdown.render();
	
	    this.dropdown.position(this.$dropdown, $container);
	
	    var ResultsAdapter = this.options.get('resultsAdapter');
	    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
	    this.$results = this.results.render();
	
	    this.results.position(this.$results, this.$dropdown);
	
	    // Bind events
	
	    var self = this;
	
	    // Bind the container to all of the adapters
	    this._bindAdapters();
	
	    // Register any DOM event handlers
	    this._registerDomEvents();
	
	    // Register any internal event handlers
	    this._registerDataEvents();
	    this._registerSelectionEvents();
	    this._registerDropdownEvents();
	    this._registerResultsEvents();
	    this._registerEvents();
	
	    // Set the initial state
	    this.dataAdapter.current(function (initialData) {
	      self.trigger('selection:update', {
	        data: initialData
	      });
	    });
	
	    // Hide the original select
	    $element.addClass('select2-hidden-accessible');
	    $element.attr('aria-hidden', 'true');
	
	    // Synchronize any monitored attributes
	    this._syncAttributes();
	
	    Utils.StoreData($element[0], 'select2', this);
	
	    // Ensure backwards compatibility with $element.data('select2').
	    $element.data('select2', this);
	  };
	
	  Utils.Extend(Select2, Utils.Observable);
	
	  Select2.prototype._generateId = function ($element) {
	    var id = '';
	
	    if ($element.attr('id') != null) {
	      id = $element.attr('id');
	    } else if ($element.attr('name') != null) {
	      id = $element.attr('name') + '-' + Utils.generateChars(2);
	    } else {
	      id = Utils.generateChars(4);
	    }
	
	    id = id.replace(/(:|\.|\[|\]|,)/g, '');
	    id = 'select2-' + id;
	
	    return id;
	  };
	
	  Select2.prototype._placeContainer = function ($container) {
	    $container.insertAfter(this.$element);
	
	    var width = this._resolveWidth(this.$element, this.options.get('width'));
	
	    if (width != null) {
	      $container.css('width', width);
	    }
	  };
	
	  Select2.prototype._resolveWidth = function ($element, method) {
	    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
	
	    if (method == 'resolve') {
	      var styleWidth = this._resolveWidth($element, 'style');
	
	      if (styleWidth != null) {
	        return styleWidth;
	      }
	
	      return this._resolveWidth($element, 'element');
	    }
	
	    if (method == 'element') {
	      var elementWidth = $element.outerWidth(false);
	
	      if (elementWidth <= 0) {
	        return 'auto';
	      }
	
	      return elementWidth + 'px';
	    }
	
	    if (method == 'style') {
	      var style = $element.attr('style');
	
	      if (typeof(style) !== 'string') {
	        return null;
	      }
	
	      var attrs = style.split(';');
	
	      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
	        var attr = attrs[i].replace(/\s/g, '');
	        var matches = attr.match(WIDTH);
	
	        if (matches !== null && matches.length >= 1) {
	          return matches[1];
	        }
	      }
	
	      return null;
	    }
	
	    if (method == 'computedstyle') {
	      var computedStyle = window.getComputedStyle($element[0]);
	
	      return computedStyle.width;
	    }
	
	    return method;
	  };
	
	  Select2.prototype._bindAdapters = function () {
	    this.dataAdapter.bind(this, this.$container);
	    this.selection.bind(this, this.$container);
	
	    this.dropdown.bind(this, this.$container);
	    this.results.bind(this, this.$container);
	  };
	
	  Select2.prototype._registerDomEvents = function () {
	    var self = this;
	
	    this.$element.on('change.select2', function () {
	      self.dataAdapter.current(function (data) {
	        self.trigger('selection:update', {
	          data: data
	        });
	      });
	    });
	
	    this.$element.on('focus.select2', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this._syncA = Utils.bind(this._syncAttributes, this);
	    this._syncS = Utils.bind(this._syncSubtree, this);
	
	    if (this.$element[0].attachEvent) {
	      this.$element[0].attachEvent('onpropertychange', this._syncA);
	    }
	
	    var observer = window.MutationObserver ||
	      window.WebKitMutationObserver ||
	      window.MozMutationObserver
	    ;
	
	    if (observer != null) {
	      this._observer = new observer(function (mutations) {
	        self._syncA();
	        self._syncS(null, mutations);
	      });
	      this._observer.observe(this.$element[0], {
	        attributes: true,
	        childList: true,
	        subtree: false
	      });
	    } else if (this.$element[0].addEventListener) {
	      this.$element[0].addEventListener(
	        'DOMAttrModified',
	        self._syncA,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeInserted',
	        self._syncS,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeRemoved',
	        self._syncS,
	        false
	      );
	    }
	  };
	
	  Select2.prototype._registerDataEvents = function () {
	    var self = this;
	
	    this.dataAdapter.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerSelectionEvents = function () {
	    var self = this;
	    var nonRelayEvents = ['toggle', 'focus'];
	
	    this.selection.on('toggle', function () {
	      self.toggleDropdown();
	    });
	
	    this.selection.on('focus', function (params) {
	      self.focus(params);
	    });
	
	    this.selection.on('*', function (name, params) {
	      if ($.inArray(name, nonRelayEvents) !== -1) {
	        return;
	      }
	
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerDropdownEvents = function () {
	    var self = this;
	
	    this.dropdown.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerResultsEvents = function () {
	    var self = this;
	
	    this.results.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerEvents = function () {
	    var self = this;
	
	    this.on('open', function () {
	      self.$container.addClass('select2-container--open');
	    });
	
	    this.on('close', function () {
	      self.$container.removeClass('select2-container--open');
	    });
	
	    this.on('enable', function () {
	      self.$container.removeClass('select2-container--disabled');
	    });
	
	    this.on('disable', function () {
	      self.$container.addClass('select2-container--disabled');
	    });
	
	    this.on('blur', function () {
	      self.$container.removeClass('select2-container--focus');
	    });
	
	    this.on('query', function (params) {
	      if (!self.isOpen()) {
	        self.trigger('open', {});
	      }
	
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:all', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('query:append', function (params) {
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:append', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('keypress', function (evt) {
	      var key = evt.which;
	
	      if (self.isOpen()) {
	        if (key === KEYS.ESC || key === KEYS.TAB ||
	            (key === KEYS.UP && evt.altKey)) {
	          self.close(evt);
	
	          evt.preventDefault();
	        } else if (key === KEYS.ENTER) {
	          self.trigger('results:select', {});
	
	          evt.preventDefault();
	        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
	          self.trigger('results:toggle', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.UP) {
	          self.trigger('results:previous', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.DOWN) {
	          self.trigger('results:next', {});
	
	          evt.preventDefault();
	        }
	      } else {
	        if (key === KEYS.ENTER || key === KEYS.SPACE ||
	            (key === KEYS.DOWN && evt.altKey)) {
	          self.open();
	
	          evt.preventDefault();
	        }
	      }
	    });
	  };
	
	  Select2.prototype._syncAttributes = function () {
	    this.options.set('disabled', this.$element.prop('disabled'));
	
	    if (this.isDisabled()) {
	      if (this.isOpen()) {
	        this.close();
	      }
	
	      this.trigger('disable', {});
	    } else {
	      this.trigger('enable', {});
	    }
	  };
	
	  Select2.prototype._isChangeMutation = function (evt, mutations) {
	    var changed = false;
	    var self = this;
	
	    // Ignore any mutation events raised for elements that aren't options or
	    // optgroups. This handles the case when the select element is destroyed
	    if (
	      evt && evt.target && (
	        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
	      )
	    ) {
	      return;
	    }
	
	    if (!mutations) {
	      // If mutation events aren't supported, then we can only assume that the
	      // change affected the selections
	      changed = true;
	    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
	      for (var n = 0; n < mutations.addedNodes.length; n++) {
	        var node = mutations.addedNodes[n];
	
	        if (node.selected) {
	          changed = true;
	        }
	      }
	    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
	      changed = true;
	    } else if ($.isArray(mutations)) {
	      $.each(mutations, function(evt, mutation) {
	        if (self._isChangeMutation(evt, mutation)) {
	          // We've found a change mutation.
	          // Let's escape from the loop and continue
	          changed = true;
	          return false;
	        }
	      });
	    }
	    return changed;
	  };
	
	  Select2.prototype._syncSubtree = function (evt, mutations) {
	    var changed = this._isChangeMutation(evt, mutations);
	    var self = this;
	
	    // Only re-pull the data if we think there is a change
	    if (changed) {
	      this.dataAdapter.current(function (currentData) {
	        self.trigger('selection:update', {
	          data: currentData
	        });
	      });
	    }
	  };
	
	  /**
	   * Override the trigger method to automatically trigger pre-events when
	   * there are events that can be prevented.
	   */
	  Select2.prototype.trigger = function (name, args) {
	    var actualTrigger = Select2.__super__.trigger;
	    var preTriggerMap = {
	      'open': 'opening',
	      'close': 'closing',
	      'select': 'selecting',
	      'unselect': 'unselecting',
	      'clear': 'clearing'
	    };
	
	    if (args === undefined) {
	      args = {};
	    }
	
	    if (name in preTriggerMap) {
	      var preTriggerName = preTriggerMap[name];
	      var preTriggerArgs = {
	        prevented: false,
	        name: name,
	        args: args
	      };
	
	      actualTrigger.call(this, preTriggerName, preTriggerArgs);
	
	      if (preTriggerArgs.prevented) {
	        args.prevented = true;
	
	        return;
	      }
	    }
	
	    actualTrigger.call(this, name, args);
	  };
	
	  Select2.prototype.toggleDropdown = function () {
	    if (this.isDisabled()) {
	      return;
	    }
	
	    if (this.isOpen()) {
	      this.close();
	    } else {
	      this.open();
	    }
	  };
	
	  Select2.prototype.open = function () {
	    if (this.isOpen()) {
	      return;
	    }
	
	    if (this.isDisabled()) {
	      return;
	    }
	
	    this.trigger('query', {});
	  };
	
	  Select2.prototype.close = function (evt) {
	    if (!this.isOpen()) {
	      return;
	    }
	
	    this.trigger('close', { originalEvent : evt });
	  };
	
	  /**
	   * Helper method to abstract the "enabled" (not "disabled") state of this
	   * object.
	   *
	   * @return {true} if the instance is not disabled.
	   * @return {false} if the instance is disabled.
	   */
	  Select2.prototype.isEnabled = function () {
	    return !this.isDisabled();
	  };
	
	  /**
	   * Helper method to abstract the "disabled" state of this object.
	   *
	   * @return {true} if the disabled option is true.
	   * @return {false} if the disabled option is false.
	   */
	  Select2.prototype.isDisabled = function () {
	    return this.options.get('disabled');
	  };
	
	  Select2.prototype.isOpen = function () {
	    return this.$container.hasClass('select2-container--open');
	  };
	
	  Select2.prototype.hasFocus = function () {
	    return this.$container.hasClass('select2-container--focus');
	  };
	
	  Select2.prototype.focus = function (data) {
	    // No need to re-trigger focus events if we are already focused
	    if (this.hasFocus()) {
	      return;
	    }
	
	    this.$container.addClass('select2-container--focus');
	    this.trigger('focus', {});
	  };
	
	  Select2.prototype.enable = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("enable")` method has been deprecated and will' +
	        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
	        ' instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      args = [true];
	    }
	
	    var disabled = !args[0];
	
	    this.$element.prop('disabled', disabled);
	  };
	
	  Select2.prototype.data = function () {
	    if (this.options.get('debug') &&
	        arguments.length > 0 && window.console && console.warn) {
	      console.warn(
	        'Select2: Data can no longer be set using `select2("data")`. You ' +
	        'should consider setting the value instead using `$element.val()`.'
	      );
	    }
	
	    var data = [];
	
	    this.dataAdapter.current(function (currentData) {
	      data = currentData;
	    });
	
	    return data;
	  };
	
	  Select2.prototype.val = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("val")` method has been deprecated and will be' +
	        ' removed in later Select2 versions. Use $element.val() instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      return this.$element.val();
	    }
	
	    var newVal = args[0];
	
	    if ($.isArray(newVal)) {
	      newVal = $.map(newVal, function (obj) {
	        return obj.toString();
	      });
	    }
	
	    this.$element.val(newVal).trigger('input').trigger('change');
	  };
	
	  Select2.prototype.destroy = function () {
	    this.$container.remove();
	
	    if (this.$element[0].detachEvent) {
	      this.$element[0].detachEvent('onpropertychange', this._syncA);
	    }
	
	    if (this._observer != null) {
	      this._observer.disconnect();
	      this._observer = null;
	    } else if (this.$element[0].removeEventListener) {
	      this.$element[0]
	        .removeEventListener('DOMAttrModified', this._syncA, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeInserted', this._syncS, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeRemoved', this._syncS, false);
	    }
	
	    this._syncA = null;
	    this._syncS = null;
	
	    this.$element.off('.select2');
	    this.$element.attr('tabindex',
	    Utils.GetData(this.$element[0], 'old-tabindex'));
	
	    this.$element.removeClass('select2-hidden-accessible');
	    this.$element.attr('aria-hidden', 'false');
	    Utils.RemoveData(this.$element[0]);
	    this.$element.removeData('select2');
	
	    this.dataAdapter.destroy();
	    this.selection.destroy();
	    this.dropdown.destroy();
	    this.results.destroy();
	
	    this.dataAdapter = null;
	    this.selection = null;
	    this.dropdown = null;
	    this.results = null;
	  };
	
	  Select2.prototype.render = function () {
	    var $container = $(
	      '<span class="select2 select2-container">' +
	        '<span class="selection"></span>' +
	        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
	      '</span>'
	    );
	
	    $container.attr('dir', this.options.get('dir'));
	
	    this.$container = $container;
	
	    this.$container.addClass('select2-container--' + this.options.get('theme'));
	
	    Utils.StoreData($container[0], 'element', this.$element);
	
	    return $container;
	  };
	
	  return Select2;
	});
	
	S2.define('jquery-mousewheel',[
	  'jquery'
	], function ($) {
	  // Used to shim jQuery.mousewheel for non-full builds.
	  return $;
	});
	
	S2.define('jquery.select2',[
	  'jquery',
	  'jquery-mousewheel',
	
	  './select2/core',
	  './select2/defaults',
	  './select2/utils'
	], function ($, _, Select2, Defaults, Utils) {
	  if ($.fn.select2 == null) {
	    // All methods that should return the element
	    var thisMethods = ['open', 'close', 'destroy'];
	
	    $.fn.select2 = function (options) {
	      options = options || {};
	
	      if (typeof options === 'object') {
	        this.each(function () {
	          var instanceOptions = $.extend(true, {}, options);
	
	          var instance = new Select2($(this), instanceOptions);
	        });
	
	        return this;
	      } else if (typeof options === 'string') {
	        var ret;
	        var args = Array.prototype.slice.call(arguments, 1);
	
	        this.each(function () {
	          var instance = Utils.GetData(this, 'select2');
	
	          if (instance == null && window.console && console.error) {
	            console.error(
	              'The select2(\'' + options + '\') method was called on an ' +
	              'element that is not using Select2.'
	            );
	          }
	
	          ret = instance[options].apply(instance, args);
	        });
	
	        // Check if we should be returning `this`
	        if ($.inArray(options, thisMethods) > -1) {
	          return this;
	        }
	
	        return ret;
	      } else {
	        throw new Error('Invalid arguments for Select2: ' + options);
	      }
	    };
	  }
	
	  if ($.fn.select2.defaults == null) {
	    $.fn.select2.defaults = Defaults;
	  }
	
	  return Select2;
	});
	
	  // Return the AMD loader configuration so it can be used outside of this file
	  return {
	    define: S2.define,
	    require: S2.require
	  };
	}());
	
	  // Autoload the jQuery bindings
	  // We know that all of the modules exist above this, so we're safe
	  var select2 = S2.require('jquery.select2');
	
	  // Hold the AMD module references on the jQuery function that was just loaded
	  // This allows Select2 to use the internal loader outside of this file, such
	  // as in the language files.
	  jQuery.fn.select2.amd = S2;
	
	  // Return the Select2 instance for anyone who is importing it.
	  return select2;
	}));


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.progress = exports.dwJSPath = exports.isRTL = exports.isMobile = exports.breakpoints = exports.globalWrapper = undefined;
	exports.jumpTo = jumpTo;
	exports.allowedNumInput = allowedNumInput;
	exports.info = info;
	exports.getSelectedFilterCount = getSelectedFilterCount;
	exports.whichTransition = whichTransition;
	exports.getSelectedfilterlabels = getSelectedfilterlabels;
	exports.setdefaultFilteractive = setdefaultFilteractive;
	exports.createElWithAttrs = createElWithAttrs;
	exports.toggleOverlay = toggleOverlay;
	exports.createMessageBanner = createMessageBanner;
	exports.createCookie = createCookie;
	exports.readCookie = readCookie;
	exports.eraseCookie = eraseCookie;
	exports.shouldEnableSticky = shouldEnableSticky;
	exports.checkTypeRefinement = checkTypeRefinement;
	exports.toggleChatWidget = toggleChatWidget;
	exports.checkChatWidget = checkChatWidget;
	exports.initReplaceContent = initReplaceContent;
	exports.initCartCloseButton = initCartCloseButton;
	
	var _born = __webpack_require__(3);
	
	var _born2 = _interopRequireDefault(_born);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalWrapper = exports.globalWrapper = document.querySelector('#wrapper'); /**
	                                                                                 * [Utils]: methods and objects that contain reusable functionality and can be called on demand.
	                                                                                 */
	
	var breakpoints = exports.breakpoints = {
	  mobile: 768,
	  tablet: 1024,
	  site: 1280
	};
	
	var isMobile = exports.isMobile = {
	  Android: function Android() {
	    return navigator.userAgent.match(/Android/i);
	  },
	  BlackBerry: function BlackBerry() {
	    return navigator.userAgent.match(/BlackBerry/i);
	  },
	  iOS: function iOS() {
	    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	  },
	  Opera: function Opera() {
	    return navigator.userAgent.match(/Opera Mini/i);
	  },
	  Windows: function Windows() {
	    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
	  },
	  any: function any() {
	    return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
	  }
	};
	
	var isRTL = exports.isRTL = document.documentElement.getAttribute('dir') === 'rtl' ? true : false;
	
	var dwJSPath = exports.dwJSPath = 'cartridges/app_modist_core/cartridge/js/';
	
	var progress = exports.progress = {
	  loader: null,
	  show: function show(container) {
	    var $target = !container || $(container).length === 0 ? BORN.$body : $(container);
	
	    this.loader = $target.find('.ajax-loader');
	
	    if (!this.loader.length) {
	      this.loader = $('<div/>').addClass('ajax-loader');
	      $target.append(this.loader);
	    }
	
	    this.loader.fadeIn(250);
	  },
	  hide: function hide() {
	    if (this.loader) {
	      this.loader.fadeOut(250);
	    }
	  }
	};
	
	/**
	 * add attribute to an html element to scroll to part of the page
	 * @param  [string 'target selector'| object {target, offset }] options
	 *
	 * Usage: <a data-jumpto='{"target": '.header', "offset": 200}'>jump</a>
	 */
	function jumpTo(options) {
	  // check if options was passed as an object string
	  try {
	    options = JSON.parse(options);
	  } catch (e) {}
	  // string with target was passed.. hopefully
	
	
	  //Do nothing if this option is on, which means the source element has the 
	  //'toggle--active' class on.
	  if (options.ignoreOnToggle && !this.classList.contains('toggle--active')) {
	    return;
	  }
	
	  // pull options keys or set defaults
	  var $target = options.target ? $(options.target) : $(options),
	      offset = isNaN(options.offset) && document.querySelector(options.offset) ? document.querySelector(options.offset).getBoundingClientRect().height : options.offset || 0,
	      targetOffsetTop = $target.offset().top - offset;
	
	  // scroll mofo
	  $('body, html').animate({
	    scrollTop: targetOffsetTop
	  }, 500);
	}
	
	function allowedNumInput(evt) {
	  var upDownArrows = evt.keyCode === 38 || evt.keyCode === 40,
	      leftRightArows = evt.keyCode === 37 || evt.keyCode === 39,
	      allowEnter = evt.keyCode === 13,
	      allowedKeys = evt.keyCode > 47 && evt.keyCode < 58 || allowEnter || upDownArrows || leftRightArows || evt.metaKey || evt.ctrlKet || evt.altKey || evt.keyCode === 8 || evt.keyCode === 9,
	      allowPeriod = allowedKeys || evt.keyCode === 190;
	
	  return {
	    'upDown': upDownArrows,
	    'leftRightArows': leftRightArows,
	    'allowed': allowedKeys,
	    'allowPeriod': allowPeriod
	  };
	}
	
	function info(test) {
	  console.log('Utils: ' + test);
	}
	/**
	 * [Returns the selected filter count in mobile]
	 */
	function getSelectedFilterCount() {
	  $(".refinement_filtercount--mob").each(function () {
	    var selectedCount = $(this).closest('.refinement').find("a.refinement__link.checked").length;
	    $(this).text(selectedCount > 0 ? selectedCount : "");
	  });
	}
	
	/**
	 * [Returns the transition event type supported by the browser]
	 */
	function whichTransition() {
	  var dummyEl = document.createElement('dummy'),
	      transitions = {
	    'transition': 'transitionend',
	    'OTransition': 'oTransitionEnd',
	    'MozTransition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd'
	  };
	
	  for (var key in transitions) {
	    if (dummyEl.style[key] !== undefined) {
	      return transitions[key];
	    }
	  }
	}
	/**
	 * [Returns the selected filter labels in web view]
	 */
	function getSelectedfilterlabels() {
	  $('.refinement_filtervalues').each(function () {
	    var selectedEle = [];
	    var $selectionArea = $(this).parents('.toggle__link').siblings('.toggle__content').find('.refinement__link.checked');
	    if ($selectionArea.length > 0) {
	      $selectionArea.each(function () {
	        selectedEle.push($.trim($(this).immediateText()));
	      });
	      if (selectedEle.length > 0) {
	        var selectedElelabel = selectedEle.length > 2 ? selectedEle[0] + ", " + selectedEle[1] + " + " + (parseInt(selectedEle.length) - 2) : selectedEle.join(", ");
	        $(this).html(selectedElelabel);
	        $(this).attr('title', selectedEle.join(","));
	      }
	    }
	  });
	}
	
	/**
	 * [Returns the default view in filter mobile]
	 */
	function setdefaultFilteractive($generic, $specific) {
	  $generic.removeClass('activefilter toggle--active');
	  $generic.children('.toggle__content,.toggle__link').removeClass('toggle--active');
	  $specific.addClass('activefilter');
	  $specific.children('.toggle__content,.toggle__link').addClass('toggle--active');
	}
	
	/**
	 * [createElWithAttrs creates an element with a set of given attributes passed as the 2nd parameter,
	 * then appends the new element to the target parent passed on the 1st parameter]
	 * @param  {[type]} appendTarget [description]
	 * @param  {[type]} attributes   [description]
	 *  @param {[type]} type        [description]
	 * @return {[type]}              [description]
	 */
	function createElWithAttrs(appendTarget, attributes, type) {
	  var el = document.createElement(type || 'div');
	
	  for (var key in attributes) {
	    el.setAttribute(key, attributes[key]);
	  }
	
	  if (appendTarget) {
	    appendTarget.appendChild(el);
	  }
	
	  return el;
	}
	
	/**
	 * [toggleOverlay Initial overlay functionality.
	 * This needs more work if we're implementing for random elements]
	 * This is kinda shitty.
	 * @param  {[type]} show   [description]
	 * @param  {[type]} setOnHeader [description]
	 * @return {[type]}        [description]
	 */
	function toggleOverlay(show, setOnHeader) {
	  var showOnMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	
	  //Disable this functionality on mobile if required
	  if (!showOnMobile && window.innerWidth < breakpoints.mobile) {
	    return;
	  }
	
	  //For this project, the main nav needs to be position: fixed; so we insert the overlay in it cause transforms create a new context, this containing it.
	  var overlayBody = document.querySelector('.focus-overlay--body') || createElWithAttrs(globalWrapper, { 'class': 'focus-overlay focus-overlay--body' }),
	      overlayHeader = document.querySelector('.focus-overlay--header') || createElWithAttrs(document.querySelector('.header__main'), { 'class': 'focus-overlay focus-overlay--header' });
	
	  if (show) {
	    overlayBody.classList.add('set--active');
	    overlayBody.classList.add('overlay--body--mob');
	
	    if (setOnHeader) {
	      overlayHeader.classList.add('set--active');
	    }
	
	    if (window.innerWidth < breakpoints.mobile) {
	      overlayBody.addEventListener('click', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	      });
	    }
	  } else {
	    overlayBody.classList.remove('set--active');
	    overlayHeader.classList.remove('set--active');
	    overlayBody.classList.remove('overlay--body--mob');
	  }
	}
	
	/**
	 * [Creates a message banner that can be displayed either on top or bottom of the viewport]
	 * @param  {[type]} message  [description]
	 * @param  {[type]} wrapper  [description]
	 * @param  {[type]} position [description]
	 * @return {[type]}          [description]
	 */
	function createMessageBanner(message, wrapper, position) {
	  var container = wrapper || document.body,
	      bannerID = 'notif-banner--' + new Date().getTime(),
	      banner = createElWithAttrs(container, { id: bannerID, class: 'notif-banner notif-banner--' + (position || 'bottom') }),
	      bannerContents = createElWithAttrs(banner, { class: 'notif-banner__center max-width--site gutter-padding--full' }),
	      bannerTrigger = createElWithAttrs(bannerContents, { class: 'notif-banner__trigger', 'data-toggle-target': '#' + bannerID, 'data-toggle-immediate': true }, 'span'),
	      bannerCopy = createElWithAttrs(bannerContents, { class: 'notif-banner__message p3' }, 'p'),
	      bannerCancel = createElWithAttrs(bannerContents, { class: 'notif-banner__action icon--cancel link txt--upper', 'data-toggle-close': true }, 'span');
	
	  bannerCopy.textContent = message || 'Complete';
	  bannerCancel.textContent = window.Resources.CLOSE;
	
	  _born2.default.toggle.init('#' + bannerID + ' .notif-banner__trigger');
	  // banner.showContent();
	}
	
	/**
	 * [createCookie creates a cookie]
	 * @param  {[string]} name  [cookie name]
	 * @param  {[string]} value [cookie description]
	 * @param  {[int]} days  [amount of days the cookie must be alive for]
	 */
	function createCookie(name, value, days) {
	  var expires;
	
	  if (days) {
	    var date = new Date();
	
	    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	    expires = '; expires=' + date.toGMTString();
	  } else {
	    expires = '';
	  }
	
	  document.cookie = name + '=' + value + expires + '; path=/';
	}
	
	/**
	 * [readCookie tries to find a cookie with the provided name]
	 * @param  {[string]} name [cookie name]
	 * @return {[string]}      [string containing the searched cookie, if any]
	 */
	function readCookie(name) {
	  var nameEQ = name + '=',
	      cookieList = document.cookie.split(';');
	
	  for (var i = 0; i < cookieList.length; i++) {
	    var currentCookie = cookieList[i];
	
	    while (currentCookie.charAt(0) == ' ') {
	      currentCookie = currentCookie.substring(1, currentCookie.length);
	    }
	
	    if (currentCookie.indexOf(nameEQ) === 0) {
	      return currentCookie.substring(nameEQ.length, currentCookie.length);
	    }
	  }
	
	  return null;
	}
	
	/**
	 * [eraseCookie]
	 * @param  {[string]} name [cookie name that needs to be erased]
	 */
	function eraseCookie(name) {
	  createCookie(name, '', -1);
	}
	
	function shouldEnableSticky() {
	  var wrapperH = document.querySelector('#wrapper').getBoundingClientRect().height,
	      excludedPages = document.querySelector('.pt_checkout, .pt_order-confirmation, .pt_azdesigners, .pt_account, .pt_wishlist, .pt_order'),
	      isNotMobile = window.innerWidth >= breakpoints.mobile,
	      isPLP = document.querySelector('.pt_product-search-result'),
	      compareHeight = isPLP ? 1350 : 1400,
	      shouldntEnable = isNotMobile && (excludedPages || wrapperH <= compareHeight);
	
	  if (shouldntEnable) {
	    return false;
	  }
	
	  return true;
	}
	
	/*Remove empty category refinement element*/
	function checkTypeRefinement() {
	  var categoryRefinement = $('#categoryRefinement');
	  if (categoryRefinement && categoryRefinement.length > 0) {
	    var subCatEl = categoryRefinement.find('ul li');
	    if (subCatEl && subCatEl.length > 0) {
	      categoryRefinement.show();
	    } else {
	      categoryRefinement.remove();
	      if (window.innerWidth < breakpoints.mobile) {
	        var allRefinementEl = $('.refinement__all__toggle');
	        if (allRefinementEl && allRefinementEl.find('.activefilter').length <= 0) {
	          var filtersRefinementEl = allRefinementEl.find('.refinement');
	          if (filtersRefinementEl && filtersRefinementEl.length > 0) {
	            var firstEl = $(filtersRefinementEl[0]).find('.toggle__link');
	            if (firstEl && firstEl.length > 0) {
	              firstEl.trigger('click');
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	/*Show/Hide Chat widget*/
	function toggleChatWidget(hide) {
	  if (window.innerWidth < breakpoints.mobile) {
	    if (checkChatWidget()) {
	      zE(function () {
	        if (hide) {
	          zE.show();
	        } else {
	          zE.hide();
	        }
	      });
	    }
	  }
	}
	
	function checkChatWidget() {
	  if (typeof zE !== 'undefined' && !!zE) {
	    return true;
	  }
	  return false;
	}
	
	function initReplaceContent(el) {
	  replaceContent(el);
	  $(window).on('resize', function () {
	    replaceContent(el);
	  });
	}
	
	function replaceContent(el) {
	  if (el === undefined || !el) {
	    return;
	  }
	  var webContent = $(el + '-web');
	  var mobileContent = $(el + '-mob');
	  if (window.innerWidth <= breakpoints.mobile) {
	    if (mobileContent.length > 0 && webContent.length > 0) {
	      if (mobileContent.children().length > 0) {
	        return;
	      }
	      var content = webContent.children();
	      if (content.length <= 0) {
	        return;
	      }
	      mobileContent.html("");
	      mobileContent.html(content.clone());
	    }
	  }
	}
	
	function initCartCloseButton() {
	  if (window.innerWidth <= breakpoints.mobile) {
	    $(".cart-back-cta").on('click', function () {
	      var url = getPageUrlHistory();
	      if (url && url != '') {
	        window.location.href = url;
	      } else {
	        window.history.back();
	      }
	    });
	  }
	}
	
	function getPageUrlHistory() {
	  return localStorage.getItem("pageurlhistory");
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @dependencies: http://kenwheeler.github.io/slick/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Initializes slick.js on any element with the js-carousel class.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	var _born = __webpack_require__(3);
	
	var _born2 = _interopRequireDefault(_born);
	
	var _born3 = __webpack_require__(10);
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Carousel = function () {
		function Carousel(query) {
			var _this = this;
	
			_classCallCheck(this, Carousel);
	
			var $carousels = $(query + ':not(.slick-initialized)');
			$carousels.each(function (index, carousel) {
	
				var $carousel = $(carousel),
				    carouselSettings = JSON.parse(carousel.getAttribute('data-slick'));
	
				if ('slidesToShow' in carouselSettings) {
					carouselSettings.slidesToShow = parseInt(carouselSettings.slidesToShow);
				}
	
				if ('slidesToScroll' in carouselSettings) {
					carouselSettings.slidesToShow = parseInt(carouselSettings.slidesToShow);
				}
	
				$carousel.imagesLoaded(function () {
					//Only add events if carousel has any video elements.
					if (carousel.querySelector('[data-video]')) {
						//Make sure video is initialized before toggling videos.
						_born2.default.video.init();
						$carousel.on('init beforeChange', _this.toggleVideo.bind(_this));
					}
	
					carousel.slickInitialSlide = carousel.slickInitialSlide || function () {
						return false;
					};
	
					var inisl = carousel.slickInitialSlide($carousel) || 0;
					var isProductSize = $carousel.data('productsize');
					var isModelView = $('.results-container').data('view') === 'model-view';
					var initialSlideModel = !isProductSize && isModelView ? 1 : inisl;
	
					var showVidThumb = $carousel.data('video-thumb');
					if (showVidThumb !== undefined && parseInt(showVidThumb) > 0) {
						$carousel.not('.slick-initialized').slick({
							rtl: _born3.isRTL && !carouselSettings.vertical,
							initialSlide: initialSlideModel,
							customPaging: _this.buildDots.bind(carousel)
						});
					} else {
						$carousel.not('.slick-initialized').slick({
							rtl: _born3.isRTL && !carouselSettings.vertical,
							initialSlide: initialSlideModel
						});
					}
					if ($carousel.attr('data-slick-sync')) {
						_this.setupSync($carousel);
					}
				});
			});
		}
	
		//Determines to play/pause videos depending on the target slide
	
	
		_createClass(Carousel, [{
			key: 'toggleVideo',
			value: function toggleVideo(evt, $slick, slideIndex, nextSlideIndex) {
	
				var targetIndex = nextSlideIndex > 0 ? nextSlideIndex : 0,
				    slidesToShow = $slick.slickGetOption('slidesToShow');
	
				[].forEach.call(Carousel.getPreviousVideos($slick.$list[0]), Carousel.pausePrevious);
				Carousel.playNext(Carousel.getNextVideos($slick.$slides[targetIndex]), $slick.$slider[0]);
	
				//Sometimes the slider can have more than 1 visible slide at a time (slidesToShow),
				//this makes sure all of which are played when visible
				if (slidesToShow > 1) {
					for (var index = targetIndex + 1; index < targetIndex + slidesToShow; index++) {
						Carousel.playNext(Carousel.getNextVideos($slick.$slides[index]), $slick.$slider[0]);
					}
				}
			}
		}, {
			key: 'buildDots',
			value: function buildDots(slider, i) {
				var showVidThumb = $(this).data('video-thumb');
				var className = '';
				if (showVidThumb !== undefined && parseInt(showVidThumb) > 0 && parseInt(showVidThumb) == parseInt(i + 1)) {
					className = 'thumb--video';
				}
				return $('<button type="button" data-role="none" role="button" tabindex="0" class="' + className + '" />').text(i + 1);
			}
			//Get all (currently playing, if youtube) videos inside the current carousel
	
		}, {
			key: 'setupSync',
	
	
			/**
	   * Slick doesn't provide a great method to sync sliders AND allow the slidesToScroll to be anything over 1,
	   * so this creates an alternate functionality.
	   *
	   * This also works for custom navigations, i.e. an NodeList that's not a Slick object.
	   */
	
			value: function setupSync($main) {
				var scope = this,
				    $nav = $($main.attr('data-slick-sync')),
				    isSlick = $nav.hasClass('slick-slider'),
				    $navItems = isSlick ? $($nav.slick('getSlick').$slides) : $nav.children();
	
				$navItems[0].classList.add('slick-nav--active');
	
				$main.on('beforeChange', function (evt, slick, currentSlide, nextSlide) {
					scope.syncNav(nextSlide, $nav, $navItems, isSlick);
				});
	
				$navItems.on('click focus', function () {
					scope.syncMain.call(this, $main, $navItems);
				});
			}
		}, {
			key: 'syncNav',
			value: function syncNav(nextSlide, $nav, $navItems, isSlick) {
				var prevSlide = $nav[0].querySelector('.slick-nav--active'),
				    currSlide = $navItems[nextSlide];
	
				if (isSlick) {
					$nav.slick('slickGoTo', nextSlide);
				}
	
				prevSlide.classList.remove('slick-nav--active');
				currSlide.classList.add('slick-nav--active');
			}
		}, {
			key: 'syncMain',
			value: function syncMain($main, $navItems) {
				var index = $navItems.index(this);
	
				$main.slick('slickGoTo', index);
			}
		}], [{
			key: 'getPreviousVideos',
			value: function getPreviousVideos(target) {
				return target.querySelectorAll('video, .video--playing');
			}
	
			//Get the next visible videos from the coming slide(s)
	
		}, {
			key: 'getNextVideos',
			value: function getNextVideos(target) {
				return target.querySelector('[data-video]');
			}
	
			//Pauses all previous videos
	
		}, {
			key: 'pausePrevious',
			value: function pausePrevious(currentlyPlaying) {
				if (currentlyPlaying) {
					if (currentlyPlaying.nodeName === 'VIDEO') {
	
						// disables autoplay through onScreen
						if (currentlyPlaying.video) {
							currentlyPlaying.video.videoSlideInView = false;
						}
	
						currentlyPlaying.pause();
					} else {
						currentlyPlaying.player.pauseVideo();
					}
				}
			}
	
			//Plays all videos inside the next slide(s)
	
		}, {
			key: 'playNext',
			value: function playNext(targetSlideVideo, slider) {
				//Only play video if slider element is currently on viewport and it's not mobile.
				if (targetSlideVideo && window.innerWidth >= _born3.breakpoints.mobile) {
					//Make sure the HTML video module is initialized for this to work properly
					if (targetSlideVideo.nodeName === 'VIDEO') {
						//&& !targetSlideVideo.video.manuallyPaused
						if (targetSlideVideo.video.options.playOnSlideIn) {
							// enables autoplay through onScreen
							targetSlideVideo.video.videoSlideInView = true;
	
							if (_util2.default.elementInViewport(slider)) {
								targetSlideVideo.play();
							}
						}
					} else {
						//This is very ugly but my brain is toast right now and can't think of anything else.
						var waitVideo = setInterval(function () {
							if (targetSlideVideo.player && targetSlideVideo.player.playVideo) {
								clearInterval(waitVideo);
								targetSlideVideo.player.playVideo();
							}
						}, 10);
					}
				}
			}
		}]);
	
		return Carousel;
	}();
	
	exports.default = Carousel;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(7);
	
	var util = {
	    /**
	     * @function
	     * @description appends the parameter with the given name and value to the given url and returns the changed url
	     * @param {String} url the url to which the parameter will be added
	     * @param {String} name the name of the parameter
	     * @param {String} value the value of the parameter
	     */
	    appendParamToURL: function appendParamToURL(url, name, value) {
	        // quit if the param already exists
	        if (url.indexOf(name + '=') !== -1) {
	            return url;
	        }
	        var separator = url.indexOf('?') !== -1 ? '&' : '?';
	        return url + separator + name + '=' + encodeURIComponent(value);
	    },
	
	    /**
	     * @function
	     * @description remove the parameter and its value from the given url and returns the changed url
	     * @param {String} url the url from which the parameter will be removed
	     * @param {String} name the name of parameter that will be removed from url
	     */
	    removeParamFromURL: function removeParamFromURL(url, name) {
	        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
	            return url;
	        }
	        var hash;
	        var params;
	        var domain = url.split('?')[0];
	        var paramUrl = url.split('?')[1];
	        var newParams = [];
	        // if there is a hash at the end, store the hash
	        if (paramUrl.indexOf('#') > -1) {
	            hash = paramUrl.split('#')[1] || '';
	            paramUrl = paramUrl.split('#')[0];
	        }
	        params = paramUrl.split('&');
	        for (var i = 0; i < params.length; i++) {
	            // put back param to newParams array if it is not the one to be removed
	            if (params[i].split('=')[0] !== name) {
	                newParams.push(params[i]);
	            }
	        }
	        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
	    },
	
	    /**
	     * @function
	     * @description appends the parameters to the given url and returns the changed url
	     * @param {String} url the url to which the parameters will be added
	     * @param {Object} params
	     */
	    appendParamsToUrl: function appendParamsToUrl(url, params) {
	        var _url = url;
	        _.each(params, function (value, name) {
	            _url = this.appendParamToURL(_url, name, value);
	        }.bind(this));
	        return _url;
	    },
	    /**
	     * @function
	     * @description extract the query string from URL
	     * @param {String} url the url to extra query string from
	     **/
	    getQueryString: function getQueryString(url) {
	        var qs;
	        if (!_.isString(url)) {
	            return;
	        }
	        var a = document.createElement('a');
	        a.href = url;
	        if (a.search) {
	            qs = a.search.substr(1); // remove the leading ?
	        }
	        return qs;
	    },
	    /**
	     * @function
	     * @description
	     * @param {String}
	     * @param {String}
	     */
	    elementInViewport: function elementInViewport(el, offsetToTop) {
	        var top = el.offsetTop,
	            left = el.offsetLeft,
	            width = el.offsetWidth,
	            height = el.offsetHeight;
	
	        while (el.offsetParent) {
	            el = el.offsetParent;
	            top += el.offsetTop;
	            left += el.offsetLeft;
	        }
	
	        if (typeof offsetToTop !== 'undefined') {
	            top -= offsetToTop;
	        }
	
	        if (window.pageXOffset !== null) {
	            return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
	        }
	
	        if (document.compatMode === 'CSS1Compat') {
	            return top < window.document.documentElement.scrollTop + window.document.documentElement.clientHeight && left < window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth && top + height > window.document.documentElement.scrollTop && left + width > window.document.documentElement.scrollLeft;
	        }
	    },
	
	    /**
	     * @function
	     * @description Appends the parameter 'format=ajax' to a given path
	     * @param {String} path the relative path
	     */
	    ajaxUrl: function ajaxUrl(path) {
	        return this.appendParamToURL(path, 'format', 'ajax');
	    },
	
	    /**
	     * @function
	     * @description
	     * @param {String} url
	     */
	    toAbsoluteUrl: function toAbsoluteUrl(url) {
	        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
	            url = '/' + url;
	        }
	        return url;
	    },
	    /**
	     * @function
	     * @description Loads css dynamically from given urls
	     * @param {Array} urls Array of urls from which css will be dynamically loaded.
	     */
	    loadDynamicCss: function loadDynamicCss(urls) {
	        var i,
	            len = urls.length;
	        for (i = 0; i < len; i++) {
	            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
	        }
	    },
	
	    /**
	     * @function
	     * @description Loads css file dynamically from given url
	     * @param {String} url The url from which css file will be dynamically loaded.
	     */
	    loadCssFile: function loadCssFile(url) {
	        return $('<link/>').appendTo($('head')).attr({
	            type: 'text/css',
	            rel: 'stylesheet'
	        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
	    },
	    // array to keep track of the dynamically loaded CSS files
	    loadedCssFiles: [],
	
	    /**
	     * @function
	     * @description Removes all css files which were dynamically loaded
	     */
	    clearDynamicCss: function clearDynamicCss() {
	        var i = this.loadedCssFiles.length;
	        while (0 > i--) {
	            $(this.loadedCssFiles[i]).remove();
	        }
	        this.loadedCssFiles = [];
	    },
	    /**
	     * @function
	     * @description Extracts all parameters from a given query string into an object
	     * @param {String} qs The query string from which the parameters will be extracted
	     */
	    getQueryStringParams: function getQueryStringParams(qs) {
	        if (!qs || qs.length === 0) {
	            return {};
	        }
	        var params = {},
	            unescapedQS = decodeURIComponent(qs);
	        // Use the String::replace method to iterate over each
	        // name-value pair in the string.
	        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
	            params[$1] = $3;
	        });
	        return params;
	    },
	
	    fillAddressFields: function fillAddressFields(address, $form) {
	        // var triggerOnce = true;
	
	        for (var field in address) {
	
	            if (field === 'ID' || field === 'UUID' || field === 'key' || field === 'type' || field === 'displayValue') {
	                continue;
	            }
	
	            // if the key in address object ends with 'Code', remove that suffix
	            // keys that ends with 'Code' are postalCode, stateCode and countryCode
	            var $formInput = $form.find('[name$="' + field.replace('Code', '') + '"]');
	
	            // console.log($formInput[0], address[field]);
	
	            $formInput.val(address[field]);
	
	            if ($formInput.is('input, select') && field !== 'countryCode') {
	                // triggerOnce = false;
	                $formInput.trigger('change');
	            }
	            if (field === 'addressType') {
	                $('.address-type-selector .address-type.active').removeClass('active');
	                $form.find(".address-type.selectable[data-value='" + address[field] + "']").addClass('active');
	            }
	            // update the state fields
	            if (field === 'countryCode') {
	                // $form.find('[name$="country"]').trigger('change');
	                // Don't trigger 'change' on the _country field to avoid reloading the country format fields. 
	                $form.find('select[name$="country"]').selectric('refresh');
	                // retrigger state selection after country has changed
	                // this results in duplication of the state code, but is a necessary evil
	                // for now because sometimes countryCode comes after stateCode
	                $form.find('[name$="state"]').val(address.stateCode);
	            }
	
	            //Sets and formats visible phone field.
	            if (field === 'phone--dummy') {
	                $formInput.intlTelInput('setNumber', address['phone']);
	            }
	        }
	    },
	    /**
	     * @function
	     * @description Updates the number of the remaining character
	     * based on the character limit in a text area
	     */
	    limitCharacters: function limitCharacters() {
	        $('form').find('textarea[data-character-limit]').each(function () {
	            var characterLimit = $(this).data('character-limit');
	            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG, '<span class="char-remain-count">' + characterLimit + '</span>', '<span class="char-allowed-count">' + characterLimit + '</span>');
	            var charCountContainer = $(this).next('.char-count');
	            if (charCountContainer.length === 0) {
	                charCountContainer = $('<div class="form-caption char-count"/>').insertAfter($(this));
	            }
	            charCountContainer.html(charCountHtml);
	            // trigger the keydown event so that any existing character data is calculated
	            $(this).change();
	        });
	    },
	    /**
	     * @function
	     * @description Binds the onclick-event to a delete button on a given container,
	     * which opens a confirmation box with a given message
	     * @param {String} container The name of element to which the function will be bind
	     * @param {String} message The message the will be shown upon a click
	     */
	    setDeleteConfirmation: function setDeleteConfirmation(container, message) {
	        $(container).on('click', '.delete', function () {
	            return window.confirm(message);
	        });
	    },
	    /**
	     * @function
	     * @description Scrolls a browser window to a given x point
	     * @param {String} The x coordinate
	     */
	    scrollBrowser: function scrollBrowser(xLocation) {
	        $('html, body').animate({ scrollTop: xLocation }, 500);
	    },
	
	    isMobile: function isMobile() {
	        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
	        var idx = 0;
	        var isMobile = false;
	        var userAgent = navigator.userAgent.toLowerCase();
	
	        while (mobileAgentHash[idx] && !isMobile) {
	            isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
	            idx++;
	        }
	        return isMobile;
	    },
	
	    isMobiles: function isMobiles() {
	        return this.isMobile() && $(window).width() < 768;
	    },
	    isTablet: function isTablet() {
	        return this.isMobile() && $(window).width() >= 768;
	    },
	
	
	    isSafari: function isSafari() {
	        return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	        );
	    },
	
	    /**
	     * @function getCookie
	     *
	     * @param {string} key - The cookie name
	     * @returns {string} value - the value of the cookie if found, null otherwise
	     **/
	    getCookie: function getCookie(key) {
	        var cookies = document.cookie.split(';');
	        for (var i = 0; i < cookies.length; i++) {
	            var tokens = cookies[i].split('=');
	            var cookieKey = tokens[0].trim();
	            if (cookieKey === key) {
	                return tokens[1];
	            }
	        }
	        return '';
	    },
	
	    /**
	     * @function setCookie
	     *
	     * @param {string} key - The cookie name
	     * @param {string} value - The cookie value
	     * @param {integer} minutes - The number of minutes to expire the cookie
	     **/
	    setCookie: function setCookie(key, value, minutes) {
	        var date = new Date();
	        date.setTime(date + minutes * 60 * 1000);
	
	        document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
	    },
	
	    /**
	    * @function
	    * @description Check if the device is touch enabled
	    */
	    hasTouch: function hasTouch() {
	        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	    }
	};
	
	module.exports = util;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * This module is used to switch the product grid image view.
	 */
	
	var Views = function () {
		function Views(query) {
			_classCallCheck(this, Views);
	
			var viewSwitchers = document.querySelectorAll(query);
	
			// assign handlers to each switcher
			[].forEach.call(viewSwitchers, this.setHandler.bind(this));
		}
	
		_createClass(Views, [{
			key: 'setHandler',
			value: function setHandler(viewSwitcher) {
				var viewProps = JSON.parse(viewSwitcher.getAttribute('data-view-props'));
	
				$(viewSwitcher).on('click', function (event) {
					Views.switchView(event, viewProps);
				});
			}
	
			/**
	   * Sswitches the target container's data-view to the passed type.
	   * @param  {[Object]} viewProps: .type: [string], .target: [String selector]
	   */
	
		}], [{
			key: 'switchView',
			value: function switchView(event, viewProps) {
				var viewContainer = document.querySelector(viewProps.target);
	
				viewContainer.setAttribute('data-view', viewProps.type);
	
				Views.updateSlick(viewContainer, viewProps.type);
	
				$.ajax({
					type: 'post',
					url: $(event.target).data('url'),
					dataType: 'json',
					data: {
						'prop': viewProps.type
					}
				});
	
				return false;
			}
	
			/**
	   * Updates the tile slick items (if any) to the target view type: model-view or product-view.
	   * @param  {[Node]} viewContainer [target container from which the slick items should be selected]
	   * @param  {[String]} viewType      [target view type]
	   */
	
		}, {
			key: 'updateSlick',
			value: function updateSlick(viewContainer, viewType) {
				var tileSliders = viewContainer.querySelectorAll('.product__images.slick-slider');
	
				[].forEach.call(tileSliders, function (tile) {
					var $tile = $(tile),
					    targetIndex = Views.getIndex($tile, viewType);
	
					$tile.slick('slickGoTo', targetIndex, true);
				});
			}
		}, {
			key: 'getIndex',
			value: function getIndex($tile, viewType) {
	
				viewType = viewType || $tile.closest('[data-view]').attr('data-view');
	
				return viewType === 'model-view' ? 1 : 0;
			}
		}]);
	
		return Views;
	}();
	
	exports.default = Views;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Very basic HTML5 video player functionality.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _onscreen = __webpack_require__(9);
	
	var _onscreen2 = _interopRequireDefault(_onscreen);
	
	var _born = __webpack_require__(10);
	
	var _module = __webpack_require__(18);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * options::
	 * 	autoplay: [Boolean] Allows video autoplay. Added as a property inside the data-video attribute because we don't want all videos to start playing even when out of screen view.
	 *  clickToggle: [Boolean] Allow clicking on video to play/pause
	 *  playOnSlideIn: [Boolean] Plays the video on Slick slide-in
	 *  dynamicDetect: [Boolean] Wether to detect if video has audio in order to display specific styles/format
	 *  youtubeID: [String] If video should load from a YouTube iframe, this is the YouTube video ID
	 */
	
	var Video = function () {
		function Video(query) {
			_classCallCheck(this, Video);
	
			this.query = query;
			this.videos = document.querySelectorAll(this.query + ':not([data-initialized])');
			this.ytVideos = [];
	
			[].forEach.call(this.videos, this.setupStream.bind(this));
	
			if (!this.setupYTStream() && window.innerWidth >= _born.breakpoints.mobile) {
				this.setOnScreen();
			}
		}
	
		_createClass(Video, [{
			key: 'setupStream',
			value: function setupStream(stream) {
				stream.video = {};
				stream.video.options = this.getSettings(stream);
				stream.setAttribute('data-initialized', true);
	
				//handling youtube videos and HTML5 videos
				if (stream.video.options.youtubeID) {
					this.ytVideos.push(stream);
				}
	
				//Tests if video should detect what kind of presentation to display
				else if (stream.video.options.dynamicDetect) {
						var videoInterval = window.setInterval(function () {
							var anyMobile = _born.isMobile.any();
	
							//This is so terrible.
							if (anyMobile || this.hasAudio(stream)) {
								this.setVideoType(stream, anyMobile);
								this.setHandlers(stream);
	
								window.clearInterval(videoInterval);
							}
						}.bind(this), 100);
					} else {
						this.setHandlers(stream);
					}
			}
	
			//Loops through youtube videos and initializes them on API ready
	
		}, {
			key: 'setupYTStream',
			value: function setupYTStream() {
				if (this.ytVideos.length) {
					if (window.ytIframeAPIReady) {
						this.renderYTVideos(this.ytVideos);
					} else {
						this.loadYTAPI();
	
						window.onYouTubeIframeAPIReady = function () {
							window.ytIframeAPIReady = true;
							this.renderYTVideos(this.ytVideos);
						}.bind(this);
					}
	
					return true;
				}
	
				return false;
			}
	
			/**
	   * Extracts video settings as a JSON object
	   * @return {JSON}        
	   */
	
		}, {
			key: 'getSettings',
			value: function getSettings(stream) {
				var options = stream.getAttribute('data-video');
	
				return options ? JSON.parse(options) : {};
			}
	
			//Determines how the video should be displayed. Either as a cover video, or as a toggable video with audio.
	
		}, {
			key: 'setVideoType',
			value: function setVideoType(stream, forceToggle) {
				if (forceToggle || this.hasAudio(stream)) {
					stream.parentNode.classList.add('video--playwrap');
					stream.video.options.clickToggle = true;
					if (stream.video.options.handleloop && stream.video.options.autoplay) {
						var timeoutTmp = null;
	
						clearInterval(timeoutTmp);
	
						timeoutTmp = setInterval(function () {
							if ($(stream).is(':visible')) {
								if (stream.paused) {
									stream.play();
									clearInterval(timeoutTmp);
								}
							}
						}, 1000);
					}
				} else {
					stream.parentNode.classList.remove('video--playwrap');
					stream.parentNode.classList.add('video--cover');
					stream.loop = true;
					stream.muted = true;
					stream.video.options.autoplay = true;
	
					stream.play();
				}
	
				stream.classList.remove('hidden');
			}
	
			/**
	   * Sets up video's event handlers, not much more.
	   */
	
		}, {
			key: 'setHandlers',
			value: function setHandlers(stream) {
				var _this2 = this;
	
				var clickToggle = stream.video.options.clickToggle;
	
				var steamParent = stream.parentNode;
				var bindedClickHandler = this.toggleVideo.bind(stream);
				var hasPlaywrap = steamParent.classList.contains('video--playwrap');
				var videoBox = steamParent.closest('.video-box');
				var controlButtons = videoBox && videoBox.querySelectorAll('.js-video-control');
	
				if (clickToggle) {
					//If video's parent has the video--playwrap class, add the handler to the parent instead so that we can toggle the pretty "play" icon on and off.
					//(hasPlaywrap ? steamParent : stream).addEventListener('click', hasPlaywrap ? bindedClickHandler : this.toggleVideo);
	
					if (hasPlaywrap) {
						var hasCoverwrap = steamParent.classList.contains('postdetail--video');
						if (hasCoverwrap) {
							steamParent.addEventListener('click', this.toggleCoverVideo.bind(stream));
							steamParent.querySelector('i').addEventListener('click', this.toggleVideoEvent.bind(stream));
	
							/*On Firefox*/
							stream.addEventListener('play', this.toggleCoverVideo.bind(stream));
							stream.addEventListener('pause', this.toggleCoverVideo.bind(stream));
						} else {
							if (!stream.classList.contains("video-redirect-element")) {
								steamParent.addEventListener("click", bindedClickHandler);
							}
						}
					} else {
						stream.addEventListener("click", this.toggleVideo);
					}
				}
	
				if (controlButtons && controlButtons.length) {
					controlButtons.forEach(function (button) {
						button.addEventListener('click', bindedClickHandler);
					});
				}
	
				['playing', 'pause', 'ended'].forEach(function (event) {
					var eventHandler = _this2[event + 'Handler'].bind(_this2);
	
					stream.addEventListener(event, function (e) {
						eventHandler(e, stream);
					});
				});
				this.autoplayFunction(stream);
				Video.initHandlers.call(this, stream);
			}
	
			/**
	   * Detects if video has audio
	   * @return {Boolean}
	   */
	
		}, {
			key: 'hasAudio',
			value: function hasAudio(stream) {
				return true;
			}
		}, {
			key: 'autoplayFunction',
			value: function autoplayFunction() {
				$(".video-redirect-element").each(function (index) {
					var videoElement = $(this);
					var videoData = JSON.parse(videoElement.attr("data-video"));
					var buttons = $(".playPauseBtn");
	
					if (videoData.autoplay === true) {
						videoElement.prop("muted", true).get(0).play();
						videoElement.prop("loop", true);
					}
	
					$(buttons[index]).click(function () {
						var currentVideoElement = $(".video-redirect-element").eq(index)[0];
						if (currentVideoElement.paused) {
							if (videoData.muted === false) {
								$(currentVideoElement).prop('muted', true);
							} else {
								$(currentVideoElement).prop('muted', false);
							}
							setTimeout(function () {
								$(currentVideoElement).get(0).play();
							}, 50);
						} else {
							setTimeout(function () {
								$(currentVideoElement).get(0).pause();
							}, 50);
						}
					});
					videoElement.on("play", function () {
						$(buttons[index]).removeClass('icon--play');
						$(buttons[index]).addClass('icon--pause2');
					});
	
					videoElement.on("pause", function () {
						$(buttons[index]).removeClass('icon--pause2');
						$(buttons[index]).addClass('icon--play');
					});
	
					videoElement.on("ended", function () {
						$(buttons[index]).addClass('icon--play');
						$(buttons[index]).removeClass('icon--pause2');
					});
					videoElement.on('click', function () {
						var videoUrl = $(this).data("video-url");
						if (videoUrl) {
							window.location.href = videoUrl;
						}
					});
				});
			}
	
			/**
	   * Initializes OnScreen, which toggles video playback automatically if said video has teh "autoplay" option or if video has the "playOnSlideIn" AND "videoSlideInView" is set to true (which means video is currently visible on the current slide). Note: "videoSlideInView" is set on the module.carousel module.
	   */
	
		}, {
			key: 'setOnScreen',
			value: function setOnScreen() {
				this.OS = new _onscreen2.default({ tolerance: 200 });
				this.OS.on('enter', this.query, function (stream) {
					if (stream.video && (stream.video.options.autoplay || stream.video.videoSlideInView)) {
						if (stream.video.paused) {
							stream.play();
						}
					}
				}.bind(this));
				this.OS.on('leave', this.query, function (stream) {
					if (stream.video && (stream.video.options.autoplay || stream.video.videoSlideInView)) {
						stream.pause();
					}
				}.bind(this));
			}
		}, {
			key: 'toggleVideo',
			value: function toggleVideo() {
				if (this.paused) {
					this.play();
					$('.video-box__src,.video-box').removeClass('h-mob-100');
				} else {
					this.pause();
				}
			}
		}, {
			key: 'toggleCoverVideo',
			value: function toggleCoverVideo() {
				$(this).on('play', function () {
					$('.icon--play').hide();
					$('.video-box__src,.video-box').removeClass('h-mob-100');
				});
				$(this).on('pause', function () {
					$('.icon--play').show();
				});
			}
		}, {
			key: 'toggleVideoEvent',
			value: function toggleVideoEvent() {
				this.play();
				$(this).on('play', function () {
					$('.icon--play').hide();
					$('.video-box__src,.video-box').removeClass('h-mob-100');
				});
				$(this).on('pause', function () {
					$('.icon--play').show();
				});
			}
	
			/**
	  	* Updates currently playing video status classes in DOM.
	  */
	
		}, {
			key: 'updateDOMComponents',
			value: function updateDOMComponents(stream, isStreamPaused) {
				var $carousel = $(stream).closest('.js-carousel-hero');
				var $videoBox = $(stream).closest('.video-box');
	
				[stream, stream.parentNode].forEach(function (node) {
					node.classList[isStreamPaused ? 'remove' : 'add']('playing');
				});
	
				if ($carousel.length) {
					$carousel[(isStreamPaused ? 'remove' : 'add') + 'Class']('playing').slick('slick' + (isStreamPaused ? 'Play' : 'Pause'));
				}
	
				if ($videoBox.length) {
					$videoBox[(isStreamPaused ? 'remove' : 'add') + 'Class']('playing');
				}
			}
	
			/**
	  	* Video play status handlers
	  */
	
		}, {
			key: 'playingHandler',
			value: function playingHandler(e, stream) {
				this.updateDOMComponents(stream, stream.paused);
			}
		}, {
			key: 'pauseHandler',
			value: function pauseHandler(e, stream) {
				this.updateDOMComponents(stream, stream.paused);
			}
		}, {
			key: 'endedHandler',
			value: function endedHandler(e, stream) {
				this.updateDOMComponents(stream, true);
	
				if (stream.video.options.loop) {
					if (stream.video.options.handleloop) {
						var videoPlayCount = Video.getVideoCookieValue.call(stream);
	
						if (videoPlayCount > 0) {
							if (stream.paused) {
								stream.play();
							} else {
								$('.video-box__src,.video-box').addClass('h-mob-100');
							}
							//TrackingLayer.pushData('autoplay_event: ' + window.Resources['NOSTOCK_SIGNUP']);
						} else if (videoPlayCount <= 0) {
							stream.video.options.autoplay = false;
							stream.currentTime = 0;
							stream.load();
							$('.video-box__src,.video-box').addClass('h-mob-100');
						}
					} else {
						if (stream.paused) {
							stream.play();
						}
					}
				} else {
					$('.video-box__src,.video-box').addClass('h-mob-100');
				}
	
				if (stream.video.options.backToStartOnVideoEnd) {
					stream.video.options.autoplay = false;
					stream.currentTime = 0;
					stream.load();
				}
			}
		}, {
			key: 'renderYTVideos',
	
	
			//Youtube Integration
			value: function renderYTVideos(ytVideos) {
				ytVideos.forEach(this.onYTAPIReady.bind(this));
			}
	
			/**
	   * Inserts youtube script into the DOM, which initializes video API access
	   * https://developers.google.com/youtube/iframe_api_reference
	   */
	
		}, {
			key: 'loadYTAPI',
			value: function loadYTAPI() {
				var ytTag = document.createElement('script'),
				    firstTag = document.getElementsByTagName('script')[0];
	
				ytTag.src = "https://www.youtube.com/iframe_api";
	
				firstTag.parentNode.insertBefore(ytTag, firstTag);
			}
	
			/**
	   * Sets up configurations for the YouTube video object
	   * @param  {[Node]} stream [The youtube video element]
	   */
	
		}, {
			key: 'onYTAPIReady',
			value: function onYTAPIReady(stream) {
				var videoTarget = document.createElement('div');
	
				stream.appendChild(videoTarget);
	
				stream.player = new window.YT.Player(videoTarget, {
					videoId: stream.video.options.youtubeID,
					playerVars: {
						// 'controls': 0,
						'showinfo': 1,
						'modestbranding': 1,
						'rel': 0,
						'origin': window.location.hostname
					},
					events: {
						'onStateChange': this.onYTStateChange.bind(stream)
					}
				});
			}
		}, {
			key: 'onYTStateChange',
			value: function onYTStateChange(evt) {
				if (evt.data === 3 || evt.data === 1) {
					this.classList.add('playing');
				} else {
					this.classList.remove('playing');
				}
			}
		}], [{
			key: 'initHandlers',
			value: function initHandlers(stream) {
				var _this = this;
	
				// Handle mute
				var $videoMuteBlock = $('.js-video-mute');
				if (stream.muted) {
					$videoMuteBlock.addClass('video-muted');
				}
	
				$videoMuteBlock.click(function (e) {
					e.preventDefault();
					stream.muted = !stream.muted;
					$(this).toggleClass('video-muted');
	
					var dataObj = {
						'name': 'N/A',
						'video_src': stream.currentSrc,
						'duration': stream.duration,
						'current_time': stream.currentTime,
						'event': stream.muted ? 'mute' : 'unmute'
					};
	
					_module2.default.pushData(dataObj, 'videoData');
					_module2.default.pushData('video');
				});
	
				// Handle loop playback
				if (stream.video.options.handleloop) {
					var videoPlayCount = Video.getVideoCookieValue.call(stream);
	
					if (videoPlayCount && videoPlayCount <= 0) {
						stream.video.options.autoplay = false;
						stream.pause();
					}
				}
			}
		}, {
			key: 'getVideoCookieValue',
			value: function getVideoCookieValue() {
				var VIDEO_COOKIE_NAME = 'videoPlayCount',
				    MAX_LOOP_TIMES = 2;
				var videoPlayCount = (0, _born.readCookie)(VIDEO_COOKIE_NAME);
	
				if (videoPlayCount) {
					videoPlayCount = +videoPlayCount - 1;
				} else {
					videoPlayCount = MAX_LOOP_TIMES;
				}
	
				(0, _born.createCookie)(VIDEO_COOKIE_NAME, videoPlayCount, SitePreferences.VIDEO_COOKIE_LIFETIME);
	
				return videoPlayCount;
			}
		}]);
	
		return Video;
	}();
	
	exports.default = Video;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Sets up event tracking on specific element. Uses the 'data-tracking' attribute to determine what to track.
	 */
	
	var TrackingLayer = function () {
		function TrackingLayer(query) {
			_classCallCheck(this, TrackingLayer);
	
			var isNode = query instanceof HTMLElement,
			    elList = isNode ? query : document.querySelectorAll(query);
	
			if (isNode) {
				this.setElement(elList);
			} else {
				[].forEach.call(elList, this.setElement.bind(this));
			}
		}
	
		/**
	  * Sets up individual elements that have the data-tracking property
	  * @param {[type]} el [description]
	  */
	
	
		_createClass(TrackingLayer, [{
			key: 'setElement',
			value: function setElement(el) {
				//autoDetect -> Set only when the element doesn't contain a 'data-tracking' attribute,
				//checks the element's HTML tag to determine what type of tracking to use.
				//If a 'data-tracking' is present, then those properties will  be used instead. 
				var options = el.getAttribute('data-tracking') ? JSON.parse(el.getAttribute('data-tracking')) : { autoDetect: true };
	
				options.el = el;
	
				this.setHandler(options);
			}
	
			/**
	   * Adds a tracking handler to the passed element
	   * @param {[Object]} options:
	   *        el: [Node]
	   *        event: [String] Event to listen to
	   *        type: [String] Optional. Handler for the event 
	   *        report: [String] Value that will be reported for the 'layerVar'
	   *        layerVar: [String] Name of the data layer variable, usually part of a 'layerObj'
	   *        layerObj: [String] Name of the data layer object on which this event will be tracked
	   */
	
		}, {
			key: 'setHandler',
			value: function setHandler(options) {
				options.el.trackingLayer = options.el.trackingLayer || {};
	
				if (options.el.trackingLayer.initialized) {
					return false;
				}
	
				var handler = void 0,
				    eventList = void 0;
	
				if (options.autoDetect) {
					if (options.el.nodeName === 'VIDEO') {
						handler = this.video;
						eventList = 'play pause';
	
						if (pageContext && (pageContext.ns === 'storefront' || pageContext.ns === 'brandcampaign')) {
							this.addShareEvents.call(handler);
						}
					}
	
					//If tag is not supported, don't attach anything.
					else {
							return false;
						}
				} else {
					//If 'options.type' does not exist as a method, use the default 'eventTracking' method.
					handler = typeof this[options.type] === 'function' ? this[options.type] : this.eventTracking;
					eventList = options.event || 'click';
				}
	
				eventList = eventList.trim().split(' ');
	
				//Attach a listener for each passed event.
				eventList.forEach(function (eventName) {
					options.el.addEventListener(eventName, handler.bind(options.el, options));
				});
	
				options.el.trackingLayer.initialized = true;
			}
	
			/**
	   * Default tracking method. Just pushes back a report value to the Data Layer
	   * @param  {[String | Boolean]} options.report [property, attribute, or string to report]
	   * @param  {[String]} options.layerVar  [Data Layer variable to report to]
	   * @param  {[String]} options.layerObj [Name of the layer object to attach the variable to. ex: "interactions", "event", etc.]
	   * @param  {[Boolean]} options.asString [DEFAULT: TRUE. Force the data to be pushed as a string]
	   */
	
		}, {
			key: 'eventTracking',
			value: function eventTracking(options) {
				//Determines what to push into the data layerVar.
				//First checks for properties, attributes, and Resources then, if all fails, returns the string 
				var reportVal = this[options.report] || this.getAttribute(options.report) || window.Resources[options.report] || options.report,
				    dataObj = {};
	
				options.asString = options.hasOwnProperty('asString') ? options.asString : true;
	
				//If there's no layer variable, pass as a string for the layer object, 
				if (options.layerVar) {
					if (options.asString) {
						dataObj = options.layerVar + ': ' + reportVal;
					} else {
						dataObj[options.layerVar] = reportVal;
					}
				} else {
					dataObj = reportVal;
				}
	
				TrackingLayer.pushData(dataObj, options.layerObj);
			}
	
			/**
	   * Tracking video interactions
	   */
	
		}, {
			key: 'video',
			value: function video(options, evt) {
				var dataObj = {
					'name': 'N/A',
					'video_src': this.currentSrc,
					'duration': this.duration,
					'current_time': this.currentTime,
					'event': evt.type
				};
	
				TrackingLayer.pushData(dataObj, 'videoData');
				if (pageContext && (pageContext.ns === 'storefront' || pageContext.ns === 'brandcampaign')) {
					TrackingLayer.pushData('video');
				}
			}
		}, {
			key: 'addShareEvents',
			value: function addShareEvents() {
				$('.js-share-events a').on('click', function () {
					var video = $(this).parents().find('video');
	
					if (video.length) {
						var dataObj = {
							'name': 'N/A',
							'video_src': video[0].currentSrc,
							'duration': video[0].duration,
							'current_time': video[0].currentTime,
							'event': $(this).attr('title')
						};
	
						TrackingLayer.pushData(dataObj, 'videoData');
						TrackingLayer.pushData('video');
					}
				});
			}
		}], [{
			key: 'pushData',
			value: function pushData(dataObj, layerObj) {
	
				if (!window.dataLayer) {
					return false;
				}
	
				var varsObj = {};
	
				layerObj = layerObj || 'event';
	
				varsObj[layerObj] = {};
	
				//If the data is an object, loop through it and add all properties
				//Else, add the direct value to the layer object
				if (dataObj.constructor === Object) {
					for (var key in dataObj) {
						varsObj[layerObj][key] = dataObj[key] && typeof dataObj[key] === 'string' ? dataObj[key].toLowerCase() : dataObj[key];
					}
				} else {
					varsObj[layerObj] = dataObj.toLowerCase();
				}
	
				// console.log(varsObj);
				window.dataLayer.push(varsObj);
			}
		}]);
	
		return TrackingLayer;
	}();
	
	exports.default = TrackingLayer;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Attaches functionality to the afterContentShow and afterContentHide methods of [toggle]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _born = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OverlayToggle = function () {
		function OverlayToggle(query) {
			_classCallCheck(this, OverlayToggle);
	
			var els = document.querySelectorAll(query);
	
			[].forEach.call(els, this.setCallbacks);
		}
	
		_createClass(OverlayToggle, [{
			key: 'setCallbacks',
			value: function setCallbacks(el) {
				if (el.toggle) {
					var targetContent = el.toggle.contentEl,
					    cancelWindowScroll = el.hasAttribute('data-toggle-scroll');
	
					targetContent.afterContentShow = function () {
						(0, _born.toggleOverlay)(true, true);
	
						if (cancelWindowScroll) {
							document.documentElement.classList.add('cancel-scroll');
						}
					};
	
					targetContent.afterContentHide = function () {
						(0, _born.toggleOverlay)();
	
						if (cancelWindowScroll) {
							document.documentElement.classList.remove('cancel-scroll');
						}
					};
				}
			}
		}]);
	
		return OverlayToggle;
	}();
	
	exports.default = OverlayToggle;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _born = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * [createModal creates a modal and body overlay on the fly
	 * @param  {[object literal]} options [
	 * options to setup your modal
	 * 
	 * modalID: [string] modal ID, can be space separeted for multiple classes. This class should be unique if you're using keepAlive because the method will open the modal through that class, if there exists more than one match it'll open the first one.
	 * 
	 * modalContent: [object] element object which contains all the content for your modal. 
	 * 
	 * wrapper: [string] (optional) specify a custom wrapper for the overlay, defaults to the page's '.wrapper' element.
	 * 
	 * keepAlive: [boolean] (optional) wether or not to not remove the modal from the DOM after it's closed. Defaults to false.
	 * 
	 * closeCallback: [function] (optional) callback to run after the modal is closed.
	 * 
	 * beforeOpenCallback: [function] (optiona) callback to run before the modal is opened.
	 * 
	
	 * afterCreateCallback: [function] (optional) callback that runs after the modal is created. If keepAlive is true it will run every time the modal loads.
	 * 
	 * ]
	 * @return {[object]}         [returns overlay element]
	 */
	
	var Modal = function () {
		function Modal(options) {
			_classCallCheck(this, Modal);
	
			this.options = options || {};
	
			//Options
			this.options.closeOthers = this.options.closeOthers ? true : false;
			this.options.overlayClass = 'window-overlay ' + (this.options.overlayClass || '');
			this.options.modalClass = 'window-overlay--modal ' + (this.options.modalClass || '');
			this.options.modalID = this.options.modalID || 'window-overlay-default-id';
			this.options.wrapper = (typeof this.options.wrapper === 'string' ? document.querySelector(this.options.wrapper) : this.options.wrapper) || document.querySelector('body');
			this.options.isCloseBlocked = this.options.isCloseBlocked ? true : false;
	
			//Callbacks
			this._beforeOpenCallback = this.options.beforeOpenCallback || function () {};
			this._afterCreateCallback = this.options.afterCreateCallback || function () {};
	
			this.overlay = document.querySelector('#modal-' + this.options.modalID);
	
			this._beforeOpenCallback(this.overlay, this);
	
			//Close other modals before opening this one if true.
			if (this.options.closeOthers) {
				Modal.closeModal();
			}
	
			//If overlay doesn't exist create it
			if (!this.overlay) {
				this.overlay = this.renderModal();
			}
	
			if (this.options.update) {
				this.updateModal(this.overlay, this.options.modalContent);
			}
	
			this._afterCreateCallback(this.overlay, this);
	
			Modal.openModal(this.overlay);
		}
	
		/**
	  * creates the modal
	  */
	
	
		_createClass(Modal, [{
			key: 'renderModal',
			value: function renderModal() {
				var _this = this;
	
				var overlay = (0, _born.createElWithAttrs)(false, { 'id': 'modal-' + this.options.modalID, 'class': this.options.overlayClass, 'data-modal-id': this.options.modalID }),
				    modal = (0, _born.createElWithAttrs)(overlay, { 'class': this.options.modalClass });
	
				if (!this.options.isCloseBlocked) {
					this.insertCloseBtn(modal);
				}
	
				overlay.modal = {};
				overlay.modal.wrapper = this.options.wrapper;
				overlay.modal.keepAlive = this.options.hasOwnProperty('keepAlive') ? this.options.keepAlive : true;
				overlay.modal.afterOpen = this.options.afterOpenCallback || function () {};
				overlay.modal.afterClose = this.options.afterCloseCallback || function () {};
				overlay.modal.open = Modal.openModal.bind(this, overlay);
				overlay.modal.close = Modal.closeModal;
				overlay.modal.isCloseBlocked = this.options.isCloseBlocked;
	
				if (this.options.modalContent) {
					this.insertContent(modal, this.options.modalContent);
				}
	
				//Using jQuery append cause sometimes the HTML might contain <script> tags
				$(overlay.modal.wrapper).append(overlay);
	
				//Delay activation a bit to allow for DOM appends to finish, hopefully.
				//This is ugly.
				var checkReady = setInterval(function () {
					if (Modal.exists(_this.options.modalID)) {
						clearInterval(checkReady);
	
						overlay.modal.open();
					}
				});
	
				return overlay;
			}
	
			/**
	   * Replaces modal's ID and content with the provided values
	   * @param  {[type]} options [description]
	   */
	
		}, {
			key: 'updateModal',
			value: function updateModal(overlay, modalContent, newID) {
				var modal = overlay.querySelector('.window-overlay--modal');
	
				if (newID) {
					overlay.id = 'modal-' + newID;
					overlay.setAttribute('data-modal-id', newID);
				}
	
				modal.innerHTML = '';
				this.insertContent(modal, modalContent);
	
				if (!this.options.isCloseBlocked) {
					this.insertCloseBtn(modal);
				}
			}
	
			//Inserts close button into modal
	
		}, {
			key: 'insertCloseBtn',
			value: function insertCloseBtn(modal) {
				var closeBtn = (0, _born.createElWithAttrs)(modal, { 'class': 'window-overlay--close', 'data-modal-close': true }, 'span');
			}
	
			//Adds modal content depending as a string or as a node.
	
		}, {
			key: 'insertContent',
			value: function insertContent(modal, modalContent) {
				if (typeof modalContent === 'string') {
					modal.insertAdjacentHTML('afterbegin', modalContent);
				} else {
					modal.appendChild(modalContent);
				}
			}
	
			/**
	   * Opens referenced modal
	   * @param  {[Node]} overlay [Overlay element to be opened]
	   */
	
		}], [{
			key: 'openModal',
			value: function openModal(overlay) {
	
				overlay.addEventListener('click', Modal.closeModal);
				document.body.addEventListener('keydown', Modal.closeModal);
	
				document.documentElement.classList.add('cancel-scroll');
				overlay.classList.add('overlay--active');
				overlay.modal.wrapper.classList.add('overlay--shown');
	
				//Run this when eerything's in place
				overlay.modal.afterOpen(overlay);
			}
	
			/**
	   * [closeModal method to... You guessed it, close modals!]
	   * @param  {[object]} e [event]
	   */
	
		}, {
			key: 'closeModal',
			value: function closeModal(e) {
				var overlay = Modal.getActiveOverlay(),
				    canClose = true;
	
				if (!overlay) {
					return;
				}
	
				if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
					var wasClick = e.type === 'click' && (e.target === overlay || e.target.hasAttribute('data-modal-close')),
					    wasEsc = document.activeElement.tagName !== 'INPUT' && e.keyCode === 27;
	
					canClose = wasClick || wasEsc;
				}
	
				if (overlay.modal.isCloseBlocked) {
					canClose = false;
				}
	
				if (canClose) {
					overlay.removeEventListener('click', Modal.closeModal);
					document.body.removeEventListener('keydown', Modal.closeModal);
	
					document.documentElement.classList.remove('cancel-scroll');
					overlay.modal.wrapper.classList.remove('overlay--shown');
	
					if (overlay.modal.keepAlive) {
						overlay.classList.remove('overlay--active');
					} else {
						overlay.parentNode.removeChild(overlay);
					}
	
					overlay.modal.afterClose(overlay, e);
				}
			}
	
			/**
	   * Gets the currently active modal
	   * @return {Node}
	   */
	
		}, {
			key: 'getActiveOverlay',
			value: function getActiveOverlay() {
				return document.querySelector('.window-overlay.overlay--active');
			}
	
			/**
	   * Returns Modal NodeElement if the passed ID matches a modal.
	   * @return {Node}    
	   */
	
		}, {
			key: 'exists',
			value: function exists(modalID) {
				return document.querySelector('#modal-' + modalID);
			}
		}]);
	
		return Modal;
	}();
	
	exports.default = Modal;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This module is used to detect and validate international phone input fields.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Uses 'intl-tel-input' available through vendor.js <–> WebPack
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	__webpack_require__(22);
	
	var _born = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(query) {
			_classCallCheck(this, _class);
	
			//let siteSelectedCountry = $('select#countrySelectorList :selected').data('country'),
			var siteSelectedCountry = 'ae',
			    telInputs = document.querySelectorAll(query),
			    excludeCountries = [];
	
			try {
				var selectorEl = $('select#countrySelectorList :selected');
				var currentSite = selectorEl.length > 0 ? selectorEl.data('country') : false;
				if (!currentSite) {
					currentSite = (0, _born.readCookie)('preferredCountry');
				}
				if (currentSite && currentSite.toUpperCase() == 'LB') {
					excludeCountries.push('il');
				}
			} catch (e) {}
	
			// assign handlers to each phone input, needs to be individual to detect country per form
			[].forEach.call(telInputs, function (telInput) {
				var $telInput = $(telInput),
				    formCountry = $telInput.closest('form').find('input.country, select.country').val(),
				    selectedCountry = formCountry ? formCountry : siteSelectedCountry;
	
				$telInput.intlTelInput({
					initialCountry: selectedCountry,
					preferredCountries: ["ae"],
					excludeCountries: excludeCountries,
					utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.7/js/utils.js',
					customPlaceholder: function customPlaceholder(selectedCountryPlaceholder) {
						return '\u200E' + selectedCountryPlaceholder;
					}
				});
	
				this.setDummyPhone(telInput);
			}.bind(this));
		}
	
		/**
	  * Update a hidden phone field with the full phone number
	  * Needed cause by default the country code is hidden.
	  */
	
	
		_createClass(_class, [{
			key: 'setDummyPhone',
			value: function setDummyPhone(originalPhone) {
				var $originalPhone = $(originalPhone),
				    dummyPhone = document.createElement('input');
	
				dummyPhone.type = 'hidden';
				dummyPhone.name = originalPhone.name;
	
				originalPhone.name = originalPhone.name + '--dummy';
				originalPhone.parentNode.appendChild(dummyPhone);
	
				$originalPhone.closest('form').on('submit', function () {
					var originalPhoneNumber = $originalPhone.intlTelInput('getNumber');
					if (!originalPhoneNumber.length) {
						originalPhoneNumber = $originalPhone.val();
					}
	
					dummyPhone.value = originalPhoneNumber;
				});
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Toggle = function () {
		function Toggle(query) {
			_classCallCheck(this, Toggle);
	
			var triggers = document.querySelectorAll(query + ':not([data-initialized])');
	
			[].forEach.call(triggers, this.setTriggers.bind(this));
	
			document.addEventListener('keydown', function (evt) {
				if (evt.keyCode === 13 && this.activeElement !== document.body && this.activeElement.toggle) {
					$(this.activeElement).trigger('target.toggle', evt);
				}
			});
		}
	
		/**
	  * [setTriggers checks the current trigger for the data-persistent attribute and adds classes if it has that attribute]
	  * @param {[object]} trigger [the trigger element, which contains the data-persistent attribute]
	  * data-toggle-onleave
	  * data-toggle-onout
	  * data-toggle-persistent
	  * data-toggle-immediate
	  * data-toggle-closerelatives
	  * data-toggle-close
	  * data-toggle-noclose
	  */
	
	
		_createClass(Toggle, [{
			key: 'setTriggers',
			value: function setTriggers(trigger) {
	
				var triggerParent = this.getParent(trigger),
				    triggerTarget = this.getTarget(trigger, triggerParent);
	
				if (!triggerTarget) {
					return;
				}
	
				trigger.toggle = {};
	
				trigger.toggle.contentEl = triggerTarget;
				trigger.toggle.parentEl = triggerParent;
				trigger.toggle.activeClass = 'toggle--active';
	
				triggerTarget.toggle = {};
	
				triggerTarget.toggleContent = Toggle.toggle.bind(this, trigger);
				triggerTarget.showContent = Toggle.show.bind(this, trigger);
				triggerTarget.hideContent = Toggle.hide.bind(this, trigger);
	
				triggerTarget.afterContentHide = triggerTarget.afterContentHide || function () {
					return true;
				};
				triggerTarget.beforeUnsetOthers = triggerTarget.beforeUnsetOthers || function () {
					return true;
				};
				triggerTarget.beforeContentShow = triggerTarget.beforeContentShow || function () {
					return true;
				};
				triggerTarget.afterContentShow = triggerTarget.afterContentShow || function () {
					return true;
				};
	
				if (trigger.hasAttribute('data-toggle-persistent')) {
					triggerTarget.toggle.persistent = true;
	
					//This should only take place if data-toggle-persistent is set because otherwise it makes no sense to have it.
					if (trigger.hasAttribute('data-toggle-closerelatives')) {
						triggerTarget.toggle.relatives = trigger.getAttribute('data-toggle-closerelatives');
					}
				}
	
				if (trigger.hasAttribute('data-toggle-immediate')) {
					triggerTarget.showContent();
				}
	
				this.setHandlers(trigger);
	
				trigger.setAttribute('data-initialized', true);
			}
		}, {
			key: 'setHandlers',
			value: function setHandlers(trigger) {
				var self = this,
				    evtType = trigger.getAttribute('data-toggle-event') || 'click';
	
				$(trigger).on(evtType + ' target.toggle', function (evt, relayedEvt) {
					//Check if the relayedEvt object contains the properties or methods we're going to use...
					//This is useful when 'target.toggle' is triggered through an external event and we need to use that other event's data.
					var canUseRelayed = relayedEvt && relayedEvt.type && relayedEvt.preventDefault && relayedEvt.stopImmediatePropagation,
					    triggerEvt = canUseRelayed ? relayedEvt : evt,
					    isTouchStart = triggerEvt.type === 'touchstart';
	
					if (this.nodeName === 'A' || isTouchStart) {
						triggerEvt.preventDefault();
					}
	
					Toggle.toggle.call(self, this, evt);
	
					if (isTouchStart) {
						triggerEvt.stopImmediatePropagation();
					}
				});
			}
	
			/**
	   * [getParent] Gets and returns the trigger's parent. If no parent selector is set with data-parent it will default to parentNode
	   * @param  {[object]} trigger [the target trigger]
	   * @return {[object]}         [trigger's target parent]
	   */
	
		}, {
			key: 'getParent',
			value: function getParent(trigger) {
				return document.querySelector(trigger.getAttribute('data-toggle-parent')) || trigger.parentNode;
			}
	
			/**
	   * [getTarget] Gets and returns the trigger's content. If there are more than one matching content
	   * the method will return the trigger's parent content.
	   * @param  {[object]} trigger       [the target trigger]
	   * @return {[object]}               [the targeted content]
	   */
	
		}, {
			key: 'getTarget',
			value: function getTarget(trigger, triggerParent) {
				var contentSelector = trigger.getAttribute('data-toggle-target'),
				    contentEl = document.querySelectorAll(contentSelector);
	
				if (!contentEl.length) {
					console.warn('No content target (data-toggle-target) provided or element not found for: ', trigger);
	
					return;
				}
	
				return contentEl.length > 1 ? triggerParent.querySelector(contentSelector) : contentEl[0];
			}
	
			/**
	   * [hide] hides the target content and removes events from the body
	   * @param  {[object]} trigger
	   */
	
		}], [{
			key: 'hide',
			value: function hide(trigger) {
				Toggle.$body = Toggle.$body || $('body');
	
				var triggerOptions = trigger.toggle,
				    triggerTarget = triggerOptions.contentEl;
	
				trigger.classList.remove(triggerOptions.activeClass);
				triggerOptions.parentEl.classList.remove(triggerOptions.activeClass);
				triggerTarget.classList.remove(triggerOptions.activeClass);
	
				if (triggerOptions.pointerTouchEvt) {
					Toggle.$body.off('.' + trigger.getAttribute('data-toggle-target'));
				}
	
				triggerTarget.afterContentHide(trigger);
			}
	
			/**
	   * [show description]
	   * beforeContentShow, afterContentShow are fired here
	   * 
	   * @param  {[type]} trigger [description]
	   * @param  {[type]} evtType [description]
	   * @return {[type]}         [description]
	   */
	
		}, {
			key: 'show',
			value: function show(trigger, evtType) {
	
				Toggle.$body = Toggle.$body || $('body');
	
				var triggerEvt = evtType || '',
				    triggerTarget = trigger.toggle.contentEl,
				    triggerParent = trigger.toggle.parentEl;
	
				if (triggerTarget.beforeContentShow(trigger)) {
	
					if (triggerTarget.beforeUnsetOthers()) {
						Toggle.unsetActive(trigger.toggle.activeClass, triggerTarget.toggle.relatives);
					}
	
					trigger.classList.add(trigger.toggle.activeClass);
					triggerParent.classList.add(trigger.toggle.activeClass);
					triggerTarget.classList.add(trigger.toggle.activeClass);
	
					triggerTarget.afterContentShow(trigger);
	
					//If the current trigger doesn't have the data-toggle-onout, toggle (attach) a hide click event to the body
					//to hide the content if the users clicks outside the trigger or its content.
					if (!trigger.getAttribute('data-toggle-onout')) {
						var bodyEvtType = triggerEvt.indexOf('touch') >= 0 ? triggerEvt : 'click';
						//Attach this property to determine if we should remove the click event from the body after it's being executed.
						trigger.toggle.pointerTouchEvt = bodyEvtType + '.' + trigger.getAttribute('data-toggle-target');
	
						$('body').off('.' + trigger.getAttribute('data-toggle-target')).on(trigger.toggle.pointerTouchEvt, function (evt) {
	
							var $target = $(evt.target),
							    $closestParent = $target.closest(triggerParent),
							    $closestContent = $target.closest(triggerTarget);
	
							// if(!$target.closest('.toggle--active').length){
							// This is also ugly, but it works. The reason we check for parent AND content length is
							// cause sometimes the parent does not contain the content, but only the trigger
							if (!$closestContent.length && !$closestParent.length && $target[0] !== trigger) {
								// console.log('click', trigger);
								triggerTarget.hideContent();
							}
						});
					}
	
					//Hide content on hover out
					if (trigger.hasAttribute('data-toggle-onleave')) {
						var $triggerParent = $(triggerParent);
	
						$triggerParent.on('mouseleave.hideOnLeave', function () {
							$triggerParent.off('mouseleave.hideOnLeave');
							triggerTarget.hideContent();
						});
					}
	
					//Toggles the content off after 'data-toggle-timeout' has elapsed
					if (trigger.hasAttribute('data-toggle-timeout')) {
						window.setTimeout(triggerTarget.hideContent, trigger.getAttribute('data-toggle-timeout'));
					}
	
					//This is very ugly, but it works.
					var closeTargets = triggerTarget.querySelectorAll('[data-toggle-close]');
	
					[].forEach.call(closeTargets, function (closeEl) {
						$(closeEl).off('click.closeContent').on('click.closeContent', triggerTarget.hideContent);
					});
				}
			}
	
			/**
	   * [toggle] determines wether it should display or hide the content.
	   * Gets the current active triggers and removes their active classes.
	   * @param  {[object]} trigger [trigger which has the target content and parent]
	   */
	
		}, {
			key: 'toggle',
			value: function toggle(trigger, evt) {
				var triggerTarget = trigger.toggle.contentEl,
				    evtType = evt ? evt.type : '';
	
				if (triggerTarget.classList.contains(trigger.toggle.activeClass)) {
					if (!trigger.hasAttribute('data-toggle-noclose') && evtType !== 'mouseenter') {
						triggerTarget.hideContent();
					}
				} else {
					Toggle.show(trigger, evtType);
					if (trigger.hasAttribute('data-toggle-scrollup')) {
						var scrollTarget = trigger.getAttribute('data-toggle-scrollup');
						if (scrollTarget && $(scrollTarget).length > 0) {
							$('html, body').animate({
								scrollTop: $(scrollTarget).offset().top
							}, 1000);
						}
					}
				}
			}
	
			/**
	   * Unsets all active items. Unless the item has the data-toggle-persistent attribute (but if it has data-toggle-persistent AND data-toggle-closerelatives the the relatives will be closed)
	   */
	
		}, {
			key: 'unsetActive',
			value: function unsetActive(activeClass, relatives) {
				var activeTriggers = document.querySelectorAll('.' + activeClass + ':not([data-toggle-target])');
	
				Array.prototype.forEach.call(activeTriggers, function (activeItem) {
					if (activeItem.toggle && (!activeItem.toggle.persistent || activeItem.classList.contains(relatives)) && activeItem.hideContent) {
						activeItem.hideContent();
					}
				});
			}
		}]);
	
		return Toggle;
	}();
	
	exports.default = Toggle;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductRating = function () {
		function ProductRating(query) {
			var _this = this;
	
			_classCallCheck(this, ProductRating);
	
			var ratings = $(query + ':not(.star-init)');
			ratings.each(function (index, el) {
				var score = $(el).data('score');
				if (score === undefined || score <= 0) {
					return;
				}
				var starEl = $(el).find('.stars-inner');
				if (starEl.length <= 0) {
					return;
				}
				var ratingPercentage = _this.getRatingPercentage(score);
				starEl.width(ratingPercentage);
				$(el).addClass('star-init');
			});
		}
	
		_createClass(ProductRating, [{
			key: 'getRatingPercentage',
			value: function getRatingPercentage(rating) {
				var ratingTotal = 5;
				var ratingPercentage = rating / ratingTotal * 100;
				ratingPercentage = ratingPercentage + '%';
				return ratingPercentage;
			}
		}]);
	
		return ProductRating;
	}();
	
	exports.default = ProductRating;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	 * Add page/section specific features here.
	 *
	 * To load a feature on more than one page,
	 * separate each class name with a comma and a space
	 * @type {Object}
	 */
	
	var Pages = {
		'.pt_azdesigners': {
			init: function init() {
				__webpack_require__.e/* nsure */(1, function () {
					__webpack_require__(27);
				});
			}
		},
	
		'.pt_product-details': {
			init: function init() {
				__webpack_require__.e/* nsure */(2, function () {
					__webpack_require__(29).init();
				});
			}
		},
	
		'.pt_product-search-result': {
			init: function init() {
				!/* require.ensure */(function () {
					__webpack_require__(49).init();
				}(__webpack_require__));
			}
		},
	
		'.pt_blog': {
			init: function init() {
				__webpack_require__.e/* nsure */(3, function () {
					__webpack_require__(52).init();
				});
			}
		},
	
		'.pt_checkout': {
			init: function init() {
				__webpack_require__.e/* nsure */(4, function () {
					__webpack_require__(53).init();
				});
			}
		}
	};
	
	exports.default = Pages;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(7);
	
	function pdpOfferTimer() {
		var isQuickview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		var countdownTo = $('.pdpTimerCountdownTo' + (isQuickview ? '.quickview-timer' : '')).first().val();
		if (!countdownTo || !countdownTo.length) {
			$((isQuickview ? '.quickview__dialog ' : '') + '.pdp__timer').hide();
			return;
		}
		var intrvl = setInterval(function () {
			var now = new Date().getTime();
			countdownTo = new Date(countdownTo).getTime();
			var counterStart = countdownTo - now;
			var timeEntries = $((isQuickview ? '.quickview__dialog ' : '') + '.pdp__timer-countdown-item--number');
			if (counterStart <= 0) {
				$((isQuickview ? '.quickview__dialog ' : '') + '.pdp__timer').hide();
				return;
			}
	
			if (counterStart < 0) {
				timeEntries.each(function (index) {
					$(this).html('00');
				});
				clearInterval(intrvl);
			} else {
				var days = Math.floor(counterStart / (1000 * 60 * 60 * 24));
				var hrs = Math.floor(counterStart % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
				var mins = Math.floor(counterStart % (1000 * 60 * 60) / (1000 * 60));
				var secs = Math.floor(counterStart % (1000 * 60) / 1000);
	
				var timer = [days, hrs, mins, secs];
				timer = timer.map(function (num) {
					return num.toLocaleString('en-US', {
						minimumIntegerDigits: 2,
						useGrouping: false
					});
				});
				var length = timer.length;
				timeEntries.each(function (index) {
					if (index < length) {
						$(this).html(timer[index]);
					} else {
						$(this).html(timer[index - length]);
					}
				});
			}
		}, 1000);
	}
	
	function categoryOfferTimer() {
		var countdownTo = $('.plpTimerCountdownTo').first().val();
		if (!countdownTo || !countdownTo.length) {
			$('.plp__offer__timer').hide();
			return;
		}
		var intrvl = setInterval(function () {
			var now = new Date().getTime();
			countdownTo = new Date(countdownTo).getTime();
			var counterStart = countdownTo - now;
			var timeEntries = $('.plp__offer__timer-countdown-item--number');
			if (counterStart <= 0) {
				$('.plp__offer__timer').hide();
				return;
			}
	
			if (counterStart < 0) {
				timeEntries.each(function (index) {
					$(this).html('00');
				});
				clearInterval(intrvl);
			} else {
				var days = Math.floor(counterStart / (1000 * 60 * 60 * 24));
				var hrs = Math.floor(counterStart % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
				var mins = Math.floor(counterStart % (1000 * 60 * 60) / (1000 * 60));
				var secs = Math.floor(counterStart % (1000 * 60) / 1000);
	
				var timer = [days, hrs, mins, secs];
				timer = timer.map(function (num) {
					return num.toLocaleString('en-US', {
						minimumIntegerDigits: 2,
						useGrouping: false
					});
				});
	
				timeEntries.each(function (index) {
					$(this).html(timer[index]);
				});
			}
		}, 1000);
	}
	
	exports.pdpOfferTimer = pdpOfferTimer;
	exports.categoryOfferTimer = categoryOfferTimer;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var progress = __webpack_require__(43),
	    util = __webpack_require__(15);
	
	var currentRequests = [];
	
	/**
	 * @function
	 * @description Ajax request to get json response
	 * @param {Boolean} async  Asynchronous or not
	 * @param {String} url URI for the request
	 * @param {Object} data Name/Value pair data request
	 * @param {Function} callback  Callback function to be called
	 */
	var getJson = function getJson(options) {
	    options.url = util.toAbsoluteUrl(options.url);
	    // return if no url exists or url matches a current request
	    if (!options.url || currentRequests[options.url]) {
	        return;
	    }
	
	    currentRequests[options.url] = true;
	
	    // make the server call
	    $.ajax({
	        dataType: 'json',
	        url: options.url,
	        async: typeof options.async === 'undefined' || options.async === null ? true : options.async,
	        data: options.data || {}
	    })
	    // success
	    .done(function (response) {
	        if (options.callback) {
	            options.callback(response);
	        }
	    })
	    // failed
	    .fail(function (xhr, textStatus) {
	        if (textStatus === 'parsererror') {
	            window.alert(Resources.BAD_RESPONSE);
	        }
	        if (options.callback) {
	            options.callback(null);
	        }
	    })
	    // executed on success or fail
	    .always(function () {
	        // remove current request from hash
	        if (currentRequests[options.url]) {
	            delete currentRequests[options.url];
	        }
	    });
	};
	/**
	 * @function
	 * @description ajax request to load html response in a given container
	 * @param {String} url URI for the request
	 * @param {Object} data Name/Value pair data request
	 * @param {Function} callback  Callback function to be called
	 * @param {Object} target Selector or element that will receive content
	 */
	var load = function load(options) {
	    options.url = util.toAbsoluteUrl(options.url);
	    // return if no url exists or url matches a current request
	    if (!options.url || currentRequests[options.url]) {
	        return;
	    }
	
	    currentRequests[options.url] = true;
	
	    // make the server call
	    $.ajax({
	        dataType: 'html',
	        url: util.appendParamToURL(options.url, 'format', 'ajax'),
	        data: options.data,
	        xhrFields: {
	            withCredentials: true
	        }
	    }).done(function (response) {
	        // success
	        if (options.target) {
	            $(options.target).empty().html(response);
	        }
	        if (options.callback) {
	            options.callback(response);
	        }
	    }).fail(function (xhr, textStatus) {
	        // failed
	        if (textStatus === 'parsererror') {
	            window.alert(Resources.BAD_RESPONSE);
	        }
	        options.callback(null, textStatus);
	    }).always(function () {
	        progress.hide();
	        // remove current request from hash
	        if (currentRequests[options.url]) {
	            delete currentRequests[options.url];
	        }
	    });
	};
	
	exports.getJson = getJson;
	exports.load = load;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	var $loader;
	
	/**
	 * @function
	 * @description Shows an AJAX-loader on top of a given container
	 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
	 */
	var show = function show(container) {
	    var target = !container || $(container).length === 0 ? $('body') : $(container);
	    $loader = $loader || $('.loader');
	
	    if ($loader.length === 0) {
	        $loader = $('<div/>').addClass('loader').append($('<div/>').addClass('loader-indicator loading'), $('<div/>').addClass('loader-bg'));
	    }
	    return $loader.appendTo(target).show();
	};
	/**
	 * @function
	 * @description Hides an AJAX-loader
	 */
	var hide = function hide() {
	    if ($loader) {
	        $loader.hide();
	    }
	};
	
	exports.show = show;
	exports.hide = hide;

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _born = __webpack_require__(10);
	
	var dialog = __webpack_require__(46);
	var util = __webpack_require__(15);
	var progress = __webpack_require__(43);
	var storeContext = { name: 'storelocator' };
	var STORE_OPTIONS = {
		listView: '.store-list-wrapper',
		searchContainer: '.search-container',
		searchInput: 'input[name="qstoresrch"]',
		centerLat: geCenterLat(),
		centerLng: getCenterLng(),
		mapID: 'storelocationmap',
		listViewWrap: '#map-view-list',
		mapViewWrap: '#map-view-mark',
		zoomSize: getZoomSize(),
		searchButton: '.store__search__trigger',
		mobHeadView: '.store__mob--heading',
		pagination: '.store-pagination',
		perPage: 'input[name="store-per-page"]',
		searchItems: '#store-search-items'
	};
	
	var gmapEl = void 0;
	var inforObj = [];
	var markersOnMap = [];
	var gMarkers = [];
	var gmInfoWindows = [];
	var searchCallTimer = false;
	var searchCallXhr = true;
	var activeCount = void 0;
	var gmlatlng = [];
	var iconURL = '';
	
	window.userCoordinates = false;
	
	function getCenterCord() {
		return {
			lat: geCenterLat(),
			lng: getCenterLng()
		};
	}
	
	function geCenterLat() {
		var centerLat = getStoreSpecificField('centerLat');
		if (centerLat) {
			return centerLat;
		}
		return 25.044633;
	}
	
	function getCenterLng() {
		var centerLng = getStoreSpecificField('centerLng');
		if (centerLng) {
			return centerLng;
		}
	
		return 55.118962;
	}
	
	function getZoomSize() {
		var zoomSize = getStoreSpecificField('zoom');
		if (zoomSize) {
			return zoomSize;
		}
	
		return 7;
	}
	
	function getStoreSpecificField(name) {
		if (SitePreferences.SITE_SPECIFIC_CONFIGS) {
			var config = JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS).storeLocatorCenter;
			if (config && config[name] !== undefined && config[name]) {
				return config[name];
			}
		}
	
		return false;
	}
	
	function addGMarkerInfo(markers) {
		if (markers !== undefined) {
			markersOnMap = markers;
		}
		var btnClass = 'button button--primary btn-temp';
		var btnIcon = '';
		if (storeContext.name == 'pdpstore') {
			btnClass = 'store-dirlink map-address-details';
			btnIcon = '<span class="icon-left"></span>';
		}
		for (var i = 0; i < markersOnMap.length; i++) {
			var gcord = markersOnMap[i].coordinates;
			if (gcord.lat != null && gcord.lng != null) {
				var contentString;
				var latlng;
	
				(function () {
					contentString = '<div class="store-details">' + '<div class="store-image-container">' + '<img src="' + markersOnMap[i].image + '" alt="store-image" class="store-image" />' + '</div>' + '<div class="store-details-container" data-storeid="' + markersOnMap[i].id + '">' + '<h1 class="store-name text-uppercase text-nowrap">' + markersOnMap[i].name + '</h1>' + '<h3 class="store-location text-nowrap">' + markersOnMap[i].address + '</h3>' + '<span class="store-timing text-uppercase">' + markersOnMap[i].timing + '</span>' + '<span class="store-contact">' + markersOnMap[i].contact + '</span>' + '<a href="http://maps.google.com/maps?hl=en&f=q&q=' + encodeURI(markersOnMap[i].geolocation) + '" target="_blank" class="' + btnClass + '">' + Resources.STORE_INFO_BUTTON + ' ' + btnIcon + '</a>' + '</div>' + '</div>';
	
	
					iconURL = getIconUrl();
					var marker = new google.maps.Marker({
						position: markersOnMap[i].coordinates,
						map: gmapEl,
						icon: iconURL
					});
	
					var infowindow = new google.maps.InfoWindow({
						content: contentString,
						maxWidth: 400
					});
					if (storeContext.name == 'pdpstore') {
						google.maps.event.addListener(infowindow, 'domready', function () {
							trackStoreEvent();
						});
					}
					marker.addListener('click', function () {
						closeOtherInfo();
						infowindow.open(marker.get('map'), marker);
						inforObj[0] = infowindow;
					});
	
					marker.addListener('mouseover', function () {
						closeOtherInfo();
						infowindow.open(marker.get('map'), marker);
						inforObj[0] = infowindow;
					});
	
					gMarkers.push(marker);
	
					latlng = new google.maps.LatLng(gcord.lat, gcord.lng);
	
					gmlatlng.push(latlng);
				})();
			}
		}
	
		if (gmlatlng.length > 0) {
			var latlngbounds = new google.maps.LatLngBounds();
			for (var i = 0; i < gmlatlng.length; i++) {
				latlngbounds.extend(gmlatlng[i]);
			}
			gmapEl.fitBounds(latlngbounds);
			gmapEl.setZoom(getZoomSize());
		}
	
		trackStoreEvent();
	}
	
	function addGMarkers() {
		iconURL = getIconUrl();
		for (var i = 0; i < markersOnMap.length; i++) {
			var gcord = markersOnMap[i].coordinates;
			if (gcord.lat != null && gcord.lng != null) {
				var marker = new google.maps.Marker({
					position: markersOnMap[i].coordinates,
					map: gmapEl,
					icon: iconURL
				});
				gMarkers.push(marker);
			}
		}
	}
	
	function showListView() {
		$(STORE_OPTIONS.listView).show();
		showPagination();
	}
	
	function hideListView() {
		$(STORE_OPTIONS.listView).hide();
		hidePagination();
	}
	
	function removeActiveView() {
		$('.map-view-options .icon').removeClass('set--active');
	}
	
	function setActiveView() {
		var activeEl = false;
	
		$('.map-view-options .icon').each(function () {
			if ($(this).hasClass('set--active')) {
				activeEl = $(this);
				return false;
			}
		});
		var listViewWrapOption = STORE_OPTIONS.listViewWrap;
		if (activeEl) {
			if (listViewWrapOption.indexOf(activeEl.attr('id')) !== -1 || listViewWrapOption.indexOf(activeEl.attr('class')) !== -1) {
				setListView();
			} else {
				setMapView();
			}
		}
	}
	
	function closeOtherInfo() {
		if (inforObj.length > 0) {
			inforObj[0].set("marker", null);
			inforObj[0].close();
			inforObj.length = 0;
		}
	}
	
	function searchStores(q, init, count) {
		var siteSpecificConfigs = JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
		var showAllStoresOnLoad = false;
		if (siteSpecificConfigs && _typeof(siteSpecificConfigs.showAllStoresOnLoad) !== undefined) {
			showAllStoresOnLoad = siteSpecificConfigs.showAllStoresOnLoad;
		}
		if (!q.trim() && !showAllStoresOnLoad) {
			return;
		}
		var findUrl = Urls.searchStores;
		if (!findUrl) {
			return;
		}
		$.ajax({
			type: 'POST',
			url: findUrl,
			data: { q: q, start: count },
			beforeSend: function beforeSend() {
				$(STORE_OPTIONS.listView).empty();
				$(STORE_OPTIONS.mobHeadView).empty();
				deleteGMarkers();
				$(STORE_OPTIONS.pagination).hide();
				removeActiveList();
				refreshGMap();
			},
			success: function success(response) {
				if (response.status == true) {
					var _markersOnMap = [];
					_markersOnMap = response.markersOnMap;
					addGMarkerInfo(_markersOnMap);
					setPagination(response.pagination);
					if (init == true) {
						togglePageButton();
					}
					if (window.innerWidth < _born.breakpoints.mobile) {
						if (response.isEmpty == true) {
							$(STORE_OPTIONS.mobHeadView).html(response.listView);
						} else {
							$(STORE_OPTIONS.listView).html(response.listView);
							hidePagination();
						}
					} else {
						$(STORE_OPTIONS.listView).html(response.listView);
					}
					setActiveView();
				}
			},
			error: function error() {},
			complete: function complete() {
				initStorePageEvent();
			}
		});
	}
	
	function getStoresByAddress() {
		var findUrl = Urls.listStoresByAddress;
		if (!findUrl) {
			return;
		}
	
		var selectedSize = $('.swatch__link');
		if (!selectedSize || selectedSize.length <= 0) {
			return;
		}
	
		var variantAttr = '';
		var variantAttrEl = $('input[name="variantAttr"]');
		if (variantAttrEl.length > 0) {
			variantAttr = variantAttrEl.val();
		}
		var sizeList = [];
		selectedSize.each(function () {
			var aEl = $(this).find('a');
			if (aEl && aEl.length > 0 && aEl.data('id') && aEl.data('productid')) {
				sizeList.push({
					size: aEl.data('id'),
					productId: aEl.data('productid')
				});
			}
		});
		if (sizeList.length <= 0) {
			return;
		}
		$.ajax({
			type: 'POST',
			url: findUrl,
			data: { size: JSON.stringify(sizeList), variantAttr: variantAttr },
			beforeSend: function beforeSend() {
				beforeStoreSearch();
				progress.show('.chkstore_modal');
			},
			success: function success(response) {
				if (response.status == true) {
					markersOnMap = response.markersOnMap;
					addGMarkerInfo();
					setPagination(response.pagination);
					togglePageButton();
					resetPagination(0);
					$(STORE_OPTIONS.listView).html(response.listView);
					if (response.pagination.total != undefined) {
						var total = parseInt(response.pagination.total);
						if (total > 0) {
							$('#' + STORE_OPTIONS.mapID).show();
							$(".storelist-scroll").css('height', "");
						}
						$('.search-view-count').show().find('.value').html(markersOnMap.length);
						checkGeolocation();
						sortStores('city');
						storeAvailabilityResultsGAEvent(markersOnMap.length);
					}
					removeActiveList();
				}
				progress.hide();
			},
			error: function error() {
				progress.hide();
				$(STORE_OPTIONS.listView).html('<div class="error-info">' + Resources.STORE_AVAILABLITY_FAIL + '</div>');
			},
			complete: function complete() {
				initStorePageEvent();
				progress.hide();
				trackStoreEvent();
			}
		});
	}
	
	function storeAvailabilityResultsGAEvent(total) {
		var resultCount = total > 0 ? total : 'No result';
		var user = dataLayer.find(function (o) {
			return o.user != null;
		}).user;
		var product = dataLayer.find(function (o) {
			return o.product != null;
		}).product;
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'PDP',
			'eventAction': 'check_in_store_availability_result',
			'eventLabel': 'check in store availability result view - ' + resultCount, //Number of results if more than 0 then number else No result
			'productName': product ? product.name : '', // Name of product page
			'country': window.GlobalAttributes.COUNTRY,
			'language': window.GlobalAttributes.LANGUAGE,
			'screenName': 'PDP',
			'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
			'userId': user.user_id != '' ? user.user_id : ''
		});
	}
	
	function setGMapOnAll(map) {
		for (var _i = 0; _i < gMarkers.length; _i++) {
			gMarkers[_i].setMap(map);
		}
	}
	
	function clearGMarkers() {
		setGMapOnAll(null);
	}
	
	function deleteGMarkers() {
		clearGMarkers();
		gMarkers = [];
	}
	
	function initGmap(id) {
		return new google.maps.Map(document.getElementById(id), {
			zoom: getZoomSize(),
			center: getCenterCord()
		});
	}
	
	function refreshGMap() {
		google.maps.event.trigger(gmapEl, 'resize');
		gmapEl.setZoom(gmapEl.getZoom());
	}
	
	function initializeEvents() {
		$(document).ready(function () {
			gmapEl = initGmap(STORE_OPTIONS.mapID);
	
			$(STORE_OPTIONS.searchContainer).submit(function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				searchStoreByQuery(true);
			});
	
			$(STORE_OPTIONS.searchButton).on('click', function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				searchStoreByQuery(true);
			});
	
			$(STORE_OPTIONS.listViewWrap).on('click', function () {
				setListView();
			});
	
			$(STORE_OPTIONS.mapViewWrap).on('click', function () {
				setMapView();
			});
	
			var searchEl = $(STORE_OPTIONS.searchInput);
			var q = searchEl.val();
			searchStores(q, true, 0);
		});
	
		window.addEventListener("resize", switchMapListView);
	
		document.addEventListener("click", function (e) {
			removeActiveList();
		});
	
		storeSearchByName();
	}
	
	function initializePDPEvents() {
		$(document).ready(function () {
			gmapEl = initGmap(STORE_OPTIONS.mapID);
			$(STORE_OPTIONS.searchContainer).submit(function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				searchStoreByAddress();
			});
	
			$(STORE_OPTIONS.searchButton).on('click', function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				searchStoreByAddress();
			});
			$('.store-sortby-list').on('change', function () {
				sortStores(this.value);
			});
		});
		searchByAddress();
		storeContext.name = 'pdpstore';
	}
	
	function initStorePageEvent() {
		$('.store-page-next, .store-page-prev').on('click', function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
			event.stopPropagation();
			if ($(this).hasClass('store-page-next')) {
				callPageEl('next');
			} else {
				callPageEl('prev');
			}
		});
	}
	
	function callPageEl(type) {
		var total = $('input[name="total-count"]').val();
		var current = $('input[name="current-count"]');
		total = parseInt(total);
		var next;
		if (type == 'next') {
			next = parseInt(current.val()) + 1;
			if (total - 1 > next) {
				$('.store-page-next').removeAttr('disabled');
			} else {
				$('.store-page-next').attr('disabled', true);
			}
			if (next <= 0) {
				$('.store-page-prev').attr('disabled', true);
			} else {
				$('.store-page-prev').removeAttr('disabled');
			}
		} else {
			next = parseInt(current.val()) - 1;
			if (next <= 0) {
				$('.store-page-prev').attr('disabled', true);
			}
			if (next < total) {
	
				$('.store-page-next').removeAttr('disabled');
			}
			if (next == total) {
				$('.store-page-prev').attr('disabled', true);
			}
		}
	
		current.val(next);
		getStorePagination(next);
		setPagination({
			current: next,
			total: total
		});
		scrollToTopListView();
		closeOtherInfo();
	}
	
	function scrollToTopListView() {
		var scrollEl = $('.chkstore_wrapper .storelist-scroll');
		if (scrollEl.length > 0) {
			$(".storelist-scroll").scrollTop(0);
		} else {
			var scrollTop = $(STORE_OPTIONS.listView).offset().top;
	
			if (window.innerWidth < _born.breakpoints.mobile) {
				scrollTop = scrollTop - 70;
			} else {
				scrollTop = scrollTop - 10;
			}
			scrollTop = scrollTop - 10 - getTopHeight();
			$('html, body').animate({
				scrollTop: scrollTop
			}, 1000);
		}
	}
	
	function getTopHeight() {
		var mainEl = $('#store-locator');
		if (!mainEl || mainEl.length <= 0) {
			return 0;
		}
		var prev = mainEl.prev();
		if (!prev || prev.length <= 0) {
			return 0;
		}
		var height = prev.height();
		if (height) {
			height = parseInt(height);
		}
		if (height > 100) {
			return height - 50;
		}
		return height;
	}
	
	function setPagination(pagination) {
		var current = parseInt(pagination.current);
		var total = parseInt(pagination.total);
	
		if (total > 0) {
			$(STORE_OPTIONS.pagination).show();
		} else {
			$(STORE_OPTIONS.pagination).hide();
		}
		var displayCurrent = current;
		if (total > current) {
			displayCurrent = current + 1;
		}
		var pageEl = $(STORE_OPTIONS.pagination);
		pageEl.find(".store-page-start").html(displayCurrent);
		pageEl.find(".store-page-end").html(total);
		pageEl.find("input[name='total-count']").val(total);
		pageEl.find("input[name='current-count']").val(current);
	}
	
	function getStorePagination(count) {
		var perPage = $(STORE_OPTIONS.perPage).val();
		var $storeEl = jQuery('.store-list-wrapper .store-details');
		var storeElCount = $storeEl.length;
		var index = count * perPage;
		$storeEl.hide();
		for (var i = 0; i < perPage; i++) {
			$storeEl.eq(index + i).show();
		}
	}
	function togglePageButton() {
		var pageEl = $(STORE_OPTIONS.pagination);
		var total = pageEl.find("input[name='total-count']").val();
		total = parseInt(total);
		$('.store-page-prev').attr('disabled', true);
	
		if (total > 1) {
			$('.store-page-next').removeAttr('disabled');
		} else {
			$('.store-page-next').attr('disabled', true);
		}
	}
	
	function searchStoreByQuery(init, count) {
		if (init === undefined) {
			init = false;
		}
	
		if (count === undefined) {
			count = 0;
		}
		var searchEl = $(STORE_OPTIONS.searchInput);
		var q = searchEl.val();
		q = q.trim();
		if (!q) {
			searchEl.addClass('error');
			return;
		}
		searchEl.blur();
		searchEl.removeClass('error');
		searchStores(q, init, count);
	}
	
	function searchStoreByAddress() {
		var searchEl = $(STORE_OPTIONS.searchInput);
		var q = searchEl.val();
		q = q.trim();
		if (!q) {
			searchEl.addClass('error');
			return;
		}
		searchEl.blur();
		searchEl.removeClass('error');
		getStoresByAddress();
	
		if (typeof pdpStoreStockCheckPushEvent !== "undefined") {
			var data = [];
			data.push({ key: 'location', value: q });
			pdpStoreStockCheckPushEvent('store_search_button', data);
		}
	}
	
	function setListView() {
		if (window.innerWidth < _born.breakpoints.mobile) {
			showListView();
			removeActiveView();
			$(STORE_OPTIONS.listViewWrap).addClass('set--active');
		} else {
			setDesktopView();
		}
	}
	
	function setMapView() {
		if (window.innerWidth < _born.breakpoints.mobile) {
			hideListView();
			removeActiveView();
			$(STORE_OPTIONS.mapViewWrap).addClass('set--active');
		} else {
			setDesktopView();
		}
	}
	
	function setDesktopView() {
		showListView();
	}
	
	function showPagination() {
		var pageEl = $(STORE_OPTIONS.pagination);
		var total = pageEl.find("input[name='total-count']").val();
		if (total > 0) {
			pageEl.show();
		} else {
			pageEl.hide();
		}
	}
	
	function hidePagination() {
		$(STORE_OPTIONS.pagination).hide();
	}
	
	function switchMapListView() {
		if (window.innerWidth >= _born.breakpoints.mobile) {
			setDesktopView();
		} else {
			setActiveView();
		}
	}
	
	function storeSearchByName() {
		storeSearchFieldBind('name');
	}
	
	function searchByAddress() {
		storeSearchFieldBind('address');
	}
	
	function storeSearchFieldBind(typeName) {
		var searchEl = $(STORE_OPTIONS.searchInput);
		searchEl.bind({
			input: function input(e) {
				var val = this.value;
				removeActiveList();
				if (!val) {
					return false;
				}
				val = val.trim();
				activeCount = -1;
				window.clearTimeout(searchCallTimer);
				searchCallTimer = window.setTimeout(function () {
					removeActiveList();
					val = $(STORE_OPTIONS.searchInput).val();
					if (val && val.length >= 2) {
						if (typeName == 'address') {
							getItemsFromAddress(val);
						} else {
							getItemsFromearch(val);
						}
					}
				}, 400);
			},
			keydown: function keydown(e) {
				var x = document.getElementById("store-search-items");
				if (x) x = x.getElementsByTagName("div");
				if (e.keyCode == 40) {
					activeCount++;
					setActiveEl(x);
				} else if (e.keyCode == 38) {
					activeCount--;
					setActiveEl(x);
				} else if (e.keyCode == 13) {
					e.preventDefault();
					if (activeCount > -1) {
						if (x) x[activeCount].click();
					}
				}
			},
			keyup: function keyup(e) {
				var event = e || window.event;
				var keyCode = event.keyCode || event.which;
				if (keyCode == 13) {
					var q = this.value;
					removeActiveList();
					if (typeName == 'address') {
						searchStoreByAddress();
					} else {
						searchStoreByQuery(true);
					}
					if (q && q.trim()) {
						$(this).blur();
					}
				}
				return true;
			}
		});
	}
	function setActiveEl(el) {
		if (!el) {
			return false;
		}
		removeActiveEl(el);
		if (activeCount >= el.length) {
			activeCount = 0;
		}
		if (activeCount < 0) {
			activeCount = el.length - 1;
		}
		el[activeCount].classList.add("store__search--active");
	}
	
	function removeActiveEl(el) {
		for (var i = 0; i < el.length; i++) {
			el[i].classList.remove("store__search--active");
		}
	}
	
	function removeActiveList() {
		$(STORE_OPTIONS.searchItems).empty();
	}
	
	function getItemsFromearch(q) {
		var findUrl = Urls.searchStoresByName;
		if (!findUrl) {
			return;
		}
		var itemsEl = $(STORE_OPTIONS.searchItems);
		$.ajax({
			type: 'POST',
			url: findUrl,
			data: { q: q },
			beforeSend: function beforeSend() {
				itemsEl.empty();
			},
			success: function success(response) {
				if (response.status == true) {
					var listArr = response.storesArr;
					if (listArr.length <= 0) {
						return;
					}
					var searchEl = $(STORE_OPTIONS.searchInput);
					$(STORE_OPTIONS.searchItems).empty();
					for (i = 0; i < listArr.length; i++) {
						var el = document.createElement("DIV");
						el.innerHTML = '<span>' + listArr[i].name + '</span>';
						el.innerHTML += "<input type='hidden' value='" + listArr[i].name + "'>";
						el.addEventListener("click", function (e) {
							var inputVal = this.getElementsByTagName("input")[0].value;
							searchEl.val(inputVal);
							removeActiveList();
							$(STORE_OPTIONS.searchButton).trigger('click');
						});
						itemsEl.append(el);
					}
				}
			},
			error: function error() {},
			complete: function complete() {}
		});
	}
	
	function getItemsFromAddress(q) {
		var findUrl = Urls.searchStoresByAddress;
		if (!findUrl) {
			return;
		}
	
		var itemsEl = $(STORE_OPTIONS.searchItems);
		$.ajax({
			type: 'POST',
			url: findUrl,
			data: { q: q },
			beforeSend: function beforeSend() {
				itemsEl.empty();
			},
			success: function success(response) {
				if (response.status == true) {
					var listArr = response.storesArr;
					if (listArr.length <= 0) {
						return;
					}
					var searchEl = $(STORE_OPTIONS.searchInput);
					$(STORE_OPTIONS.searchItems).empty();
					for (i = 0; i < listArr.length; i++) {
						var el = document.createElement("DIV");
						el.innerHTML = '<span>' + listArr[i].name + '</span>';
						el.innerHTML += "<input type='hidden' value='" + listArr[i].name + "'>";
						el.addEventListener("click", function (e) {
							var inputVal = this.getElementsByTagName("input")[0].value;
							searchEl.val(inputVal);
							removeActiveList();
							$(STORE_OPTIONS.searchButton).trigger('click');
						});
						itemsEl.append(el);
					}
				}
			},
			error: function error() {},
			complete: function complete() {}
		});
	}
	function initStoreAppointment() {
		$(document).ready(function () {
			gmapEl = initGmap(STORE_OPTIONS.mapID);
	
			$(STORE_OPTIONS.searchContainer).submit(function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				triggerAppointmentSearch();
			});
	
			$(STORE_OPTIONS.searchButton).on('click', function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();
				event.stopPropagation();
				triggerAppointmentSearch();
			});
			searchStoreAppointment();
		});
	}
	
	function triggerAppointmentSearch() {
		var searchEl = $(STORE_OPTIONS.searchInput);
		var q = searchEl.val();
		searchAppointmentByQuery(q);
	}
	
	function searchStoreAppointment() {
		searchAppointmentByQuery('', true);
	}
	
	function searchAppointmentByQuery(searchKey, init) {
		try {
			if (searchKey === undefined) {
				searchKey = '';
			}
			if (init === undefined) {
				init = false;
			}
			var items = filterAppointment(searchKey, init);
			$(STORE_OPTIONS.listView).html("");
			clearGMarkers();
			if (items && items.length > 0) {
				markersOnMap = items;
				addMarkeronMap();
	
				items.forEach(function (v, key) {
					bulildStoreInfo(v);
				});
				showPagination();
				var perPage = $(STORE_OPTIONS.perPage).val();
				setPagination({
					current: 0,
					total: Math.ceil(items.length / perPage)
				});
				togglePageButton();
				initStorePageEvent();
				getStorePagination(0);
			} else {
				showEmptyResult();
				hidePagination();
			}
	
			progress.hide();
		} catch (e) {
			progress.hide();
		}
	}
	
	function filterAppointment(searchKey, init) {
		var list = window.storeInfo !== undefined && window.storeInfo.markersOnMap !== undefined ? window.storeInfo.markersOnMap : [];
		if (init === true) {
			return list;
		}
		var name = searchKey.toUpperCase();
		return list.filter(function (entry) {
			return entry.address.toUpperCase().indexOf(name) !== -1;
		});
	}
	
	function bulildStoreInfo(item) {
		var activeEl = $('input[name$="storeappointment_storeID"]').val();
		var activeClass = "";
		var checkedClass = "";
		if (activeEl == item.id) {
			activeClass = "active-store";
			checkedClass = "checked";
		}
		var el = '<div class="store-details storelist_wa ' + activeClass + '" id="store-' + item.id + '" data-storeid="' + item.id + '">' + '<div class="control-label checkbox ' + checkedClass + '"></div>' + '<div class="store-details-container">' + '<h1 class="store-name text-uppercase text-nowrap">' + item.name + ' </h1>' + '<h3 class="store-location">' + item.address + '</h3>' + '<span class="store-timing text-uppercase">' + item.timing + '</span>' + '<span class="store-contact">' + item.contact + '</span>' + '<input type="hidden" name="" class="store_details_bkapp" value="' + item.name + '|' + item.address + '|' + item.contact + '" />' + '</div>' + '</div>';
		$(STORE_OPTIONS.listView).append(el);
	}
	
	function showEmptyResult() {
		var emptyEl = $('input[name="empty_result"]');
		if (emptyEl.length > 0) {
			var el = '<div class="empty-store-result">' + emptyEl.val() + '</div>';
			$(STORE_OPTIONS.listView).html(el);
		}
	}
	
	function addMarkeronMap() {
		iconURL = getIconUrl();
	
		for (var i = 0; i < markersOnMap.length; i++) {
			var gcord = markersOnMap[i].coordinates;
			if (gcord.lat != null && gcord.lng != null) {
				var marker = new google.maps.Marker({
					position: markersOnMap[i].coordinates,
					map: gmapEl,
					icon: iconURL
				});
	
				gMarkers.push(marker);
				var latlng = new google.maps.LatLng(gcord.lat, gcord.lng);
				gmlatlng.push(latlng);
			}
		}
		if (gmlatlng.length > 0) {
			var latlngbounds = new google.maps.LatLngBounds();
			for (var i = 0; i < gmlatlng.length; i++) {
				latlngbounds.extend(gmlatlng[i]);
			}
			gmapEl.fitBounds(latlngbounds);
		}
	}
	
	function beforeStoreSearch() {
		deleteGMarkers();
		$(STORE_OPTIONS.pagination).hide();
		removeActiveList();
		refreshGMap();
		$('#' + STORE_OPTIONS.mapID).hide();
		$('.search-view-count').hide();
		$(".storelist-scroll").css('height', "auto");
		$(STORE_OPTIONS.listView).empty();
	}
	
	function resetStoreSearch() {
		beforeStoreSearch();
		$(STORE_OPTIONS.searchInput).val('');
	}
	
	function trackStoreEvent() {
		if ($('.map-address-details').length > 0) {
			$('.map-address-details').click(function () {
				sendStoreEvent(this);
			});
		}
	}
	
	function sendStoreEvent(el) {
		var storeWrapEl = $(el).closest('.store-details-container');
		if (storeWrapEl.length > 0 && storeWrapEl.data('storeid') != null) {
			if (typeof pdpStoreStockCheckPushEvent !== "undefined") {
				var data = [];
				var storeId = storeWrapEl.data('storeid');
				data.push({ key: 'SFCC_store_ID', value: storeId });
				pdpStoreStockCheckPushEvent('store_selection', data);
			}
		}
	}
	
	function initPDPStoreData() {
		getStoresByAddress();
	}
	
	function getLocationDistance(lat1, lng1, lat2, lng2) {
		if (lat1 && lng1 && lat2 && lng2) {
			var eRad = 6371;
			var lat = degreeToRadius(lat2 - lat1);
			var lng = degreeToRadius(lng2 - lng1);
			var calc = Math.sin(lat / 2) * Math.sin(lat / 2) + Math.cos(degreeToRadius(lat1)) * Math.cos(degreeToRadius(lat2)) * Math.sin(lng / 2) * Math.sin(lng / 2);
			var total = 2 * Math.atan2(Math.sqrt(calc), Math.sqrt(1 - calc));
			return eRad * total;
		}
		return 99999;
	}
	
	function degreeToRadius(deg) {
		return deg * (Math.PI / 180);
	}
	
	function sortStores(sort) {
		if (sort == 'location') {
			sortStoresByLocation();
		} else {
			sortStoreByCity();
		}
	}
	
	function sortStoresByLocation() {
		if (!initGeolocation()) {
			return;
		}
	}
	
	function checkGeolocation() {
	
		$('.store-location-help').hide();
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function () {}, removeSortLocation);
			return true;
		}
		removeSortLocation();
		return false;
	}
	
	function initGeolocation() {
	
		$('.store-location-help').hide();
		if (navigator.geolocation) {
			var options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			};
			navigator.geolocation.getCurrentPosition(success, fail, options);
			return true;
		}
		removeSortLocation();
		return false;
	}
	
	function success(position) {
		window.userCoordinates = {
			lng: position.coords.longitude,
			lat: position.coords.latitude
		};
		var storesIds = markersOnMap;
		for (var _i2 = 0; _i2 < storesIds.length; _i2++) {
			var distance = getLocationDistance(window.userCoordinates.lat, window.userCoordinates.lng, storesIds[_i2].coordinates.lat, storesIds[_i2].coordinates.lng);
			storesIds[_i2].distance = distance;
		}
	
		storesIds.sort(function (a, b) {
			return a.distance - b.distance;
		});
		var ids = [];
		for (i = 0; i < storesIds.length; i++) {
			ids.push(storesIds[i].id);
		}
		sortStoreByLatLng(ids);
	}
	
	function fail() {
		removeSortLocation();
	}
	
	function removeSortLocation() {
		$(".store-sortby-list option[value='location']").attr({ 'disabled': true, 'title': 'Enable location' });
		$(".store-sortby-list").selectric('refresh').trigger('change');
		$('.store-location-help').show();
	}
	
	function sortStoreByLatLng(ids) {
	
		var wrapEls = $('.store-list-wrapper .store-details');
		var elements = [];
		var item;
		$.each(ids, function (i, position) {
			item = wrapEls.find('[data-storeid="' + position + '"]').closest('.store-details');
			elements.push(item);
		});
	
		$('.store-list-wrapper').html(elements);
		resetPagination();
	}
	
	function sortStoreByCity() {
		var wrapEl = document.querySelector(STORE_OPTIONS.listView);
		[].slice.call(wrapEl.children).sort(function (a, b) {
			var tx1 = a.querySelector('.store-location');
			var tx2 = b.querySelector('.store-location');
			return tx1.innerHTML == tx2.innerHTML ? 0 : tx1.innerHTML > tx2.innerHTML ? 1 : -1;
		}).forEach(function (el) {
			wrapEl.appendChild(el);
		});
		resetPagination();
	}
	
	function resetPagination() {
		var perPage = $(STORE_OPTIONS.perPage).val();
		var wrapEl = $('.store-list-wrapper .store-details');
		var length = wrapEl.length;
		wrapEl.hide();
		setPagination({
			current: 0,
			total: Math.ceil(length / perPage)
		});
		togglePageButton();
		getStorePagination(0);
	}
	function getIconUrl() {
		var iconURL = "";
		var imgEl = document.querySelector('input[name="imageurl"]');
		if (imgEl) {
			iconURL = imgEl.value;
		}
		return iconURL;
	}
	
	exports.init = function () {
		initializeEvents();
	};
	
	exports.initializePDPEvents = initializePDPEvents;
	exports.initStoreAppointment = initStoreAppointment;
	exports.resetStoreSearch = resetStoreSearch;
	exports.initPDPStoreData = initPDPStoreData;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ajax = __webpack_require__(42),
	    util = __webpack_require__(15),
	    progress = __webpack_require__(43),
	    imagesLoaded = __webpack_require__(13),
	    BornModal = __webpack_require__(20).default;
	
	var dialog = {
	    /**
	     * @function
	     * @description Opens a dialog using the given url (params.url) or html (params.html)
	     * @param {Object} params
	     * @param {Object} params.url should contain the url
	     * @param {String} params.html contains the html of the dialog content
	     */
	    open: function open(params) {
	        this.replace(params);
	    },
	    /**
	     * @description populate the dialog with html content, then open it
	     **/
	    openWithContent: function openWithContent(params) {
	        var content = params.content || params.html,
	            callback;
	
	        if (!content) {
	            return;
	        }
	
	        params.options = params.options || {};
	        params.options.modalContent = content;
	
	        params.options.afterOpenCallback = function (overlay) {
	            callback = typeof params.callback === 'function' ? params.callback : function () {};
	            callback();
	        };
	
	        params.options.afterCreateCallback = function (overlay) {
	            callback = typeof params.afterCreateCallback === 'function' ? params.afterCreateCallback : function () {};
	            callback();
	        };
	
	        params.options.afterCloseCallback = function (overlay) {
	            callback = typeof params.afterCloseCallback === 'function' ? params.afterCloseCallback : function () {};
	            callback();
	        };
	
	        var modal = new BornModal(params.options);
	    },
	    /**
	     * @description Replace the content of current dialog
	     * @param {object} params
	     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
	     * @param {string} params.html - If no url property is provided, use html provided to replace
	     */
	    replace: function replace(params) {
	
	        if (params.url) {
	            progress.show();
	            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
	            ajax.load({
	                url: params.url,
	                data: params.data,
	                callback: function (response) {
	                    progress.hide();
	
	                    params.content = response;
	                    this.openWithContent(params);
	                }.bind(this)
	            });
	        } else if (params.html) {
	            this.openWithContent(params);
	        }
	    },
	    /**
	     * @function
	     * @description Closes the dialog
	     */
	    close: function close() {
	        BornModal.closeModal();
	    }
	};
	
	module.exports = dialog;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * @function
	 * @description Initializes the tooltip-content and layout
	 */
	
	exports.init = function () {
	    $(document).tooltip({
	        items: '.tooltip',
	        track: true,
	        content: function content() {
	            return $(this).find('.tooltip-content').html();
	        }
	    });
	
	    $('.share-link').on('click', function (e) {
	        e.preventDefault();
	        var target = $(this).data('target');
	        if (!target) {
	            return;
	        }
	        $(target).toggleClass('active');
	    });
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DEVICE_MOBILE = 'mobile',
	    DEVICE_TABLET = 'tablet';
	
	var defaultConfig = {
	    lazySourceAttr: 'data-lazysrc',
	    lazySrcsetAttr: 'data-lazysrcset',
	    preloadExpandBy: 0,
	    observerId: '',
	    deviceAttr: 'data-device',
	    breakPointMobile: 480,
	    breakPointTablet: 900
	},
	    loadSuccessClass = 'lazyloaded';
	
	function preloadElement(entry, config) {
	    var attribute = '',
	        isImage = true;
	
	    if (entry.tagName === 'IMG') {
	        attribute = config.lazySourceAttr;
	    } else {
	        attribute = config.lazySrcsetAttr;
	        isImage = false;
	    }
	
	    var lazysrc = entry.getAttribute(attribute);
	
	    if (isImage) {
	        if (entry.classList.contains(loadSuccessClass)) return true;
	        if (window.innerWidth > config.breakPointTablet) {
	            entry.src = lazysrc;
	            entry.classList += ' ' + loadSuccessClass;
	            return true;
	        }
	    } else {
	        switch (entry.getAttribute(config.deviceAttr)) {
	            case DEVICE_MOBILE:
	                return preloadSource(entry, config.breakPointMobile, lazysrc);
	            case DEVICE_TABLET:
	                if (window.innerWidth > config.breakPointMobile) {
	                    return preloadSource(entry, config.breakPointTablet, lazysrc);
	                }
	                break;
	            default:
	                break;
	        }
	        return false;
	    }
	}
	
	function preloadSource(entry, breakPoint, lazysrc) {
	    if (entry.classList.contains(loadSuccessClass)) return true;
	    if (window.innerWidth <= breakPoint) {
	        entry.srcset = lazysrc;
	        entry.classList += ' ' + loadSuccessClass;
	        if (entry.nextElementSibling) {
	            entry.nextElementSibling.classList += ' sourceloaded';
	        }
	        return true;
	    }
	}
	
	function preloadImages(entry, config, observer) {
	    var sources = entry.querySelectorAll('source:not(' + loadSuccessClass + ')');
	    var images = entry.querySelectorAll('img:not(' + loadSuccessClass + ')');
	    if (sources.length === 0 && images.length === 0) {
	        observer.unobserve(entry.target);
	        return;
	    }
	
	    [].concat(_toConsumableArray(sources), _toConsumableArray(images)).forEach(function (item) {
	        preloadElement(item, config);
	    });
	}
	
	function findSlickParent(element) {
	    var parent = element.parentElement;
	    while (parent) {
	        if (parent.hasAttribute('data-slick') || parent.hasAttribute('data-multicarousel')) {
	            return parent;
	        }
	        parent = parent.parentElement;
	    }
	    return null;
	}
	
	exports.init = function () {
	    var customConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var config = Object.assign(defaultConfig, customConfig);
	
	    var elements = document.querySelectorAll('[' + config.lazySourceAttr + ']:not(.' + loadSuccessClass + '), [' + config.lazySrcsetAttr + ']:not(.' + loadSuccessClass + ')');
	    var carouselContainers = [];
	    var imageElements = [];
	
	    elements.forEach(function (element) {
	        var slickParent = findSlickParent(element);
	        if (slickParent) {
	            if (!carouselContainers.includes(slickParent)) {
	                carouselContainers.push(slickParent);
	            }
	        }
	        var pictureParent = element.parentElement;
	        if (!imageElements.includes(pictureParent)) {
	            imageElements.push(pictureParent);
	        }
	    });
	
	    var elementObserver = new IntersectionObserver(function (entries, elementObserver) {
	        entries.forEach(function (entry) {
	            if (!entry.isIntersecting) {
	                return;
	            } else {
	                preloadImages(entry.target, config, elementObserver);
	            }
	        });
	    }, { rootMargin: '0px 0px ' + config.preloadExpandBy + 'px 0px' });
	
	    var carouselObserver = new IntersectionObserver(function (entries, carouselObserver) {
	        entries.forEach(function (entry) {
	            if (!entry.isIntersecting) {
	                return;
	            } else {
	                preloadImages(entry.target, config, carouselObserver);
	            }
	        });
	    }, { rootMargin: '0px 0px ' + config.preloadExpandBy + 'px 0px' });
	
	    imageElements.forEach(function (entry) {
	        elementObserver.observe(entry);
	    });
	
	    carouselContainers.forEach(function (entry) {
	        carouselObserver.observe(entry);
	    });
	
	    if (config.observerId === '') return;
	
	    var target = document.querySelector('#' + config.observerId);
	
	    if (target === null) return;
	
	    var mutationConfig = { childList: true };
	    var mutationCallBack = function mutationCallBack() {
	        var newElements = document.querySelectorAll('[' + config.lazySourceAttr + ']:not(.' + loadSuccessClass + '), [' + config.lazySrcsetAttr + ']:not(.' + loadSuccessClass + ')');
	        var newCarouselContainers = [];
	        var newImageElements = [];
	
	        newElements.forEach(function (element) {
	            var slickParent = findSlickParent(element);
	            if (slickParent) {
	                if (!newCarouselContainers.includes(slickParent)) {
	                    newCarouselContainers.push(slickParent);
	                }
	            }
	            var pictureParent = element.parentElement;
	            if (!newImageElements.includes(pictureParent)) {
	                newImageElements.push(pictureParent);
	            }
	        });
	
	        newImageElements.forEach(function (entry) {
	            elementObserver.observe(entry);
	        });
	
	        newCarouselContainers.forEach(function (entry) {
	            carouselObserver.observe(entry);
	        });
	    };
	
	    var mutationObs = new MutationObserver(mutationCallBack);
	    mutationObs.observe(target, mutationConfig);
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.saveStickyToggleState = saveStickyToggleState;
	exports.PLPCategoryToggle = PLPCategoryToggle;
	exports.setFilterScrollPosition = setFilterScrollPosition;
	exports.setOverlayInnerScroll = setOverlayInnerScroll;
	exports.init = init;
	
	var _module = __webpack_require__(50);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _born = __webpack_require__(10);
	
	var _gtm = __webpack_require__(51);
	
	var _lazypictureload = __webpack_require__(48);
	
	var _lazypictureload2 = _interopRequireDefault(_lazypictureload);
	
	var _offertimer = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var util = __webpack_require__(15),
	    progress = __webpack_require__(43);
	var haveSelectedFilter = false;
	var retainfilterSelected = null;
	window.selectedStickyFilter = null;
	var lastAppliedOrRemovedFilterOffset = 0;
	var lastInnerScrollPosition = 0;
	var lastScrollPosition = 0;
	var userPastOverlayScrollPos = [0, 0];
	
	// selected filter view more functionality
	function filterOverflowToggle() {
	    var $badgeContainer = $('#badgeContainer');
	    var $overflowTrigger = $('#badgeOverflowTrigger');
	    var $badgeOverflowLimit = $('#badgeOverflowLimit');
	    var overflowClass = "allow-overflow";
	    if ($badgeOverflowLimit.height() > 82) {
	        $overflowTrigger.removeClass('visually-hidden');
	    } else {
	        $overflowTrigger.addClass('visually-hidden');
	    }
	    showHiddenFilterCount(); // get count of hidden items
	    $overflowTrigger.on('click', function () {
	        if ($badgeContainer.hasClass(overflowClass)) {
	            $badgeContainer.removeClass(overflowClass);
	            $overflowTrigger.removeClass(overflowClass);
	        } else {
	            $badgeContainer.addClass(overflowClass);
	            $overflowTrigger.addClass(overflowClass);
	        }
	    });
	}
	
	//set parent width as same as child to avoid jerk on sticky filters (web only)
	function setStickyFilterWidth() {
	    var makeSticky = function makeSticky(e) {
	        if ($(window).width() > 767) {
	            $('.refinement__static-filter').each(function () {
	                var $child = $(this).find('form.web-sort-by-toggle, form.web-sort-by-filter');
	                var width = $child.width();
	                $(this).width(width);
	            });
	        } else {
	            $('.refinement__static-filter').each(function () {
	                $(this).removeAttr('style');
	            });
	        }
	    };
	    makeSticky();
	    $(window).on('resize', makeSticky);
	}
	
	//dock the web filter list to top if scrolled past (web only)
	function dockFilters() {
	    var havePLPTimer = $('.plp__offer__timer').length > 0;
	    havePLPTimer && $('#refinementOptions').addClass('has-plp-timer');
	    var dockEnableCheck = function dockEnableCheck(offset, toggleItem, toggleClass) {
	        var currentScroll = $(window).scrollTop();
	        if (currentScroll >= offset && currentScroll < $(document).height() - window.innerHeight - 150) {
	            toggleItem.addClass(toggleClass);
	        } else {
	            toggleItem.removeClass(toggleClass);
	        }
	    };
	    var doDocking = function doDocking() {
	        var $refinementItem = $('#refinementOptions');
	        var $productGrid = $('#productGridContainer');
	
	        if ($(window).width() > 767) {
	            $(window).off('scroll.mobileScrollEvent');
	            $productGrid.removeClass('dock-to-relative');
	
	            var fixmeTop = $refinementItem.offset().top;
	
	            dockEnableCheck(fixmeTop - 117, $refinementItem, 'docked-at-top'); //do the check on load also
	
	            $(window).on('scroll.webScrollEvent', function () {
	                dockEnableCheck(fixmeTop - 117, $refinementItem, 'docked-at-top');
	            });
	        } else {
	            $(window).off('scroll.webScrollEvent');
	        }
	    };
	    doDocking();
	    $(window).on('resize', doDocking);
	}
	
	// cut paste the seo div while switching to mobile view or back
	function cutPasteSEO() {
	    var $seoMob = $('#seo-mob');
	    var $seoDesk = $('#seo-desktop');
	    var doCutPaste = function doCutPaste() {
	        var $seoContent = $('#refine-catseotexthead');
	        if ($(window).width() > 767) {
	            if ($seoContent.parent() !== $seoDesk) {
	                $seoContent.remove();
	                $seoDesk.append($seoContent);
	                $seoContent.addClass('display--small-up').find('.cat-seo-text').addClass('toggle--active');
	            }
	        } else {
	            if ($seoContent.parent() !== $seoMob) {
	                $seoContent.remove();
	                $seoMob.append($seoContent);
	                $seoContent.removeClass('display--small-up').find('.cat-seo-text').addClass('toggle--active');
	            }
	        }
	    };
	    doCutPaste();
	    $(window).on('resize', doCutPaste);
	}
	
	// show the count of filters hidden by the overflow
	function showHiddenFilterCount() {
	    var $containerParent = $('#badgeOverflowLimit');
	    var $badges = $containerParent.find('.filter-badge');
	    var offsets = [];
	
	    var calcCount = function calcCount() {
	        $badges.each(function () {
	            offsets.push($(this).offset().top);
	        });
	        offsets = Array.from(new Set(offsets));
	        var count = offsets.length > 1 ? $badges.filter(function () {
	            return $(this).offset().top > offsets[1];
	        }).length : 0;
	        $('#badgeOverflowTrigger').find('.content-to-replace').html(count);
	    };
	    calcCount();
	}
	
	//cancel scroll if sort is open (mobile only)
	// sort click away listener
	function sortScrollAndClickAway() {
	    var $toggledElements = $('.web-sort-by-toggle,.web-sort-by-filter,.refinement__static-filter');
	    var propagationHandler = function propagationHandler(e) {
	        e.stopImmediatePropagation();
	        e.stopPropagation();
	        e.preventDefault();
	        if ($toggledElements.hasClass('toggle--active')) {
	            $toggledElements.removeClass('toggle--active');
	            //avoid sort menu closing, if clicked inside the menu
	            $('#main').off('click', '.web-sort-by-toggle,.web-sort-by-filter', function (e) {
	                return e.stopPropagation();
	            });
	            $(window).off('click', propagationHandler);
	            $('body').removeClass('cancel-scroll');
	        }
	        if ($(window).width() <= 767 && $(e.currentTarget).is('.refinement__sorts')) {
	            if (typeof zE !== 'undefined' && !!zE) {
	                zE(function () {
	                    zE.show();
	                });
	            }
	        }
	        saveStickyToggleState();
	    };
	    $('.refinement__static-filter').on('click', function (e) {
	        var width = $(window).width();
	        var isLink = $(e.target).is('.refinement--link, .refinement-text, .refinement_filtercount');
	        if ($(e.currentTarget).hasClass('toggle--active')) {
	            if (width <= 767) {
	                $('body').removeClass('cancel-scroll');
	                if ($(e.currentTarget).is('.refinement__sorts') && !isLink) {
	                    if (typeof zE !== 'undefined' && !!zE) {
	                        zE(function () {
	                            zE.show();
	                        });
	                    }
	                }
	            }
	            if (!isLink) {
	                $(e.currentTarget).removeClass('toggle--active').find('.toggle__link, .toggle__content, .web-sort-by-filter, .web-sort-by-toggle').removeClass('toggle--active');
	            }
	            //avoid sort menu closing, if clicked inside the menu
	            $('#main').off('click', '.web-sort-by-toggle,.web-sort-by-filter', function (e) {
	                return e.stopPropagation();
	            });
	            $(window).off('click', propagationHandler);
	        } else {
	            if (width <= 767) {
	                $('body').addClass('cancel-scroll');
	                if ($(e.currentTarget).is('.refinement__sorts')) {
	                    if (typeof zE !== 'undefined' && !!zE) {
	                        zE(function () {
	                            zE.hide();
	                        });
	                    }
	                }
	            }
	            $toggledElements.removeClass('toggle--active');
	            $(e.currentTarget).addClass('toggle--active').find('.toggle__link, .toggle__content, .web-sort-by-filter, .web-sort-by-toggle').addClass('toggle--active'); //avoid sort menu closing, if clicked inside the menu
	            $('#main').on('click', '.web-sort-by-toggle,.web-sort-by-filter', function (e) {
	                return e.stopPropagation();
	            });
	            $(window).on('click', propagationHandler);
	        }
	        if (!$(e.target).is('.refinement--link, .refinement-text, .refinement_filtercount')) {
	            saveStickyToggleState();
	        }
	    });
	    $('.filterby-toggle-head').on('click', function (e) {
	        $('body').addClass('cancel-scroll');
	        $(window).width() <= 767 ? scrollLockIos(true) : "";
	        window.filteroverlay = true;
	    });
	    $('.filterapply,.filterapply--mob,.filter--mob-backbtn,.refinement__filter_close').on('click', function (e) {
	        $('body').removeClass('cancel-scroll');
	        $(window).width() <= 767 ? scrollLockIos(false) : "";
	    });
	}
	//Overlay Scroll Fix in IOS
	function scrollLockIos(state) {
	    if (state === true) {
	        userPastOverlayScrollPos = [self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft, self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop];
	        $('html').addClass('cancel-scroll noscrollios');
	    } else {
	        $('html').removeClass('cancel-scroll noscrollios');
	        window.scrollTo(userPastOverlayScrollPos[0], userPastOverlayScrollPos[1]);
	    }
	}
	
	function setHaveSelectedFilter() {
	    $('.refinement.toggle--nb').on('click.setHaveSelectedFilter', function (e) {
	        var width = $(window).width();
	        if (width > 767) {
	            return;
	        }
	        var $eleList = $('.refinement.toggle--nb');
	        var idx = $eleList.index(this);
	        if (idx != 0) {
	            if ($('.refinement.toggle--nb.activefilter').first() !== $eleList.first()) {
	                haveSelectedFilter = true;
	            } else {
	                haveSelectedFilter = false;
	            }
	        }
	    });
	}
	
	function saveStickyToggleState() {
	    var $activefilter = $('.refinement__static-filter.toggle--active:not(.refinement__sorts)');
	    if ($activefilter.length > 0) {
	        $activefilter.each(function (ind, ele) {
	            window.selectedStickyFilter = $(ele).attr('id') !== window.selectedStickyFilter ? $(ele).attr('id') : window.selectedStickyFilter;
	        });
	    } else {
	        window.selectedStickyFilter = null;
	    }
	}
	
	function instantHighlighter() {
	    $('.refinement__all__toggle').first().find('.refinement__link.control-label.checkbox').on('click', function (e) {
	        $(e.currentTarget).toggleClass('checked');
	        lastAppliedOrRemovedFilterOffset = $('.refinement__all__toggle').scrollTop();
	        lastInnerScrollPosition = $(e.currentTarget).parents('.toggle__content').first().scrollTop();
	    });
	    $('.refinement__clear.refinement__web_clearfilter').first().on('click', function (e) {
	        $('.refinement__all__toggle').first().find('.refinement__link.control-label.checkbox').removeClass('checked');
	        $('.refinement__categorybrandrefinement .refinement__all__toggle').find('.active').removeClass('active');
	        lastAppliedOrRemovedFilterOffset = 0;
	        userPastOverlayScrollPos = [0, 0];
	        $('.expandable').removeClass('active').find('.active').removeClass('active');
	    });
	    //PLP filter highlighter
	    $('.refinement__web_cmfilter .refinement--link').on('click', function (e) {
	        $(this).toggleClass('checked');
	        lastScrollPosition = $(e.currentTarget).parents('.toggle__content').first().scrollTop();
	    });
	}
	
	function productTypeSelectPostOp() {
	    $('#categoryBrandRefinementMob .typerefinements .refinement__link').on('click', function () {
	        $(document).one('ajaxStop', function () {
	            setTimeout(function () {
	                $('#categoryBrandRefinementMob').addClass('activefilter').find('.toggle__link, .toggle__content').addClass('toggle--active');
	            }, 0);
	        });
	    });
	    $('#categoryRefinement .typerefinements .refinement__link').on('click', function () {
	        $(document).one('ajaxStop', function () {
	            setTimeout(function () {
	                $('#categoryRefinement').addClass('activefilter').find('.toggle__link, .toggle__content').addClass('toggle--active');
	            }, 0);
	        });
	    });
	}
	
	function PLPCategoryToggle() {
	    $('.category-list.has-children a.category-click').on('click', function (e) {
	        if ($(this).closest('.category-list').hasClass('last-child')) {
	            return;
	        }
	        e.preventDefault();
	        e.stopPropagation();
	        $(this).toggleClass('active').closest('.expandable').toggleClass('active');
	    });
	}
	
	function setFilterScrollPosition() {
	    lastAppliedOrRemovedFilterOffset > 0 && $('.refinement__all__toggle').animate({
	        scrollTop: lastAppliedOrRemovedFilterOffset
	    }, 500);
	}
	function setOverlayInnerScroll(scrollItem, origin) {
	    if (origin == "overlay") {
	        lastInnerScrollPosition > 0 && $('#' + scrollItem).parents('.toggle__content').animate({
	            scrollTop: lastInnerScrollPosition
	        }, 500);
	    } else {
	        lastScrollPosition > 0 && $('#' + scrollItem).find('.toggle__content').animate({
	            scrollTop: lastScrollPosition
	        }, 500);
	    }
	}
	
	function initBreadCrumbOverFlow() {
	    var $breadcrumbs = $('#breadcrumbs'),
	        isBreadCrumbOverflown = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0));
	    if (isBreadCrumbOverflown) {
	        $breadcrumbs.addClass('show-ellipsis');
	    } else {
	        $breadcrumbs.removeClass('show-ellipsis');
	    }
	}
	
	function isOverflown(element) {
	    return element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
	}
	
	//function to check browser agent to apply specific styles for mac-safari in plp-promo-tile slot.
	function checkIfBrowserMacSafari() {
	    if (typeof navigator !== 'undefined' && typeof navigator.platform !== 'undefined' && typeof navigator.userAgent !== 'undefined' && navigator.platform.toUpperCase().indexOf('MAC') >= 0 && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	        $(".plp-listing-promo").removeClass("zero-padding");
	    }
	}
	
	function init() {
	    var $filterElements = $(".refinements__filtercontainer .refinement");
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	        var lazyLoadConfig = { observerId: 'search-result-items', preloadExpandBy: 100 };
	        _lazypictureload2.default.init(lazyLoadConfig);
	    }
	    $(document).ready(function () {
	        //Filter list narrowing
	        $(document).on("keyup", ".refinement__filtersearch", function (e) {
	            var value = $.trim($(this).val().toLowerCase());
	            var childele = $(window).width() <= 767 ? $(this).parent().siblings('.toggle__content').find('li:not(.refinement_nofiltervalue)') : $(this).siblings('.toggle__content').find('li:not(.refinement_nofiltervalue)');
	            childele.hide().filter(function () {
	                return $(this).find('a').immediateText().toLowerCase().indexOf(value) > -1;
	            }).show();
	            if ($(window).width() <= 767) $(this).parent().siblings('.toggle__content').find('li:not(.refinement_nofiltervalue):visible').length == 0 ? $(this).parent().siblings('.toggle__content').find('.refinement_nofiltervalue').show() : $(this).parent().siblings('.toggle__content').find('.refinement_nofiltervalue').hide();else $(this).siblings('.toggle__content').find('li:not(.refinement_nofiltervalue):visible').length == 0 ? $(this).siblings('.toggle__content').find('.refinement_nofiltervalue').show() : $(this).siblings('.toggle__content').find('.refinement_nofiltervalue').hide();
	        });
	
	        $(window).on('popstate', function (event) {
	            if ($(".refinements__filtercontainer").hasClass('toggle--active')) {
	                $(".refinements__filtercontainer").removeClass('toggle--active');
	                $(".refinement-wrapper").removeClass('toggle--active');
	                (0, _born.toggleOverlay)();
	            }
	        });
	
	        //FilterPanel View
	        $(document).on("click", ".refinement__filterby--head", function (e) {
	            if (typeof zE !== 'undefined' && !!zE) {
	                zE(function () {
	                    zE.hide();
	                });
	            }
	            toggleFilterPanel('show');
	        });
	        //FilterPanel Close
	        $(document).on("click", ".refinement__filter_close,.filterapply,.filter--mob-backbtn,.filterapply--mob", function () {
	            if (typeof zE !== 'undefined' && !!zE) {
	                zE(function () {
	                    zE.show();
	                });
	            }
	            window.filteroverlay = false;
	            toggleFilterPanel('hide');
	        });
	
	        //Clearing individual narrowing on clear all scenario
	        $(document).on("click", ".refinement__web_clearfilter,.clear-filter-btn", function (e) {
	            $(".refinement__filtersearch").val("");
	            $(".refinement__filtersearch").siblings('.toggle__content').find('li:not(.refinement_nofiltervalue)').show();
	            var $firstEleView = $(".refinements__filtercontainer .refinement:first");
	            if ($(this).hasClass('refinement__web_clearfilter') && !$(this).hasClass('refinement__disable')) {
	                progress.show($(".refinements__filtercontainer"));
	                if ($(window).width() <= 767) {
	                    $firstEleView = $firstEleView.children().length > 0 ? $firstEleView : $firstEleView.next();
	                    (0, _born.setdefaultFilteractive)($filterElements, $firstEleView);
	                } else {
	                    $filterElements.removeClass('toggle--active');
	                    $filterElements.find('.toggle__link').removeClass('toggle--active');
	                    $filterElements.find('.toggle__content').removeClass('toggle--active');
	                }
	            }
	            retainfilterSelected = $firstEleView.attr('id');
	            $('.expandable').removeClass('active').find('.active').removeClass('active');
	        });
	
	        $(document).on('click', ".refinement__selected-filters .filter-badge button", function () {
	            if ($(".filter-badge").length == 0) retainfilterSelected = null;
	        });
	        //Mobile filter view handling
	        $(document).on("click", ".refinements__filtercontainer .refinement", function (e) {
	            if ($(window).width() <= 767) (0, _born.setdefaultFilteractive)($filterElements, $(this));
	        });
	
	        $(document).on("click", ".refinements__filtercontainer .refinement__link,.refinement__all__toggle .refinement__clear", function (e) {
	            var target = $(this).parents('.refinement').attr('id');
	            userPastOverlayScrollPos = [0, 0];
	            progress.show($(".refinements__filtercontainer"));
	            retainfilterSelected = target;
	        });
	        (0, _gtm.selectItem)();
	        (0, _gtm.selectPromotion)();
	        (0, _gtm.selectBannerPromotion)();
	        (0, _gtm.initCategoryNavigation)();
	        checkIfBrowserMacSafari();
	    });
	
	    $(window).on('resize', function () {
	        clearTimeout(window.resizeFinished);
	        window.resizeFinished = setTimeout(function () {
	            if ($('.refinements__filtercontainer').hasClass('toggle--active')) {
	                $(".refinement-wrapper").addClass('toggle--active');
	                if ($(window).width() <= 767) {
	                    handleMobilelayout();
	                    (0, _born.getSelectedFilterCount)();
	                } else {
	                    var checkSelectedItem = $(".refinement__link.checked");
	                    if (checkSelectedItem.length == 0) {
	                        $filterElements.children('.toggle__content,.toggle__link').removeClass('toggle--active');
	                    }
	                    (0, _born.getSelectedfilterlabels)();
	                    (0, _born.toggleOverlay)(true, true);
	                    $(".focus-overlay").addClass('forcily-visible');
	                }
	                setFilterScrollPosition();
	            } else {
	                if ($('.refinements__filtercontainer.toggle--active, .header__secondary.toggle--active').length === 0) {
	                    (0, _born.toggleOverlay)();
	                }
	                $(window).width() <= 767 ? $(".refinement-wrapper").removeClass('toggle--active') : $(".refinements__filtercontainer").removeClass('toggle--active');
	            }
	        }, 800);
	
	        initBreadCrumbOverFlow();
	    });
	
	    function toggleFilterPanel(trigger) {
	        if (trigger == 'show') {
	            $(".refinements__filtercontainer,.refinement-wrapper").addClass('toggle--active');
	            if ($(window).width() <= 767) {
	                handleMobilelayout();
	                (0, _born.getSelectedFilterCount)();
	            } else {
	                (0, _born.getSelectedfilterlabels)();
	                (0, _born.toggleOverlay)(true, true);
	            }
	            (0, _born.checkTypeRefinement)();
	        } else {
	            $(".refinements__filtercontainer,.refinement-wrapper").removeClass('toggle--active');
	            (0, _born.toggleOverlay)(false, false);
	            $(".focus-overlay").removeClass('forcily-visible');
	        }
	    }
	
	    filterOverflowToggle();
	    setStickyFilterWidth();
	    dockFilters();
	    cutPasteSEO();
	    sortScrollAndClickAway();
	    setHaveSelectedFilter();
	    instantHighlighter();
	    PLPCategoryToggle();
	    productTypeSelectPostOp();
	    (0, _offertimer.categoryOfferTimer)();
	    initBreadCrumbOverFlow();
	    $.fn.immediateText = function () {
	        return this.contents().not(this.children()).text();
	    };
	
	    var handleMobilelayout = function handleMobilelayout() {
	        (0, _born.toggleOverlay)(false, false, false);
	        var $firstEleView = "";
	        $(".focus-overlay").removeClass('forcily-visible');
	        $firstEleView = retainfilterSelected !== null ? $('#' + retainfilterSelected) : $(".refinements__filtercontainer .refinement:first");
	        $firstEleView = $firstEleView.children().length > 0 ? $firstEleView : $firstEleView.next();
	        !haveSelectedFilter && (0, _born.setdefaultFilteractive)($filterElements, $firstEleView);
	    };
	}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var util = __webpack_require__(15);
	
	var FixIt = function () {
		function FixIt(options) {
			_classCallCheck(this, FixIt);
	
			this.options = options;
	
			this.enabled = this.options.enabled || function () {
				return true;
			};
			this.offset = this.options.offset || 0;
			this.target = this.options.target || false;
	
			if (this.enabled() && this.target) {
	
				this.setPlaceholder();
	
				this.parentContainer = this.options.containedInParent ? this.options.containedInParent.nodeType === 1 ? this.options.containedInParent : this.target.parentNode : false;
	
				if (this.options.respondToParent) {
					this.options.respondToParent = this.options.respondToParent.nodeType === 1 ? this.options.respondToParent.nodeType : this.target.parentNode;
	
					window.addEventListener('resize', this.respondTo.bind(this));
				}
	
				window.addEventListener('scroll', this.updateStickyStatus.bind(this));
	
				this.scrollPosition = 0;
				this.updateStickyStatus();
			}
		}
	
		/**
	  * Updates the status of the sticky object according to where it is on the current scroll.
	  */
	
	
		_createClass(FixIt, [{
			key: 'updateStickyStatus',
			value: function updateStickyStatus() {
				var placeholderRect = this.placeholder.getBoundingClientRect(),
				    canContainInParent = !this.parentContainer || this.getTargetHeight() < this.parentContainer.getBoundingClientRect().height;
	
				var scrollDir = this.getScrollDirection();
	
				//canContainInParent if target is smaller than its parent
				//Make sure the entirety of the target element is visible on screen before applying the fixed status.
				if (placeholderRect.top < this.offset && canContainInParent) {
	
					if (!this.targetIsTall()) {
						if (!this.isActive) {
							this.setActive();
						}
					} else {
						if (scrollDir === 'down') {
							if (Math.floor(this.target.getBoundingClientRect().bottom) <= document.body.offsetHeight) {
								if (!this.isActive) {
									this.isFrozen = false;
									this.setActive(true);
								}
							}
							//We don't wanna run this if it's docked
							else if (this.isActive && !this.isDocked) {
									this.isActive = false;
									this.setFrozen();
								}
						} else {
							if (this.target.getBoundingClientRect().top >= this.offset) {
								if (!this.isActive) {
									this.isFrozen = false;
									this.setActive();
								}
							}
							//We don't wanna run this if it's docked
							else if (this.isActive && !this.isDocked) {
									this.isActive = false;
									this.setFrozen();
								}
						}
					}
	
					this.containInParent();
				} else if (this.isActive) {
					this.isActive = false;
					this.setInactive();
				}
	
				return this.isActive || this.isFrozen;
			}
	
			/**
	   * Constrains the target element's scroll to the inside of a defined parent [parentContainer] element.
	   */
	
		}, {
			key: 'containInParent',
			value: function containInParent() {
				if (!util.isMobile() && this.parentContainer && this.isActive) {
					var parentBottom = this.parentContainer.getBoundingClientRect().bottom,
					    placeholderRect = this.placeholder.getBoundingClientRect(),
					    targetRect = this.target.getBoundingClientRect();
	
					//Make sure bottom of parent is visible, then ensure the target and the parent's bottom are at the same level, then confirm the window's offset is not over the target
					if (parentBottom <= document.body.offsetHeight && targetRect.bottom >= parentBottom && targetRect.top <= this.offset) {
						this.setDocked();
					} else if (this.isDocked && targetRect.top >= this.offset) {
						this.setUndocked();
					}
				}
			}
		}, {
			key: 'setDocked',
			value: function setDocked() {
				this.isDocked = true;
				this.target.classList.add('fixit--docked');
				this.target.classList.remove('fixit--bottom');
				this.setTargetPos(true);
			}
		}, {
			key: 'setUndocked',
			value: function setUndocked() {
				this.isDocked = false;
				this.target.classList.remove('fixit--docked');
				this.setTargetPos();
			}
	
			/**
	   * Either sets the target's 'top' property to the offset value, or clears it depending on [reset] value. 
	   * @param  {[boolean]} reset 
	   */
	
		}, {
			key: 'setTargetPos',
			value: function setTargetPos(reset) {
				var newPos = '';
	
				if (!reset && this.options.useOffsetOnTarget) {
					newPos = this.offset + 'px';
				}
	
				this.target.style.top = newPos;
			}
	
			/**
	   * Adapts target's width according to its parent's width. Needed cause fixed elements respond to the window.
	   */
	
		}, {
			key: 'respondTo',
			value: function respondTo() {
				if (this.isActive || this.isFrozen) {
					var parentComputedStyle = window.getComputedStyle(this.options.respondToParent),
					    parentWidth = this.options.respondToParent.getBoundingClientRect().width - parseFloat(parentComputedStyle['padding-left']) - parseFloat(parentComputedStyle['padding-right']);
					this.target.style.width = parentWidth + 'px';
				}
			}
	
			/**
	   * Freezes the target at its current position relative to its parent.
	   */
	
		}, {
			key: 'setFrozen',
			value: function setFrozen() {
				this.isFrozen = true;
				this.target.style.top = Math.abs(this.parentContainer.getBoundingClientRect().top - this.target.getBoundingClientRect().top) + 'px';
				this.target.classList.remove('fixit--bottom');
				this.target.classList.remove('fixit--active');
				this.target.classList.add('fixit--frozen');
			}
	
			/**
	   * If 'toBottom' is set to true, the fixed element is attached to the bottom of its container.
	   * @param {[type]} toBottom [description]
	   */
	
		}, {
			key: 'setActive',
			value: function setActive(toBottom) {
				this.isActive = true;
				this.setPlaceholderProps(true);
				this.target.classList.remove('fixit--frozen');
				this.target.classList.add('fixit--active');
	
				if (toBottom) {
					this.target.classList.add('fixit--bottom');
					this.setTargetPos(true);
				} else {
					this.setTargetPos();
				}
	
				if (this.options.respondToParent) {
					this.respondTo();
				}
			}
	
			//Removes all statuses/settings from the fixit object
	
		}, {
			key: 'setInactive',
			value: function setInactive() {
				this.setPlaceholderProps();
				this.target.classList.remove('fixit--active');
				this.target.classList.remove('fixit--bottom');
				this.target.classList.remove('fixit--docked');
				this.target.classList.remove('fixit--frozen');
	
				if (this.options.useOffsetOnTarget) {
					this.setTargetPos(true);
				}
	
				if (this.options.respondToParent) {
					this.target.style.width = '';
				}
			}
	
			/**
	   * Creates a "placeholder" element that will take the height (including padding) and margin properties of
	   * the target element and is used to avoid a jump when scrolling down and activating the 'fixed' status
	   */
	
		}, {
			key: 'setPlaceholder',
			value: function setPlaceholder() {
				var target = this.target;
	
				this.placeholder = document.createElement('div');
	
				this.placeholder.className = 'fixit-placeholder';
	
				target.parentNode.insertBefore(this.placeholder, target);
			}
	
			/**
	   * Updates placeholder properties
	   * @param {[boolean]} sync [either sets or resets values]
	   */
	
		}, {
			key: 'setPlaceholderProps',
			value: function setPlaceholderProps(sync) {
				if (sync) {
					this.placeholder.style.height = this.getTargetHeight() + 'px';
					this.placeholder.style.margin = window.getComputedStyle(this.target).margin;
					this.placeholder.fixitActive = true;
				} else {
					this.placeholder.style.height = '';
					this.placeholder.style.margin = '';
					this.placeholder.fixitActive = false;
				}
			}
		}, {
			key: 'targetIsTall',
			value: function targetIsTall() {
				return this.getTargetHeight() + this.offset > document.body.offsetHeight;
			}
		}, {
			key: 'getTargetHeight',
			value: function getTargetHeight() {
				return this.target.getBoundingClientRect().height;
			}
	
			//This method needs revision:
			//Position is not properly reported on certain browsers when using window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	
		}, {
			key: 'getScrollDirection',
			value: function getScrollDirection() {
				var direction = void 0,
				    docScrollTop = this.placeholder.getBoundingClientRect().top;
	
				if (this.scrollPosition > docScrollTop) {
					direction = 'down';
				} else {
					direction = 'up';
				}
	
				this.scrollPosition = docScrollTop;
	
				return direction;
			}
		}]);
	
		return FixIt;
	}();
	
	exports.default = FixIt;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.selectItem = selectItem;
	exports.selectPromotion = selectPromotion;
	exports.selectBannerPromotion = selectBannerPromotion;
	exports.initCategoryNavigation = initCategoryNavigation;
	/**
	 * Add GTM specific features here.
	 */
	
	function selectItem() {
	    //GA4 - select item
	    $(document).on("click", '.product-grid__item.col-xs-6.col-md-4', function (e) {
	        var itemid = $(this).find('.product').data('itemid');
	        var productLists = dataLayer.filter(function (o) {
	            return o.productList != null;
	        });
	        var product = productLists.find(function (s) {
	            return s.productList.itemsList.find(function (o) {
	                return o.id == itemid;
	            });
	        }).productList.itemsList.find(function (m) {
	            return m.id == itemid;
	        });
	        var lazyLoadPageSize = SitePreferences.LAZY_LOAD_PAGESIZE ? SitePreferences.LAZY_LOAD_PAGESIZE : 12;
	        //GA4 events for select item
	        var ecomObjectSelectItems = {
	            event: "ecom_event",
	            eventCategory: "ecommerce",
	            eventAction: "select_item",
	            ecommerce: {
	                items: []
	            }
	        };
	        var customProduct = {
	            "item_id": product.item_id,
	            "item_name": product.item_name,
	            "affiliation": product.affiliation ? product.affiliation : '',
	            "coupon": product.coupon,
	            "currency": product.currency,
	            "discount": product.discount,
	            "index": +lazyLoadPageSize * (productLists.length - 1) + +product.position,
	            "item_brand": product.item_brand,
	            "item_category": product.item_category,
	            "item_category2": product.item_category2,
	            "item_category3": product.item_category3,
	            "item_category4": product.item_category4,
	            "item_category5": product.item_category5,
	            "item_list_id": product.item_list_id,
	            "item_list_name": product.item_list_name,
	            "item_variant": product.item_variant,
	            "location_id": product.location_id,
	            "price": product.price,
	            "quantity": product.quantity
	        };
	        ecomObjectSelectItems.ecommerce.items.push(customProduct);
	        var productCategoryList = JSON.parse(sessionStorage.getItem('productCategoryList')) || {};
	        productCategoryList[product.item_id] = { "id": product.item_list_id, "name": product.item_list_name };
	        sessionStorage.setItem('productCategoryList', JSON.stringify(productCategoryList));
	        dataLayer.push(ecomObjectSelectItems);
	    });
	}
	
	function handlePromotionClick(selector, eventAction) {
	    $(document).on("click", selector, function (e) {
	        var promotionList = dataLayer.filter(function (o) {
	            return o.eventAction === "view_promotion";
	        });
	        var promotionLabel = $(this).find("a").data("eventlabel");
	        if (promotionLabel.length > 0) {
	            promotionLabel = promotionLabel.trim().replace(/"/g, '');
	            var selectedPromotion = promotionList.filter(function (p) {
	                return p.eventLabel === promotionLabel;
	            });
	
	            if (selectedPromotion.length > 0) {
	                var ecomObject = selectedPromotion[0];
	                ecomObject.eventAction = eventAction;
	                dataLayer.push({ ecommerce: null });
	                dataLayer.push(ecomObject);
	            }
	        }
	    });
	}
	
	function selectPromotion() {
	    handlePromotionClick(".plp-listing-promo .product__promo", "select_promotion");
	}
	
	function selectBannerPromotion() {
	    handlePromotionClick(".plp-promo-banner .promo-banner__item", "select_promotion");
	}
	
	function initCategoryNavigation() {
	    // General function to handle category clicks
	    function handleCategoryClick(selector, eventLabelPrefix) {
	        $(document).on("click", selector, function (e) {
	            var isVisualNav = $(this).children().eq(0).hasClass("cta-image");
	            var eventCategory = $(this).attr('data-category');
	            var category = $(this).attr('data-path');
	            if (category.length > 0) {
	                category = category.split('|').pop();
	            }
	
	            var user = dataLayer.find(function (o) {
	                return o.user != null;
	            }).user;
	            var eventAction = isVisualNav ? eventLabelPrefix + '_visual_cta_click' : eventLabelPrefix + '_text_cta_click';
	
	            var CTAObject = {
	                'event': 'custom_event',
	                'eventCategory': eventCategory,
	                'eventAction': eventAction,
	                'eventLabel': category,
	                'language': window.GlobalAttributes.LANGUAGE,
	                'country': window.GlobalAttributes.COUNTRY,
	                'loginMode': user.user_id !== '' ? "email" : "NA",
	                'screenName': "PLP",
	                'userType': user.user_id !== '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id !== '' ? user.user_id : ''
	            };
	
	            dataLayer.push(CTAObject);
	        });
	    }
	
	    // Initialize navigation for categories
	    handleCategoryClick(".links-item .category-click", 'subcategory');
	    handleCategoryClick(".cat-cta-item .category-click, .cat-cta-item--selected .category-click", 'subcategory');
	}

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    //Initializing Megamenu with some custom classes
	    mainNav = new _module2.default(NAV_OPTIONS);
	    fixedNav = new _module4.default(FIXIT_OPTIONS);
	
	    if (matContent) {
	        welcomeMat = new _module6.default(MAT_OPTIONS);
	    }
	
	    if (signupContent) {
	        signup = new _module6.default(SIGNUP_OPTIONS);
	        addSignupHandler();
	    }
	
	    if (gdprContent) {
	        gdprModal = new _module6.default(GDPR_OPTIONS);
	    }
	
	    togglePromoBanner();
	    setNavInteractions();
	    focusHeaderSearch();
	    setPageUrlHistory();
	    closeSearchPopup();
	    initLazyImages();
	    maskCartIcon();
	    onSearchSuggestionClick();
	    headerGAEvents();
	    toggleLanguagesMobile();
	    initFlyoutLazyLoad();
	    reinitFlyoutSlickOnResize();
	    initFlyoutImageCtaRedirect();
	};
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _validator = __webpack_require__(56);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _born = __webpack_require__(10);
	
	var Utils = _interopRequireWildcard(_born);
	
	var _module = __webpack_require__(57);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _module3 = __webpack_require__(50);
	
	var _module4 = _interopRequireDefault(_module3);
	
	var _module5 = __webpack_require__(20);
	
	var _module6 = _interopRequireDefault(_module5);
	
	var _module7 = __webpack_require__(18);
	
	var _module8 = _interopRequireDefault(_module7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var page = __webpack_require__(58),
	    util = __webpack_require__(15);
	
	/**
	 * Navigation::
	 * Bunch of useless things.
	 * Making stuff work on tablet and desktops. When is touch device media query coming to CSS?
	 */
	
	var mainNav,
	    fixedNav,
	    welcomeMat,
	    signup,
	    gdprModal,
	    matContent = document.querySelector('.modal--welcomemat__content'),
	    signupContent = document.querySelector('.modal--signup__content'),
	    gdprContent = document.querySelector('.js-gdpr-modal');
	
	var NAV_OPTIONS = {
	    menu: ".header__catmenu",
	    triggers: ".header__catmenu__anchor,.flyout-col__heading",
	    target: ".header__catmenu__sub,.flyout-col__all_item",
	    beforeItemSet: onSetNav,
	    afterItemUnset: onUnsetNav,
	    waitForAnimateEl: ".header__catmenu__sub,.flyout-col__all_item",
	    allowClickThrough: "level-1",
	    afterMenuSet: showOverlay,
	    afterMenuUnset: hideOverlay,
	    flyOutDisabled: 'js-no-flyout',
	    responsive: [{
	        breakpoint: _born.breakpoints.mobile,
	        settings: {
	            events: 'click',
	            unsetOnMouseleave: false,
	            cancelCloseSelf: false,
	            allowClickThrough: 'second-level-cat',
	            allowClickThroughDirectly: 'direct'
	        }
	    }]
	};
	
	var FIXIT_OPTIONS = {
	    target: document.querySelector('.header__main'),
	    enabled: _born.shouldEnableSticky
	};
	
	var MAT_OPTIONS = {
	    modalID: 'welcomeMatOverlay',
	    modalClass: 'modal--welcomemat',
	    modalContent: matContent,
	    beforeOpenCallback: beforeMatOpen,
	    afterCloseCallback: afterMatClose
	};
	
	var SIGNUP_OPTIONS = {
	    modalID: 'signupOverlay',
	    modalClass: 'modal--signup',
	    modalContent: signupContent,
	    beforeOpenCallback: beforeSignupOpen,
	    afterCloseCallback: afterSignupClose
	};
	
	var GDPR_OPTIONS = {
	    modalID: 'gdprOverlay',
	    modalClass: 'modal-gdpr',
	    modalContent: gdprContent,
	    beforeOpenCallback: beforeGDPROpen,
	    afterCloseCallback: afterGDPRClose,
	    isCloseBlocked: true
	};
	
	function beforeMatOpen(overlay) {
	    document.documentElement.classList.add('cancel-scroll--force');
	    matContent.classList.remove('hidden');
	}
	
	function afterMatClose() {
	    document.documentElement.classList.remove('cancel-scroll--force');
	}
	
	function beforeSignupOpen(overlay) {
	    document.documentElement.classList.add('cancel-scroll--force');
	    signupContent.classList.remove('hidden');
	}
	
	function afterSignupClose() {
	    document.documentElement.classList.remove('cancel-scroll--force');
	}
	
	function beforeGDPROpen(overlay) {
	    // Disable scrolling and make popup visible
	    $(document).addClass('cancel-scroll--force');
	    $(gdprContent).removeClass('hidden');
	
	    // GDPR Events
	    $('.js-gdpr-modal button').click(function (e) {
	        e.preventDefault();
	
	        var $form = $(this).closest('form'),
	            buttonName = $(this).attr('name'),
	            buttonVal = $(this).val(),
	            url = util.appendParamToURL($form.attr('action'), buttonName, buttonVal);
	
	        // Tracking layer
	        if ($(this).hasClass('js-gdpr-submit')) {
	            _module8.default.pushData('gdpr_tracking: ' + window.Resources['GDPR_ON']);
	        } else if ($(this).hasClass('js-gdpr-discard')) {
	            _module8.default.pushData('gdpr_tracking: ' + window.Resources['GDPR_OFF']);
	        }
	
	        // Send request
	        $.ajax({
	            url: url,
	            type: 'POST',
	            data: $form.serialize(),
	            complete: function complete(response) {
	                page.refresh();
	            }
	        });
	    });
	}
	
	function afterGDPRClose() {
	    $(document).removeClass('cancel-scroll--force');
	}
	
	function onSetNav(trigger) {
	    loadFlyoutImages(trigger);
	    toggleNavStyles(trigger, true);
	}
	
	function onUnsetNav(trigger) {
	    toggleNavStyles(trigger);
	}
	
	function showOverlay() {
	    (0, _born.toggleOverlay)(true, false, false);
	}
	
	function hideOverlay() {
	    (0, _born.toggleOverlay)(false, false, false);
	}
	
	function loadFlyoutImages(el) {
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD && window.innerWidth >= _born.breakpoints.mobile) {
	        var activeEl = $(el).closest('.header__catmenu__item.level-1').find(".flyout-col__cta__images img:not(.unveil-loaded)");
	        if (activeEl.length > 0) {
	            activeEl.unveil(300, function () {
	                $(this).addClass('unveil-loaded');
	            });
	        } else {
	            $(".flyout-col__cta__images img:not(.unveil-loaded)").unveil(300, function () {
	                $(this).addClass('unveil-loaded');
	            });
	        }
	    }
	}
	
	function toggleNavStyles(trigger, isShow) {
	
	    /**
	     * [adds a class to the closest scrollable nav to disable scrolling,
	     * fixing a mobile Safari bug on child scrollable views]
	     */
	    if (window.innerWidth < _born.breakpoints.mobile) {
	        var scrollableNav;
	
	        if (trigger.classList.contains('level-1')) {
	            scrollableNav = document.querySelector('.header__secondary__content');
	        } else {
	            scrollableNav = $(trigger).closest('.header__catmenu__sub')[0];
	        }
	
	        if (isShow) {
	            scrollableNav.classList.add('megamenu--prev-nav');
	        } else {
	            scrollableNav.classList.remove('megamenu--prev-nav');
	        }
	    }
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD && window.innerWidth < _born.breakpoints.mobile) {
	        $("img.product__img:not(.unveil-loaded)").trigger("unveil");
	        var activeEl = $(trigger).closest('.level-1').find("img.header--flyout__img:not(.unveil-loaded)");
	        if (activeEl && activeEl.length > 0) {
	            activeEl.unveil(4000, function () {
	                $(this).addClass('unveil-loaded');
	            });
	        } else {
	            $("img.header--flyout__img:not(.unveil-loaded)").unveil(4000, function () {
	                $(this).addClass('unveil-loaded');
	            });
	        }
	    }
	}
	
	function setNavInteractions() {
	    var header = document.querySelector('.header'),
	        secondaryNav = document.querySelector('.header__secondary'),
	        countryDropdown = document.querySelector('.header__sett__country .header__sett__list'),
	        langDropdown = document.querySelector('.header__sett__lang .header__sett__list'),
	        logoDropdown = document.querySelector('.header__tagline__descr'),
	        scrollableNav = document.querySelector('.header__secondary__content'),
	        promoBanner = document.querySelector('.header__promo-banner');
	
	    //Hooking functionality to toggle no-scroll on page wrapper on mobile main nav show/hide
	    if (secondaryNav !== null) {
	        secondaryNav.beforeContentShow = function () {
	            // document.documentElement.classList.add('cancel-scroll');
	            document.body.classList.add('cancel-scroll');
	
	            scrollableNav.scrollTop = 0;
	            var promoBannerHeight = promoBanner.getBoundingClientRect().height;
	            var sideNavHeight = 'calc(100dvh - ' + promoBannerHeight + 'px)';
	
	            var currentScrollPos = window.scrollY || document.documentElement.scrollTop;
	            var fixitHeader = document.querySelector('.header__main.fixit--active');
	            if (fixitHeader) {
	                sideNavHeight = '100dvh';
	            } else if (currentScrollPos < promoBannerHeight) {
	                sideNavHeight = 'calc(100dvh - ' + (promoBannerHeight - currentScrollPos) + 'px)';
	            }
	
	            secondaryNav.style.height = sideNavHeight;
	
	            (0, _born.toggleOverlay)(true);
	
	            return true;
	        };
	
	        secondaryNav.afterContentHide = function () {
	            // document.documentElement.classList.remove('cancel-scroll');
	            document.body.classList.remove('cancel-scroll');
	            secondaryNav.style.height = '';
	
	            (0, _born.toggleOverlay)(false);
	        };
	    }
	    if (logoDropdown) {
	        logoDropdown.beforeContentShow = function () {
	            (0, _born.toggleOverlay)(true);
	
	            return true;
	        };
	
	        logoDropdown.afterContentHide = function () {
	            (0, _born.toggleOverlay)(false);
	        };
	    }
	    if (langDropdown) {
	        langDropdown.afterContentShow = function (trigger) {
	            scrollableNav.scrollTop = trigger.offsetTop;
	        };
	    }
	    if (countryDropdown) {
	        countryDropdown.afterContentShow = function (trigger) {
	            scrollableNav.scrollTop = trigger.offsetTop;
	        };
	    }
	    //Disable country/language from unsetting other active elements.
	    //This is to prevent this trigger from closing the main nav.
	    if (countryDropdown) {
	        countryDropdown.beforeUnsetOthers = toggleSetting;
	    }
	
	    if (langDropdown) {
	        langDropdown.beforeUnsetOthers = toggleSetting;
	    }
	
	    function toggleSetting() {
	        if (window.innerWidth < _born.breakpoints.mobile) {
	            return false;
	        }
	
	        return true;
	    }
	}
	
	function addSignupHandler() {
	    //dwValidator.settings.onfocusout = false;
	
	    var form = document.querySelector('.modal--signup__subscribe__form'),
	        subFormSettings = $.extend(true, { submitHandler: sendSignupRequest }, _validator2.default.settings);
	
	    $(form).find('input').on('change', function () {
	        $(this).closest('.modal--signup__details').find('.modal--signup__subscribe__message').remove();
	    });
	
	    $('.modal--signup__later').on('click', function () {
	        $(form).closest('.window-overlay--modal').find('.window-overlay--close').click();
	    });
	
	    if (_born.isMobile.Android()) {
	        $(form).find('input.modal--signup__emailsignup').on('focus', function () {
	            setTimeout(function () {
	                $('.overlay--active').scrollTop($(form).offset().top);
	            }, 500);
	        });
	    }
	
	    _validator2.default.initForm(form, subFormSettings);
	}
	
	function sendSignupRequest(form) {
	
	    $.ajax({
	        url: _util2.default.ajaxUrl($(form).attr('action')),
	        data: $(form).serialize(),
	        complete: function complete(response) {
	
	            $(form).closest('.window-overlay--modal').find('.window-overlay--close').click();
	
	            var responseContent = JSON.parse(response.responseText);
	
	            Utils.createMessageBanner(responseContent.message);
	
	            _module8.default.pushData('mail_signup: ' + window.Resources['USER_SIGNUP']);
	        }
	    });
	
	    return false;
	}
	
	function togglePromoBanner() {
	    var items = $('.header__promo-banner .item'),
	        totalItems = items.length,
	        currentItem = 1; // start from the second item since the first item is displayed by css
	
	    if (totalItems > 1) {
	
	        setInterval(function () {
	
	            items.hide();
	            items.eq(currentItem).show();
	
	            if (currentItem < totalItems) {
	                currentItem++;
	            }
	
	            if (currentItem == totalItems) {
	                currentItem = 0;
	            }
	        }, 5000);
	    }
	}
	
	function focusHeaderSearch() {
	    var $searchInput = $('.header__search__input');
	    var $searchTrigger = $('.js-header-search-trigger');
	
	    $searchTrigger.on('click', function (e) {
	        $searchInput.focus();
	        if ($(window).width() > 767) {
	            $('.header__search--backdrop').toggleClass('hidden');
	            $('html, body').toggleClass('no-scroll');
	        }
	        // Push to data layer
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        if (!$('.js-header-search-trigger').hasClass('toggle--active')) {
	            onSearchPopUpClose(user);
	        } else {
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'search',
	                'eventAction': 'go_to_search',
	                'eventLabel': 'go to search',
	                'country': window.GlobalAttributes.COUNTRY,
	                'language': window.GlobalAttributes.LANGUAGE,
	                'screenName': 'Search',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        }
	    });
	
	    $('.header__search__form').on('submit', function (e) {
	        var searchObj = $(this).find('input[name="q"]');
	        if (searchObj.length > 0) {
	            if (searchObj.val().trim() == '') {
	                e.preventDefault();
	                searchObj.addClass('error');
	            } else {
	                searchObj.removeClass('error');
	            }
	        }
	    });
	}
	
	function closeSearchPopup() {
	    $('.search-titlebar-mobile .close-icon').on('click', function () {
	        $('button.js-header-search-trigger').trigger('click');
	    });
	    $('.header__search--backdrop').on('click', function () {
	        $('.js-header-search-trigger:visible').trigger('click');
	    });
	}
	
	function onSearchPopUpClose(user) {
	    // Push to data layer
	    var searchObj = $('body').find('input[name="q"]');
	    dataLayer.push({
	        'event': 'custom_event',
	        'eventCategory': 'search',
	        'eventAction': 'cancel_search',
	        'eventLabel': 'cancel search',
	        'searchTerm': searchObj.val() ? searchObj.val().trim() : '',
	        'country': window.GlobalAttributes.COUNTRY,
	        'language': window.GlobalAttributes.LANGUAGE,
	        'screenName': 'Search',
	        'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	        'userId': user.user_id != '' ? user.user_id : ''
	    });
	}
	
	function maskCartIcon() {
	    $('.header__mobile-trigger').on('click', function () {
	        $('#mini-cart').toggleClass('cart-masked');
	        $('.mega-item--active').removeClass('mega-item--active');
	        $('.megamenu--prev-nav').removeClass('megamenu--prev-nav');
	    });
	}
	
	function setPageUrlHistory() {
	    try {
	        if (window.innerWidth <= _born.breakpoints.mobile) {
	            var currentUrl = window.location.href;
	            var previousUrl = document.referrer;
	            if (currentUrl !== previousUrl) {
	                var setUrlItem = checkValidPageUrl(currentUrl);
	                if (!setUrlItem) {
	                    setUrlItem = checkValidPageUrl(previousUrl);
	                }
	                if (setUrlItem) {
	                    localStorage.setItem('pageurlhistory', setUrlItem);
	                }
	            }
	        }
	    } catch (e) {}
	}
	
	function checkValidPageUrl(url) {
	    var excludeUrls = ['Cart-SubmitForm', 'SGCart-SubmitForm', 'shopping-bag'];
	    for (var i = 0; i < excludeUrls.length; i++) {
	        if (url.indexOf(excludeUrls[i]) !== -1) {
	            return false;
	        }
	    }
	    return url;
	}
	
	function initLazyImages() {
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	        $('.logo__default:not(.unveil-loaded),.logo__sticky:not(.unveil-loaded)').unveil(0, function () {
	            $(this).addClass('unveil-loaded');
	        });
	        $('img.asset-laz-load:not(.unveil-loaded)').unveil(200, function () {
	            $(this).addClass('unveil-loaded');
	        });
	    }
	}
	
	function onSearchSuggestionClick() {
	    $('.header__search,.header__mobile-search').on('click', '.search-suggestion-wrapper .hit', function (e) {
	        // Push to data layer
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'search',
	            'eventAction': 'search_query_suggestion_click',
	            'eventLabel': $(this).text(), //click text
	            'searchTerm': $(this).text(),
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Search',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	        window.location = this.href;
	    });
	}
	function getScreenName() {
	    var pageName = pageContext.type;
	    var screenName = '';
	    if (pageName == 'storefront' || pageName == 'homepage') {
	        screenName = 'Home page';
	    } else if (pageName == 'search') {
	        screenName = 'Search';
	    } else if (pageName == 'product') {
	        screenName = 'PDP';
	    } else if (pageName == 'Cart') {
	        screenName = 'Cart page';
	    } else if (pageName == 'checkout') {
	        screenName = 'Checkout Page';
	    } else if (pageName == 'MyAccount') {
	        screenName = 'My Account';
	    } else if (pageName == 'orderconfirmation') {
	        screenName = 'Thank you screen';
	    }
	    return screenName;
	}
	
	function headerGAEvents() {
	    $('.header__user__item .header__user__link--account').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_account_click',
	            'eventLabel': 'Signin/Register',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.header__user__item .header__user__link--wishlist,.header__mobile-wishlist').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_wishlist_click',
	            'eventLabel': 'top navigation wishlist click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.header__user__item.minicart .minicart__trigger').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_bag_click',
	            'eventLabel': 'top navigation bag click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.flyout-col__all_item.level-3 .flyout-col__item-anchor').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var level2Cat = $(this).closest('.level-3').find('.top--cat').text();
	        var level1Cat = $(this).closest('.level-3').find('.level-1-cat').text();
	        var level3Cat = $(this).text();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation',
	            'eventLabel': level1Cat + ' > ' + level2Cat + ' > ' + level3Cat,
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.header__catmenu__item.level-1 .header__catmenu__anchor').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var level1Cat = $(this).text();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation',
	            'eventLabel': level1Cat,
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.header__catmenu__item .header__catmenu__sub.level-2 .header__catmenu__sub__wrap .flyout-col-up__heading,.header__catmenu__item .header__catmenu__sub.level-2 .header__catmenu__sub__wrap .second-level-cat').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var level1Cat = $(this).closest('.header__catmenu__sub.level-2').find('.level-2-heading').text();
	        var level2Cat = $(this).text();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation',
	            'eventLabel': level1Cat + ' > ' + level2Cat,
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.header__logo__anchor').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var screenName = getScreenName();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_logo_click',
	            'eventLabel': 'top navigation logo click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': screenName,
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('#countrySelectorList').on('change', function () {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var screenName = getScreenName();
	        var country = $('select#countrySelectorList option:selected').data('country');
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_country_select',
	            'eventLabel': country, //selected country
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': screenName,
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.languageSelectorList').on('click', function () {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var screenName = getScreenName();
	        var language = $(this).data('locale');
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_language_click',
	            'eventLabel': language, // language
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': screenName,
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	}
	
	function toggleLanguagesMobile() {
	    $('.language-accordion').on('click', function () {
	        if (window.innerWidth < _born.breakpoints.mobile) {
	            $(this).parent().toggleClass('active');
	        }
	    });
	}
	
	function initFlyoutLazyLoad() {
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	        var targetElements = document.querySelectorAll('.header__catmenu__sub.level-2');
	
	        var callback = function callback(mutationsList, observer) {
	            mutationsList.forEach(function (mutation) {
	                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
	                    var element = mutation.target;
	                    $(element).trigger('classChanged');
	                }
	            });
	        };
	
	        targetElements.forEach(function (element) {
	            var observer = new MutationObserver(callback);
	            observer.observe(element, {
	                attributes: true,
	                attributeFilter: ['class']
	            });
	        });
	
	        $('.header__catmenu__sub.level-2').on('classChanged', function () {
	            var $this = $(this);
	            if ($this.hasClass('mega-item--active')) {
	                $this.find('img[data-ondemandsrc]:not(.loaded-on-demand)').each(function () {
	                    var srcVal = $(this).data('ondemandsrc');
	                    $(this).attr('src', srcVal).addClass('loaded-on-demand');
	                });
	            }
	        });
	    }
	}
	
	function reinitFlyoutSlickOnResize() {
	    $(window).on('resize', function () {
	        $('.flyout-col__cta__interactive').slick('refresh');
	    });
	}
	
	function initFlyoutImageCtaRedirect() {
	    $(".flyout-col__cta__container").on('click', 'img', function () {
	        if ($(this).data('ctaurl')) {
	            window.location.href = $(this).data('ctaurl');
	        }
	    });
	}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	// import 'intl-tel-input';
	
	var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
	var regex = {
	    phone: {
	        us: naPhone,
	        ca: naPhone,
	        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
	        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
	        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
	        cn: /.*/,
	        gb: /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/
	    },
	    postal: {
	        us: /^\d{5}(-\d{4})?$/,
	        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
	        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
	        it: /^([0-9]){5}$/,
	        jp: /^([0-9]){3}[-]([0-9]){4}$/,
	        cn: /^([0-9]){6}$/,
	        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
	    },
	    notCC: /^(?!(([0-9 -]){13,19})).*$/
	};
	
	var currencies = '\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6';
	
	// global form validator settings
	var settings = {
	    showErrors: function showErrors(errorMap, errorList) {
	        $.each(errorList, function (index, item) {
	            var $element = $(item.element);
	
	            if ($element[0].nodeName === 'SELECT') {
	                $element.parent().next().addClass('error');
	            }
	        });
	
	        this.defaultShowErrors(); // to display the default error placement
	    },
	    errorClass: 'error',
	    errorElement: 'span',
	    onkeyup: false,
	    onfocusout: function onfocusout(element) {
	        var $element = $(element),
	            $clearCCDetailsField = $('#isClearCCDetails');
	
	        if ($clearCCDetailsField && $clearCCDetailsField.val() === 'false') {
	            if ($element.hasClass('input-select') && ($element.closest('.month').length > 0 || $element.closest('.year').length > 0)) {
	                return;
	            }
	        }
	
	        if (!this.checkable(element) && !$element.hasClass('modal--signup__emailsignup')) {
	            this.element(element);
	        }
	
	        // add or remove error class from selectric drop down wrapper
	        if ($element[0].nodeName === 'SELECT') {
	            if ($element.hasClass('error')) {
	                $element.parent().next().addClass('error');
	            } else {
	                $element.parent().next().removeClass('error');
	            }
	        }
	    },
	    errorPlacement: placeError
	};
	
	/**
	 * [placeError] Customizing placement of created error labels to insert the error for
	 * <select> tags after their styled wrapped.
	 * @param  {[type]} jQuery object [The error label to insert into the DOM.]
	 * @param  {[type]} jQuery object [The validated input, for relative positioning.]
	 */
	function placeError(error, $element) {
	    if ($element[0].nodeName === 'SELECT' || $element.hasClass('input-multicheckbox')) {
	        $element = $element.closest('.field-wrapper')[0] || $element.parent();
	    }
	
	    error.insertAfter($element);
	}
	
	/**
	 * @function
	 * @description Validates a given phone number against the countries phone regex
	 * @param {String} value The phone number which will be validated
	 * @param {String} el The input field
	 */
	// var validatePhone = function (value, el) {
	//     var country = $(el).closest('form').find('.country');
	
	//     if(/[a-zA-Z]/.test(value.trim())) {
	//         return false;
	//     }
	
	//     if (country.length === 0 || country.val().length === 0 || !regex.phone[country.val().toLowerCase()]) {
	//         return true;
	//     }
	
	//     var rgx = regex.phone[country.val().toLowerCase()];
	//     var isOptional = this.optional(el);
	//     var isValid = rgx.test($.trim(value));
	
	//     return isOptional || isValid;
	// };
	
	var validatePhone2 = function validatePhone2(value, element) {
	    var $element = $(element);
	
	    if ($.trim($element.val())) {
	        if ($element.intlTelInput('isValidNumber') === false) {
	            return false;
	        } else {
	            return true;
	        }
	    }
	};
	
	var validatePostal = function validatePostal(value) {
	
	    var trimmed = value.trim();
	
	    return trimmed === '' || /^[a-zA-Z0-9\-_. ]+$/.test(trimmed) ? true : false;
	};
	
	var validateCvn = function validateCvn(value) {
	    moengagePaymentPushEvent('payment_credit_card');
	    return (/^[0-9\*-_]+$/.test(value.trim())
	    );
	};
	
	/**
	 * @function
	 * @description Validates that a credit card owner is not a Credit card number
	 * @param {String} value The owner field which will be validated
	 * @param {String} el The input field
	 */
	var validateOwner = function validateOwner(value) {
	    var isValid = regex.notCC.test($.trim(value));
	    return isValid;
	};
	
	function matchFields(originalClass, confirmClass, value, field) {
	    var dependentField = field.form.querySelector('.' + (field.classList.contains(originalClass) ? confirmClass : originalClass)),
	        fieldsMatch = field.value == dependentField.value;
	
	    return dependentField.value == '' || fieldsMatch;
	}
	
	/**
	 * Validates that value is an ASCII character plus certain language specific codes
	 */
	function validateASCII(value) {
	    // console.log(value);
	    //return value.trim() === '' || /^[\x00-\x7FÀ-úÀ-ÿ¡¿≤≥÷”’»—º‚\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]+$/.test(value.trim());
	    var regex = /^[\u0621-\u064A\u0660-\u0669a-zA-Z0-9\x00-\x7FÀ-úÀ-ÿ¡¿≤≥÷”’»—º‚\u0000-\u024F]+$/;
	
	    // allow Latin only    
	    return value.trim() === '' || regex.test(value.trim());
	}
	
	/**
	 * Validates that value has Emojis 
	 */
	
	function validateEmoji(value) {
	    return value.trim() === '' || !/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(value.trim());
	}
	
	/**
	 * Validate name
	 * - Numbers are not allowed
	 * - Spaces only are not allowed
	 * - There are should be at least one symbol from English alphabet or accent
	 * @param {String} value
	 * @returns {Boolean}
	 */
	function validateName(value) {
	    var regex = /[\u0621-\u064A\u0660-\u0669a-zA-Z\u00C0-\u017F]+/;
	
	    return value === '' || validateASCII(value) && !/\d/.test(value) && !/^\s+$/.test(value) && regex.test(value) && !/[!~@#$^*()_+=[\]{}|\\,.?:-]/.test(value);
	}
	
	/**
	 * Validate name length
	 * @param {String} value
	 * @returns {Boolean}
	 */
	function validateNameLength(value) {
	    return value === '' || value.trim().length >= 2;
	}
	
	/**
	 * Add phone validation method to jQuery validation plugin.
	 * Text fields must have 'phone' css class to be validated as phone
	 */
	// $.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);
	$.validator.addMethod('phone', validatePhone2, Resources.INVALID_PHONE);
	
	/**
	 * Add postal validation method to jQuery validation plugin.
	 * Text fields must have 'postal' css class to be validated as postal
	 */
	$.validator.addMethod('postal', validatePostal, Resources.INVALID_ZIP);
	
	/**
	 * Add CVN validation method to jQuery validation plugin.
	 * Text fields must have 'cvn' css class to be validated as CVN
	 */
	$.validator.addMethod('cvn', validateCvn, Resources.VALIDATE_CVN);
	
	/**
	 * Add CCOwner validation method to jQuery validation plugin.
	 * Text fields must have 'owner' css class to be validated as not a credit card
	 */
	$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);
	
	/**
	 * Add ASCII validation method to jQuery validation plugin.
	 * Text fields must have 'validate-char' css class to be validated as not a credit card
	 */
	$.validator.addMethod('validate-char', validateASCII, Resources.VALIDATE_CHARACTERS);
	
	/**
	 * Add emoji validation method to jQuery validation plugin.
	 * Text fields must have 'validate-emoji' css class to be validated
	 */
	$.validator.addMethod('validate-emoji', validateEmoji, Resources.VALIDATE_EMOJIS);
	
	/**
	 * Add gift cert amount validation method to jQuery validation plugin.
	 * Text fields must have 'gift-cert-amont' css class to be validated
	 */
	$.validator.addMethod('gift-cert-amount', function (value, el) {
	    var isOptional = this.optional(el);
	    var isValid = !isNaN(value) && parseFloat(value) >= 5 && parseFloat(value) <= 5000;
	    return isOptional || isValid;
	}, Resources.GIFT_CERT_AMOUNT_INVALID);
	
	/**
	 * Add positive number validation method to jQuery validation plugin.
	 * Text fields must have 'positivenumber' css class to be validated as positivenumber
	 */
	$.validator.addMethod('positivenumber', function (value) {
	    if ($.trim(value).length === 0) {
	        return true;
	    }
	    return !isNaN(value) && Number(value) >= 0;
	}, Resources.VALIDATE_NUMBER); // '' should be replaced with error message if needed
	
	// Name validation has to display different messages for different circumstances. Because of this it is divided in 3 validators:
	// "validate-name": common validator
	// "validate-first-name-length": name length validator with own message for first name
	// "validate-last-name-length": name length validator with own message for last name
	/**
	 * Add name field validation
	 */
	$.validator.addMethod('validate-name', validateName, Resources.VALIDATE_NAME);
	
	/**
	 * Add first name length field validation
	 */
	$.validator.addMethod('validate-first-name-length', validateNameLength, Resources.VALIDATE_FIRST_NAME_LENGTH);
	
	/**
	 * Add last name length field validation
	 */
	$.validator.addMethod('validate-last-name-length', validateNameLength, Resources.VALIDATE_LAST_NAME_LENGTH);
	
	/**
	 * Check if confirmation element matches the original on blur.
	 * @param  {[type]} confirmEl [description]
	 */
	function confirmOriginalMatch(confirmEl) {
	    if (confirmEl.value !== '') {
	        $(confirmEl).valid();
	    }
	}
	
	/**
	 * Better field match validation. New 'matches' validation can be implemented by
	 * just adding a new object to the matchValidations array
	 */
	
	var matchValidations = [{
	    type: 'email',
	    error: Resources.VALIDATE_EMAILMATCH
	}, {
	    type: 'password',
	    error: Resources.VALIDATE_PASSMATCH
	}];
	
	matchValidations.forEach(function (match) {
	    var validationType = 'validate-' + match.type + '-match',
	        originalClass = 'original-' + match.type,
	        confirmClass = 'confirm-' + match.type,
	        originalEl = document.querySelector('.' + originalClass),
	        confirmEl = document.querySelector('.' + confirmClass);
	
	    if (!originalEl) {
	        return false;
	    }
	
	    originalEl.addEventListener('blur', confirmOriginalMatch.bind(this, confirmEl));
	    $.validator.addMethod(validationType, matchFields.bind(this, originalClass, confirmClass), match.error);
	});
	
	/**
	 * Add better email address validation
	 */
	$.validator.addMethod('validate-strict-email', function (value, el) {
	    return value == '' || /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i.test(value);
	}, Resources.VALIDATE_EMAIL);
	
	/**
	 * This function validates atleast one user interest is selected. 
	 */
	$.validator.addMethod('validate-user-interests', function (value, element) {
	    return $('input[name="' + element.name + '"]:checked').length > 0;
	}, Resources.VALIDATE_USER_INTEREST);
	
	$.extend($.validator.messages, {
	    required: Resources.VALIDATE_REQUIRED,
	    remote: Resources.VALIDATE_REMOTE,
	    email: Resources.VALIDATE_EMAIL,
	    url: Resources.VALIDATE_URL,
	    date: Resources.VALIDATE_DATE,
	    dateISO: Resources.VALIDATE_DATEISO,
	    number: Resources.VALIDATE_NUMBER,
	    digits: Resources.VALIDATE_DIGITS,
	    creditcard: Resources.VALIDATE_CREDITCARD,
	    equalTo: Resources.VALIDATE_EQUALTO,
	    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
	    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
	    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
	    range: $.validator.format(Resources.VALIDATE_RANGE),
	    max: $.validator.format(Resources.VALIDATE_MAX),
	    min: $.validator.format(Resources.VALIDATE_MIN)
	});
	
	var validator = {
	    regex: regex,
	    settings: settings,
	    init: function init() {
	        var self = this;
	
	        $('form .form-row').find('input, select, textarea').on('change.unsetBEError', function () {
	            var $rowError = $(this).closest('.form-row.error'),
	                $backendError = $rowError.find('.form-caption.error-message');
	
	            if ($rowError.length && $backendError.length) {
	                $rowError.removeClass('error');
	                $backendError.remove();
	            }
	        });
	
	        $('form:not(.suppress)').each(function () {
	            $(this).validate(self.settings);
	        });
	    },
	    initForm: function initForm(f, s) {
	        $(f).validate(s || this.settings);
	    }
	};
	
	function getRequestLocale() {
	    if (window.GlobalAttributes.LANGUAGE !== undefined && window.GlobalAttributes.hasOwnProperty('LANGUAGE')) {
	        return window.GlobalAttributes.LANGUAGE.toLowerCase();
	    } else if (window.locale !== undefined) {
	        return window.locale;
	    }
	}
	
	module.exports = validator;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _born = __webpack_require__(10);
	
	var _util = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Megamenu = function () {
	    function Megamenu(options) {
	        _classCallCheck(this, Megamenu);
	
	        this.options = options || {};
	
	        this.setProperties();
	
	        this.menu = document.querySelector(this.options.menu);
	
	        if (!this.menu) {
	            console.warn('Could not find target element');
	            return;
	        }
	
	        this._beforeItemSet = this.options.beforeItemSet || function () {};
	        this._afterItemSet = this.options.afterItemSet || function () {};
	        this._afterMenuSet = this.options.afterMenuSet || function () {};
	        this._afterItemUnset = this.options.afterItemUnset || function () {};
	        this._afterMenuUnset = this.options.afterMenuUnset || function () {};
	
	        var triggers = this.menu.querySelectorAll(this.options.triggers);
	
	        [].forEach.call(triggers, this.setupNavigation.bind(this));
	
	        this.menu.addEventListener('mousemove', this.preventUndesiredHover.bind(this));
	
	        /**
	         * Determines if 'menu' should be closed when hovering out of it.
	         * This can be set on a breakpoint basis, so that the 'menu' is not closed when tapping out.
	         */
	        if (this.options.unsetOnMouseleave) {
	            this.menu.addEventListener('mouseleave', function () {
	                this.unsetRelatives();
	                this._afterItemUnset(triggers[0]);
	            }.bind(this));
	        }
	    }
	
	    /**
	     * Calculates the speed at which the cursor is moving inside the 'menu'.
	     * If the curve is too fast and skewed (meaning not vertical/horizontal), then the hover action will be ignored.
	     * @param  {[Object]} evt ['mousemove' event object]
	     */
	
	
	    _createClass(Megamenu, [{
	        key: 'preventUndesiredHover',
	        value: function preventUndesiredHover(evt) {
	            var newX = Math.abs(evt.clientX),
	                newY = Math.abs(evt.clientY),
	                diffX = Math.abs((this._origX || 0) - newX),
	                diffY = Math.abs((this._origY || 0) - newY);
	
	            this._origX = newX;
	            this._origY = newY;
	
	            this.isMouseMoveFast = diffX / diffY >= 0.5 ? true : false;
	        }
	
	        /**
	         * Sets up the properties for the menu.
	         * These can be set on a breakpoint basis.
	         *
	         * Properties::
	            events: [String] string with events to listen to.
	            menuActiveClass: [String] class to add to the 'menu' when the dropdowns are active
	            itemActiveClass: [String] class to add to the 'item' when it is active
	            unsetOnMouseleave: [Boolean] Determines if 'menu' should be closed when hovering out of it.
	            cancelCloseSelf: [String | Boolean] Determines if item should close itself when actioning on it (i.e. clicks).
	                                                Pass a class name to disallow the referenced element from closing.
	            responsive: [Object] Sets breakpoints settings using this format:
	                        responsive: [
	                            {
	                                breakpoint: <breakpoint>,
	                                settings: {
	                                    property: value
	                                }
	                            }
	                        ]
	            
	            allowClickThrough: [String | Boolean] On an anchor, specify a class which will enable clicks on if said anchor is also a 'menu' 'item'. Flag to false to disable link clicking.
	           */
	
	    }, {
	        key: 'setProperties',
	        value: function setProperties() {
	            this.options.events = this.options.events || 'touchstart click mouseenter';
	            this.options.menuActiveClass = this.options.menuActiveClass || 'mega--active';
	            this.options.itemActiveClass = this.options.itemActiveClass || 'mega-item--active';
	            this.options.unsetOnMouseleave = this.options.hasOwnProperty('unsetOnMouseleave') ? this.options.unsetOnMouseleave : true;
	            this.options.cancelCloseSelf = this.options.cancelCloseSelf || undefined;
	
	            //Loops through the responsive array
	            //to replace default settings with breakpoint specific settings. 
	            if (this.options.responsive.length > 0) {
	                this.options.responsive.sort(lowestBreakpoint);
	
	                //Not using forEach cause can't kill the loop.
	                for (var i = 0; i < this.options.responsive.length; i++) {
	                    if (updateProperty.call(this, this.options.responsive[i])) {
	                        break;
	                    }
	                }
	            }
	
	            /**
	             * Updates properties with ones coming from a matching breakpoint.
	             * @param  {[Object]} breakpointOpts literal with all breakpoint specific settings
	             * @return {[Boolean]}
	             */
	            function updateProperty(breakpointOpts) {
	                if (document.body.offsetWidth <= breakpointOpts.breakpoint) {
	                    for (var key in breakpointOpts.settings) {
	                        this.options[key] = breakpointOpts.settings[key];
	                    }
	
	                    return true;
	                }
	
	                return false;
	            }
	
	            function lowestBreakpoint(a, b) {
	                return a.breakpoint > b.breakpoint;
	            }
	        }
	
	        /**
	         * Sets item/trigger specific settings and handlers
	         * @param  {[Node]} trigger [Node to which the settings are going to be applied to]
	         */
	
	    }, {
	        key: 'setupNavigation',
	        value: function setupNavigation(trigger) {
	            trigger.megamenu = {
	                cancelCloseSelf: this.options.cancelCloseSelf ? trigger.classList.contains(this.options.cancelCloseSelf) : false
	            };
	
	            this.getParent(trigger);
	            this.getTarget(trigger);
	
	            if (trigger.megamenu.target) {
	                this.setupHandlers(trigger);
	            }
	        }
	
	        /**
	         * Gets the parent of the passed Node
	         * @param  {[Node]} trigger [Node where we're getting the parent Node from]
	         * @return {[Node]} [Parent of the passed element]
	         */
	
	    }, {
	        key: 'getParent',
	        value: function getParent(trigger) {
	            trigger.megamenu.parent = trigger.parentNode;
	
	            return trigger.megamenu.parent;
	        }
	
	        /**
	         * Gets the target of the passed Node (the first matching Node from the query)
	         * @param  {[Node]} trigger [Node where we're getting the target Node from]
	         * @return {[Node]} [Target of the passed element]
	         */
	
	    }, {
	        key: 'getTarget',
	        value: function getTarget(trigger) {
	            trigger.megamenu.target = trigger.megamenu.parent.querySelector(this.options.target);
	
	            return trigger.megamenu.target;
	        }
	
	        /**
	         * Uses 'this.options.events' to set up handlers on per item/trigger basis.
	         * @param  {[Node]} trigger [Node where we're setting handlers to]
	         */
	
	    }, {
	        key: 'setupHandlers',
	        value: function setupHandlers(trigger) {
	            var scope = this;
	
	            $(trigger).on(this.options.events, function (evt) {
	                var isTouch = evt.type.indexOf('touch') >= 0,
	                    isMobileFlag = (0, _util.isMobile)(),
	                    isL1Image = evt.target.nodeName === 'IMG',
	                    anchorEle = isL1Image ? evt.target.parentElement.parentElement : evt.target,
	                    allowClickThroughEl = scope.options.allowClickThrough ? anchorEle.classList.contains(scope.options.allowClickThrough) : false,
	                    allowClickThroughDirectlyEl = scope.options.allowClickThroughDirectly ? anchorEle.classList.contains(scope.options.allowClickThroughDirectly) : false,
	                    disableDesktopFlyout = scope.options.flyOutDisabled ? anchorEle.classList.contains(scope.options.flyOutDisabled) : false;
	                //Check if click was on an allowed element, if so allow link through.
	                if ((isTouch || anchorEle.nodeName === 'A' && !allowClickThroughEl) && !allowClickThroughDirectlyEl) {
	                    evt.preventDefault();
	                } else if (isTouch || anchorEle.nodeName === 'A' && !allowClickThroughEl && allowClickThroughDirectlyEl && !disableDesktopFlyout) {
	                    isL1Image && evt.preventDefault();
	                }
	
	                if (!allowClickThroughDirectlyEl && disableDesktopFlyout && !isMobileFlag && evt.type.indexOf('click') >= 0) {
	                    evt.preventDefault();
	                    window.location.href = $(evt.target).attr('href');
	                    return false;
	                } else {
	
	                    if (evt.type.indexOf('mouseenter') >= 0) {
	                        if (scope.isMouseMoveFast) {
	
	                            scope.overstay = setTimeout(function () {
	                                scope.toggleItemActive(this, evt.type, disableDesktopFlyout);
	                            }.bind(this), 125);
	
	                            return;
	                        } else {
	                            scope.toggleItemActive(this, evt.type, disableDesktopFlyout);
	                        }
	                    } else if (!allowClickThroughDirectlyEl || isL1Image && allowClickThroughDirectlyEl && !disableDesktopFlyout) {
	                        scope.toggleItemActive(this, evt.type, disableDesktopFlyout, !allowClickThroughDirectlyEl);
	                    }
	
	                    //Making sure further events are not fired after touchstart
	                    if (isTouch) {
	                        evt.stopImmediatePropagation();
	                    }
	                }
	            });
	
	            trigger.megamenu.parent.addEventListener('mouseleave', function (evt) {
	                clearInterval(scope.overstay);
	            });
	
	            trigger.megamenu.target.addEventListener('mouseleave', function (evt) {
	                scope.isMouseMoveFast = false;
	            });
	
	            trigger.megamenu.target.addEventListener('click', function (evt) {
	                scope.unsetItemActive(evt, trigger);
	            });
	        }
	
	        /**
	         * If the targeted item/trigger is active, and can be closed, removes the active status and fires _afterItemUnset.
	         * Otherwise trigger is activated and the corresponding callbacks are fired. If disableDesktopFlyout option true flyout 
	         * of desktop menu is disabled, mobileFlag used to determine mobile flyout of menu.
	         * @param  {[Node]} trigger [description]
	         * @param  {[String]} evtType [description]
	         * @param  {[Boolean]} disableDesktopFlyout [description]
	         * @param  {[Boolean]} mobileFlag [description]
	         */
	
	    }, {
	        key: 'toggleItemActive',
	        value: function toggleItemActive(trigger, evtType, disableDesktopFlyout, mobileFlag) {
	
	            if (trigger.classList.contains(this.options.itemActiveClass)) {
	                if (evtType !== 'mouseenter' && !trigger.megamenu.cancelCloseSelf) {
	                    this.unsetRelatives(trigger);
	                    this._afterItemUnset(trigger);
	                }
	            } else {
	                this._beforeItemSet(trigger);
	                if (!mobileFlag) {
	                    this.unsetRelatives(trigger);
	                }
	
	                if (!disableDesktopFlyout || mobileFlag) {
	                    this.setItemActive(trigger);
	                }
	
	                this._afterItemSet(trigger);
	            }
	        }
	
	        /**
	         * [setItemActive description]
	            waitForAnimateEl: [String] Selector to use to determine when to set the 'active' state on the menu.
	                                        Thist activation will wait until all transitions are complete on the targeted element.
	         * @param {[Node]} trigger [item/trigger to set active]
	         */
	
	    }, {
	        key: 'setItemActive',
	        value: function setItemActive(trigger) {
	
	            trigger.classList.add(this.options.itemActiveClass);
	            trigger.megamenu.target.classList.add(this.options.itemActiveClass);
	            trigger.megamenu.parent.classList.add(this.options.itemActiveClass);
	
	            trigger.megamenu.target.scrollTop = 0;
	            if ($(window).width() > 767) {
	                var fixitHeader = $('.header__main.fixit--active');
	                var heightReduction = fixitHeader.length ? fixitHeader.outerHeight() : $('.header').outerHeight();
	                var setHeight = 'calc(100vh - ' + heightReduction + 'px)';
	                $('.header__catmenu__sub.level-2').css('max-height', setHeight);
	            } else {
	                $('.header__secondary__content').addClass('cancel-scroll');
	            }
	
	            if (!this.menu.isActive) {
	                if (this.options.waitForAnimateEl) {
	                    var $activeWaitEl = $(this.options.waitForAnimateEl + '.' + this.options.itemActiveClass);
	
	                    $activeWaitEl.on((0, _born.whichTransition)() + '.megaActive', function () {
	                        this.setMenuActive();
	
	                        $activeWaitEl.off('.megaActive');
	                    }.bind(this));
	                } else {
	                    this.setMenuActive();
	                }
	            } else if (this._menuUnsetTimeout) {
	                clearTimeout(this._menuUnsetTimeout);
	            }
	        }
	
	        /**
	         * [Unsets the active state on the trigger]
	         * @param  {[type]} evt     [description]
	         * @param  {[type]} trigger [description]
	         */
	
	    }, {
	        key: 'unsetItemActive',
	        value: function unsetItemActive(evt, trigger) {
	            if (evt.target.getAttribute('data-menu-close') && $(evt.target).closest(this.options.target)[0] === trigger.megamenu.target) {
	                this.unsetRelatives(trigger);
	                this._afterItemUnset(trigger);
	            }
	        }
	
	        /**
	         * Sets 'this.menu' to active only if it has any active items, then '_afterMenuSet' is fired
	         */
	
	    }, {
	        key: 'setMenuActive',
	        value: function setMenuActive() {
	            if (this.menu.querySelector('.' + this.options.itemActiveClass)) {
	                this.menu.isActive = true;
	                this.menu.classList.add(this.options.menuActiveClass);
	                this._afterMenuSet(this.menu);
	            }
	        }
	
	        /**
	         * Unsets all of the [trigger] relatives, then '_afterMenuUnset' is fire
	         */
	
	    }, {
	        key: 'unsetRelatives',
	        value: function unsetRelatives(trigger) {
	            var commonContainer = null;
	            if ((0, _util.isMobile)()) {
	                commonContainer = trigger ? trigger.megamenu.target.parentNode : this.menu;
	            } else {
	                commonContainer = trigger ? trigger.megamenu.parent.parentNode : this.menu;
	            }
	
	            var activeElements = commonContainer.querySelectorAll('.' + this.options.itemActiveClass);
	
	            Array.prototype.forEach.call(activeElements, function (el) {
	                el.classList.remove(this.options.itemActiveClass);
	            }.bind(this));
	
	            //If there are no more active items, unset the nav.
	            //Sets a very short timer to determine if another item was set
	            //before unsetting the whole navigation. 
	            if (!this.menu.querySelector('.' + this.options.itemActiveClass)) {
	                this._menuUnsetTimeout = setTimeout(function () {
	                    this.menu.isActive = false;
	                    this.menu.classList.remove(this.options.menuActiveClass);
	                    this._afterMenuUnset(this.menu);
	                }.bind(this), 10);
	            }
	            $('.header__catmenu__sub.level-2').css('max-height', '');
	            $('.header__secondary__content').removeClass('cancel-scroll');
	        }
	    }]);
	
	    return Megamenu;
	}();
	
	exports.default = Megamenu;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15);
	
	var page = {
	    title: '',
	    type: '',
	    params: util.getQueryStringParams(window.location.search.substr(1)),
	    redirect: function redirect(newURL) {
	        setTimeout(function () {
	            window.location.href = newURL;
	        }, 0);
	    },
	    refresh: function refresh() {
	        setTimeout(function () {
	            window.location.assign(window.location.href);
	        }, 500);
	    }
	};
	
	module.exports = page;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		addSubHandler();
		genderSelectionCheckmarkToggle();
		if (backToTop) {
			window.addEventListener('scroll', _lodash2.default.debounce(stickBackToTop, 100, { leading: true }));
		}
		footerGAEvents();
	};
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _validator = __webpack_require__(56);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _born = __webpack_require__(10);
	
	var Utils = _interopRequireWildcard(_born);
	
	var _module = __webpack_require__(18);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {dwJSPath} from '../../helpers/born.utils';
	
	var util = __webpack_require__(15);
	
	var progress = __webpack_require__(43);
	
	function addSubHandler() {
		var form = document.querySelector('.footer__subscribe__form'),
		    subFormSettings = $.extend(true, { submitHandler: sendSubRequest }, _validator2.default.settings);
	
		$(form).find('input').on('change', function () {
			$(this).closest('.footer__subscribe').find('.footer__subscribe__message').remove();
		});
	
		_validator2.default.initForm(form, subFormSettings);
	}
	
	function sendSubRequest(form) {
	
		_module2.default.pushData('mail_signup: ' + window.Resources['USER_SIGNUP']);
	
		progress.show($('body'));
	
		return true;
	}
	
	/**
	 * Cookie agreement functionality
	*/
	
	function readAgreementCookie() {
		if (!Utils.readCookie('modist--agreed-browse')) {
			var cookieAgreement = document.querySelector('.cookie-agreement');
	
			cookieAgreement.showContent();
	
			cookieAgreement.afterContentHide = function () {
				Utils.createCookie('modist--agreed-browse', true, 1000);
			};
		}
	}
	
	var backToTop = document.querySelector('.back-to-top');
	
	function stickBackToTop() {
		var scrollBreakpoint = util.isMobile() ? 20 : 650;
		var scrolledDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	
		backToTop.classList[scrolledDistance >= scrollBreakpoint ? 'add' : 'remove']('set--active');
	}
	
	function genderSelectionCheckmarkToggle() {
		$('.gender-radio').each(function () {
			if ($(this).is(':checked')) {
				$(this).parent().addClass('selected');
			}
		});
		$('.gender-radio').on('change', function () {
			$('.gender-selection-radio').removeClass('selected');
			$(this).parent().addClass('selected');
		});
	}
	
	function footerGAEvents() {
		var user = dataLayer.find(function (o) {
			return o.user != null;
		}).user;
		$('.footer__col .footer__list .footer__list__item .footer__list__anchor').on('click', function (e) {
			dataLayer.push({
				'event': 'custom_event',
				'eventCategory': 'footer_navigation',
				'eventAction': 'footer_navigation_click',
				'eventLabel': $(this).text(),
				'country': window.GlobalAttributes.COUNTRY,
				'language': window.GlobalAttributes.LANGUAGE,
				'screenName': 'Footer navigation',
				'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
				'userId': user.user_id != '' ? user.user_id : ''
			});
		});
		$('.footer__container .footer__col .footer__social-item').on('click', function (e) {
			dataLayer.push({
				'event': 'custom_event',
				'eventCategory': 'footer_navigation',
				'eventAction': 'footer_navigation_social_icon',
				'eventLabel': $(this).data('sharing-option'),
				'country': window.GlobalAttributes.COUNTRY,
				'language': window.GlobalAttributes.LANGUAGE,
				'screenName': 'Footer navigation',
				'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
				'userId': user.user_id != '' ? user.user_id : ''
			});
		});
		$('.footer__container .footer__col--app-links a').on('click', function (e) {
			dataLayer.push({
				'event': 'custom_event',
				'eventCategory': 'footer_navigation',
				'eventAction': 'footer_navigation_app_download_click',
				'eventLabel': $(this).data('app-name'),
				'country': window.GlobalAttributes.COUNTRY,
				'language': window.GlobalAttributes.LANGUAGE,
				'screenName': 'Footer navigation',
				'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
				'userId': user.user_id != '' ? user.user_id : ''
			});
		});
		$('.footer__subscribe__form button').on('click', function (e) {
			if ($('#dwfrm_moengage_emailsignup_email-error').length > 0) {
				dataLayer.push({
					'event': 'custom_event',
					'eventCategory': 'footer_navigation',
					'eventAction': 'newsletter_failed',
					'eventLabel': 'newsletter failed',
					'failedReason': $('#dwfrm_moengage_emailsignup_email-error').text(),
					'country': window.GlobalAttributes.COUNTRY,
					'language': window.GlobalAttributes.LANGUAGE,
					'screenName': 'Footer navigation',
					'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
					'userId': user.user_id != '' ? user.user_id : ''
				});
			}
		});
	}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *    (c) 2009-2014 Demandware Inc.
	 *    Subject to standard usage terms and conditions
	 *    For all details and documentation:
	 *    https://bitbucket.com/demandware/sitegenesis
	 */
	
	'use strict';
	
	var _require = __webpack_require__(10),
	    isMobile = _require.isMobile;
	
	var _require2 = __webpack_require__(15),
	    hasTouch = _require2.hasTouch;
	
	var countries = __webpack_require__(61),
	    dialog = __webpack_require__(46),
	    minicart = __webpack_require__(62),
	    page = __webpack_require__(58),
	
	// rating = require('./rating'),
	// searchplaceholder = require('./searchplaceholder'),
	searchsuggest = __webpack_require__(64),
	
	// tooltip = require('./tooltip'),
	util = __webpack_require__(15),
	    validator = __webpack_require__(56),
	    tls = __webpack_require__(65),
	    bornModules = __webpack_require__(3).default,
	    productTile = __webpack_require__(66),
	    eventlanding = __webpack_require__(82),
	    popupArabicVersionPromotion = __webpack_require__(83),
	    recaptcha = __webpack_require__(84),
	    lazyPictureLoad = __webpack_require__(48),
	    lazyLoadVideo = __webpack_require__(85);
	
	// if jQuery has not been loaded, load from google cdn
	if (!window.jQuery) {
	    var s = document.createElement('script');
	    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
	    s.setAttribute('type', 'text/javascript');
	    document.getElementsByTagName('head')[0].appendChild(s);
	}
	
	__webpack_require__(86)();
	__webpack_require__(87)();
	__webpack_require__(88)();
	
	function initializeEvents() {
	    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
	
	    /** Initialize arabic site version promotion pop-up close button */
	    popupArabicVersionPromotion();
	
	    $('body').on('keydown', 'textarea[data-character-limit]', function (e) {
	        var text = $.trim($(this).val()),
	            charsLimit = $(this).data('character-limit'),
	            charsUsed = text.length;
	
	        if (charsUsed >= charsLimit && controlKeys.indexOf(e.which.toString()) < 0) {
	            e.preventDefault();
	        }
	    }).on('change keyup mouseup', 'textarea[data-character-limit]', function () {
	        var text = $.trim($(this).val()),
	            charsLimit = $(this).data('character-limit'),
	            charsUsed = text.length,
	            charsRemain = charsLimit - charsUsed;
	
	        if (charsRemain < 0) {
	            $(this).val(text.slice(0, charsRemain));
	            charsRemain = 0;
	        }
	
	        $(this).parent().find('.char-remain-count').html(charsRemain);
	    });
	
	    /**
	     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
	     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
	     * */
	
	    searchsuggest.init(util.isMobiles() ? '.js-mobile-search' : '#navigation .header-search', Resources.SIMPLE_SEARCH);
	
	    // add show/hide navigation elements
	    // $('.secondary-navigation .toggle').click(function () {
	    //     $(this).toggleClass('expanded').next('ul').toggle();
	    // });
	
	    // add generic toggle functionality
	    // $('.toggle').next('.toggle-content').hide();
	    // $('.toggle').click(function () {
	    //     $(this).toggleClass('expanded').next('.toggle-content').toggle();
	    // });
	
	    // subscribe email box
	    // var $subscribeEmail = $('.subscribe-email');
	    // if ($subscribeEmail.length > 0)    {
	    //     $subscribeEmail.focus(function () {
	    //         var val = $(this.val());
	    //         if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
	    //             return; // do not animate when contains non-default value
	    //         }
	
	    //         $(this).animate({color: '#999999'}, 500, 'linear', function () {
	    //             $(this).val('').css('color', '#333333');
	    //         });
	    //     }).blur(function () {
	    //         var val = $.trim($(this.val()));
	    //         if (val.length > 0) {
	    //             return; // do not animate when contains value
	    //         }
	    //         $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
	    //             .css('color', '#999999')
	    //             .animate({color: '#333333'}, 500, 'linear');
	    //     });
	    // }
	
	    eventlanding.init();
	
	    $('.privacy-policy').on('click', function (e) {
	        e.preventDefault();
	        dialog.open({
	            url: $(e.target).attr('href'),
	            options: {
	                height: 600
	            }
	        });
	    });
	
	    // main menu toggle
	    $('.menu-toggle').on('click', function () {
	        $('#wrapper').toggleClass('menu-active');
	    });
	    $('.menu-category li .menu-item-toggle').on('click', function (e) {
	        e.preventDefault();
	        var $parentLi = $(e.target).closest('li');
	        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa-chevron-up active').addClass('fa-chevron-right');
	        $parentLi.toggleClass('active');
	        $(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
	    });
	    $('.user-account').on('click', function (e) {
	        e.preventDefault();
	        $(this).parent('.user-info').toggleClass('active');
	    });
	
	    $(document).on('recommendationsLoad', function () {
	        bornModules.carousel.init();
	        bornModules.productRating.init();
	        if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	            var lazyLoadConfig = { preloadExpandBy: 100 };
	            lazyPictureLoad.init(lazyLoadConfig);
	        }
	    }).trigger('recommendationListenerReady');
	
	    lazyLoadVideo.init();
	
	    $(document).on('productTileRatingLoad', function () {
	        bornModules.productRating.init();
	    });
	
	    $(document).on('lazyhomepictureloadLoad', function () {
	        if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	            var lazyConfig = { observerId: 'homepage', preloadExpandBy: 100 };
	            lazyPictureLoad.init(lazyConfig);
	        }
	    });
	    $(document).on('lazyPictureLoad', function () {
	        if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	            var lazyLoadConfig = { preloadExpandBy: 500, breakPointMobile: 576 };
	            lazyPictureLoad.init(lazyLoadConfig);
	        }
	    });
	}
	/**
	 * @private
	 * @function
	 * @description Adds class ('js') to html for css targeting and loads js specific styles.
	 */
	function initializeDom() {
	    // add class to html for css targeting
	    $('html').addClass('js');
	    if (!util.isMobile() && SitePreferences.LISTING_INFINITE_SCROLL) {
	        $('html').addClass('infinite-scroll');
	    }
	    // load js specific styles
	    util.limitCharacters();
	}
	
	var pages = {
	    account: __webpack_require__(89),
	    cart: __webpack_require__(151),
	    checkout: __webpack_require__(153),
	    // compare: require('./pages/compare'),
	    product: __webpack_require__(68),
	    // registry: require('./pages/registry'),
	    search: __webpack_require__(159),
	    storefront: __webpack_require__(161),
	    wishlist: __webpack_require__(163),
	    signuppage: __webpack_require__(164),
	    subscribersignuppage: __webpack_require__(165),
	    orderconfirmation: __webpack_require__(166),
	    subscriberconfirmation: __webpack_require__(167),
	    brandcampaign: __webpack_require__(168),
	    magazine: __webpack_require__(169),
	    storelocator: __webpack_require__(45),
	    bookappointment: __webpack_require__(170),
	    storeqr: __webpack_require__(171),
	    bloghome: __webpack_require__(172)
	};
	
	// Remove hover styles for IOS mobile devices to avoid the tap initiates hover issue
	function removeHoverForIOS() {
	    if (window.innerWidth < 768 && isMobile.iOS()) {
	
	        if (hasTouch()) {
	            // remove all the :hover stylesheets
	            try {
	                // prevent exception on browsers not supporting DOM styleSheets properly
	                for (var si in document.styleSheets) {
	                    var styleSheet = document.styleSheets[si];
	                    if (styleSheet.rules) {
	                        for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
	                            if (!styleSheet.rules[ri].selectorText) continue;
	
	                            if (styleSheet.rules[ri].selectorText.match(':hover')) {
	                                styleSheet.deleteRule(ri);
	                            }
	                        }
	                    } else if (styleSheet.cssRules) {
	                        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
	                            if (!styleSheet.cssRules[ri].selectorText) continue;
	
	                            if (styleSheet.cssRules[ri].selectorText.match(':hover')) {
	                                styleSheet.deleteRule(ri);
	                            }
	                        }
	                    }
	                }
	            } catch (ex) {}
	        }
	    }
	}
	
	function checkoutSignInPopup() {
	    $(document).on('click', '.checkout-btn', function () {
	        sessionStorage.setItem('showSignInModal', 'true');
	    });
	}
	
	var app = {
	    init: function init() {
	        if (document.cookie.length === 0) {
	            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
	        }
	        initializeDom();
	        initializeEvents();
	
	        // init specific global components
	        countries.init();
	        // tooltip.init();
	        minicart.init();
	        validator.init();
	        productTile.init();
	        recaptcha.init();
	        // rating.init();
	        // searchplaceholder.init();
	        // execute page specific initializations
	        $.extend(page, window.pageContext);
	        var ns = page.ns;
	        if (ns && pages[ns] && pages[ns].init) {
	            pages[ns].init();
	        }
	
	        // Check TLS status if indicated by site preference
	        if (SitePreferences.CHECK_TLS === true) {
	            tls.getUserAgent();
	        }
	
	        var countryCode = $("#currentCountryCode").val();
	        if (countryCode != null) {
	            $("#currentCountry").val(countryCode);
	        }
	        removeHoverForIOS();
	        checkoutSignInPopup();
	    }
	};
	
	// general extension functions
	(function () {
	    String.format = function () {
	        var s = arguments[0];
	        var i,
	            len = arguments.length - 1;
	        for (i = 0; i < len; i++) {
	            var reg = new RegExp('\\{' + i + '\\}', 'gm');
	            s = s.replace(reg, arguments[i + 1]);
	        }
	        return s;
	    };
	})();
	
	// initialize app
	$(document).ready(function () {
	    app.init();
	});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var TrackingLayer = __webpack_require__(18).default,
	    bornUtils = __webpack_require__(10),
	    ajax = __webpack_require__(42);
	
	/**
	 * Sets the locale cookie by getting the selected index's data-locale.
	 */
	function setLocaleCookie(localeValue) {
	
	    bornUtils.createCookie('preferredLocale', localeValue, 365);
	}
	
	exports.init = function init() {
	
	    // set country and currency first before reloading the page
	    $('.country-selector__save').on('click', function (e) {
	        var trigger = this,
	            countries = document.querySelector(this.getAttribute('data-context') + ' .country-selector__list'),
	            languages = $('.languageSelectorList'),
	            country = countries.options[countries.selectedIndex].getAttribute('data-country'),
	            url = countries.value,
	            pipeline = Urls.setSessionCountryAndCurrency;
	
	        $.ajax({
	            dataType: 'json',
	            url: Urls.setSessionCountryAndCurrency,
	            data: {
	                format: 'ajax',
	                countryCode: country
	            }
	        }).done(function (response) {
	            if (!response.success) {
	                throw new Error('Unable to set country/currency');
	            }
	
	            //Assing the url refresh into a different locale only if said locale is not the current.
	            url = languages.data('value');
	
	            setLocaleCookie(languages.data('locale'));
	
	            if (trigger.getAttribute('data-context') === '.modal--welcomemat__sett') {
	                TrackingLayer.pushData('alternative_countryselect: ' + window.Resources['TRUE_STRING']);
	                TrackingLayer.pushData('alternative_country_selected: ' + country);
	            } else {
	                TrackingLayer.pushData('curency_changed: ' + window.Resources['TRUE_STRING']);
	            }
	
	            sessionStorage.clear();
	
	            window.location.href = url;
	        });
	    });
	    if ($('#countrySelectorList').length > 0) {
	        var countryCode = $('#countrySelectorList').find(":selected").data('country').toLowerCase();
	        $('#countrySelectorList').selectric({ disableOnMobile: false, nativeOnMobile: false });
	        var regionText = $('#countrySelectPopUp').data('regiontext');
	        $('#countrySelectPopUp').prepend('<span id="selectricCountryFlag" class="country-' + countryCode + '"></span>').prepend('<span class="region-text txt--sm-medium display--small-only">' + regionText + '</span>');
	        $('.country-selector').on('click', '#selectricCountryFlag', function () {
	            $('.country-selector .selectric__arrow').trigger('click');
	        });
	    }
	    //Sets the language selection inside a <select> tag.
	    $('.language-selector__save').on('click', function () {
	        var languages = $('.languageSelectorList');
	
	        setLocaleCookie(languages.data('locale'));
	        window.location.href = languages.data('value');
	    });
	};
	
	//Sets the language selection inside a <select> tag.
	$('.languageSelectorList').on('click', function (e) {
	    e.preventDefault();
	    var url = $(this).data('value');
	    var locale = $(this).data('locale');
	    setLocaleCookie(locale);
	
	    updateUrlFromLocale(url, locale);
	});
	
	$('.language-option:not(.selected)').on('click', function (e) {
	    e.preventDefault();
	    var url = $(this).attr('href');
	    var locale = $(this).data('locale');
	    if (locale === undefined || locale == '') {
	        locale = 'en';
	    }
	    bornUtils.createCookie('preferredLocale', locale, 365);
	
	    updateUrlFromLocale(url, locale);
	});
	
	function updateUrlFromLocale(url, newLocale) {
	    var lastPipelineName = $("#lastPipelineName").val();
	    if (url.includes("lang=en")) {
	        if (lastPipelineName == 'Cart-SubmitForm' || lastPipelineName == 'SGCart-SubmitForm') {
	            url = Urls.cartShow;
	        }
	        url = url.replace("lang=en", "lang=" + newLocale);
	    } else if (url.includes("lang=ar")) {
	        if (lastPipelineName == 'Cart-SubmitForm' || lastPipelineName == 'SGCart-SubmitForm') {
	            url = Urls.cartShow;
	        }
	        url = url.replace("lang=ar", "lang=" + newLocale);
	    }
	
	    window.location.href = url;
	}
	// set country and currency when changing country dropdown
	$("#countrySelectorList").change(function (e) {
	    var trigger = this,
	        countries = document.querySelector('.header__sett .country-selector__list'),
	        country = countries.options[countries.selectedIndex].getAttribute('data-country'),
	        siteID = countries.options[countries.selectedIndex].getAttribute('data-site'),
	        url = e.target.value;
	    //pipeline    = Urls.setSessionCountryAndCurrency;
	    bornUtils.createCookie('preferredSite', siteID, 365);
	
	    $.ajax({
	        dataType: 'json',
	        url: Urls.updateUserCountry,
	        data: {
	            countryCode: country,
	            requestType: "ajax"
	        }
	    }).done(function (response) {});
	    $('#selectricCountryFlag')[0].className = 'country-' + country.toLowerCase();
	    window.location.href = url;
	    //        $.ajax({
	    //            dataType: 'json',
	    //            url: Urls.hasRestrictedProducts,
	    //            data: {
	    //                countryCode: country,
	    //                requestType:"ajax"
	    //            }
	    //        })
	    //        .done(function (response) {
	    //        	if(response.hasRestrictedProducts){
	    //        		document.getElementById("restrictedCountryPopUpWrapper").style.display = "block";
	    //        		$('#countrySelectPopUp').hide();
	    //        	}else{
	    //        		document.getElementById("restrictedCountryPopUpWrapper").style.display = "none";
	    //        		setSessionCountryAndCurrency()
	    //        	}
	    //        });
	});
	
	$('#countryPopUpOk').on('click', function () {
	    var countries = document.querySelector('.header__sett .country-selector__list');
	    var country = countries.options[countries.selectedIndex].getAttribute('data-country');
	
	    $.ajax({
	        dataType: 'json',
	        async: "false",
	        data: {
	            countryCode: country,
	            requestType: "ajax"
	        },
	        type: 'POST',
	        url: Urls.removeRestrictedProducts
	    }).done(function (response) {});
	
	    setSessionCountryAndCurrency();
	});
	
	$('#countryPopUpCancel').on('click', function () {
	    document.getElementById("restrictedCountryPopUpWrapper").style.display = "none";
	    var countryCode = $("#currentCountryCode").val();
	    var selectedObj = $('#countrySelectorList [data-country="' + countryCode + '"]');
	    if (selectedObj.length > 0) {
	        var selectedIndex = selectedObj.index();
	        $('#countrySelectorList').prop('selectedIndex', selectedIndex).selectric('refresh');
	    }
	    $('#countrySelectPopUp').show();
	});
	
	function setSessionCountryAndCurrency() {
	    var countries = document.querySelector('.header__sett .country-selector__list');
	    var country = countries.options[countries.selectedIndex].getAttribute('data-country');
	    var url = countries.value;
	    $.ajax({
	        dataType: 'json',
	        url: Urls.setSessionCountryAndCurrency,
	        data: {
	            format: 'ajax',
	            countryCode: country
	        }
	    }).done(function (response) {
	        if (!response.success) {
	            throw new Error('Unable to set country/currency');
	        }
	
	        TrackingLayer.pushData('curency_changed: ' + window.Resources['TRUE_STRING']);
	
	        sessionStorage.clear();
	        var isGeoEnabled = SitePreferences.IS_GEO_TARGETING_ENABLED;
	        var lastPipelineName = $("#lastPipelineName").val();
	        if (isGeoEnabled) {
	            if (lastPipelineName == 'Product-Show') {
	                if (url.includes("country=")) {
	                    url = updateActionURL(url, country);
	                } else if (url.includes("?")) {
	                    url = url + "&country=" + country;
	                } else {
	                    url = url + "?country=" + country;
	                }
	            } else if (lastPipelineName == 'Search-Show' || url.includes("country=")) {
	                if (url.includes("country=")) {
	                    url = updateActionURL(url, country);
	                } else {
	                    if (url.includes("?")) {
	                        url = url + "&country=" + country;
	                    }
	                }
	            }
	        }
	        if (lastPipelineName == 'Cart-SubmitForm' || lastPipelineName == 'SGCart-SubmitForm') {
	            url = Urls.cartShow;
	        }
	        window.location.href = url;
	    });
	}
	
	function updateActionURL(url, country) {
	    var actionURL = url;
	    if (actionURL.includes("country=")) {
	        var array = actionURL.split("?");
	        if (array.length > 1) {
	            for (var i = 0; i < array.length; i++) {
	                if (array[i].includes("&")) {
	                    var paramArray = array[i].split("&");
	                    if (paramArray.length > 1) {
	                        for (var j = 0; j < paramArray.length; j++) {
	                            if (paramArray[j].includes("country=")) {
	                                var replaceParam = paramArray[j];
	                                var newParam = "country=" + country;
	                                var url = url.replace(replaceParam, newParam);
	                                return url;
	                            }
	                        }
	                    }
	                } else if (array[i].includes("=") && array[i].includes("country=")) {
	                    var replaceParam = array[i];
	                    var newParam = "country=" + country;
	                    var url = url.replace(replaceParam, newParam);
	                    return url;
	                }
	            }
	        }
	    }
	}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15),
	    bonusProductsView = __webpack_require__(63),
	    bornModules = __webpack_require__(3).default;
	
	var timer = {
	    id: null,
	    clear: function clear() {
	        if (this.id) {
	            window.clearTimeout(this.id);
	            delete this.id;
	        }
	    },
	    start: function start(duration, callback) {
	        this.id = setTimeout(callback, duration);
	    }
	};
	
	function refreshMiniCart() {
	    return new Promise(function (resolve) {
	        $.ajax({
	            url: Urls.miniCartShow,
	            type: 'GET'
	        }).done(function (response) {
	            minicart.updateContent(response);
	        }).fail(function () {
	            page.refresh();
	        }).always(function () {
	            resolve();
	        });
	    });
	}
	
	var minicart = {
	    init: function init() {
	        this.$el = $('#mini-cart');
	        var isApiCalled = false;
	        this.$content = this.$el.find('.minicart__content');
	        $('#headerMinicartLink').hover(function (e) {
	            if (!isApiCalled) {
	                refreshMiniCart();
	                isApiCalled = true;
	            }
	        }, function () {
	            //This function is for unhover.
	            isApiCalled = false;
	        });
	        $('#headerMinicartLink, #mobileHeaderMinicartLink, #minicartview, .minicart__link--cart').click(function (e) {
	            moengageGoToBagEvent("go_to_bag");
	        });
	        this.updateMinicartCheckout();
	    },
	    /**
	     * @function
	     * @description Shows the given content in the mini cart
	     * @param {String} A HTML string with the content which will be shown
	     */
	    show: function show(html) {
	        var showMinicartPopup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        this.replaceContent(html, showMinicartPopup);
	        if (showMinicartPopup) {
	            this.slide();
	        }
	        this.updateMinicartCheckout();
	    },
	    /**
	     * @function
	     * @description Replaces the given content in the mini cart
	     * @param {String} A HTML string with the content which will be placed in minicart content
	     */
	    replaceContent: function replaceContent(html) {
	        this.$el.html(html);
	        this.init();
	        bornModules.toggle.init();
	        bornModules.overlayToggle.init();
	        bornModules.cancelScroll.init();
	        bonusProductsView.loadBonusOption();
	        this.updateMinicartCheckout();
	    },
	
	    updateContent: function updateContent(html) {
	        this.$el = $('#mini-cart');
	        var parseHTML = $.parseHTML(html);
	        var content = $(parseHTML).filter('.minicart__content');
	        $('#mini-cart .minicart__content').html(content.html());
	        this.updateMinicartCheckout();
	    },
	    /**
	     * @function
	     * @description Slides down and show the contents of the mini cart
	     */
	    slide: function slide() {
	        timer.clear();
	        // show the item
	        this.$content[0].showContent();
	        // after a time out automatically close it
	        timer.start(5000, this.close.bind(this));
	
	        this.$content.on('mouseenter.toggled', timer.clear.bind(timer));
	    },
	    /**
	     * @function
	     * @description Closes the mini cart
	     */
	    close: function close() {
	        timer.clear();
	        this.$content[0].hideContent();
	    },
	    updateMinicartCheckout: function updateMinicartCheckout(e) {
	        $('#minicartview').click(function (e) {
	            var user = dataLayer.find(function (o) {
	                return o.user != null;
	            }).user;
	            dataLayer.push({
	                "event": 'custom_event',
	                "eventCategory": 'bag_popup',
	                "eventAction": 'popup_view_shopping_bag',
	                "eventLabel": 'popup view shopping bag click',
	                "country": window.GlobalAttributes.COUNTRY,
	                "language": window.GlobalAttributes.LANGUAGE,
	                "screenName": 'Bag Popup',
	                "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	                "userId": user.user_id != '' ? user.user_id : ''
	            });
	        });
	        if ($("#begin-checkout-minicart").length > 0) {
	            $("#begin-checkout-minicart").on('click', function (e) {
	                var user = dataLayer.find(function (o) {
	                    return o.user != null;
	                }).user;
	                dataLayer.push({
	                    "event": 'custom_event',
	                    "eventCategory": 'bag_popup',
	                    "eventAction": 'popup_proceed_to_checkout',
	                    "eventLabel": 'popup proceed to checkout click',
	                    "country": window.GlobalAttributes.COUNTRY,
	                    "language": window.GlobalAttributes.LANGUAGE,
	                    "screenName": 'Bag Popup',
	                    "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	                    "userId": user.user_id != '' ? user.user_id : ''
	                });
	                e.preventDefault();
	                var cartId = $(this).data('value');
	                moengagecheckoutPushEvent(cartId);
	                window.location = $(this).attr('href');
	            });
	        }
	    }
	};
	
	module.exports = minicart;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dialog = __webpack_require__(46),
	    page = __webpack_require__(58),
	    util = __webpack_require__(15);
	
	var selectedList = [];
	var maxItems = 1;
	var bliUUID = '';
	
	/**
	 * @private
	 * @function
	 * description Gets a list of bonus products related to a promoted product
	 */
	function getBonusProducts() {
	    var bonusproducts = [];
	
	    var i, len;
	    for (i = 0, len = selectedList.length; i < len; i++) {
	        var p = {
	            pid: selectedList[i].pid,
	            qty: selectedList[i].qty,
	            options: {}
	        };
	        var a,
	            alen,
	            bp = selectedList[i];
	        if (bp.options) {
	            for (a = 0, alen = bp.options.length; a < alen; a++) {
	                var opt = bp.options[a];
	                p.options = { optionName: opt.name, optionValue: opt.value };
	            }
	        }
	        bonusproducts.push({ product: p });
	    }
	    return { bonusproducts: bonusproducts };
	}
	
	var selectedItemTemplate = function selectedItemTemplate(data) {
	    var attributes = '';
	    for (var attrID in data.attributes) {
	        var attr = data.attributes[attrID];
	        attributes += '<li data-attribute-id="' + attrID + '">\n';
	        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
	        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
	        attributes += '</li>';
	    }
	    attributes += '<li class="item-qty">\n';
	    attributes += '<span class="display-name">Qty</span>: ';
	    attributes += '<span class="display-value">' + data.qty + '</span>';
	    return ['<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">', '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>', '<div class="item-name">' + data.name + '</div>', '<ul class="item-attributes">', attributes, '<ul>', '<li>'].join('\n');
	};
	
	// hide swatches that are not selected or not part of a Product Variation Group
	var hideSwatches = function hideSwatches() {
	    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
	    // prevent unselecting the selected variant
	    $('.bonus-product-item .swatches .selected').on('click', function () {
	        return false;
	    });
	};
	
	/**
	 * @private
	 * @function
	 * @description Updates the summary page with the selected bonus product
	 */
	function updateSummary() {
	    var $bonusProductList = $('#bonus-product-list');
	    if (!selectedList.length) {
	        $bonusProductList.find('li.selected-bonus-item').remove();
	    } else {
	        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
	        var i, len;
	        for (i = 0, len = selectedList.length; i < len; i++) {
	            var item = selectedList[i];
	            var li = selectedItemTemplate(item);
	            $(li).appendTo(ulList);
	        }
	    }
	
	    // get remaining item count
	    var remain = maxItems - selectedList.length;
	    $bonusProductList.find('.bonus-items-available').text(remain);
	    if (remain <= 0) {
	        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
	    } else {
	        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
	    }
	}
	
	function initializeGrid() {
	    var $bonusProduct = $('#bonus-product-dialog'),
	        $bonusProductList = $('#bonus-product-list'),
	        bliData = $bonusProductList.data('line-item-detail');
	    maxItems = bliData.maxItems;
	    bliUUID = bliData.uuid;
	
	    if (bliData.itemCount >= maxItems) {
	        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
	    }
	
	    var cartItems = $bonusProductList.find('.selected-bonus-item');
	    cartItems.each(function () {
	        var ci = $(this);
	        var product = {
	            uuid: ci.data('uuid'),
	            pid: ci.data('pid'),
	            qty: ci.find('.item-qty').text(),
	            name: ci.find('.item-name').html(),
	            attributes: {}
	        };
	        var attributes = ci.find('ul.item-attributes li');
	        attributes.each(function () {
	            var li = $(this);
	            product.attributes[li.data('attributeId')] = {
	                displayName: li.children('.display-name').html(),
	                displayValue: li.children('.display-value').html()
	            };
	        });
	        selectedList.push(product);
	    });
	
	    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
	        e.preventDefault();
	        var url = this.href,
	            $this = $(this);
	        url = util.appendParamsToUrl(url, {
	            'source': 'bonus',
	            'format': 'ajax'
	        });
	        $.ajax({
	            url: url,
	            success: function success(response) {
	                $this.closest('.bonus-product-item').empty().html(response);
	                hideSwatches();
	            }
	        });
	    }).on('change', '.input-text', function () {
	        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
	        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
	    }).on('click', '.select-bonus-item', function (e) {
	        e.preventDefault();
	        if (selectedList.length >= maxItems) {
	            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
	            $bonusProductList.find('.bonus-items-available').text('0');
	            return;
	        }
	
	        var form = $(this).closest('.bonus-product-form'),
	            detail = $(this).closest('.product-detail'),
	            uuid = form.find('input[name="productUUID"]').val(),
	            qtyVal = form.find('input[name="Quantity"]').val(),
	            qty = isNaN(qtyVal) ? 1 : +qtyVal;
	
	        if (qty > maxItems) {
	            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
	            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
	            return;
	        }
	
	        var product = {
	            uuid: uuid,
	            pid: form.find('input[name="pid"]').val(),
	            qty: qty,
	            name: detail.find('.product-name').text(),
	            attributes: detail.find('.product-variations').data('attributes'),
	            options: []
	        };
	
	        var optionSelects = form.find('.product-option');
	
	        optionSelects.each(function () {
	            product.options.push({
	                name: this.name,
	                value: $(this).val(),
	                display: $(this).children(':selected').first().html()
	            });
	        });
	        selectedList.push(product);
	        updateSummary();
	    }).on('click', '.remove-link', function (e) {
	        e.preventDefault();
	        var container = $(this).closest('.selected-bonus-item');
	        if (!container.data('uuid')) {
	            return;
	        }
	
	        var uuid = container.data('uuid');
	        var i,
	            len = selectedList.length;
	        for (i = 0; i < len; i++) {
	            if (selectedList[i].uuid === uuid) {
	                selectedList.splice(i, 1);
	                break;
	            }
	        }
	        updateSummary();
	    }).on('click', '.add-to-cart-bonus', function (e) {
	        e.preventDefault();
	        var url = util.appendParamsToUrl(Urls.addBonusProduct, { bonusDiscountLineItemUUID: bliUUID });
	        var bonusProducts = getBonusProducts();
	        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
	            bonusProducts.bonusproducts[0].product.qty = maxItems;
	        }
	        // make the server call
	        $.ajax({
	            type: 'POST',
	            dataType: 'json',
	            cache: false,
	            contentType: 'application/json',
	            url: url,
	            data: JSON.stringify(bonusProducts)
	        }).done(function () {
	            // success
	            page.refresh();
	        }).fail(function (xhr, textStatus) {
	            // failed
	            if (textStatus === 'parsererror') {
	                window.alert(Resources.BAD_RESPONSE);
	            } else {
	                window.alert(Resources.SERVER_CONNECTION_ERROR);
	            }
	        }).always(function () {
	            $bonusProduct.dialog('close');
	        });
	    }).on('click', '#more-bonus-products', function (e) {
	        e.preventDefault();
	        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;
	
	        //get the next page of choice of bonus products
	        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
	        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
	        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));
	
	        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
	            bonusDiscountLineItemUUID: uuid,
	            format: 'ajax',
	            lazyLoad: 'true',
	            pageStart: lineItemDetail.pageStart,
	            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
	            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
	        });
	
	        $.ajax({
	            type: 'GET',
	            cache: false,
	            contentType: 'application/json',
	            url: url
	        }).done(function (data) {
	            //add the new page to DOM and remove 'More' link if it is the last page of results
	            $('#more-bonus-products').before(data);
	            if (lineItemDetail.pageStart + lineItemDetail.pageSize >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
	                $('#more-bonus-products').remove();
	            }
	        }).fail(function (xhr, textStatus) {
	            if (textStatus === 'parsererror') {
	                window.alert(Resources.BAD_RESPONSE);
	            } else {
	                window.alert(Resources.SERVER_CONNECTION_ERROR);
	            }
	        });
	    });
	}
	
	var bonusProductsView = {
	    /**
	     * @function
	     * @description Open the list of bonus products selection dialog
	     */
	    show: function show(url) {
	        var $bonusProduct = $('#bonus-product-dialog');
	        // create the dialog
	        dialog.open({
	            target: $bonusProduct,
	            url: url,
	            options: {
	                width: 795,
	                title: Resources.BONUS_PRODUCTS
	            },
	            callback: function callback() {
	                initializeGrid();
	                hideSwatches();
	            }
	        });
	    },
	    /**
	     * @function
	     * @description Open bonus product promo prompt dialog
	     */
	    loadBonusOption: function loadBonusOption() {
	        var self = this,
	            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
	        if (!bonusDiscountContainer) {
	            return;
	        }
	
	        // get the html from minicart, then trash it
	        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
	        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);
	
	        dialog.open({
	            html: bonusDiscountContainerHtml,
	            options: {
	                width: 400,
	                title: Resources.BONUS_PRODUCT,
	                buttons: [{
	                    text: Resources.SELECT_BONUS_PRODUCTS,
	                    click: function click() {
	                        var uuid = $('.bonus-product-promo').data('lineitemid'),
	                            url = util.appendParamsToUrl(Urls.getBonusProducts, {
	                            bonusDiscountLineItemUUID: uuid,
	                            source: 'bonus',
	                            format: 'ajax',
	                            lazyLoad: 'false',
	                            pageStart: 0,
	                            pageSize: 10,
	                            bonusProductsTotal: -1
	                        });
	                        $(this).dialog('close');
	                        self.show(url);
	                    }
	                }, {
	                    text: Resources.NO_THANKS,
	                    click: function click() {
	                        $(this).dialog('close');
	                    }
	                }]
	            },
	            callback: function callback() {
	                // show hide promo details
	                $('.show-promo-details').on('click', function () {
	                    $('.promo-details').toggleClass('visible');
	                });
	            }
	        });
	    }
	};
	
	module.exports = bonusProductsView;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15);
	
	var currentQuery = null,
	    lastQuery = null,
	    runningQuery = null,
	    listTotal = -1,
	    listCurrent = -1,
	    delay = 30,
	    $resultsContainer,
	    $resultList,
	    $searchForm,
	    $searchField;
	
	/**
	 * @function
	 * @description Handles keyboard's arrow keys
	 * @param keyCode Code of an arrow key to be handled
	 */
	function handleArrowKeys(keyCode) {
	
	    switch (keyCode) {
	        case 38:
	            // keyUp
	            listCurrent = listCurrent <= 0 ? listTotal - 1 : listCurrent - 1;
	            break;
	        case 40:
	            // keyDown
	            listCurrent = listCurrent >= listTotal - 1 ? 0 : listCurrent + 1;
	            break;
	        default:
	            // reset
	            listCurrent = -1;
	            return false;
	    }
	
	    $resultList.filter('.selected').removeClass('selected');
	
	    var $newSelected = $resultList.eq(listCurrent);
	
	    $newSelected.addClass('selected');
	    $('input[name="q"]').val($newSelected.find('.product-name').first().text());
	    return true;
	}
	
	var searchsuggest = {
	    /**
	     * @function
	     * @description Configures parameters and required object instances
	     */
	    init: function init(container, defaultValue) {
	        var $searchContainer = $(container);
	        var $simpleSearch = $('.js-simple-search');
	        var $mobileSearchContainer = $('.js-mobile-search');
	        var $defaultSearchContainer = $('#navigation .header-search');
	        var helpers = {
	            replaceSearch: function replaceSearch($parent) {
	                $simpleSearch.appendTo($parent);
	                $resultsContainer.appendTo($parent);
	            },
	            hasSimpleSearch: function hasSimpleSearch($parent) {
	                return $parent.children('.js-simple-search').length;
	            }
	        };
	
	        var replaceSearch = helpers.replaceSearch,
	            hasSimpleSearch = helpers.hasSimpleSearch;
	
	
	        if (util.isMobiles()) {
	            $simpleSearch.appendTo($searchContainer);
	        }
	
	        $searchForm = $searchContainer.find($simpleSearch);
	        $searchField = $searchForm.find('input[name="q"]');
	
	        // disable browser auto complete
	        $searchField.attr('autocomplete', 'off');
	
	        // on focus listener (clear default value)
	        $searchField.focus(function () {
	            if (!$resultsContainer) {
	                // create results container if needed
	                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
	
	                $resultsContainer.off('.removeSelected').on('mouseenter.removeSelected', '.product-suggestion', function () {
	                    $resultsContainer.find('.selected').removeClass('selected');
	                    listCurrent = -1;
	                });
	            }
	            if ($searchField.val() === defaultValue) {
	                $searchField.val('');
	            }
	            if ($searchField.val() == '') {
	                $searchField.keyup();
	            }
	        });
	
	        util.isMobile() && $(window).on('resize', function () {
	            if (util.isMobiles() && !hasSimpleSearch($mobileSearchContainer)) {
	                replaceSearch($mobileSearchContainer);
	            }
	
	            if (util.isTablet() && !hasSimpleSearch($defaultSearchContainer)) {
	                replaceSearch($defaultSearchContainer);
	            }
	        });
	
	        // on key up listener
	        $searchField.on('keyup', function (e) {
	
	            if (e.keyCode || window.event.keyCode) {
	                // get keyCode (window.event is for IE)
	                var keyCode = e.keyCode || window.event.keyCode;
	
	                // check and treat up and down arrows
	                if (handleArrowKeys(keyCode)) {
	                    return;
	                }
	                // check for an ENTER or ESC
	                if (keyCode === 13 || keyCode === 27) {
	                    this.clearResults();
	                    return;
	                }
	            }
	
	            currentQuery = $searchField.val().trim();
	
	            // no query currently running, init an update
	            if (!runningQuery) {
	                runningQuery = currentQuery;
	                setTimeout(this.suggest.bind(this), delay);
	            }
	        }.bind(this));
	    },
	
	    /**
	     * @function
	     * @description trigger suggest action
	     */
	    suggest: function suggest() {
	        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
	        // (we had a little delay)
	        if (runningQuery !== currentQuery) {
	            // update running query to the most recent search phrase
	            runningQuery = currentQuery;
	        }
	        var isSearchPhrasesEnabled = SitePreferences.IS_SEARCH_PHRASES_ENABLED;
	
	        // if it's empty and isSearchPhrasesEnabled is not enabled clear the results box and return
	        if (runningQuery.length === 0 && !isSearchPhrasesEnabled) {
	            this.clearResults();
	            runningQuery = null;
	            return;
	        }
	
	        // if the current search phrase is the same as for the last suggestion call, just return
	        if (lastQuery === runningQuery && runningQuery.length != 0) {
	            runningQuery = null;
	            return;
	        }
	
	        // build the request url
	        var isAzHeader = $('.az-header').length;
	        var reqUrl = util.appendParamToURL(isAzHeader ? Urls.sgSearchsuggest : Urls.searchsuggest, 'q', runningQuery);
	
	        // execute server call
	        $.get(reqUrl, function (data) {
	            var suggestionHTML = data,
	                ansLength = suggestionHTML.trim().length;
	
	            // if there are results populate the results div
	            if (ansLength === 0) {
	                this.clearResults();
	            } else {
	                // update the results div
	                $resultsContainer.html(suggestionHTML).fadeIn(200);
	                $resultList = $resultsContainer.find('.product-suggestion');
	                listTotal = $resultList.length;
	            }
	
	            // record the query that has been executed
	            lastQuery = runningQuery;
	            // reset currently running query
	            runningQuery = null;
	
	            // check for another required update (if current search phrase is different from just executed call)
	            if (currentQuery !== lastQuery) {
	                // ... and execute immediately if search has changed while this server call was in transit
	                runningQuery = currentQuery;
	                setTimeout(this.suggest.bind(this), delay);
	            }
	            this.hideLeftPanel();
	        }.bind(this));
	    },
	    /**
	     * @function
	     * @description
	     */
	    clearResults: function clearResults() {
	        if (!$resultsContainer) {
	            return;
	        }
	        $resultsContainer.fadeOut(0, function () {
	            $resultsContainer.empty();
	        });
	    },
	    /**
	     * @function
	     * @description
	     */
	    hideLeftPanel: function hideLeftPanel() {
	        //hide left panel if there is only a matching suggested custom phrase
	        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
	            $('.search-suggestion-left-panel').css('display', 'none');
	            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
	            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
	        }
	    }
	};
	
	module.exports = searchsuggest;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15);
	/**
	 * Checks the TLS and displays a warning if appropriate
	 * @function getUserAgent Checks the TLS and displays a warning if appropriate
	 **/
	function getUserAgent() {
	    // Use an external service to check the TLS of the browser
	    // NOTE: this implementation uses https://www.howsmyssl.com
	    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
	    var url = 'https://www.howsmyssl.com/a/check';
	    var cookieName = 'dw_TLSWarning';
	    var cookieValue = util.getCookie(cookieName);
	
	    // Test to see if this browser has already been flagged by looking at its cookies
	    if (!cookieValue) {
	        getTLS(url, function (message) {
	            if (message.length > 0) {
	                showWarning(message[0]);
	
	                // the browser is bad - set the cookie to true (for 15 minutes)
	                util.setCookie(cookieName, 'true', 15);
	            } else {
	                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
	                util.setCookie(cookieName, 'false', 60 * 24 * 30);
	            }
	        });
	    } else if (cookieValue === 'true') {
	        // if we already know that this is an invalid browser, show the warning
	        showWarning(Resources.TLS_WARNING);
	    }
	}
	
	/**
	 * Calls out to the TLS service and calls the callback with a message (if necessary)
	 * @function getTLS
	 *
	 * @param {string} url - URL of external TLS-checking API
	 * @param {function} callback - function to call with response
	 **/
	function getTLS(url, callback) {
	    var message = [];
	
	    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
	    var userAgent = navigator.userAgent;
	
	    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
	    var badBrowsers = ['MSIE 6.0', 'MSIE 7.0', 'MSIE 8.0', 'MSIE 9.0', 'MSIE 10.0', 'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3', 'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
	    function checkTLSLevel(data) {
	        // If we can determine the TLS level, check to see if it's less than 1.2
	        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
	            message.push(Resources.TLS_WARNING);
	            callback(message);
	
	            //If you want to track statistics on bad TLS hits, include this call
	            $.ajax({ url: Urls.TLSBadTLS });
	        }
	    }
	
	    function reportBadBrowser() {
	        // If the TLS level cannot be determined just report that this browser is suspect
	        message.push(Resources.TLS_WARNING);
	        callback(message);
	
	        //If you want to track statistics on deprecated browsers, include this call
	        $.ajax({ url: Urls.TLSBadBrowser });
	    }
	
	    for (var i = 0; i < badBrowsers.length; i++) {
	        if (userAgent.match(badBrowsers[i])) {
	            // It's a suspect browser, let's see what it's TLS level is
	            $.ajax({
	                url: url
	            }).done(checkTLSLevel).fail(reportBadBrowser);
	            break;
	        }
	    }
	
	    /** For testing purposes, uncomment this block
	        message.push(Resources.TLS_WARNING);
	    **/
	    callback(message);
	}
	
	/**
	 * @function showWarning turns on the browser-compatibility-alert and sets the message
	 *
	 * @param {string} message - the message that will be shown upon detection of a bad browser
	 **/
	function showWarning(message) {
	    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
	}
	
	/**
	 * Export the getUserAgent function
	 */
	
	exports.getUserAgent = getUserAgent;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _offertimer = __webpack_require__(41);
	
	var quickview = __webpack_require__(67),
	    bornModules = __webpack_require__(3).default,
	    product = __webpack_require__(68),
	    util = __webpack_require__(15);
	
	//set parent width as same as child to avoid jerk on sticky filters (web only)
	function seoCatgryToggleHeight() {
	    var $seoEle = $('#toggle_content');
	    if ($seoEle.length > 0) {
	        parseInt($seoEle.height()) > 20 ? $('#top_toggle_link').removeClass('visually-hidden') : $('#top_toggle_link').addClass('visually-hidden');
	    }
	    var toggleBtn = $seoEle.find('.toggle-icon');
	    var actualSEOContent = $seoEle.children().first();
	    if (actualSEOContent.height() <= 40) {
	        toggleBtn.hide();
	    } else if (window.innerWidth > 768) {
	        toggleBtn.show().css('opacity', '1');
	    }
	}
	
	function debounce(callback, delay, timer) {
	    clearTimeout(timer);
	    timer = setTimeout(callback, delay);
	}
	
	//Catgory SEO ITem handling in mobile
	$(document).on('click', '.top-seoItem .seo-text-toggle', function (e) {
	    e.stopImmediatePropagation();
	    $(this).closest('.top-seoItem').toggleClass('open');
	    $('.top_toggle_content').toggle();
	    seoCatgryToggleHeight();
	});
	
	$(document).on("click", ".nohits-seocontent", function () {
	    if ($(window).width() < 767) {
	        $('#seo-mob').find('.cat-seo-text,.toggle--nb,.toggle__link').toggleClass('toggle--active');
	    }
	});
	
	$(window).on('resize load', debounce(seoCatgryToggleHeight, 700));
	
	// cut paste the seo div while switching to mobile view or back - Search not found Page
	function cutPasteSEO() {
	    var $seoMob = $('#seo-mob');
	    var $seoDesk = $('#seo-desktop');
	    var doCutPaste = function doCutPaste() {
	        var $seoContent = $('#refine-catseotexthead');
	        if ($(window).width() > 767) {
	            if ($seoContent.parent() !== $seoDesk) {
	                $seoContent.remove();
	                $seoDesk.html($seoContent);
	                $seoContent.find('.cat-seo-text').addClass('toggle--active');
	            }
	        } else {
	            if ($seoContent.parent() !== $seoMob) {
	                $seoContent.remove();
	                $seoMob.html($seoContent);
	                setTimeout(function () {
	                    $('#seo-mob').find('.cat-seo-text,.toggle--nb,.toggle__link').addClass('toggle--active');
	                }, 500);
	            }
	        }
	    };
	    doCutPaste();
	    $(window).on('resize', doCutPaste);
	}
	function initQuickView() {
	    // Default Dialog container class
	
	    $('body').on('click', '.js-open-quickview', function (e) {
	        e.preventDefault();
	        var $dialogContainer = $("#QuickViewDialog"),
	            url = $(this).attr('href'),
	            isUpdateRequired = true;
	
	        if ($dialogContainer.data('lastQuickViewURL') && $dialogContainer.data('lastQuickViewURL') === url) {
	            isUpdateRequired = false;
	        }
	
	        $dialogContainer.data('lastQuickViewURL', url);
	
	        var scrollTopDistance = $(document).scrollTop();
	        window.quickViewProduct = false;
	        quickview.show({
	            url: url,
	            source: 'quickview',
	            isUpdateRequired: true,
	            keepAlive: false,
	            callback: function callback() {
	                product.init();
	                bornModules.carousel.init();
	                bornModules.video.init();
	                bornModules.selectTags.init();
	                bornModules.qtyControl.init();
	                bornModules.modalToggle.init();
	                bornModules.toggle.init();
	                bornModules.showMoreSwatches.init('.quickview__dialog .swatch-variation-wrap');
	                if (util.isMobile()) {
	                    setTimeout(function () {
	                        $('.overlay--active').scrollTop(0);
	                    }, 100);
	                }
	                initMoQuickEvents();
	                var addToCartBtn = $('.pdp.quickview__dialog .add-to-cart');
	                if (addToCartBtn.length > 0) {
	                    addToCartBtn.attr('disabled', false);
	                }
	                (0, _offertimer.pdpOfferTimer)(true);
	            }
	        });
	    });
	
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	        $(function () {
	            $("img.product__img:not(.unveil-loaded)").unveil(300, function () {
	                $(this).addClass('unveil-loaded');
	            });
	        });
	    }
	}
	
	function initMoQuickEvents() {
	    var items = $('.quickview__dialog .sharing__item');
	    if (items.length > 0 && typeof initMoengageShareEvents !== "undefined") {
	        initMoengageShareEvents(items);
	    }
	}
	
	/**
	 * @private
	 * @function
	 * @description Initializes events on the product-tile for the following elements:
	 * - quickview
	 */
	function initializeEvents() {
	    $(".plp-recommendations-nohitwrapper").length > 0 ? cutPasteSEO() : "";
	    initQuickView();
	    seoCatgryToggleHeight();
	    $(document).on('click', '.bck--flx', function (e) {
	        e.stopPropagation();
	    });
	}
	
	$(document).on('click', '.toggle-icon', function (e) {
	    var $toggleContent = $('#toggle_content');
	    $(this).toggleClass('toggle-icon-down toggle-icon-up');
	    if ($toggleContent.hasClass('collapsed')) {
	        $toggleContent.removeClass('collapsed').addClass('expanded');
	        $(this).text('');
	    } else {
	        $toggleContent.removeClass('expanded').addClass('collapsed');
	        $(this).text('...');
	    }
	});
	
	exports.init = function () {
	    initializeEvents();
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dialog = __webpack_require__(46),
	    product = __webpack_require__(68),
	    util = __webpack_require__(15),
	    _ = __webpack_require__(7),
	    bornModules = __webpack_require__(3).default;
	
	var makeUrl = function makeUrl(url, source, productListID) {
	    if (source) {
	        url = util.appendParamToURL(url, 'source', source);
	    }
	    if (productListID) {
	        url = util.appendParamToURL(url, 'productlistid', productListID);
	    }
	    return url;
	};
	
	var removeParam = function removeParam(url) {
	    if (url.indexOf('?') !== -1) {
	        return url.substring(0, url.indexOf('?'));
	    } else {
	        return url;
	    }
	};
	
	// function to keep swatches open when a variant from the hidden swatches are accessed directly
	function shouldKeepSwatchesOpen() {
	    var $swatchContainer = $('#swatch-variation');
	    if ($swatchContainer.length == 0) return;
	
	    var index = -1;
	    index = $swatchContainer.find('.swatches__item').index($('.swatches__item.selected'));
	
	    var containerWidth = $swatchContainer.innerWidth(),
	        elementWidth = $('.swatches__item').innerWidth() + parseInt($('.swatches__item').css('margin-right'));
	    var visibleItems = parseInt(containerWidth / elementWidth) * 2;
	
	    if (index + 1 > visibleItems) {
	        $('#show-more-link:not(.toggle--active)').trigger('click');
	    }
	}
	function quantityButtonCheck() {
	    $('input.qty-input__ctrl').on('change', function (event) {
	        var maxValue = void 0;
	        var maxQty = $(event.target).data('max-qty');
	        if (maxQty > 0) {
	            maxValue = maxQty;
	        } else {
	            maxValue = $(event.target).data('available');
	        }
	        var currVal = event.target.value;
	        if (currVal < maxValue) {
	            $('button.qty-input__ctrl.plus').removeAttr('disabled');
	        } else {
	            $('button.qty-input__ctrl.plus').attr('disabled', 'true');
	        }
	        if (currVal <= maxValue) {
	            $('button.add-to-cart').removeAttr('disabled');
	        } else {
	            $('button.add-to-cart').attr('disabled', 'true');
	        }
	    });
	}
	
	var quickview = {
	    init: function init() {
	        if (!this.exists()) {
	            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
	        }
	        this.productLinks = $('.product-grid .link').map(function (index, thumbLink) {
	            return $(thumbLink).attr('href');
	        });
	    },
	
	    setup: function setup(qvUrl) {
	        var $btnNext = $('.quickview-next'),
	            $btnPrev = $('.quickview-prev');
	
	        product.initializeEvents();
	
	        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
	            return removeParam(url) === removeParam(qvUrl);
	        });
	
	        // hide the buttons on the compare page or when there are no other products
	        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
	            $btnNext.hide();
	            $btnPrev.hide();
	            return;
	        }
	
	        if (this.productLinkIndex === this.productLinks.length - 1) {
	            $btnNext.attr('disabled', 'disabled');
	        }
	        if (this.productLinkIndex === 0) {
	            $btnPrev.attr('disabled', 'disabled');
	        }
	
	        $btnNext.on('click', function (e) {
	            e.preventDefault();
	            this.navigateQuickview(1);
	        }.bind(this));
	        $btnPrev.on('click', function (e) {
	            e.preventDefault();
	            this.navigateQuickview(-1);
	        }.bind(this));
	    },
	
	    /**
	     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
	     */
	    navigateQuickview: function navigateQuickview(step) {
	        // default step to 0
	        this.productLinkIndex += step ? step : 0;
	        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
	        dialog.replace({
	            url: url,
	            callback: this.setup.bind(this, url)
	        });
	    },
	
	    /**
	     * @description show quick view dialog
	     * @param {Object} options
	     * @param {String} options.url - url of the product details
	     * @param {String} options.source - source of the dialog to be appended to URL
	     * @param {String} options.productlistid - to be appended to URL
	     * @param {Function} options.callback - callback once the dialog is opened
	     */
	    show: function show(options) {
	        var url;
	        if (!this.exists()) {
	            this.init();
	        }
	        url = makeUrl(options.url, options.source, options.productlistid);
	
	        dialog.open({
	            target: this.$container,
	            url: url,
	            options: {
	                width: 920,
	                title: Resources.QUICK_VIEW_POPUP,
	                update: options.isUpdateRequired,
	                keepAlive: options.keepAlive
	            },
	            afterCreateCallback: options.callback,
	            afterCloseCallback: options.afterCloseCallback,
	            afterOpenCallback: options.afterOpenCallback
	        });
	        setTimeout(function () {
	            shouldKeepSwatchesOpen();
	            quantityButtonCheck();
	        }, 1000);
	    },
	    exists: function exists() {
	        return this.$container && this.$container.length > 0;
	    }
	};
	
	module.exports = quickview;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dialog = __webpack_require__(46),
	    productStoreInventory = __webpack_require__(69),
	
	// tooltip = require('../../tooltip'),
	util = __webpack_require__(15),
	    addToCart = __webpack_require__(72),
	    availability = __webpack_require__(71),
	
	// image = require('./image'),
	productNav = __webpack_require__(75),
	    productSet = __webpack_require__(76),
	
	// recommendations = require('./recommendations'),
	variant = __webpack_require__(77),
	    tooltip = __webpack_require__(80),
	    bisn = __webpack_require__(79),
	    comingsoon = __webpack_require__(81);
	
	/**
	 * @description Initialize product detail page with reviews, recommendation and product navigation.
	 */
	function initializeDom() {
	    productNav();
	    getFirstTrOfTable();
	    // recommendations();
	    // tooltip.init();
	}
	
	/**
	 * @description Initialize event handlers on product detail page
	 */
	function initializeEvents() {
	    var $mainClass = $('body');
	
	    addToCart();
	    availability.init();
	    variant();
	    // image();
	    productSet();
	    if (SitePreferences.STORE_PICKUP) {
	        productStoreInventory.init();
	    }
	
	    // Add to Wishlist and Add to Gift Registry links behaviors
	    $mainClass.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
	        var data = util.getQueryStringParams($('.pdpForm').serialize());
	        if (data.cartAction) {
	            delete data.cartAction;
	        }
	        var url = util.appendParamsToUrl(this.href, data);
	        this.setAttribute('href', url);
	    });
	
	    $mainClass.off('click', '.js-add-to-wishlist').on('click', '.js-add-to-wishlist', function (e) {
	        var obj = $(this);
	        var $variantSelector = $('.pdpForm').find('.size-conversion-container .sizeConversion .sizeLabel, .size-conversion-container .sizeConversion.no-conversion');
	        var isNoConversion = $('.pdpForm').find('.size-conversion-container .sizeConversion.no-conversion').length > 0;
	        var $colorSelector = $('.pdpForm').find('.swatch_container .swatch_label');
	        var $colorVariantCount = 0;
	        $colorVariantCount = $('.pdpForm').find('.swatch_container .swatches.color .swatches__item');
	        if ($variantSelector.length > 0 && $colorVariantCount.length <= 1) {
	            var isVariantSelected = _isVariantSelected.call(this);
	            if (!isVariantSelected) {
	                e.preventDefault();
	                tooltip.show(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector, Resources.WISHLIST_SELECT_VARIANT, 75);
	                return false;
	            } else {
	                tooltip.hide(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector);
	            }
	        } else if ($colorSelector.length > 0 && $colorVariantCount.length > 1) {
	            var isVariantSelected = _isColorSelected.call(this);
	            if (!isVariantSelected) {
	                e.preventDefault();
	                tooltip.show($colorSelector, Resources.WISHLIST_SELECT_COLOR, 75);
	                return false;
	            } else {
	                tooltip.hide($colorSelector);
	            }
	        }
	
	        if ($(this).hasClass('go-to-wishlist')) {
	            window.location.href = Urls.wishlistshow;
	        }
	        if ($('#auth').length) {
	            e.preventDefault();
	            var auth = $('#auth').val();
	            var url = Urls.accountshow;
	            if (auth == 'true') {
	                $.ajax({
	                    url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
	                    dataType: 'json'
	                }).done(function (data) {
	                    if (data.success) {
	                        obj.find('i').removeClass('icon--wishlist-heart').addClass('icon--favorite');
	                        obj.find('.wishlist-btn-txt').html(Resources.WHISHLIST_BUTTON);
	                        obj.addClass('go-to-wishlist').off('click');
	                        pushAddToWhishlistAction(data.moengageProduct);
	                    } else {
	                        window.alert(Resources.BAD_RESPONSE);
	                    }
	                });
	            } else {
	                window.location.href = url;
	            }
	        }
	    });
	
	    // product options
	    $mainClass.on('change', '.product-options select', function () {
	        var salesPrice = $(this).closest().find('.product-add-to-cart .price-sales');
	        var selectedItem = $(this).children().filter(':selected').first();
	        salesPrice.text(selectedItem.data('combined'));
	    });
	
	    // prevent default behavior of thumbnail link and add this Button
	    $mainClass.on('click', '.thumbnail-link, .unselectable a', function (e) {
	        e.preventDefault();
	    });
	
	    $mainClass.on('click', '.js-size-guide-btn', function (e) {
	        e.preventDefault();
	        if ($('.window-overlay').find('div.back-in-stock__dialog').length !== 0) {
	            $('.window-overlay').find('div.back-in-stock__dialog').parent().parent().remove();
	        }
	        var $data = $(this).data('dialog');
	
	        dialog.openWithContent({
	            html: $($data.content).html(),
	            modalClass: $data.modalClass
	        });
	    });
	    bisn.init();
	
	    $mainClass.on('click', '.window-overlay--close', function (e) {
	        e.preventDefault();
	        if ($('.window-overlay').find('div.size-guide__container').length !== 0) {
	            $('.window-overlay').find('div.size-guide__container').parent().parent().remove();
	        }
	    });
	
	    $mainClass.on('click', '.apple-pay-submt-btn', function (e) {
	        e.preventDefault();
	        var $variantSelector = $(this).closest('.pdpForm').find('.js-variation-select');
	        var selectButton = $(this).closest('.pdpForm').find('#va-size.variation-select');
	        var flag = false;
	        if (selectButton.length > 0 && selectButton.val().includes("size")) {
	            flag = true;
	        }
	        var notifyButton = $('.pdpForm').find('.notify-me-button');
	        if (notifyButton.length > 0 && flag) {
	            tooltip.show($variantSelector, Resources.SOLDOUT_SELECT_VARIANT);
	        } else if (notifyButton.length > 0 && !flag) {
	            tooltip.show($variantSelector, Resources.APPLEPAY_SELECT_VARIANT);
	        } else {
	            tooltip.show($variantSelector, Resources.APPLEPAY_SELECT_VARIANT);
	        }
	        return false;
	    });
	
	    $mainClass.on('click', 'a.store-menu-link', function (e) {
	        e.preventDefault();
	        var brandNameEl = $('input[name="produc-brand-name"]');
	        var url = $(this).attr('href');
	        if (brandNameEl.length <= 0) {
	            window.location = url;
	            return;
	        }
	        var brandName = brandNameEl.val();
	        if (brandName) {
	            brandName = brandName.trim();
	            url += url.indexOf("?") === -1 ? "?" : "&";
	            window.location = url + "name=" + encodeURIComponent(brandName);
	        } else {
	            window.location = url;
	        }
	    });
	
	    $(document).ready(function () {
	        var obj = $('.apple-pay-submt-btn');
	        if (obj.length > 0) {
	            var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') == -1 && navigator.userAgent.indexOf('FxiOS') == -1;
	            if (isSafari !== true) {
	                obj.remove();
	            }
	        }
	    });
	
	    $mainClass.on('click', '.add-to-cart-disabled', function (e) {
	        var obj = $(this);
	        var $variantSelector = obj.closest('.pdpForm').find('.size-conversion-container .sizeConversion .sizeLabel, .size-conversion-container .sizeConversion.no-conversion');
	        var isNoConversion = obj.closest('.pdpForm').find('.size-conversion-container .sizeConversion.no-conversion').length > 0;
	        var $colorSelector = obj.closest('.pdpForm').find('.swatch_container .swatch_label');
	        var $colorVariantCount = 0;
	        $colorVariantCount = $('.pdpForm').find('.swatch_container .swatches.color .swatches__item');
	        if ($variantSelector.length > 0 && $colorVariantCount.length <= 1) {
	            var isVariantSelected = _isVariantSelected.call(this);
	            if (!isVariantSelected) {
	                e.preventDefault();
	                tooltip.show(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector, Resources.WISHLIST_SELECT_VARIANT, 75);
	                return false;
	            } else {
	                tooltip.hide(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector);
	            }
	        } else if ($colorSelector.length > 0 && $colorVariantCount.length > 1) {
	            var isVariantSelected = _isColorSelected.call(this);
	            if (!isVariantSelected) {
	                e.preventDefault();
	                tooltip.show($colorSelector, Resources.WISHLIST_SELECT_COLOR, 75);
	                return false;
	            } else {
	                tooltip.hide($colorSelector);
	            }
	        }
	    });
	
	    $(window).click(function (e) {
	        if (e.target !== undefined) {
	            var targetEl = $(e.target);
	            if (targetEl.length > 0) {
	                if (!targetEl.hasClass('notify-me-button')) {
	                    tooltip.hideAll();
	                }
	            }
	        }
	    });
	
	    comingsoon.init();
	}
	
	function getFirstTrOfTable() {
	    var $sizesColumn = $('.size-guide__sizes'),
	        $sizesContent = $('.size-guide__content'),
	        $sizesTitleContainer = $('.size-guide__title-conteiner'),
	        $shoesSizes = $('[id*="--size-guide-shoes"]'),
	        $tableContent = $('<tbody>'),
	        $sizesTitle = $('.table--captioned caption');
	
	    if ($shoesSizes.length === 0) {
	
	        var maxColCount = Math.max.apply(Math, $sizesContent.find('tr').map(function () {
	            return $(this).find('td').length;
	        }));
	
	        if ($sizesContent.length > 1) {
	            $sizesContent.each(function () {
	                var $tableContentElement = $('<tbody>');
	                $(this).find('tr').each(function () {
	                    var $tdElements = $(this).find('td'),
	                        $td = $tdElements.eq(0);
	
	                    if ($tdElements.length === maxColCount) {
	                        $td.removeAttr('rowspan');
	                        $tableContentElement.append($('<tr>').append($td[0].outerHTML));
	                        $td.remove();
	                    }
	                });
	                $(this).find('tr:first-child th:first-child').remove();
	
	                if ($tableContentElement.length > 0) {
	                    $tableContentElement.find('tr:first-child td:first-child').addClass('first-td');
	                    $tableContentElement.find('tr:last-child td:first-child').addClass('last-td');
	                    $(this).siblings('.size-guide__sizes').append($('<table>').append($tableContentElement));
	                }
	            });
	        } else {
	            $sizesContent.find('tr').each(function () {
	                var $tdElements = $(this).find('td'),
	                    $td = $tdElements.eq(0);
	
	                if ($tdElements.length === maxColCount) {
	                    $td.removeAttr('rowspan');
	                    $tableContent.append($('<tr>').append($td[0].outerHTML));
	                    $td.remove();
	                }
	            });
	
	            $sizesContent.find('tr:first-child th:first-child').remove();
	
	            if ($tableContent.length > 0) {
	                $tableContent.find('tr:first-child td:first-child').addClass('first-td');
	                $tableContent.find('tr:last-child td:first-child').addClass('last-td');
	
	                $sizesColumn.append($('<table>').append($tableContent));
	            }
	        }
	    }
	}
	
	function _initCustomScroll() {
	    if (!('ns' in pageContext) && pageContext.ns !== 'product') {
	        return;
	    }
	
	    $(".size-guide__content").mCustomScrollbar({
	        theme: "dark",
	        axis: "x",
	        enable: false,
	        advanced: {
	            updateOnContentResize: true
	        }
	    });
	}
	
	function _isVariantSelected() {
	    var $jsVariationSelect = $('.pdpForm').find('.size-conversion-container');
	    if ($jsVariationSelect.length <= 0) {
	        return true;
	    }
	    $jsVariationSelect = $jsVariationSelect.find('.sizeDescription .content-items .links-item.selected');
	
	    if ($jsVariationSelect.length > 0) {
	        return true;
	    } else {
	        return false;
	    }
	}
	
	function _isColorSelected() {
	    var $jsColorSelect = $('.pdpForm').find('.swatch_container .swatches.color');
	    if ($jsColorSelect.length <= 0) {
	        return true;
	    }
	    $jsColorSelect = $jsColorSelect.find('.swatches__item.selected');
	
	    if ($jsColorSelect.length > 0) {
	        return true;
	    } else {
	        return false;
	    }
	}
	
	var product = {
	    initializeEvents: initializeEvents,
	    init: function init() {
	        initializeDom();
	        initializeEvents();
	    }
	};
	
	module.exports = product;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(7),
	    util = __webpack_require__(15),
	    ajax = __webpack_require__(42),
	    progress = __webpack_require__(43),
	    inventory = __webpack_require__(70);
	
	var bornModules = __webpack_require__(3).default;
	
	var availability = __webpack_require__(71);
	
	var newLine = '\n';
	var pdpStoreTemplate = function pdpStoreTemplate(store) {
	    return ['<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">', '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode + ' ' + store.postalCode + '</div>', '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>', '</li>'].join(newLine);
	};
	var pdpStoresListingTemplate = function pdpStoresListingTemplate(stores) {
	    if (stores && stores.length) {
	        return ['<div class="store-list-pdp-container">', stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : '', '    <ul class="store-list-pdp">', _.map(stores, pdpStoreTemplate).join(newLine), '    </ul>', '</div>'].join(newLine);
	    }
	};
	
	var storesListing = function storesListing(stores) {
	    // list all stores on PDP page
	    if ($('.store-list-pdp-container').length) {
	        $('.store-list-pdp-container').remove();
	    }
	    $('.availability-results').append(pdpStoresListingTemplate(stores));
	};
	
	var productInventory = {
	    setPreferredStore: function setPreferredStore(storeId) {
	        User.storeId = storeId;
	        $.ajax({
	            url: Urls.setPreferredStore,
	            type: 'POST',
	            data: { storeId: storeId }
	        });
	    },
	    productSelectStore: function productSelectStore() {
	        var self = this;
	        inventory.getStoresInventory(this.pid).then(function (stores) {
	            inventory.selectStoreDialog({
	                stores: stores,
	                selectedStoreId: User.storeId,
	                selectedStoreText: Resources.PREFERRED_STORE,
	                continueCallback: storesListing,
	                selectStoreCallback: self.setPreferredStore
	            });
	        }).done();
	    },
	    init: function init() {
	        var $availabilityContainer = $('.availability-results'),
	            self = this;
	        var quickviewElement = $('.quickview__dialog');
	        if (quickviewElement.length > 0) {
	            this.pid = quickviewElement.find('#pid').val();
	            var target = quickviewElement.find('.qty-input__ctrl.input--white.value');
	            var quickview = quickviewElement.find('.js-quickview').val();
	            var qty = quickviewElement.find('input[name="Quantity"]').val();
	        } else {
	            this.pid = $('input[name="pid"]').val();
	            var target = document.getElementsByClassName("qty-input__ctrl input--white value");
	            var quickview = $('.js-quickview').val();
	            var qty = $('input[name="Quantity"]').val();
	        }
	
	        ajax.getJson({
	            url: util.appendParamsToUrl(Urls.getAvailability, {
	                pid: this.pid,
	                Quantity: qty
	            }),
	            callback: function callback(data) {
	                availability.updateContainer(data, $(target));
	            }
	        });
	
	        var format = '';
	        if (document.getElementById("requestFormat")) {
	            format = document.getElementById("requestFormat").value;
	        }
	        if (format != 'ajax' && pageContext && pageContext.ns != 'cart') {
	            var $target = $(".variation-container").last();
	            var selectedSizeGrid = $target.find('.size-conversion-container li.selected').text() != '' ? $target.find('.size-conversion-container li.selected').text() : $target.find('.size-conversion-container option:selected').text();
	            var params = {
	                pid: this.pid,
	                quickview: quickview,
	                source: quickview == "true" ? 'quickview' : 'detail',
	                selectedSizeGrid: selectedSizeGrid
	            };
	            var URL = util.appendParamsToUrl(Urls.getVariationDropdown, params);
	            var isSet = $target.attr('data-isSet');
	            if (isSet !== 'true') {
	                progress.show($target);
	                ajax.load({
	                    url: URL,
	                    target: $target,
	                    callback: function callback(data) {
	                        bornModules.selectTags.init();
	                        bornModules.carousel.init();
	                        if (quickview == "true") {
	                            bornModules.showMoreSwatches.init('.quickview__dialog .swatch-variation-wrap');
	                        } else {
	                            bornModules.showMoreSwatches.init();
	                        }
	                        progress.hide($target);
	                    }
	                });
	            }
	        }
	
	        $('#product-content .set-preferred-store').on('click', function (e) {
	            e.preventDefault();
	            if (!User.zip) {
	                inventory.zipPrompt(function () {
	                    self.productSelectStore();
	                });
	            } else {
	                self.productSelectStore();
	            }
	        });
	
	        if ($availabilityContainer.length) {
	            if (User.storeId) {
	                inventory.getStoresInventory(this.pid).then(storesListing);
	            }
	
	            // See more or less stores in the listing
	            $availabilityContainer.on('click', '.stores-toggle', function (e) {
	                e.preventDefault();
	                $('.store-list-pdp .store-list-item').toggleClass('visible');
	                if ($(this).hasClass('collapsed')) {
	                    $(this).text(Resources.SEE_LESS);
	                } else {
	                    $(this).text(Resources.SEE_MORE);
	                }
	                $(this).toggleClass('collapsed');
	            });
	        }
	    }
	};
	
	module.exports = productInventory;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(7),
	    dialog = __webpack_require__(46),
	    TPromise = __webpack_require__(30),
	    util = __webpack_require__(15);
	
	var newLine = '\n';
	var storeTemplate = function storeTemplate(store, selectedStoreId, selectedStoreText) {
	    return ['<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">', '    <p class="store-address">', '        ' + store.address1 + '<br/>', '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode, '    </p>', '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>', '    <button class="select-store-button" data-store-id="' + store.storeId + '"' + (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>', '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE), '    </button>', '</li>'].join(newLine);
	};
	
	var storeListTemplate = function storeListTemplate(stores, selectedStoreId, selectedStoreText) {
	    if (stores && stores.length) {
	        return ['<div class="store-list-container">', '<ul class="store-list">', _.map(stores, function (store) {
	            return storeTemplate(store, selectedStoreId, selectedStoreText);
	        }).join(newLine), '</ul>', '</div>', '<div class="store-list-pagination">', '</div>'].join(newLine);
	    } else {
	        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
	    }
	};
	
	var zipPromptTemplate = function zipPromptTemplate() {
	    return ['<div id="preferred-store-panel">', '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>', '</div>'].join(newLine);
	};
	
	/**
	 * @description test whether zipcode is valid for either US or Canada
	 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
	 **/
	var validateZipCode = function validateZipCode(zipCode) {
	    var regexes = {
	        canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
	        usa: /^\d{5}(-\d{4})?$/
	    },
	        valid = false;
	    if (!zipCode) {
	        return;
	    }
	    _.each(regexes, function (re) {
	        var regexp = new RegExp(re);
	        valid = regexp.test(zipCode);
	    });
	    return valid;
	};
	
	var storeinventory = {
	    zipPrompt: function zipPrompt(callback) {
	        var self = this;
	        dialog.open({
	            html: zipPromptTemplate(),
	            options: {
	                title: Resources.STORE_NEAR_YOU,
	                width: 500,
	                buttons: [{
	                    text: Resources.SEARCH,
	                    click: function click() {
	                        var zipCode = $('#user-zip').val();
	                        if (validateZipCode(zipCode)) {
	                            self.setUserZip(zipCode);
	                            if (callback) {
	                                callback(zipCode);
	                            }
	                        }
	                    }
	                }],
	                open: function open() {
	                    $('#user-zip').on('keypress', function (e) {
	                        if (e.which === 13) {
	                            // trigger the search button
	                            $('.ui-dialog-buttonset .ui-button').trigger('click');
	                        }
	                    });
	                }
	            }
	        });
	    },
	    getStoresInventory: function getStoresInventory(pid) {
	        return TPromise.resolve($.ajax({
	            url: util.appendParamsToUrl(Urls.storesInventory, {
	                pid: pid,
	                zipCode: User.zip
	            }),
	            dataType: 'json'
	        }));
	    },
	    /**
	     * @description open the dialog to select store
	     * @param {Array} options.stores
	     * @param {String} options.selectedStoreId
	     * @param {String} options.selectedStoreText
	     * @param {Function} options.continueCallback
	     * @param {Function} options.selectStoreCallback
	     **/
	    selectStoreDialog: function selectStoreDialog(options) {
	        var self = this,
	            stores = options.stores,
	            selectedStoreId = options.selectedStoreId,
	            selectedStoreText = options.selectedStoreText,
	            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
	        dialog.open({
	            html: storeList,
	            options: {
	                title: Resources.SELECT_STORE + ' - ' + User.zip,
	                buttons: [{
	                    text: Resources.CHANGE_LOCATION,
	                    click: function () {
	                        self.setUserZip(null);
	                        // trigger the event to start the process all over again
	                        $('.set-preferred-store').trigger('click');
	                    }.bind(this)
	                }, {
	                    text: Resources.CONTINUE,
	                    click: function click() {
	                        if (options.continueCallback) {
	                            options.continueCallback(stores);
	                        }
	                        dialog.close();
	                    }
	                }],
	                open: function open() {
	                    $('.select-store-button').on('click', function (e) {
	                        e.preventDefault();
	                        var storeId = $(this).data('storeId');
	                        // if the store is already selected, don't select again
	                        if (storeId === selectedStoreId) {
	                            return;
	                        }
	                        $('.store-list .store-tile.selected').removeClass('selected').find('.select-store-button').text(Resources.SELECT_STORE);
	                        $(this).text(selectedStoreText).closest('.store-tile').addClass('selected');
	                        if (options.selectStoreCallback) {
	                            options.selectStoreCallback(storeId);
	                        }
	                    });
	                }
	            }
	        });
	    },
	    setUserZip: function setUserZip(zip) {
	        User.zip = zip;
	        $.ajax({
	            type: 'POST',
	            url: Urls.setZipCode,
	            data: {
	                zipCode: zip
	            }
	        });
	    },
	    shippingLoad: function shippingLoad() {
	        var $checkoutForm = $('.address');
	        $checkoutForm.off('click');
	        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
	            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
	        });
	    }
	};
	
	module.exports = storeinventory;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ajax = __webpack_require__(42),
	    util = __webpack_require__(15);
	
	var updateContainer = function updateContainer(data, $target) {
	    var $parentMain = $target.closest('#pdpMain');
	    var $availabilityMsg = $parentMain.find('.availability .availability-msg');
	    var message; // this should be lexically scoped, when `let` is supported (ES6)
	    if (!data) {
	        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
	        return;
	    }
	    $availabilityMsg.empty();
	    // Look through levels ... if msg is not empty, then create span el
	    if (data.levels.IN_STOCK > 0) {
	        if (data.showMaxQtyMsg && data.levels.NOT_AVAILABLE === 0) {
	            message = data.maxQtyReachedMsg;
	        } else if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
	            // Just in stock
	            //Comented cause we don't want the app to do anything if the message is in stock.
	            // message = Resources.IN_STOCK;
	            message = '';
	        } else {
	            // In stock with conditions ...
	            message = data.inStockMsg;
	        }
	
	        if (data.showMaxQtyMsg && data.levels.NOT_AVAILABLE === 0) {
	            $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
	        } else {
	            $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
	        }
	    }
	    if (data.levels.PREORDER > 0) {
	        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
	            message = Resources.PREORDER;
	        } else {
	            message = data.preOrderMsg;
	        }
	        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
	    }
	    if (data.levels.BACKORDER > 0) {
	        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
	            message = Resources.BACKORDER;
	        } else {
	            message = data.backOrderMsg;
	        }
	        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
	    }
	    if (data.inStockDate !== '') {
	        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
	    }
	    if (data.levels.NOT_AVAILABLE > 0) {
	        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
	            message = Resources.NOT_AVAILABLE;
	        } else {
	            message = data.reduceQtyMsg;
	        }
	        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'PDP',
	            'eventAction': 'product_out_of_stock',
	            'eventLabel': 'product out of stock - ' + product.id, //product id i.e. 57_2MM598_513V
	            "productName": product.name,
	            "country": window.GlobalAttributes.COUNTRY,
	            "language": window.GlobalAttributes.LANGUAGE,
	            "screenName": 'PDP',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    }
	};
	
	var getAvailability = function getAvailability() {
	    var target = this;
	    if (!target.value) {
	        return;
	    }
	
	    ajax.getJson({
	        url: util.appendParamsToUrl(Urls.getAvailability, {
	            pid: $(target).closest('form').find('input[name="pid"]').val(),
	            Quantity: $(target).val()
	        }),
	        callback: function callback(data) {
	            updateContainer(data, $(target));
	        }
	    });
	};
	var init = function init() {
	    var $mainElement = $('body');
	    $mainElement.off('change.getAvailability').on('change.getAvailability', '.pdpForm input[name="Quantity"]', getAvailability);
	};
	module.exports = {
	    init: init,
	    updateContainer: updateContainer
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _remainScrollAfterCtaAction = __webpack_require__(73);
	
	var _remainScrollAfterCtaAction2 = _interopRequireDefault(_remainScrollAfterCtaAction);
	
	var _born = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ajax = __webpack_require__(42),
	    dialog = __webpack_require__(46),
	    minicart = __webpack_require__(62),
	    progress = __webpack_require__(43),
	    util = __webpack_require__(15),
	    Promise = __webpack_require__(30),
	    _ = __webpack_require__(7),
	    TrackingLayer = __webpack_require__(18).default,
	    stickySummary = __webpack_require__(74);
	
	function initEventHandlers(callback) {
	    var helpers = {
	        isCartContext: function isCartContext() {
	            return pageContext && pageContext.ns && pageContext.ns === 'cart';
	        },
	        /**
	        * @description Make the AJAX request to add an item to cart
	        * @param {Element} form The form element that contains the item quantity and ID data
	        * @returns {Promise}
	        */
	        addItemToCart: function addItemToCart(form) {
	            var $form = $(form),
	                $qty = $form.find('input[name="Quantity"]') || $form.find('select[name="Quantity"]');
	            if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
	                $qty.val('1');
	            }
	            return Promise.resolve($.ajax({
	                type: 'POST',
	                url: util.ajaxUrl(Urls.addProduct),
	                data: helpers.isCartContext() ? $(form).find(':input').serialize() : $form.serialize()
	            })).then(function (response) {
	                // handle error in the response
	                if (response.error) {
	                    throw new Error(response.error);
	                } else {
	                    return response;
	                }
	            });
	        },
	
	        /**
	         * @description Handler to handle the add to cart event
	         */
	        addToCart: function addToCart(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var $form = helpers.isCartContext() ? $(this).closest('.js-cart-pli') : $(this).closest('form'),
	                $cartPage = $('.js-cart-page');
	
	            var btnContxt = $(this).data('postpage');
	            if (btnContxt !== undefined) {
	                //check whether the page is from magazine
	                $form = $('.magAddtoCart');
	            } else if ($(this).data('addcart') !== undefined && helpers.isCartContext()) {
	                //check whether the page is from cart
	                $form = $(this).closest('.pdpForm');
	            }
	
	            if (helpers.isCartContext() && $(this).data('addcart') === undefined) {
	                var $selectInput = $(this).find('.variation-select');
	                if ($selectInput.length > 0 && $selectInput.val().length <= 0) {
	                    return;
	                }
	                progress.show($('body'));
	            }
	
	            helpers.addItemToCart($form).then(function (response) {
	                var $uuid = $form.find('input[name="uuid"]');
	
	                if (!(0, _born.shouldEnableSticky)()) {
	                    window.scroll(0, 0);
	                }
	
	                if (btnContxt !== undefined) {
	                    $form[0].reset();
	                    var obj = $(this);
	                    var container = $('.magazine-article__section');
	                    var btn = container.find('button[type="button"].btn-add-to-bag:not(.out-stk-btn)');
	                    btn.attr('disabled', true);
	                    container.find('.add-to-bag').removeClass('active');
	
	                    btn.html(Resources.ADD_TO_CART_BUTTON);
	                    btn.attr('title', Resources.ADD_TO_CART_BUTTON);
	                }
	                //If $uuid.length exists, this product is being updated. 
	                if ($uuid.length > 0 && $uuid.val().length > 0) {
	                    // page.refresh();
	                    TrackingLayer.pushData('shopping_bag: ' + window.Resources['BAG_UPDATED']);
	
	                    if ($cartPage.length > 0) {
	                        $cartPage.replaceWith($(response));
	                        (0, _born.initCartCloseButton)();
	                    }
	
	                    callback().then(function () {
	                        progress.hide();
	                    });
	                } else {
	                    // do not close quickview if adding individual item that is part of product set
	                    // @TODO should notify the user some other way that the add action has completed successfully
	                    if (!$(this).hasClass('sub-product-item')) {
	                        dialog.close();
	                    }
	
	                    TrackingLayer.pushData('shopping_bag: ' + window.Resources['PRODUCT_ADDED']);
	
	                    // Hide Minicart popup only for PDP mobile web, but the cart should update.
	                    var showMinicartPopup = true;
	                    if ($('.pt_product-details').length > 0 && $(window).innerWidth() < 768) {
	                        showMinicartPopup = false;
	                    }
	                    minicart.show(response, showMinicartPopup);
	
	                    // Show cart notification message
	                    if (!showMinicartPopup) {
	                        var $addToCart = $('#add-to-cart');
	                        var notification = $('\n                            <div class="pdp-cart-notification display--small-only w-100 align--center">\n                                <i class="icon--circled-checkmark"></i>\n                                <span class="poppins txt--medium">' + Resources.PDP_CART_NOTIFICATION + '</span>\n                            </div>\n                        ');
	                        var buttonText = $('\n                            <span>\n                                <i class="icon--circled-checkmark txt--normal"></i>\n                                <span>' + Resources.PDP_PRODUCT_ADDED_TEXT + '</span>\n                            </span>\n                        ');
	                        var currentBtnText = $addToCart.html();
	                        $addToCart.html(buttonText.html());
	                        $('.qty-add-wrapper').prepend(notification);
	                        notification.hide().fadeIn(500);
	                        setTimeout(function () {
	                            notification.fadeOut(500, function () {
	                                $(this).remove();
	                                $addToCart.html(currentBtnText);
	                            });
	                        }, 2500);
	                    }
	                    if (helpers.isCartContext() && $form.find('#add-to-cart').length > 0 && $form.find('#add-to-cart').data('addcart') === true || $('.listcartadd') !== 'undefined' && $('.listcartadd').val().length > 0) {
	                        location.reload(true);
	                    }
	                }
	                if (!window.ApplePaySession) {
	                    $('#ckoApplePayButton').hide();
	                }
	                if ($('.show-ship-msg-space').length > 0) {
	                    $('.breadcrumb-spacer').addClass('has-approach-promo');
	                    $('.show-ship-msg-space').remove();
	                } else {
	                    $('.breadcrumb-spacer').removeClass('has-approach-promo');
	                }
	            }.bind(this));
	        },
	
	        /**
	         * @description Handler to handle the add all items to cart event
	         */
	        addAllToCart: function addAllToCart(e) {
	            e.preventDefault();
	            var $productForms = $('#product-set-list').find('form').toArray();
	            Promise.all(_.map($productForms, this.addItemToCart)).then(function (responses) {
	                dialog.close();
	                // show the final response only, which would include all the other items
	                minicart.show(responses[responses.length - 1]);
	            });
	        }
	
	    };
	
	    var addItemToCart = helpers.addItemToCart,
	        addToCart = helpers.addToCart,
	        addAllToCart = helpers.addAllToCart,
	        isCartContext = helpers.isCartContext,
	        handleCartSelect = helpers.handleCartSelect;
	
	
	    $('#add-to-cart[disabled]').attr('title', $.trim($('.availability-msg').text()));
	    $('#pdpMain, #wishlistList').off('click', '.add-to-cart').on('click', '.add-to-cart', addToCart);
	    $('#pdpMain button:not([disabled])').on('touchstart', '.add-to-cart', addToCart);
	    $('#wishlistList').on('touchstart', '.add-to-cart', addToCart);
	    $('#add-all-to-cart').on('click touchstart', addAllToCart);
	
	    if ($('.magAddtoCart').length > 0) {
	        $(document).on('click', '.btn-add-to-bag', addToCart);
	        $(document).on('click', '.link-add-to-bag', addToCart);
	    }
	
	    if (isCartContext()) {
	        $('.js-cart-wrapper').on('change', '.js-variation-select', addToCart);
	    }
	
	    (0, _remainScrollAfterCtaAction2.default)($('a.add-to-wishlist'));
	}
	
	function init(callback) {
	    callback = callback || new Promise(function (resolve) {
	        return resolve();
	    });
	    initEventHandlers(callback);
	}
	/**
	 * @function
	 * @description Binds the click event to a given target
	 */
	module.exports = init;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = remainScrollAfterCtaAction;
	function remainScrollAfterCtaAction($cta) {
	    $(document).ready(function () {
	        var scrollY = sessionStorage.getItem('scrollY', window.scrollY);
	
	        if (scrollY) {
	            $(window).scrollTop(+scrollY);
	            sessionStorage.removeItem('scrollY');
	        }
	    });
	
	    $cta.on('click', function (e) {
	        sessionStorage.setItem('scrollY', window.scrollY);
	    });
	}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15);
	var $window = $(window);
	var windowHeight = $window.height();
	var isMobile = util.isMobile;
	
	var getfixedHeaderHeight = function getfixedHeaderHeight() {
	    var $fixedHeader = $('.header').find('.fixit--active');
	
	    return $fixedHeader.length && $fixedHeader.height() || 0;
	};
	
	function initializeEvents(options) {
	    var stickOnNode = options.stickOnNode;
	
	    var stickOnNodeSelector = $(stickOnNode).length ? stickOnNode : '.footer';
	
	    initStickySummary();
	}
	
	function initStickySummary() {
	    var left = document.getElementById('cart-summary').getBoundingClientRect().left;
	
	    $('#cart-summary').stick_in_parent({
	        parent: '#wrapper'
	    }).on("sticky_kit:stick", function (e) {
	        $(this).css({
	            //maxHeight: windowHeight - getfixedHeaderHeight() - 30,
	            left: left
	        });
	    });
	}
	
	exports.init = function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        stickOnNode: ''
	    };
	
	    if (!$('#cart-summary').length || isMobile()) return;
	
	    // initializeEvents(options);
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ajax = __webpack_require__(42),
	    util = __webpack_require__(15);
	
	/**
	 * @description loads product's navigation
	 **/
	module.exports = function () {
	    var $pidInput = $('.pdpForm input[name="pid"]').last(),
	        $navContainer = $('#product-nav-container');
	    // if no hash exists, or no pid exists, or nav container does not exist, return
	    if (window.location.hash.length <= 1 || $pidInput.length === 0 || $navContainer.length === 0) {
	        return;
	    }
	
	    var pid = $pidInput.val(),
	        hash = window.location.hash.substr(1),
	        url = util.appendParamToURL(Urls.productNav + '?' + hash, 'pid', pid);
	
	    ajax.load({
	        url: url,
	        target: $navContainer
	    });
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bornModules = __webpack_require__(3).default,
	    ajax = __webpack_require__(42),
	
	// tooltip = require('../../tooltip'),
	util = __webpack_require__(15);
	
	module.exports = function () {
	    var $addToCart = $('.product-set-list #add-to-cart'),
	        $addAllToCart = $('#add-all-to-cart'),
	        $productSetList = $('#product-set-list');
	
	    var updateAddToCartButtons = function updateAddToCartButtons() {
	        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
	            $addAllToCart.attr('disabled', 'disabled');
	            // product set does not have an add-to-cart button, but product bundle does
	            $addToCart.attr('disabled', 'disabled');
	        } else {
	            $addAllToCart.removeAttr('disabled');
	            $addToCart.removeAttr('disabled');
	        }
	    };
	
	    if ($productSetList.length > 0) {
	        updateAddToCartButtons();
	    }
	
	    function loadOption(url) {
	        var $container = $(this).closest('.product-set-item');
	        var qty = $container.find('form input[name="Quantity"]').first().val();
	
	        ajax.load({
	            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
	            target: $container,
	            callback: function callback() {
	                updateAddToCartButtons();
	                bornModules.selectTags.init();
	                // tooltip.init();
	            }
	        });
	    }
	
	    // click on swatch for product set
	    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
	        e.preventDefault();
	        if ($(this).closest('.unselectable').length) {
	            return;
	        }
	
	        var url = Urls.getSetItem + this.search;
	
	        loadOption.call(this, url);
	    });
	
	    $productSetList.on('change', '.product-set-item .variation-select', function () {
	        if ($(this).val().length === 0) {
	            return;
	        }
	
	        var url = Urls.getSetItem + '?' + util.getQueryString(this.value);
	        // console.log(util.getQueryString(this.value));
	
	        loadOption.call(this, url);
	    });
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bornModules = __webpack_require__(3).default,
	    ajax = __webpack_require__(42),
	    image = __webpack_require__(78),
	    progress = __webpack_require__(43),
	    productStoreInventory = __webpack_require__(69),
	
	// tooltip = require('../../tooltip'),
	util = __webpack_require__(15),
	    bisn = __webpack_require__(79);
	
	/**
	 * @description update product content with new variant from href, load new content to #product-content panel
	 * @param {String} href - url of the new product variant
	 **/
	var updateContent = function updateContent(href, $target) {
	    var $mainClass = $target.closest('#pdpMain');
	    var $pdpForm = $mainClass.find('.pdpForm');
	    var isRestricted = $mainClass.data('isRestricted');
	    var selectedSizeGrid = $target.closest('.size-conversion-container').find("li.selected").text() != '' ? $target.closest('.size-conversion-container').find("li.selected").text() : $target.closest('.size-conversion-container').find("option:selected").text();
	    var qty = $pdpForm.find('input[name="Quantity"]').val();
	    var selectedSize = $pdpForm.find('.swatches__item .selected');
	    var params = {
	        format: 'ajax',
	        selectedSizeGrid: selectedSizeGrid,
	        Quantity: selectedSize = !null && selectedSize.length > 0 ? qty : 1
	    };
	    progress.show($mainClass);
	    ajax.load({
	        url: util.appendParamsToUrl(href, params),
	        target: $mainClass.find('#product-content'),
	        callback: function callback() {
	            if (SitePreferences.STORE_PICKUP) {
	                productStoreInventory.init();
	            }
	            bornModules.selectTags.init();
	            bornModules.qtyControl.init();
	            bornModules.modalToggle.init();
	            image.replaceImages($mainClass);
	            // tooltip.init();
	
	            bornModules.carousel.init();
	
	            bisn.init();
	            var obj = $('.apple-pay-submt-btn');
	            if (obj.length > 0) {
	                var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') == -1 && navigator.userAgent.indexOf('FxiOS') == -1;
	                if (isSafari !== true) {
	                    obj.remove();
	                }
	            }
	            bornModules.showMoreSwatches.init();
	            var quickviewElement = $('.quickview__dialog');
	            if (quickviewElement.length > 0) {
	                $('.quickview__dialog  #productPrice > div.product-price').html($('.quickview__dialog  #hiddenPrice > div.product-price').html());
	                var addToCartBtn = $('.pdp.quickview__dialog .add-to-cart');
	                if (addToCartBtn.length > 0) {
	                    addToCartBtn.attr('disabled', false);
	                }
	            } else {
	                $('#productPrice > div.product-price').html($('#hiddenPrice > div.product-price').html());
	            }
	        }
	    });
	};
	
	// avoid jerk/jump while switching between color swatches
	function setMinProductHeight() {
	    var ele = $('#pdp-img-row');
	
	    var setMinHeight = function setMinHeight() {
	        if (ele.hasClass('has-variant')) {
	            setTimeout(function () {
	                ele.css('min-height', ele.height());
	            }, 1200);
	        }
	    };
	
	    var removeMinHeight = function removeMinHeight() {
	        ele.css('min-height', '');
	    };
	
	    if (window.innerWidth < 768) {
	        setMinHeight();
	    }
	
	    $(window).on('resize', function () {
	        removeMinHeight();
	        if (window.innerWidth < 768) {
	            setMinHeight();
	        }
	    });
	}
	
	module.exports = function () {
	    var $mainElement = $('body');
	
	    $mainElement.on('click', '.click_disabled', function (e) {
	        e.stopImmediatePropagation();
	        e.preventDefault();
	    });
	
	    // click on swatch - should replace product content with new variant
	    $mainElement.on('click', '.product-detail .swatchanchor', function (e) {
	        e.preventDefault();
	        var $target = $(this);
	        updateContent(this.href, $target);
	        if ($(this).closest('.sizeContainer').data('vattr') === 'size') {
	            localStorage.setItem("sizetype", "sizecode");
	        }
	    });
	
	    // change drop down variation attribute - should replace product content with new variant
	    $mainElement.on('change', '.product-detail .variation-select', function () {
	        var $target = $(this);
	        if ($target.val().length === 0) {
	            return;
	        }
	        updateContent($target.val(), $target);
	    });
	
	    $mainElement.on('change', '.product-detail .sizeConversion-select', function () {
	        var $target = $(this);
	        if ($target.val().length === 0) {
	            return;
	        }
	        var url = $(this).find(':selected').attr('data-url');
	        updateContent(url, $target);
	        localStorage.setItem("sizetype", "unitsize");
	    });
	    bornModules.showMoreSwatches.init();
	
	    setMinProductHeight();
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// var dialog = require('../../dialog');
	// var util = require('../../util');
	// var qs = require('qs');
	// var url = require('url');
	// var _ = require('lodash');
	
	var bornModules = __webpack_require__(3).default,
	    bornPages = __webpack_require__(26).default;
	
	// var zoomMediaQuery = matchMedia('(min-width: 960px)');
	
	/**
	 * @description Enables the zoom viewer on the product detail page
	 * @param zmq {Media Query List}
	 */
	// function loadZoom (zmq) {
	//     var $imgZoom = $('#pdpMain .main-image'),
	//         hiresUrl;
	//     if (!zmq) {
	//         zmq = zoomMediaQuery;
	//     }
	//     if ($imgZoom.length === 0 || dialog.isActive() || util.isMobile() || !zoomMediaQuery.matches) {
	//         // remove zoom
	//         $imgZoom.trigger('zoom.destroy');
	//         return;
	//     }
	//     hiresUrl = $imgZoom.attr('href');
	
	//     if (hiresUrl && hiresUrl !== 'null' && hiresUrl.indexOf('noimagelarge') === -1 && zoomMediaQuery.matches) {
	//         $imgZoom.zoom({
	//             url: hiresUrl
	//         });
	//     }
	// }
	
	// zoomMediaQuery.addListener(loadZoom);
	
	/**
	 * @description Sets the main image attributes and the href for the surrounding <a> tag
	 * @param {Object} atts Object with url, alt, title and hires properties
	 */
	// function setMainImage (atts) {
	//     $('#pdpMain .primary-image').attr({
	//         src: atts.url,
	//         alt: atts.alt,
	//         title: atts.title
	//     });
	//     // updatePinButton(atts.url);
	//     if (!dialog.isActive() && !util.isMobile()) {
	//         $('#pdpMain .main-image').attr('href', atts.hires);
	//     }
	//     // loadZoom();
	// }
	
	// function updatePinButton (imageUrl) {
	//     var pinButton = document.querySelector('.share-icon[data-share=pinterest]');
	//     if (!pinButton) {
	//         return;
	//     }
	//     var newUrl = imageUrl;
	//     if (!imageUrl) {
	//         newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
	//     }
	//     var href = url.parse(pinButton.href);
	//     var query = qs.parse(href.query);
	//     query.media = url.resolve(window.location.href, newUrl);
	//     query.url = window.location.href;
	//     var newHref = url.format(_.extend({}, href, {
	//         query: query, // query is only used if search is absent
	//         search: qs.stringify(query)
	//     }));
	//     pinButton.href = newHref;
	// }
	
	/**
	 * @description Replaces the images in the image container, for eg. when a different color was clicked.
	 */
	function replaceImages($mainClass) {
	    var $newImages = $mainClass.find('#update-images'),
	        $imageContainer = $mainClass.find('.product-image-container'),
	
	    // keep wishlist button
	    $wishlistBtn = $imageContainer.find('.item-wishlist-shoplook');
	    if ($newImages.length === 0) {
	        return;
	    }
	
	    // append wishlist button
	    $imageContainer.html($newImages.html()).append($wishlistBtn.get(0));
	    // bornModules['[data-slick]'].init('[data-slick]');
	    bornModules.carousel.init();
	    bornPages['.pt_product-details'].init();
	    $newImages.remove();
	    // loadZoom();
	}
	
	/* @module image
	 * @description this module handles the primary image viewer on PDP
	 **/
	
	/**
	 * @description by default, this function sets up zoom and event handler for thumbnail click
	 **/
	// module.exports = function () {
	// if (dialog.isActive() || util.isMobile()) {
	//     $('#pdpMain .main-image').removeAttr('href');
	// }
	// updatePinButton();
	// loadZoom();
	// handle product thumbnail click event
	// $('#pdpMain').on('click', '.productthumbnail', function () {
	//     // switch indicator
	//     $(this).closest('.product-thumbnails').find('.thumb.selected').removeClass('selected');
	//     $(this).closest('.thumb').addClass('selected');
	
	//     setMainImage($(this).data('lgimg'));
	// });
	// };
	// module.exports.loadZoom = loadZoom;
	// module.exports.setMainImage = setMainImage;
	module.exports.replaceImages = replaceImages;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _offertimer = __webpack_require__(41);
	
	var util = __webpack_require__(15),
	    dialog = __webpack_require__(46),
	    tooltip = __webpack_require__(80),
	    bornModules = __webpack_require__(3).default;
	
	/**
	 * Renders error in BISN form
	 * @param emailInput jQuery-object of verified field
	 * @param text error message
	 */
	function showError(emailInput, text) {
		var id = emailInput.attr('id') + '-error';
		if ($('#' + id).length) {
			$('#' + id).html(text).show();
		} else {
			$('<span></span>', {
				'id': id,
				'class': 'error'
			}).html(text).insertAfter(emailInput);
		}
	}
	
	/**
	 * Adds event handler on form submit 
	 */
	function initEvents() {
		notifyPopupEvents();
	}
	
	function notifyPopupEvents() {
		var $pdpMain = $('.pdp');
	
		$pdpMain.off('click', '#backin-stock-product').on('click', '#backin-stock-product', function (e) {
			e.preventDefault();
	
			// If no variant selected - show tooltip
			if (!isVariantSelected.call(this)) {
				var $jsVariationSelect = $(this).closest('.pdpForm').find('.js-variation-select');
				tooltip.show($jsVariationSelect, Resources.BACKINSTOCK_TOOLTIP);
				return;
			}
			var $variantSelector = $(this).closest('.pdpForm').find('.size-conversion-container .sizeConversion .sizeLabel, .size-conversion-container .sizeConversion.no-conversion');
			var isNoConversion = $('.pdpForm').find('.size-conversion-container .sizeConversion.no-conversion').length > 0;
			if (!_isVariantSelectedSizeGrid.call(this)) {
				tooltip.show(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector, Resources.BACKINSTOCK_TOOLTIP);
				return;
			} else {
				tooltip.hide($variantSelector);
			}
	
			var source = $(this).data('source');
	
			if (source && source === 'quickview') {
				showBackInStockSection.call(this);
			} else {
				openBackInStockPopup.call(this);
			}
		});
	
		$pdpMain.off('change', '.product-detail .variation-select').on('change', '.product-detail .variation-select', function () {
			tooltip.hide($(this));
		});
	}
	
	function showBackInStockSection() {
		var $pdpForm = $(this).closest('.pdpForm'),
		    $bisnForm = $pdpForm.find('.js-backinstock-form');
	
		// If already shown
		if ($bisnForm && $bisnForm.length >= 1) {
			return;
		}
	
		$.ajax({
			url: Urls.getBackInStockForm,
			data: $pdpForm.serialize(),
			success: function success(response) {
				$pdpForm.append(response);
				$pdpForm.data('source', $('#source').val());
				initPopupFormEvents();
			}
		});
	}
	
	function openBackInStockPopup() {
		var $token = $(this).parent().find('.js-csrf-token'),
		    $pid = $(this).parents().find('.js-pid');
	
		var notifyUrl = util.appendParamsToUrl(Urls.backInStockPopup, {
			'csrf_token': $token.val(),
			'pid': $pid.val(),
			'source': 'backinstock'
		});
	
		dialog.open({
			url: notifyUrl,
			options: {
				width: 400,
				update: true
			},
			afterCreateCallback: openNotifyPopupCallback
		});
	}
	
	function initPopupFormEvents() {
		scrollToEmail();
		// Notify me button on popup
		$('.js-notify-button').click(function (e) {
			e.preventDefault();
			var $fieldset = $(this).closest('.js-backinstock-form');
			var $emailInput = $fieldset.find('[name$=email]');
			var data = $fieldset.serialize();
			var btn = $fieldset.find("button[type=submit]");
			$.ajax({
				url: Urls.backInStock,
				method: 'POST',
				data: data + '&' + btn.attr('name'),
				dataType: 'json',
				success: function success(data) {
					if (!data.validationError) {
						// Remove errors if any
						$emailInput.parent().find('span.error').remove();
	
						// Show confirmation
						$fieldset.html(data.message);
	
						var $source = $('.js-open-notifypopup').closest('.pdpForm').data('source');
	
						if ($source === 'cart') {
							$fieldset.find('.js-backinstock-continue').remove();
						}
					} else {
						showError($emailInput, data.message);
					}
				},
				error: function error() {
					showError($emailInput, 'error');
				}
			});
		});
	
		// Continue shopping button handler
		$('.js-backinstock-form').on('click', '.js-backinstock-continue', function (e) {
			e.preventDefault();
			dialog.close();
		});
	}
	
	/**
	 * Checks variant selector
	 * 
	 * @returns {Boolean} Returns true in case if variant was selected
	 */
	function isVariantSelected() {
		var $jsVariationSelect = $(this).closest('.pdpForm').find('.js-variation-select').find('select#va-size');
	
		if (!$jsVariationSelect.length) {
			return true;
		}
	
		return $jsVariationSelect && $jsVariationSelect.val().length > 0 && $jsVariationSelect.val().includes("size");
	}
	
	function _isVariantSelectedSizeGrid() {
		var $jsVariationSelect = $(this).closest('.pdpForm').find('.size-conversion-container');
		if ($jsVariationSelect.length <= 0) {
			return true;
		}
		$jsVariationSelect = $jsVariationSelect.find('.sizeDescription .content-items .links-item.selected');
	
		if ($jsVariationSelect.length > 0) {
			return true;
		} else {
			return false;
		}
	}
	
	function scrollToEmail() {
		setTimeout(function () {
			var $emailField = $('.js-backinstock-form').find('input[name$="_email"]');
			$('.window-overlay').animate({
				scrollTop: $emailField.offset().top
			}, 500);
	
			$('.js-backinstock-form').find('input[name$="_email"]').on('focus', function () {
				var _this = $(this);
				setTimeout(function () {
					$('.overlay--active').scrollTop($('.window-overlay--modal').height());
				}, 500);
			});
		}, 500);
	}
	
	/**
	 * Callback which is triggered on popup init event
	 */
	function openNotifyPopupCallback() {
		bornModules.carousel.init();
		bornModules.video.init();
		bornModules.selectTags.init();
		bornModules.qtyControl.init();
		bornModules.modalToggle.init();
		bornModules.toggle.init();
		initPopupFormEvents();
		(0, _offertimer.pdpOfferTimer)();
		$(window).trigger('modal-open');
	}
	
	module.exports.init = initEvents;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15);
	'use strict';
	
	/**
	 * Module is used for showing tooltips
	 */
	
	// const is not used because of Safari compatibility
	var jsTooltipClass = 'js-tooltip';
	
	exports.show = function ($container, text) {
		var extraOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var isScroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
		$('.' + jsTooltipClass).remove();
	
		var $jsTooltip = $container.parent().find('.' + jsTooltipClass),
		    navOffset = 0,
		    checkViewPort = true;
	
		if (util.isMobile()) {
			navOffset = $('.header__main').height();
		}
	
		if (!$jsTooltip.length) {
			$container.before($('<div/>').addClass(jsTooltipClass).html(text));
		}
	
		$jsTooltip.show();
	
		var $topContainer = $container.parent().find('.' + jsTooltipClass);
		if (!util.isMobile()) {
			var $pdpContainer = $container.closest('#pdpMain');
			if ($pdpContainer && $pdpContainer.length > 0) {
				if (!$pdpContainer.hasClass("quickview__dialog")) {
					checkViewPort = false;
					navOffset = 50;
					$topContainer = $pdpContainer;
				}
			}
		}
	
		if (!util.isMobile() && checkViewPort && $topContainer.isInViewport()) {
			return;
		}
	
		if ($('body').hasClass('overlay--shown')) {
			return;
		}
	
		if (isScroll) {
			$('html, body').animate({
				scrollTop: $topContainer.offset().top - navOffset - extraOffset
			}, 500);
		}
	};
	
	exports.hide = function ($container) {
		$container.parent().find('.' + jsTooltipClass).hide();
	};
	exports.hideAll = function () {
		var tipEl = $('.' + jsTooltipClass);
		if (tipEl.length > 0 && tipEl.is(":visible")) {
			tipEl.hide();
		}
	};
	exports.initShippingFeeCustomToolTipEvents = function () {
		$('#main').on('mouseenter', '.icon--Info', function (e) {
			if (window.innerWidth < 768) return;
			module.exports.show($(this), $(this).data('tooltip'), 0, false);
		});
	
		$('#main').on('click', '.icon--Info', function (e) {
			e.stopImmediatePropagation();
			e.stopPropagation();
			if (window.innerWidth > 767) return;
			if ($(this).parent().find('.js-tooltip').is(':visible')) {
				module.exports.hide($(this));
			} else {
				module.exports.show($(this), $(this).data('tooltip'), 0, false);
			}
		});
	
		$('#main').on('mouseleave', '.icon--Info', function (e) {
			module.exports.hide($(this));
		});
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15),
	    dialog = __webpack_require__(46),
	    tooltip = __webpack_require__(80),
	    bornModules = __webpack_require__(3).default;
	
	/**
	 * Renders error in Coming Soon form
	 * @param emailInput jQuery-object of verified field
	 * @param text error message
	 */
	function showError(emailInput, text) {
		var id = emailInput.attr('id') + '-error';
		if ($('#' + id).length) {
			$('#' + id).html(text).show();
		} else {
			$('<span></span>', {
				'id': id,
				'class': 'error'
			}).html(text).insertAfter(emailInput);
		}
	}
	
	/**
	 * Adds event handler on form submit 
	 */
	function initEvents() {
		notifyPopupEvents();
	}
	
	function notifyPopupEvents() {
		var pdpMain = $('.pdp');
	
		pdpMain.off('click', '#coming-soon-product').on('click', '#coming-soon-product', function (e) {
			e.preventDefault();
	
			var source = $(this).data('source');
	
			if (source && source === 'quickview') {
				showComingSoonSection.call(this);
			} else {
				openComingSoonPopup.call(this);
			}
		});
	}
	
	function showComingSoonSection() {
		var pdpForm = $(this).closest('.pdpForm'),
		    csForm = pdpForm.find('.js-comingsoon-form');
	
		// If already shown
		if (csForm && csForm.length >= 1) {
			return;
		}
	
		$.ajax({
			url: Urls.comingSoonForm,
			data: pdpForm.serialize(),
			success: function success(response) {
				pdpForm.append(response);
				pdpForm.data('source', $('#source').val());
				initPopupFormEvents();
			}
		});
	}
	
	function openComingSoonPopup() {
		var token = $(this).parent().find('.js-csrf-token'),
		    pid = $(this).parents().find('.js-pid');
	
		var notifyUrl = util.appendParamsToUrl(Urls.comingSoonPopup, {
			'csrf_token': token.val(),
			'pid': pid.val(),
			'source': 'comingsoon'
		});
	
		dialog.open({
			url: notifyUrl,
			options: {
				width: 400,
				update: true
			},
			afterCreateCallback: openNotifyPopupCallback
		});
	}
	
	function initPopupFormEvents() {
		scrollToEmail();
		$('.js-notify-button').click(function (e) {
			e.preventDefault();
			var fieldset = $(this).closest('.js-comingsoon-form');
			var emailInput = fieldset.find('[name$=email]');
			var data = fieldset.serialize();
			var btn = fieldset.find("button[type=submit]");
			$.ajax({
				url: Urls.comingSoonSubmit,
				method: 'POST',
				data: data + '&' + btn.attr('name'),
				dataType: 'json',
				success: function success(data) {
					if (!data.validationError) {
						// Remove errors if any
						emailInput.parent().find('span.error').remove();
	
						// Show confirmation
						fieldset.html(data.message);
	
						var source = $('.js-open-notifypopup').closest('.pdpForm').data('source');
	
						if (source === 'cart') {
							fieldset.find('.js-cs-continue').remove();
						}
						$('.coming-soon__description').hide();
					} else {
						showError(emailInput, data.message);
					}
				},
				error: function error() {
					showError(emailInput, 'error');
				}
			});
		});
	
		// Continue shopping button handler
		$('.js-comingsoon-form').on('click', '.js-cs-continue', function (e) {
			e.preventDefault();
			dialog.close();
		});
	}
	
	function scrollToEmail() {
		setTimeout(function () {
			var wrapEl = $('.js-comingsoon-form');
			var emailField = wrapEl.find('input[name$="_email"]');
			$('.window-overlay').animate({
				scrollTop: emailField.offset().top
			}, 500);
	
			wrapEl.find('input[name$="_email"]').on('focus', function () {
				var _this = $(this);
				setTimeout(function () {
					$('.overlay--active').scrollTop($('.window-overlay--modal').height());
				}, 500);
			});
		}, 500);
	}
	
	/**
	 * Callback which is triggered on popup init event
	 */
	function openNotifyPopupCallback() {
		bornModules.carousel.init();
		bornModules.video.init();
		bornModules.modalToggle.init();
		bornModules.toggle.init();
		initPopupFormEvents();
	}
	
	module.exports.init = initEvents;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stickySummary = __webpack_require__(74);
	var util = __webpack_require__(15);
	var isMobile = util.isMobile;
	
	
	var slickNewsInit = function slickNewsInit() {
	    var $newsContainer = $('.aside-news');
	    var $editsGrid = $('.l-edits-item-grid');
	
	    if ($editsGrid.children().length > 2) {
	        $newsContainer.insertAfter($editsGrid.children().eq(1));
	    }
	
	    $newsContainer.on('init', function (event) {
	        var $img = $newsContainer.find('.news-preview__section--img img').eq(0);
	        var $arrows = $newsContainer.find('.slick-arrow');
	
	        $img.on('load', function () {
	            $arrows.length && $arrows.each(function (index, node) {
	                $(node).css({
	                    top: $img.height() / 2
	                });
	            });
	        });
	    });
	};
	
	exports.init = function () {
	    isMobile() && slickNewsInit();
	    stickySummary.init();
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @function init Used to control site arabic version promotion popup
	 * @param {Object} params
	 * @param {String} params.containerSelector
	 * @param {String} params.closeButtonSelector
	 * @param {String} params.redirectButtonSelector
	 **/
	module.exports = function init(params) {
	    var _ = __webpack_require__(7),
	        defaultOptions = {
	        closeButtonSelector: '.js-arabic-promotion-close',
	        containerSelector: '.js-arabic-promotion',
	        redirectButtonSelector: '.js-arabic-promotion-redirect'
	    };
	
	    _.extend(defaultOptions, params);
	
	    $(document).ready(function () {
	        var $container = $(defaultOptions.containerSelector),
	            $closeButton = $container.find(defaultOptions.closeButtonSelector),
	            $redirectButton = $container.find(defaultOptions.redirectButtonSelector);
	
	        function detachPopUp() {
	            $.get({
	                url: $(this).data('close-url')
	            });
	
	            $container.detach();
	        }
	
	        function redirectClick() {
	            location.href = $(this).data('url');
	        }
	
	        $closeButton.bind('click', detachPopUp);
	        $redirectButton.bind('click', redirectClick);
	    });
	};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	var recaptcha = {
	    init: function init() {
	
	        //Contact us page
	        $('#contactbtn').on('click', function (e) {
	            var captchaField = $(this).parents('form').find("input[name='google_captcha_token']");
	            if (captchaField.length && $(this).parents('form').valid()) {
	                if (captchaField.val() == '' || captchaField.data('error') === 'true') {
	                    e.preventDefault();
	                    var siteKey = captchaField.data('sitekey');
	                    grecaptcha.ready(function () {
	                        grecaptcha.execute(siteKey, { action: 'ContactUsPage' }).then(function (token) {
	                            if (token) {
	                                captchaField.val(token);
	                                $('#contactbtn').trigger('click');
	                            }
	                        });
	                    });
	                }
	            } else if ($(this).parents('form').valid()) {}
	        });
	    }
	};
	
	module.exports = recaptcha;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	var defaultConfig = {
	    lazySourceAttr: 'data-videosrc',
	    loadSuccessClass: 'lazyloaded',
	    clickListenerSelector: '.video-tile',
	    deviceTypeAttribute: 'data-device',
	    breakPointMobile: 480,
	    breakPointTablet: 900
	};
	
	var DEVICE = {
	    mobile: 'mobile',
	    tablet: 'tablet'
	};
	
	function isMobile() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
	
	    return window.innerWidth <= config.breakPointMobile;
	}
	function isTablet() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
	
	    return window.innerWidth <= config.breakPointTablet;
	}
	function loadVideo(entry, config) {
	    if (entry.classList.contains(config.loadSuccessClass)) return;
	    var lazysrc = entry.getAttribute(config.lazySourceAttr);
	    entry.src = lazysrc;
	    entry.classList += ' ' + config.loadSuccessClass;
	    var video = entry.closest('video');
	    $(video).on('play pause', function () {
	        $(video).toggleClass('playing');
	    });
	    video.load();
	    if (!$(entry).parent().hasClass('video-redirect-element')) {
	        setTimeout(function () {
	            video.play();
	        }, 50);
	    }
	}
	
	exports.init = function () {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
	
	    config = Object.assign(defaultConfig, config);
	
	    var elements = document.querySelectorAll('[' + config.lazySourceAttr + ']:not(.' + config.loadSuccessClass + ')');
	
	    elements.forEach(function (entry) {
	        function eventHandler(e) {
	            e.preventDefault();
	            e.stopPropagation();
	
	            var deviceType = entry.getAttribute(config.deviceTypeAttribute);
	            switch (deviceType) {
	                case DEVICE.mobile:
	                    isMobile(config) && loadVideo(entry, config);break;
	                case DEVICE.tablet:
	                    isTablet(config) && loadVideo(entry, config);break;
	                default:
	                    loadVideo(entry, config);
	            }
	
	            var eventHolder = entry.closest(config.clickListenerSelector);
	            var totalSources = eventHolder.querySelectorAll('source').length;
	            var loadedSources = eventHolder.querySelectorAll('source.' + config.loadSuccessClass).length;
	            totalSources === loadedSources && eventHolder.removeEventListener('click', eventHandler);
	        }
	        entry.closest(config.clickListenerSelector).addEventListener('click', eventHandler);
	    });
	};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	// jQuery extensions
	
	module.exports = function () {
	    // params
	    // toggleClass - required
	    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
	    // eventName - optional. defaults to 'click'
	    $.fn.toggledList = function (options) {
	        if (!options.toggleClass) {
	            return this;
	        }
	        var list = this;
	        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
	            e.preventDefault();
	            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
	            classTarget.toggleClass(options.toggleClass);
	            // execute callback if exists
	            if (options.callback) {
	                options.callback();
	            }
	        });
	    };
	
	    $.fn.syncHeight = function () {
	        var arr = $.makeArray(this);
	        arr.sort(function (a, b) {
	            return $(a).height() - $(b).height();
	        });
	        return this.height($(arr[arr.length - 1]).height());
	    };
	
	    $.fn.isInViewport = function () {
	        var elementTop = $(this).offset().top;
	        var elementBottom = elementTop + $(this).outerHeight();
	
	        var viewportTop = $(window).scrollTop();
	        var viewportBottom = viewportTop + $(window).height();
	
	        return elementBottom > viewportTop && elementTop < viewportBottom;
	    };
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dialog = __webpack_require__(46);
	
	/**
	 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
	 **/
	module.exports = function () {
	    /**
	     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
	     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
	     */
	    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
	        // check for privacy policy page
	        if ($('.privacy-policy').length === 0) {
	            dialog.open({
	                url: Urls.cookieHint,
	                options: {
	                    closeOnEscape: false,
	                    dialogClass: 'no-close',
	                    buttons: [{
	                        text: Resources.I_AGREE,
	                        click: function click() {
	                            $(this).dialog('close');
	                            enableCookies();
	                        }
	                    }]
	                }
	            });
	        }
	    } else {
	        // Otherwise, we don't need to show the asset, just enable the cookies
	        enableCookies();
	    }
	
	    function enableCookies() {
	        if (document.cookie.indexOf('dw=1') < 0) {
	            document.cookie = 'dw=1; path=/';
	        }
	        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
	            document.cookie = 'dw_cookies_accepted=1; path=/';
	        }
	    }
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dialog = __webpack_require__(46);
	var util = __webpack_require__(15);
	var SessionAttributes = window.SessionAttributes;
	
	/**
	 * @function captcha    Used to display/control the scrim containing the simulated captcha code
	 **/
	module.exports = function () {
	    /**
	     * if the session.privacy.ratelimited element is present then show the notification
	     * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
	     */
	    if (SessionAttributes.SHOW_CAPTCHA) {
	        dialog.open({
	            html: '<p class="heading heading--small">' + Resources.ARE_YOU_HUMAN + '</p><br /><button data-modal-close="true" class="button captcha-button button--full button--primary">' + Resources.OK + '</button>',
	            afterCreateCallback: function afterCreateCallback() {
	                $('.captcha-button').on('click', function (e) {
	                    var url = util.appendParamsToUrl(Urls.rateLimiterReset, { format: 'ajax' });
	
	                    $.ajax({
	                        url: url,
	                        complete: function complete() {
	
	                            if (util.getQueryString(window.location.href).indexOf('dwcont') >= 0) {
	                                window.location.href = util.removeParamFromURL(window.location.href, 'dwcont');
	                            }
	                        }
	                    });
	                });
	            },
	            options: {
	                modalID: 'modal--captcha',
	                modalClass: 'modal--captcha align--center'
	                // closeOnEscape: false,
	                // dialogClass: 'no-close',
	                // buttons: [{
	                //     text: Resources.OK,
	                //     click: function () {
	                //         var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
	                //         $.ajax({
	                //             url: url
	                //         });
	                //         $(this).dialog('close');
	                //     }
	                // }]
	            }
	        });
	    }
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var giftcert = __webpack_require__(90),
	    tooltip = __webpack_require__(47),
	    util = __webpack_require__(15),
	    dialog = __webpack_require__(46),
	    page = __webpack_require__(58),
	    login = __webpack_require__(91),
	    validator = __webpack_require__(56),
	    dynamicAddress = __webpack_require__(92),
	    progress = __webpack_require__(43),
	    b2borders = __webpack_require__(95),
	    bornModules = __webpack_require__(3).default,
	    customTooltip = __webpack_require__(80),
	    barcode = __webpack_require__(96);
	
	/**
	 * @private
	 * @function
	 * @description Toggles the list of Orders
	 */
	function toggleFullOrder() {
	    $('.order-items').find('li.hidden:first').prev('li').append('<a class="toggle">View All</a>').children('.toggle').click(function () {
	        $(this).parent().siblings('li.hidden').show();
	        $(this).remove();
	    });
	}
	/**
	 * @private
	 * @function
	 * @description Binds the events on the address form (edit, create, delete)
	 */
	function initAddressEvents() {
	    var addresses = $('#addresses');
	    if (addresses.length === 0) {
	        return;
	    }
	
	    addresses.on('click', '.delete', function (e) {
	        e.preventDefault();
	        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
	            $.ajax({
	                url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
	                dataType: 'json'
	            }).done(function (data) {
	                if (data.status.toLowerCase() === 'ok') {
	                    page.redirect(Urls.addressesList);
	                } else if (data.message.length > 0) {
	                    window.alert(data.message);
	                } else {
	                    page.refresh();
	                }
	            });
	        }
	    });
	}
	
	function selectAddressType() {
	    $('.address-type-selector-profile').on('click', '.address-type.selectable:not(.active)', function () {
	        var $addressType = $('select[name$="_addressType"]');
	        $('.address-type-selector-profile .address-type.active').removeClass('active');
	        $addressType.val($(this).data('value'));
	        $(this).addClass('active');
	    });
	}
	/**
	 * @private
	 * @function
	 * @description Binds the events of the payment methods list (delete card)
	 */
	function initPaymentEvents() {
	    $('.add-card').on('click', function (e) {
	        e.preventDefault();
	        dialog.open({
	            url: $(e.target).attr('href'),
	            options: {
	                open: initializePaymentForm
	            }
	        });
	    });
	
	    var paymentList = $('.payment-list');
	    if (paymentList.length === 0) {
	        return;
	    }
	
	    util.setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));
	
	    $('form[name="payment-remove"]').on('submit', function (e) {
	        e.preventDefault();
	        // override form submission in order to prevent refresh issues
	        var button = $(this).find('.delete');
	        $('<input/>').attr({
	            type: 'hidden',
	            name: button.attr('name'),
	            value: button.attr('value') || 'delete card'
	        }).appendTo($(this));
	        var data = $(this).serialize();
	        $.ajax({
	            type: 'POST',
	            url: $(this).attr('action'),
	            data: data
	        }).done(function () {
	            page.redirect(Urls.paymentsList);
	        });
	    });
	}
	
	function scrollPage(offset) {
	    $('html, body').animate({
	        scrollTop: offset
	    }, 'fast');
	}
	
	function initializePaymentForm() {
	    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
	        e.preventDefault();
	        dialog.close();
	    });
	}
	
	function initHasReturnsBehaviour() {
	    var $form = $('.js-order-return-form'),
	        $submitButton = $form.find(".js-continue-button");
	    if ($form.find('.js-returns-item').length) {
	        $submitButton.removeAttr('disabled');
	    } else {
	        $submitButton.attr('disabled', 'disabled');
	    }
	}
	
	function changeHistoryState(humanReadableURL) {
	    history.pushState({}, "", humanReadableURL);
	}
	
	function initializeReturnForm() {
	    var $form = $('.js-order-return-form'),
	        formData;
	
	    // Creating human readable url
	    $('body').on('click', '.js-start-return-button, .js-continue-button', function () {
	        var dataReturnUrlPart = $(this).data('return');
	        changeHistoryState(dataReturnUrlPart);
	    });
	    $('body').on('click', '.js-start-return-button', function () {
	        toggleReturnItem();
	        qtyActions();
	    });
	
	    $('body').on('click', '#verify-email-link', function () {
	        document.getElementById('ResendVerifyMailForm').submit();
	    });
	
	    $form.on('click', ':submit', function (e) {
	        e.preventDefault();
	        formData = $form.serializeArray();
	        var shipmentNumber;
	        var inputFieldPresent = $('#returnShipmentID').length > 0;
	        if (inputFieldPresent) {
	            shipmentNumber = $('#returnShipmentID').val();
	        } else {
	            shipmentNumber = $(e.target).data('shipmentno');
	        }
	        formData.push({
	            name: this.name,
	            value: this.value
	        });
	        formData.push({
	            name: 'shipmentNo',
	            value: shipmentNumber
	        });
	        $form.submit();
	    });
	
	    $form.on('submit', function (e) {
	        e.preventDefault();
	        progress.show($form);
	        $.ajax({
	            type: 'post',
	            url: $form.attr('action'),
	            data: formData,
	            crossDomain: true,
	            xhrFields: {
	                withCredentials: true
	            },
	            success: function success(res) {
	                var $jsOrderReturnContent = $('.js-order-return-content');
	
	                $jsOrderReturnContent.html(res);
	                var $errorMessages = $('.js-order-return-form .error-message');
	                bornModules.toggle.init();
	
	                // Disable "NEXT STEP" button in case if items  were returned or not eligible
	                initHasReturnsBehaviour();
	
	                // In order to hide Continue button if no returns selected or not applied terms
	                $('.input-radio, .js-accept-terms').trigger('change');
	
	                // Replace default select with selectic
	                if ($jsOrderReturnContent.length) {
	                    bornModules.selectTags.init('.js-return-reason-select');
	                }
	
	                if ($errorMessages.length) {
	                    scrollPage($errorMessages.eq(0).closest('.line-item').prev().prevObject.offset().top);
	                } else {
	                    scrollPage(0);
	                }
	                progress.hide($form);
	                barcode.initBarcodeByElements('.js-order-return-content .barcode-js');
	            },
	            error: function error() {
	                progress.hide($form);
	            },
	            complete: function complete() {
	                orderProgressBarDisplay();
	            }
	        });
	    });
	
	    // Hide continue button if no returns selected
	    $form.on('change', '.input-radio', function () {
	        var $returnRadios = $('.js-return-radio:checked'),
	            $submitButton = $form.find(".js-continue-button");
	        if ($returnRadios.length) {
	            $submitButton.removeAttr('disabled');
	        } else {
	            $submitButton.attr('disabled', 'disabled');
	        }
	    });
	
	    // Accept terms
	    $form.on('change', '.js-accept-terms', function () {
	        var $termsCbox = $(this);
	        var isCheckedTermsCbox = $termsCbox.is(':checked');
	        var $submitButton = $form.find('.js-continue-button');
	
	        if (sessionStorage.getItem('hasCheckedTerms')) {
	            $termsCbox.prop('checked', true);
	            isCheckedTermsCbox = true;
	            sessionStorage.removeItem('hasCheckedTerms');
	        }
	
	        if (isCheckedTermsCbox) {
	            $form.removeClass('has-not-checked-terms');
	            $submitButton.removeAttr('disabled');
	        } else {
	            $submitButton.attr('disabled', 'disabled');
	        }
	    }).on('click', '.js-continue-button-area', function () {
	        var isCheckedTermsCbox = $('.js-accept-terms').is(':checked');
	
	        if (!isCheckedTermsCbox) {
	            $form.addClass('has-not-checked-terms');
	        }
	    }).on('click', '.js-return-back', function () {
	        var isCheckedTermsCbox = $('.js-accept-terms').is(':checked');
	
	        if (isCheckedTermsCbox) {
	            sessionStorage.setItem('hasCheckedTerms', 'true');
	        }
	    });
	}
	
	// Order progress expand Animation
	function orderProgressExpand() {
	    $(document).ready(function () {
	        orderProgressBarDisplay();
	    });
	}
	
	function orderProgressBarDisplay() {
	    var valueElement = $('.progress-stage'),
	        value = 1;
	    if (valueElement.length > 0) {
	        valueElement.each(function () {
	            value = parseInt($(this).val());
	            var parentEl = $(this).closest('.order--details__progress');
	            parentEl.find('.progress-bar__expandable').addClass('stage-' + value);
	            value > 0 && parentEl.find('.progress-bar__step').slice(0, value).addClass('active');
	        });
	    }
	}
	
	/* Utility function used to check and uncheck interests 
	 Scenarios : 
	 1. Selected interest is ALL then we should uncheck individual interests.
	 2. Selected interest in Individual interests then we should uncheck ALL interest checkbox. 
	    As customer is selecting individual interests.
	*/
	function customerInterestsOnChangeEvent() {
	    $("input[name=dwfrm_profile_customer_interests]").on('change', function (e) {
	        var interests = $("input[name=dwfrm_profile_customer_interests]");
	        /* Selected interest is ALL*/
	        if ($(this).val().toUpperCase() == 'ALL') {
	            $(interests).each(function () {
	                if ($(this).val().toUpperCase() != 'ALL') {
	                    $(this).prop('checked', false);
	                }
	            });
	        }
	        /* Selected interest is individual then uncheck ALL interest checkbox*/
	        if ($(this).val().toUpperCase() != 'ALL') {
	            $(interests).each(function () {
	                if ($(this).val().toUpperCase() == 'ALL') {
	                    $(this).prop('checked', false);
	                }
	            });
	        }
	    });
	}
	
	//   To toggle item from returning list on clicking same checkbox
	function toggleReturnItem() {
	    $('body').off('click.toggleReturn').on('click.toggleReturn', '.select-item-for-return .control-label', function (e) {
	        var $toggleOffRadio = $($(this).data('toggleoffid'));
	        if ($toggleOffRadio.is(':checked')) {
	            return;
	        }
	        e.preventDefault();
	        $toggleOffRadio.prop('checked', true);
	
	        if ($('input[type=radio]:checked.js-return-radio').length <= 0) {
	            $('.js-order-return-form').find('.js-continue-button').attr('disabled', 'disabled');
	        }
	    });
	}
	
	//  Quantity buttons +/- action
	function qtyActions() {
	    $('body').off('click.qtyActionMinus').off('click.qtyActionPlus');
	    $('body').on('click.qtyActionMinus', '.line-item-quantity .qty-input .button.minus', function () {
	        var $input = $(this).parent().find('input');
	        var val = parseInt($input.val());
	        if (val === 1) return;
	        $input.val(--val);
	    }).on('click.qtyActionPlus', '.line-item-quantity .qty-input .button.plus', function () {
	        var $input = $(this).parent().find('input');
	        var maxQty = parseInt($input.data('available'));
	        var val = parseInt($input.val());
	        if (val === maxQty) return;
	        $input.val(++val);
	    });
	}
	
	function toggleReturnTypeTabs() {
	    $('.returns__type--tabs button').on('click', function () {
	        $(this).addClass('active').siblings().removeClass('active');
	        $('.returns__type--tabs-content, .returns__type--tabs-pagination').removeClass('active');
	        $($(this).data('toggle')).addClass('active');
	    });
	}
	
	/**
	 * @private
	 * @function
	 * @description Binds the events of the order, address and payment pages
	 */
	function initializeEvents() {
	    toggleFullOrder();
	    initAddressEvents();
	    dynamicAddress.init('.account__dynamic-address');
	    initPaymentEvents();
	    login.init();
	    initializeReturnForm();
	    tooltip.init();
	    orderProgressExpand();
	    toggleReturnTypeTabs();
	    if (window.history.replaceState) {
	        window.history.replaceState(null, null, window.location.href);
	    }
	    customerInterestsOnChangeEvent();
	
	    $('.positivenumber').on('input', function (e) {
	        this.value = this.value.replace(/\D/g, '');
	    });
	    selectAddressType();
	    customTooltip.initShippingFeeCustomToolTipEvents();
	
	    if (typeof initAccountPageEvents === 'function') {
	        initAccountPageEvents();
	    }
	    barcode.init();
	}
	var account = {
	    init: function init() {
	        initializeEvents();
	        giftcert.init();
	    },
	    initCartLogin: function initCartLogin() {
	        login.init();
	    },
	    customerInterestsOnChangeEvent: customerInterestsOnChangeEvent
	};
	
	module.exports = account;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ajax = __webpack_require__(42),
	    minicart = __webpack_require__(62),
	    util = __webpack_require__(15),
	    nameHolder = document.querySelector('#dtName'),
	    amountHolder = document.querySelector('#dtAmount');
	
	function updatePlaceholder() {
	    var formNameInput = document.querySelector('#dwfrm_giftcert_purchase_recipient'),
	        formAmountSelect = document.querySelector('select[name=dwfrm_giftcert_purchase_amount]');
	
	    // set initial values (necessary for when editing a gift cert.)
	    nameHolder.textContent = formNameInput.value;
	    amountHolder.textContent = formAmountSelect.options[formAmountSelect.selectedIndex].text;
	
	    // Update Name
	    formNameInput.addEventListener('input', function (event) {
	        nameHolder.textContent = formNameInput.value;
	    });
	
	    // Update Amount
	    $(formAmountSelect).on('change', function (event) {
	        amountHolder.textContent = formAmountSelect.options[formAmountSelect.selectedIndex].text;
	    });
	}
	
	var setAddToCartHandler = function setAddToCartHandler(e) {
	    e.preventDefault();
	    var form = $(this).closest('form');
	
	    if (!form.valid()) return false;
	
	    var options = {
	        url: util.ajaxUrl(form.attr('action')),
	        method: 'POST',
	        cache: false,
	        data: form.serialize()
	    };
	    $.ajax(options).done(function (response) {
	        if (response.success) {
	            ajax.load({
	                url: Urls.minicartGC,
	                data: { lineItemId: response.result.lineItemId },
	                callback: function callback(response) {
	                    minicart.show(response);
	                    form.find('input,textarea').val('').removeClass('valid');
	
	                    form.find('select').each(function () {
	                        this.selectedIndex = 0;
	                        $(this).trigger('change');
	                    });
	
	                    if (nameHolder) {
	                        nameHolder.textContent = '';
	                    }
	                }
	            });
	        } else {
	            form.find('span.error').hide();
	            for (var id in response.errors.FormErrors) {
	                var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
	                if (!$errorEl || $errorEl.length === 0) {
	                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
	                    $('#' + id).after($errorEl);
	                }
	                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
	            }
	        }
	    }).fail(function (xhr, textStatus) {
	        // failed
	        if (textStatus === 'parsererror') {
	            window.alert(Resources.BAD_RESPONSE);
	        } else {
	            window.alert(Resources.SERVER_CONNECTION_ERROR);
	        }
	    });
	};
	
	exports.init = function () {
	    $('#AddToBasketButton').on('click', setAddToCartHandler);
	
	    if (nameHolder) {
	        updatePlaceholder();
	    }
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var dialog = __webpack_require__(46),
	    page = __webpack_require__(58),
	    validator = __webpack_require__(56),
	    util = __webpack_require__(15);
	
	var login = {
	    /**
	     * @private
	     * @function
	     * @description init events for the loginPage
	     */
	    init: function init() {
	        //o-auth binding for which icon is clicked
	        $('.oAuthIcon').bind('click', function () {
	            $('#OAuthProvider').val(this.id);
	        });
	
	        //toggle the value of the rememberme checkbox
	        $('#dwfrm_login_rememberme').bind('change', function () {
	            if ($('#dwfrm_login_rememberme').attr('checked')) {
	                $('#rememberme').val('true');
	            } else {
	                $('#rememberme').val('false');
	            }
	        });
	
	        passwordResetPopup();
	
	        $(function () {
	            var docReferrer = document.referrer;
	            var headerHeight = $('.header__primary').get(0).getBoundingClientRect().height;
	            if (util.isMobile() && docReferrer.indexOf('PasswordResetDialog') >= 0) {
	                $([document.documentElement, document.body]).animate({
	                    scrollTop: $("#register_auth_section").offset().top - 50
	                }, 2000);
	            }
	            if (util.isMobile() && document.location.href.indexOf("register_auth_section") > -1) {
	                $([document.documentElement, document.body]).animate({
	                    scrollTop: $("#register_auth_section").offset().top - headerHeight
	                }, 1000);
	            }
	        });
	
	        initLoginActionEvents();
	    },
	    passwordResetPopup: passwordResetPopup,
	    initLoginActionEvents: initLoginActionEvents
	};
	
	function initLoginActionEvents() {
	
	    if (typeof initSignInEvents === 'function') {
	        initSignInEvents();
	    }
	
	    if (typeof initSignupEventProcess === 'function') {
	        initSignupEventProcess();
	    }
	
	    if (typeof initForgotPasswordEvents === 'function') {
	        initForgotPasswordEvents();
	    }
	}
	
	function passwordResetPopup() {
	    $('#password-reset').on('click', function (e) {
	        e.preventDefault();
	        moengagePushEvent("forgot_password_click");
	        dialog.open({
	            url: $(e.target).attr('href'),
	            options: {
	                modalID: 'overlay--forgot-pass',
	                modalClass: 'modal--forgot-pass align--center',
	                afterCreateCallback: function afterCreateCallback(overlay, Modal) {
	                    validator.init();
	                    var $requestPasswordForm = $('[name$="_requestpassword"]');
	                    var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
	                    $($submit).on('click', function (e) {
	                        if (!$requestPasswordForm.valid()) {
	                            return;
	                        }
	                        e.preventDefault();
	                        var data = $requestPasswordForm.serialize();
	                        // add form action to data
	                        data += '&' + $submit.attr('name') + '=';
	                        // make sure the server knows this is an ajax request
	                        if (data.indexOf('ajax') === -1) {
	                            data += '&format=ajax';
	                        }
	                        $.ajax({
	                            type: 'POST',
	                            url: $requestPasswordForm.attr('action'),
	                            data: data,
	                            success: function success(response) {
	                                if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
	                                    page.redirect(Urls.csrffailed);
	                                } else if (typeof response === 'string') {
	                                    Modal.updateModal(overlay, response);
	                                }
	                            },
	                            failure: function failure() {
	                                Modal.updateModal(overlay, '<h1>' + Resources.SERVER_ERROR + '</h1>');
	                            }
	                        });
	                    });
	                }
	            }
	        });
	    });
	}
	
	module.exports = login;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15),
	    bornModules = __webpack_require__(3).default,
	    formPrepare = __webpack_require__(93),
	    addressUtil = __webpack_require__(94);
	
	var addressMap = {
		default: {
			'postal_code': {
				selector: 'input[id$="_postal"]',
				type: 'short_name'
			},
			'postal_code_prefix': 'postal_code',
			'locality': {
				selector: '[id$="_city"]',
				type: 'long_name'
			},
			'neighborhood': 'locality',
			'administrative_area_level_1': {
				selector: '[id$="_states_state"]',
				type: 'both',
				isSelect: true
			}
		},
		gb: {
			'sublocality_level_1': {
				selector: '[id$="_address2"]',
				type: 'long_name'
			},
			'administrative_area_level_1': {
				selector: '[id$="_states_state"]',
				type: 'long_name'
			},
			'postal_town': {
				selector: '[id$="_city"]',
				type: 'long_name'
			}
		},
		se: {
			'postal_town': {
				selector: '[id$="_city"]',
				type: 'long_name'
			}
		},
		ae: {
			'sublocality_level_1': {
				selector: '[id$="_address2"]',
				type: 'long_name'
			}
		},
		sa: {
			'sublocality_level_1': {
				selector: '[id$="_address2"]',
				type: 'long_name'
			}
		},
		kw: {
			'premise': {
				selector: '[id$="_address1"]',
				type: 'long_name'
			},
			'route': {
				selector: '[id$="_address2"]',
				type: 'long_name'
			},
			'sublocality_level_1': {
				selector: '[id$="_area"]',
				type: 'long_name'
			},
			'locality': {
				selector: '[id$="_address3"]',
				type: 'long_name'
			}
		},
		sg: {},
		us: {
			'sublocality_level_1': {
				selector: '[id$="_city"]',
				type: 'long_name'
			}
		},
		lb: {
			'premise': {
				selector: '[id$="_address1"]',
				type: 'long_name'
			},
			'route': {
				selector: '[id$="_address2"]',
				type: 'long_name'
			},
			'locality': {
				selector: '[id$="_district"]',
				type: 'long_name'
			}
		}
	};
	
	function clearFields(targetContainer) {
		var elements = [];
		if (addressUtil.getFormCountry() == 'kw') {
			elements = targetContainer.querySelectorAll('input, select:not([name$="_city"])');
		} else {
			elements = targetContainer.querySelectorAll('input, select');
		}
	
		[].forEach.call(elements, function (element) {
			element.value = '';
		});
	}
	
	function getAddressFields(country, target, url, callback) {
		//If no target container is passed, do nothing cause we don't know where to place the reponse.
		if (!target) {
			return false;
		}
	
		callback = callback || function () {};
	
		var targetContainer = document.querySelector(target);
		// valueList = getFieldValues(targetContainer);
	
		url = url || window.Urls.getAddressForm;
	
		$(targetContainer).load(util.appendParamToURL(url, 'country', country), function () {
			// setFieldValues(valueList);
			//Makes sure fields are cleared even after being saved on the session.
			clearFields(targetContainer);
			callback();
			initAutocomplete(country);
			bornModules.selectTags.init();
			addressUtil.initGovernateEvents();
			addressUtil.updateGovernateArea();
			$('.positivenumber').on('input', function (e) {
				this.value = this.value.replace(/\D/g, '');
			});
		});
	}
	
	//Applies values to field
	function updateField(field, value, isSelect) {
		if (field) {
	
			if (isSelect) {
				field.value = field.nodeName === 'SELECT' ? value.short_name : value.long_name;
			} else {
				field.value = value;
			}
	
			$(field).trigger('change');
			$(field).valid();
			if ($(field).is('select') && !$(field).hasClass('select2-option')) {
				$(field).selectric('init');
			}
		}
	}
	
	//Gets the address data values from the country and property type
	function getAddressFormat(property, country) {
		var addressData = addressMap[country] && addressMap[country][property] ? addressMap[country][property] : addressMap['default'][property];
	
		//Call this function again to get the actual value in case a field is used to reference another.
		//Example 'postal_code_prefix': 'postal_code'
		//Means: 'postal_code_prefix' should use the properties from 'postal_code'.
		if (typeof addressData === 'string') {
			addressData = addressData === 'off' ? false : getAddressFormat(addressData);
		}
	
		return addressData;
	}
	
	//Loops through 'place' component and calls 'setFieldData' to map data into fields.
	function populateAddress(autocompleteField, country, targetContainer) {
		var place = this.getPlace(),
		    premiseName,
		    routeName,
		    streetNumber,
		    useRouteAsName = false;
	
		// empty address2 and address3
	
		if (document.querySelector('[id$="_address2"]') != null) {
			document.querySelector('[id$="_address2"]').value = '';
		}
		if (document.querySelector('[id$="_address3"]') != null) {
			document.querySelector('[id$="_address3"]').value = '';
		}
	
		place.address_components.forEach(function (component) {
			var componentType = component.types[0],
			    addressData = getAddressFormat(componentType, country);
	
			if (addressData) {
				var addressValue = addressData.type === 'both' ? component : component[addressData.type];
	
				updateField(document.querySelector(addressData.selector), addressValue, addressData.isSelect);
			}
	
			if (componentType === 'premise') {
				premiseName = component.long_name;
			}
	
			if (componentType === 'street_number') {
				streetNumber = component.long_name;
			}
	
			//Set these two independent values to determine if the Address Line 1 should use the 'route' data,
			//instead of the place.name data for better accuracy.
			if (componentType === 'route') {
				routeName = component.long_name;
			}
	
			if (componentType === 'postal_code' || componentType === 'postal_code_prefix') {
				useRouteAsName = component.short_name === place.name ? true : false;
			}
	
			//console.log(componentType, component.short_name, component.long_name);
		});
	
		//Resets the autocomplete field to avoid having a bunch of useless info there.
		//autocompleteField.value = useRouteAsName && routeName ? routeName : place.name;
		//autocompleteField.value = streetNumber && routeName ? streetNumber + ' ' + routeName : (useRouteAsName && routeName ? routeName : place.name);
	
		var location = premiseName && streetNumber && routeName ? premiseName + ' ' + streetNumber + ' ' + routeName : premiseName && streetNumber ? premiseName + ' ' + streetNumber : streetNumber && routeName ? streetNumber + ' ' + routeName : premiseName ? premiseName : streetNumber ? streetNumber : routeName ? routeName : place.name;
	
		// trim returned text to 35 char max according to client requirement
		autocompleteField.value = location.substring(0, 35);
	
		//console.log(place);
	
		// this will fix the field validation issue when typing address in Arabic.
		$(autocompleteField).trigger('blur');
	
		if (addressUtil.getFormCountry() == 'kw') {
			if (!addressUtil.isDependentAddress()) {
				document.querySelector('[id$="_city"]').value = Resources.KUWAIT_CITY;
				$('[id$="_city"]').trigger('blur');
			}
		}
		formPrepare.validateForm();
	}
	
	function initAutocomplete(country, target) {
		var autocompleteField = document.querySelector('input[id$="_address1"]');
		if (!autocompleteField) {
			return;
		}
		var autocomplete = new google.maps.places.Autocomplete(autocompleteField, { types: ['geocode'] }),
		    targetContainer = document.querySelector(target);
	
		autocomplete.setComponentRestrictions({ 'country': country });
		autocomplete.addListener('place_changed', populateAddress.bind(autocomplete, autocompleteField, country, targetContainer));
	
		//prevents the autocomplete field from submitting from accidentally submitting the form.
		window.addEventListener('keydown', function (e) {
			if (e.target === autocompleteField && e.keyCode === 13) {
				e.preventDefault();
			}
		});
		formPrepare.validateForm();
	}
	
	exports.init = function (target, url) {
		var countrySelector = document.querySelector('[id$="_country"]');
	
		if (countrySelector) {
			//Uses jQuery in order to easily trigger the 'change' event for Selectric.
			$(countrySelector).on('change', function () {
				var country = this.value;
				if (country) {
					$(target).closest('form').find('.phone').intlTelInput('setCountry', country).val('');
				}
				getAddressFields(this.value, target, url);
			});
	
			initAutocomplete(countrySelector.value, target);
		}
		addressUtil.init();
	};
	
	exports.getAddressFields = getAddressFields;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(7);
	
	var $form, $continue, $requiredInputs, validator, $cardList, requiredValues;
	
	var hasEmptyRequired = function hasEmptyRequired() {
	
	    if ($cardList.length > 0 && $('#is-CREDIT_CARD').is(':checked') || $cardList.length === 0 && $('#is-CREDIT_CARD').is(':checked') && $('[id$="billing_addressList"]').is(':visible')) {
	        var $addressFormValues = $('.required', '.js-address').find(':input:not(.selectric-input)');
	        var $cardValues = $('.required', '.order--checkout__ccnew').find(':input:not(.selectric-input)');
	        var $savedCardCVN = $(':input:not(.selectric-input).required', '.cvv-wrapper');
	        $requiredInputs = $.merge($addressFormValues, $.merge($cardValues, $savedCardCVN));
	
	        requiredValues = $requiredInputs.map(function () {
	            return $(this).val();
	        });
	    } else {
	        requiredValues = $requiredInputs.filter(':visible').map(function () {
	            return $(this).val();
	        });
	    }
	    return _(requiredValues).includes('');
	};
	
	var validateForm = function validateForm() {
	    // only validate form when all required fields are filled to avoid
	    // throwing errors on empty form
	    if (!validator) {
	        return;
	    }
	    if (!hasEmptyRequired()) {
	        if (validator.form()) {
	            var radiobuttons = $('input[name$="_addressList"]'),
	                isAddressInactive = $('input[name$="Address"]').hasClass('toggle--active'),
	                isChecked = false,
	                isVisible = $('.order--checkout--limit').is(':visible') || $('.address-preview').length > 0 && !$('.address-preview').hasClass('hidden') || $('#shippingBillingSame').length > 0 && $('#shippingBillingSame').val() == 'on';
	
	            if (radiobuttons.length && !isAddressInactive && !isVisible) {
	                for (var i = 0; i < radiobuttons.length; i++) {
	                    if (radiobuttons[i].type === 'radio' && radiobuttons[i].checked) {
	                        isChecked = true;
	                    } else {
	                        $continue.prop('disabled', true);
	                    }
	                }if (isChecked) {
	                    $continue.prop('disabled', false).trigger('enabled');
	                }
	            } else {
	                $continue.prop('disabled', false).trigger('enabled');
	            }
	        }
	    } else {
	        // $continue.attr('disabled', 'disabled');
	        $continue.prop('disabled', true);
	    }
	};
	
	var validateEl = function validateEl() {
	    if ($(this).val() === '') {
	        // $continue.attr('disabled', 'disabled');
	        $continue.prop('disabled', true);
	    } else {
	        var notIgnored = $(this).not(validator.settings.ignore)[0];
	        if (!hasEmptyRequired() && (!notIgnored || validator.valid(this))) {
	            // $continue.removeAttr('disabled');
	            $continue.prop('disabled', false).trigger('enabled');
	        } else {
	            // $continue.attr('disabled', 'disabled');
	            $continue.prop('disabled', true);
	        }
	    }
	};
	
	var init = function init(opts) {
	    if (!opts.formSelector || !opts.continueSelector) {
	        throw new Error('Missing form and continue action selectors.');
	    }
	    $form = $(opts.formSelector);
	    $continue = $(opts.continueSelector);
	
	    validator = $form.validate();
	    $cardList = $form.find('[id$="ckoCreditCardList"]');
	    $requiredInputs = $('.required', $form).find(':input:not(.selectric-input)');
	    validateForm();
	    // start listening
	    $requiredInputs.on('change', validateEl);
	    $requiredInputs.filter('input').on('keyup', _.debounce(validateEl, 200)).on('change', function () {
	        validateEl();
	        $(this).valid();
	    });
	};
	
	exports.init = init;
	exports.validateForm = validateForm;
	exports.validateEl = validateEl;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(10),
	    formPrepare = __webpack_require__(93);
	var progress = __webpack_require__(43);
	
	function updateGovernateArea(init) {
		var governate = getGovernateEl();
		if (!governate) {
			return;
		}
		if (window.governateArea !== undefined) {
			removeAreaSelector(init);
			updateAddressArea(init);
			return;
		}
		if (init === undefined) {
			init = false;
		}
	
		if (!governate) {
			return;
		}
		governate = governate ? $(governate).val() : false;
	
		var findUrl = Urls.getGovernateArea;
		if (!findUrl) {
			return;
		}
		try {
			$.ajax({
				type: 'POST',
				url: findUrl,
				data: { governate: governate },
				beforeSend: function beforeSend() {
					removeAreaSelector(init);
				},
				success: afterSuccess,
				error: function error() {},
				complete: function complete() {}
			});
		} catch (e) {
			console.log(e);
		}
	}
	
	function afterSuccess(response, init) {
		if (response && response.status !== undefined && response.status == true) {
			window.governateArea = response.list;
			updateAddressArea(init);
		}
	}
	
	function getGovernateEl() {
		return document.querySelector('[id$="_' + parentFieldName() + '"]');
	}
	
	function getAreaSelectorEl() {
		return document.querySelector('[id$="_' + childFieldName() + '"]');
	}
	
	function getInitAreaValue() {
		var selectedAddrssEl = $('input[name$="_addressList"]:checked');
		var isUnsaved = $('[id$="_unsavedAddressBook"]').is(':checked');
		if (!isUnsaved && selectedAddrssEl && selectedAddrssEl.length > 0) {
			var selectedAddress = selectedAddrssEl.data('address');
			var fieldName = childFieldName();
			if (selectedAddress && selectedAddress[fieldName] !== undefined) {
				return selectedAddress[fieldName];
			}
		}
	
		var initArea = document.querySelector('[id$="_initareavalue"]');
		if (initArea) {
			return initArea.value;
		}
		return '';
	}
	
	function getInitGovernateValue() {
		var selectedAddrssEl = $('input[name$="_addressList"]:checked');
		if (selectedAddrssEl && selectedAddrssEl.length > 0) {
			var selectedAddress = selectedAddrssEl.data('address');
			var fieldName = parentFieldName();
			if (selectedAddress && selectedAddress[fieldName] !== undefined) {
				return selectedAddress[fieldName];
			}
		}
	
		return '';
	}
	
	function getFormCountry() {
		var countryEl = $('[name$="_country"]');
		if (countryEl && countryEl.length > 0) {
			return countryEl.val();
		}
		return '';
	}
	
	function parentFieldName() {
		var config = SitePreferences.SITE_SPECIFIC_CONFIGS && JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
		var country = getFormCountry();
	
		if (config && country && config.addressForm !== undefined && config.addressForm[country] !== undefined && config.addressForm[country].parent !== undefined && config.addressForm[country].parent.trim() != '') {
			return config.addressForm[country].parent;
		} else {
			return 'governate';
		}
	}
	
	function childFieldName() {
		var config = SitePreferences.SITE_SPECIFIC_CONFIGS && JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
		var country = getFormCountry();
		if (config && country && config.addressForm !== undefined && config.addressForm[country] !== undefined && config.addressForm[country].child !== undefined && config.addressForm[country].child.trim() != '') {
			return config.addressForm[country].child;
		} else {
			return 'area';
		}
	}
	
	function isDependentAddress() {
		var config = SitePreferences.SITE_SPECIFIC_CONFIGS && JSON.parse(SitePreferences.SITE_SPECIFIC_CONFIGS);
		var country = getFormCountry();
		if (config && country && config.addressForm !== undefined && config.addressForm[country] !== undefined && config.addressForm[country].child !== undefined && config.addressForm[country].child.trim() != '') {
			return true;
		} else {
			return false;
		}
	}
	
	function updateAddressArea(init) {
		if (window.governateArea === undefined) {
			return;
		}
	
		if (init === undefined) {
			init = false;
		}
		var governate = getGovernateEl();
		if (!governate) {
			return;
		}
		var country = getFormCountry();
		if (!country) {
			return;
		}
		country = country.toUpperCase();
		var areasList;
		if (window.governateArea[country] === undefined) {
			areasList = window.governateArea[governate.value];
		} else {
			areasList = window.governateArea[country][governate.value];
		}
	
		if (areasList === undefined || areasList.areas === undefined) {
			return;
		}
		var areaSelector = getAreaSelectorEl();
		var initValue = getInitAreaValue();
		var lists = areasList.areas;
		$(governate).trigger('blur');
		if (areaSelector && lists.length > 0) {
			areaSelector = getAreaSelectorEl();
			$(areaSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_ADDRESS_AREA + '">' + Resources.SELECT_ADDRESS_AREA + '</option>');
			for (var i = 0; i < lists.length; i++) {
				if (lists[i] && lists[i].trim()) {
					$(areaSelector).append('<option class="select-option" label="' + lists[i] + '">' + lists[i] + '</option>');
				}
			}
			if (initValue) {
				$(areaSelector).val(initValue);
			} else {
				$(areaSelector).prop('selectedIndex', 0).val('');
			}
			$(areaSelector).trigger('change');
		} else {
			removeAreaSelector();
			$(areaSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_ADDRESS_AREA + '">' + Resources.SELECT_ADDRESS_AREA + '</option>');
		}
		updateFields();
	}
	
	function removeAreaSelector(init) {
		if (init === undefined) {
			init = false;
		}
		var areaSelector = getAreaSelectorEl();
		var initArea = document.querySelector('[id$="_initareavalue"]');
		var initValue = '';
		if (init == true && initArea) {
			initValue = $(initArea).val();
		}
	
		if (areaSelector && areaSelector.length > 0) {
			if (!$(areaSelector).hasClass('select2-option')) {
				$(areaSelector).selectric('init');
			}
			$(areaSelector).empty();
			$(areaSelector).trigger('blur');
		}
	}
	
	function updateGovernateInfo() {
		var governate = getGovernateEl();
		if (!governate) {
			return;
		}
	
		var governateVal = getInitGovernateValue();
		if (governateVal) {
			$(governate).val(governateVal).trigger('blur').trigger('change');
		}
	}
	
	function initGovernateEvents() {
		var governateSelector = getGovernateEl();
		if (governateSelector) {
			var initGovernateValue = governateSelector.value;
			var governateSelectorEl = $(governateSelector);
			if (!governateSelectorEl.hasClass('select2-option')) {
				governateSelectorEl.off('change');
			}
			governateSelectorEl.on('change', function (e) {
				e.stopPropagation();
				if (initGovernateValue != $(this).val()) {
					updateGovernateArea();
					initGovernateValue = $(this).val();
				}
				if ($(this).val() == '' && !governateSelectorEl.hasClass('select2-option')) {
					$(this).selectric('refresh');
				}
			});
			formPrepare.validateForm();
		}
		initAreaField();
	}
	
	function initAreaField() {
		var areaSelector = getAreaSelectorEl();
		if (areaSelector) {
			$(areaSelector).on('change', function (e) {
				e.stopPropagation();
				$(this).trigger('blur');
				formPrepare.validateForm();
			});
		}
	}
	
	function updateFields() {
		var governateSelector = getGovernateEl();
		var areaSelector = getAreaSelectorEl();
		if (governateSelector) {
			$(governateSelector).trigger('blur');
			if (!$(governateSelector).hasClass('select2-option')) {
				$(governateSelector).selectric('refresh');
			}
			if (areaSelector) {
				$(areaSelector).trigger('blur');
				if (!$(areaSelector).hasClass('select2-option')) {
					$(areaSelector).selectric('refresh');
				}
			}
			formPrepare.validateForm();
		}
	}
	exports.init = function () {
		var governateSelector = getGovernateEl();
		if (governateSelector) {
			var initGovernateValue = governateSelector.value;
			var governateSelectorEl = $(governateSelector);
			if (!governateSelectorEl.hasClass('select2-option')) {
				governateSelectorEl.off('change');
			}
			governateSelectorEl.on('change', function (e) {
				e.stopPropagation();
				if (initGovernateValue != $(this).val()) {
					updateGovernateArea();
					initGovernateValue = $(this).val();
				}
				if ($(this).val() == '' && !governateSelectorEl.hasClass('select2-option')) {
					$(this).selectric('refresh');
				}
			});
			updateGovernateArea(true);
		}
		initAreaField();
	};
	
	function getAddressFields() {
		return '[name*="_addressFields"]';
	}
	
	exports.updateGovernateArea = updateGovernateArea;
	exports.updateGovernateInfo = updateGovernateInfo;
	exports.initGovernateEvents = initGovernateEvents;
	exports.updateFields = updateFields;
	exports.getFormCountry = getFormCountry;
	exports.getAddressFields = getAddressFields;
	exports.isDependentAddress = isDependentAddress;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	    var rowId = 1;
	    $('.b2b_add_product').on('click', function (e) {
	        var rowCount = $(".sku-qtt-row").length;
	        if (rowCount == 1) {
	            $(".sku-qtt-row .b2b_delete_row").toggle();
	        }
	        if (rowCount < 10) {
	            $('.sku-qtt-container').append('<div class="sku-qtt-row">\n                    <div class="sku-qtt-item input-sku">\n                        <label for="b2b_product_' + ++rowId + '">' + Resources.B2B_PRODUCT_SKU + ('</label>\n                        <input class="input-text valid" type="text"  id="b2b_product_' + rowId + '" name="b2b_product_sku" value="" maxlength="20" placeholder="') + Resources.B2B_PRODUCT_SKU_PH + ('" aria-invalid="false"/>\n                    </div>\n                    <div class="sku-qtt-item input-qtt">\n                        <label for="prod_quantity_' + rowId + '">') + Resources.B2B_QUANTITY + ('</label>\n                        <input class="input-text valid" type="number" id="prod_quantity_' + rowId + '" name="b2b_quantity" placeholder="0" maxlength="100" aria-invalid="false"/>\n                    </div>\n                    <div class="btn-col">\n                        <button type="button" class="sku-qtt-item b2b_delete_row">\n                            <span class="icon--remove"></span>\n                            <span class="display--small-up text">') + Resources.REMOVE + '</span>\n                        </button>\n                    </div>\n                </div>');
	        }
	        if (rowCount + 1 == 10) {
	            $('.b2b_add_product').attr('disabled', true);
	        }
	    });
	
	    $('.sku-qtt-container').on('click', '.b2b_delete_row', function () {
	        $(this).closest('.sku-qtt-row').remove();
	        $('.b2b_add_product').attr('disabled', false);
	        var rowCount = $('.sku-qtt-row').length;
	        if (rowCount == 1) {
	            $(".sku-qtt-row .b2b_delete_row").toggle();
	        }
	    });
	});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var JsBarcode = __webpack_require__(97),
	    dialog = __webpack_require__(46);
	
	/**
	 * @function init
	 * @description Initializes the barcodes
	 */
	exports.init = function () {
	    var barcodes = $('.barcode-js');
	    var barcodeElId;
	    if (barcodes.length > 0) {
	        barcodes.each(function (key, barcode) {
	            if (barcode.id !== undefined) {
	                barcodeElId = '#' + barcode.id;
	                JsBarcode(barcodeElId).init();
	            }
	        });
	        initViewBarcodeModal();
	    }
	};
	function initViewBarcodeModal() {
	    $('.barcode-container .view-barcode').on('click', function (e) {
	        e.preventDefault();
	        var id = $(this).data('id');
	        if (id !== undefined) {
	            viewBarcodeModel(id);
	        }
	    });
	}
	function viewBarcodeModel(id) {
	    var htmlEl = $('#history-code-' + id).clone();
	    if (!htmlEl || htmlEl.length <= 0) {
	        return;
	    }
	    dialog.open({
	        html: htmlEl[0],
	        options: {
	            width: 400,
	            modalClass: 'modal--barcode align--center',
	            buttons: [{
	                click: function click() {
	                    $(this).dialog('close');
	                }
	            }]
	        }
	    });
	}
	
	exports.initBarcodeByElements = function (el) {
	    if (!el || $(el).length <= 0) {
	        return;
	    }
	    var barcodeElId;
	    $(el).each(function (key, barcode) {
	        if (barcode.id !== undefined) {
	            barcodeElId = '#' + barcode.id;
	            JsBarcode(barcodeElId).init();
	        }
	    });
	    initViewBarcodeModal();
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _barcodes = __webpack_require__(98);
	
	var _barcodes2 = _interopRequireDefault(_barcodes);
	
	var _merge = __webpack_require__(137);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _linearizeEncodings = __webpack_require__(138);
	
	var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);
	
	var _fixOptions = __webpack_require__(139);
	
	var _fixOptions2 = _interopRequireDefault(_fixOptions);
	
	var _getRenderProperties = __webpack_require__(140);
	
	var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);
	
	var _optionsFromStrings = __webpack_require__(142);
	
	var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);
	
	var _ErrorHandler = __webpack_require__(150);
	
	var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
	
	var _exceptions = __webpack_require__(149);
	
	var _defaults = __webpack_require__(143);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The protype of the object returned from the JsBarcode() call
	
	
	// Help functions
	var API = function API() {};
	
	// The first call of the library API
	// Will return an object with all barcodes calls and the data that is used
	// by the renderers
	
	
	// Default values
	
	
	// Exceptions
	// Import all the barcodes
	var JsBarcode = function JsBarcode(element, text, options) {
		var api = new API();
	
		if (typeof element === "undefined") {
			throw Error("No element to render on was provided.");
		}
	
		// Variables that will be pased through the API calls
		api._renderProperties = (0, _getRenderProperties2.default)(element);
		api._encodings = [];
		api._options = _defaults2.default;
		api._errorHandler = new _ErrorHandler2.default(api);
	
		// If text is set, use the simple syntax (render the barcode directly)
		if (typeof text !== "undefined") {
			options = options || {};
	
			if (!options.format) {
				options.format = autoSelectBarcode();
			}
	
			api.options(options)[options.format](text, options).render();
		}
	
		return api;
	};
	
	// To make tests work TODO: remove
	JsBarcode.getModule = function (name) {
		return _barcodes2.default[name];
	};
	
	// Register all barcodes
	for (var name in _barcodes2.default) {
		if (_barcodes2.default.hasOwnProperty(name)) {
			// Security check if the propery is a prototype property
			registerBarcode(_barcodes2.default, name);
		}
	}
	function registerBarcode(barcodes, name) {
		API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
			var api = this;
			return api._errorHandler.wrapBarcodeCall(function () {
				// Ensure text is options.text
				options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;
	
				var newOptions = (0, _merge2.default)(api._options, options);
				newOptions = (0, _optionsFromStrings2.default)(newOptions);
				var Encoder = barcodes[name];
				var encoded = encode(text, Encoder, newOptions);
				api._encodings.push(encoded);
	
				return api;
			});
		};
	}
	
	// encode() handles the Encoder call and builds the binary string to be rendered
	function encode(text, Encoder, options) {
		// Ensure that text is a string
		text = "" + text;
	
		var encoder = new Encoder(text, options);
	
		// If the input is not valid for the encoder, throw error.
		// If the valid callback option is set, call it instead of throwing error
		if (!encoder.valid()) {
			throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
		}
	
		// Make a request for the binary data (and other infromation) that should be rendered
		var encoded = encoder.encode();
	
		// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
		// Convert to [1-1, 1-2, 2, 3-1, 3-2]
		encoded = (0, _linearizeEncodings2.default)(encoded);
	
		// Merge
		for (var i = 0; i < encoded.length; i++) {
			encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
		}
	
		return encoded;
	}
	
	function autoSelectBarcode() {
		// If CODE128 exists. Use it
		if (_barcodes2.default["CODE128"]) {
			return "CODE128";
		}
	
		// Else, take the first (probably only) barcode
		return Object.keys(_barcodes2.default)[0];
	}
	
	// Sets global encoder options
	// Added to the api by the JsBarcode function
	API.prototype.options = function (options) {
		this._options = (0, _merge2.default)(this._options, options);
		return this;
	};
	
	// Will create a blank space (usually in between barcodes)
	API.prototype.blank = function (size) {
		var zeroes = new Array(size + 1).join("0");
		this._encodings.push({ data: zeroes });
		return this;
	};
	
	// Initialize JsBarcode on all HTML elements defined.
	API.prototype.init = function () {
		// Should do nothing if no elements where found
		if (!this._renderProperties) {
			return;
		}
	
		// Make sure renderProperies is an array
		if (!Array.isArray(this._renderProperties)) {
			this._renderProperties = [this._renderProperties];
		}
	
		var renderProperty;
		for (var i in this._renderProperties) {
			renderProperty = this._renderProperties[i];
			var options = (0, _merge2.default)(this._options, renderProperty.options);
	
			if (options.format == "auto") {
				options.format = autoSelectBarcode();
			}
	
			this._errorHandler.wrapBarcodeCall(function () {
				var text = options.value;
				var Encoder = _barcodes2.default[options.format.toUpperCase()];
				var encoded = encode(text, Encoder, options);
	
				render(renderProperty, encoded, options);
			});
		}
	};
	
	// The render API call. Calls the real render function.
	API.prototype.render = function () {
		if (!this._renderProperties) {
			throw new _exceptions.NoElementException();
		}
	
		if (Array.isArray(this._renderProperties)) {
			for (var i = 0; i < this._renderProperties.length; i++) {
				render(this._renderProperties[i], this._encodings, this._options);
			}
		} else {
			render(this._renderProperties, this._encodings, this._options);
		}
	
		return this;
	};
	
	API.prototype._defaults = _defaults2.default;
	
	// Prepares the encodings and calls the renderer
	function render(renderProperties, encodings, options) {
		encodings = (0, _linearizeEncodings2.default)(encodings);
	
		for (var i = 0; i < encodings.length; i++) {
			encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
			(0, _fixOptions2.default)(encodings[i].options);
		}
	
		(0, _fixOptions2.default)(options);
	
		var Renderer = renderProperties.renderer;
		var renderer = new Renderer(renderProperties.element, encodings, options);
		renderer.render();
	
		if (renderProperties.afterRender) {
			renderProperties.afterRender();
		}
	}
	
	// Export to browser
	if (typeof window !== "undefined") {
		window.JsBarcode = JsBarcode;
	}
	
	// Export to jQuery
	/*global jQuery */
	if (typeof jQuery !== 'undefined') {
		jQuery.fn.JsBarcode = function (content, options) {
			var elementArray = [];
			jQuery(this).each(function () {
				elementArray.push(this);
			});
			return JsBarcode(elementArray, content, options);
		};
	}
	
	// Export to commonJS
	module.exports = JsBarcode;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _CODE = __webpack_require__(99);
	
	var _CODE2 = __webpack_require__(101);
	
	var _EAN_UPC = __webpack_require__(109);
	
	var _ITF = __webpack_require__(119);
	
	var _MSI = __webpack_require__(123);
	
	var _pharmacode = __webpack_require__(130);
	
	var _codabar = __webpack_require__(131);
	
	var _CODE3 = __webpack_require__(132);
	
	var _GenericBarcode = __webpack_require__(136);
	
	exports.default = {
		CODE39: _CODE.CODE39,
		CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
		EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
		ITF14: _ITF.ITF14,
		ITF: _ITF.ITF,
		MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
		pharmacode: _pharmacode.pharmacode,
		codabar: _codabar.codabar,
		CODE93: _CODE3.CODE93, CODE93FullASCII: _CODE3.CODE93FullASCII,
		GenericBarcode: _GenericBarcode.GenericBarcode
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.CODE39 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/Code_39#Encoding
	
	var CODE39 = function (_Barcode) {
		_inherits(CODE39, _Barcode);
	
		function CODE39(data, options) {
			_classCallCheck(this, CODE39);
	
			data = data.toUpperCase();
	
			// Calculate mod43 checksum if enabled
			if (options.mod43) {
				data += getCharacter(mod43checksum(data));
			}
	
			return _possibleConstructorReturn(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
		}
	
		_createClass(CODE39, [{
			key: "encode",
			value: function encode() {
				// First character is always a *
				var result = getEncoding("*");
	
				// Take every character and add the binary representation to the result
				for (var i = 0; i < this.data.length; i++) {
					result += getEncoding(this.data[i]) + "0";
				}
	
				// Last character is always a *
				result += getEncoding("*");
	
				return {
					data: result,
					text: this.text
				};
			}
		}, {
			key: "valid",
			value: function valid() {
				return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
			}
		}]);
	
		return CODE39;
	}(_Barcode3.default);
	
	// All characters. The position in the array is the (checksum) value
	
	
	var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];
	
	// The decimal representation of the characters, is converted to the
	// corresponding binary with the getEncoding function
	var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];
	
	// Get the binary representation of a character by converting the encodings
	// from decimal to binary
	function getEncoding(character) {
		return getBinary(characterValue(character));
	}
	
	function getBinary(characterValue) {
		return encodings[characterValue].toString(2);
	}
	
	function getCharacter(characterValue) {
		return characters[characterValue];
	}
	
	function characterValue(character) {
		return characters.indexOf(character);
	}
	
	function mod43checksum(data) {
		var checksum = 0;
		for (var i = 0; i < data.length; i++) {
			checksum += characterValue(data[i]);
		}
	
		checksum = checksum % 43;
		return checksum;
	}
	
	exports.CODE39 = CODE39;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Barcode = function Barcode(data, options) {
		_classCallCheck(this, Barcode);
	
		this.data = data;
		this.text = options.text || data;
		this.options = options;
	};
	
	exports.default = Barcode;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CODE128C = exports.CODE128B = exports.CODE128A = exports.CODE128 = undefined;
	
	var _CODE128_AUTO = __webpack_require__(102);
	
	var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);
	
	var _CODE128A = __webpack_require__(106);
	
	var _CODE128A2 = _interopRequireDefault(_CODE128A);
	
	var _CODE128B = __webpack_require__(107);
	
	var _CODE128B2 = _interopRequireDefault(_CODE128B);
	
	var _CODE128C = __webpack_require__(108);
	
	var _CODE128C2 = _interopRequireDefault(_CODE128C);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CODE128 = _CODE128_AUTO2.default;
	exports.CODE128A = _CODE128A2.default;
	exports.CODE128B = _CODE128B2.default;
	exports.CODE128C = _CODE128C2.default;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _CODE2 = __webpack_require__(103);
	
	var _CODE3 = _interopRequireDefault(_CODE2);
	
	var _auto = __webpack_require__(105);
	
	var _auto2 = _interopRequireDefault(_auto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CODE128AUTO = function (_CODE) {
		_inherits(CODE128AUTO, _CODE);
	
		function CODE128AUTO(data, options) {
			_classCallCheck(this, CODE128AUTO);
	
			// ASCII value ranges 0-127, 200-211
			if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
				var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
			} else {
				var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
			}
			return _possibleConstructorReturn(_this);
		}
	
		return CODE128AUTO;
	}(_CODE3.default);
	
	exports.default = CODE128AUTO;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	var _constants = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is the master class,
	// it does require the start code to be included in the string
	var CODE128 = function (_Barcode) {
		_inherits(CODE128, _Barcode);
	
		function CODE128(data, options) {
			_classCallCheck(this, CODE128);
	
			// Get array of ascii codes from data
			var _this = _possibleConstructorReturn(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));
	
			_this.bytes = data.split('').map(function (char) {
				return char.charCodeAt(0);
			});
			return _this;
		}
	
		_createClass(CODE128, [{
			key: 'valid',
			value: function valid() {
				// ASCII value ranges 0-127, 200-211
				return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
				);
			}
	
			// The public encoding function
	
		}, {
			key: 'encode',
			value: function encode() {
				var bytes = this.bytes;
				// Remove the start code from the bytes and set its index
				var startIndex = bytes.shift() - 105;
				// Get start set by index
				var startSet = _constants.SET_BY_CODE[startIndex];
	
				if (startSet === undefined) {
					throw new RangeError('The encoding does not start with a start character.');
				}
	
				if (this.shouldEncodeAsEan128() === true) {
					bytes.unshift(_constants.FNC1);
				}
	
				// Start encode with the right type
				var encodingResult = CODE128.next(bytes, 1, startSet);
	
				return {
					text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
					data:
					// Add the start bits
					CODE128.getBar(startIndex) +
					// Add the encoded bits
					encodingResult.result +
					// Add the checksum
					CODE128.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) +
					// Add the end bits
					CODE128.getBar(_constants.STOP)
				};
			}
	
			// GS1-128/EAN-128
	
		}, {
			key: 'shouldEncodeAsEan128',
			value: function shouldEncodeAsEan128() {
				var isEAN128 = this.options.ean128 || false;
				if (typeof isEAN128 === 'string') {
					isEAN128 = isEAN128.toLowerCase() === 'true';
				}
				return isEAN128;
			}
	
			// Get a bar symbol by index
	
		}], [{
			key: 'getBar',
			value: function getBar(index) {
				return _constants.BARS[index] ? _constants.BARS[index].toString() : '';
			}
	
			// Correct an index by a set and shift it from the bytes array
	
		}, {
			key: 'correctIndex',
			value: function correctIndex(bytes, set) {
				if (set === _constants.SET_A) {
					var charCode = bytes.shift();
					return charCode < 32 ? charCode + 64 : charCode - 32;
				} else if (set === _constants.SET_B) {
					return bytes.shift() - 32;
				} else {
					return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
				}
			}
		}, {
			key: 'next',
			value: function next(bytes, pos, set) {
				if (!bytes.length) {
					return { result: '', checksum: 0 };
				}
	
				var nextCode = void 0,
				    index = void 0;
	
				// Special characters
				if (bytes[0] >= 200) {
					index = bytes.shift() - 105;
					var nextSet = _constants.SWAP[index];
	
					// Swap to other set
					if (nextSet !== undefined) {
						nextCode = CODE128.next(bytes, pos + 1, nextSet);
					}
					// Continue on current set but encode a special character
					else {
							// Shift
							if ((set === _constants.SET_A || set === _constants.SET_B) && index === _constants.SHIFT) {
								// Convert the next character so that is encoded correctly
								bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
							}
							nextCode = CODE128.next(bytes, pos + 1, set);
						}
				}
				// Continue encoding
				else {
						index = CODE128.correctIndex(bytes, set);
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
	
				// Get the correct binary encoding and calculate the weight
				var enc = CODE128.getBar(index);
				var weight = index * pos;
	
				return {
					result: enc + nextCode.result,
					checksum: weight + nextCode.checksum
				};
			}
		}]);
	
		return CODE128;
	}(_Barcode3.default);
	
	exports.default = CODE128;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _SET_BY_CODE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// constants for internal usage
	var SET_A = exports.SET_A = 0;
	var SET_B = exports.SET_B = 1;
	var SET_C = exports.SET_C = 2;
	
	// Special characters
	var SHIFT = exports.SHIFT = 98;
	var START_A = exports.START_A = 103;
	var START_B = exports.START_B = 104;
	var START_C = exports.START_C = 105;
	var MODULO = exports.MODULO = 103;
	var STOP = exports.STOP = 106;
	var FNC1 = exports.FNC1 = 207;
	
	// Get set by start code
	var SET_BY_CODE = exports.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);
	
	// Get next set by code
	var SWAP = exports.SWAP = {
		101: SET_A,
		100: SET_B,
		99: SET_C
	};
	
	var A_START_CHAR = exports.A_START_CHAR = String.fromCharCode(208); // START_A + 105
	var B_START_CHAR = exports.B_START_CHAR = String.fromCharCode(209); // START_B + 105
	var C_START_CHAR = exports.C_START_CHAR = String.fromCharCode(210); // START_C + 105
	
	// 128A (Code Set A)
	// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
	var A_CHARS = exports.A_CHARS = "[\x00-\x5F\xC8-\xCF]";
	
	// 128B (Code Set B)
	// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
	var B_CHARS = exports.B_CHARS = "[\x20-\x7F\xC8-\xCF]";
	
	// 128C (Code Set C)
	// 00–99 (encodes two digits with a single code point) and FNC1
	var C_CHARS = exports.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";
	
	// CODE128 includes 107 symbols:
	// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
	// Each symbol consist of three black bars (1) and three white spaces (0).
	var BARS = exports.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(104);
	
	// Match Set functions
	var matchSetALength = function matchSetALength(string) {
		return string.match(new RegExp('^' + _constants.A_CHARS + '*'))[0].length;
	};
	var matchSetBLength = function matchSetBLength(string) {
		return string.match(new RegExp('^' + _constants.B_CHARS + '*'))[0].length;
	};
	var matchSetC = function matchSetC(string) {
		return string.match(new RegExp('^' + _constants.C_CHARS + '*'))[0];
	};
	
	// CODE128A or CODE128B
	function autoSelectFromAB(string, isA) {
		var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
		var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));
	
		if (untilC) {
			return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
		}
	
		var chars = string.match(new RegExp('^' + ranges + '+'))[0];
	
		if (chars.length === string.length) {
			return string;
		}
	
		return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
	}
	
	// CODE128C
	function autoSelectFromC(string) {
		var cMatch = matchSetC(string);
		var length = cMatch.length;
	
		if (length === string.length) {
			return string;
		}
	
		string = string.substring(length);
	
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) >= matchSetBLength(string);
		return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
	}
	
	// Detect Code Set (A, B or C) and format the string
	
	exports.default = function (string) {
		var newString = void 0;
		var cLength = matchSetC(string).length;
	
		// Select 128C if the string start with enough digits
		if (cLength >= 2) {
			newString = _constants.C_START_CHAR + autoSelectFromC(string);
		} else {
			// Select A/B depending on the longest match
			var isA = matchSetALength(string) > matchSetBLength(string);
			newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
		}
	
		return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
		function (match, char) {
			return String.fromCharCode(203) + char;
		});
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CODE2 = __webpack_require__(103);
	
	var _CODE3 = _interopRequireDefault(_CODE2);
	
	var _constants = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CODE128A = function (_CODE) {
		_inherits(CODE128A, _CODE);
	
		function CODE128A(string, options) {
			_classCallCheck(this, CODE128A);
	
			return _possibleConstructorReturn(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants.A_START_CHAR + string, options));
		}
	
		_createClass(CODE128A, [{
			key: 'valid',
			value: function valid() {
				return new RegExp('^' + _constants.A_CHARS + '+$').test(this.data);
			}
		}]);
	
		return CODE128A;
	}(_CODE3.default);
	
	exports.default = CODE128A;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CODE2 = __webpack_require__(103);
	
	var _CODE3 = _interopRequireDefault(_CODE2);
	
	var _constants = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CODE128B = function (_CODE) {
		_inherits(CODE128B, _CODE);
	
		function CODE128B(string, options) {
			_classCallCheck(this, CODE128B);
	
			return _possibleConstructorReturn(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants.B_START_CHAR + string, options));
		}
	
		_createClass(CODE128B, [{
			key: 'valid',
			value: function valid() {
				return new RegExp('^' + _constants.B_CHARS + '+$').test(this.data);
			}
		}]);
	
		return CODE128B;
	}(_CODE3.default);
	
	exports.default = CODE128B;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CODE2 = __webpack_require__(103);
	
	var _CODE3 = _interopRequireDefault(_CODE2);
	
	var _constants = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CODE128C = function (_CODE) {
		_inherits(CODE128C, _CODE);
	
		function CODE128C(string, options) {
			_classCallCheck(this, CODE128C);
	
			return _possibleConstructorReturn(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants.C_START_CHAR + string, options));
		}
	
		_createClass(CODE128C, [{
			key: 'valid',
			value: function valid() {
				return new RegExp('^' + _constants.C_CHARS + '+$').test(this.data);
			}
		}]);
	
		return CODE128C;
	}(_CODE3.default);
	
	exports.default = CODE128C;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UPCE = exports.UPC = exports.EAN2 = exports.EAN5 = exports.EAN8 = exports.EAN13 = undefined;
	
	var _EAN = __webpack_require__(110);
	
	var _EAN2 = _interopRequireDefault(_EAN);
	
	var _EAN3 = __webpack_require__(114);
	
	var _EAN4 = _interopRequireDefault(_EAN3);
	
	var _EAN5 = __webpack_require__(115);
	
	var _EAN6 = _interopRequireDefault(_EAN5);
	
	var _EAN7 = __webpack_require__(116);
	
	var _EAN8 = _interopRequireDefault(_EAN7);
	
	var _UPC = __webpack_require__(117);
	
	var _UPC2 = _interopRequireDefault(_UPC);
	
	var _UPCE = __webpack_require__(118);
	
	var _UPCE2 = _interopRequireDefault(_UPCE);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.EAN13 = _EAN2.default;
	exports.EAN8 = _EAN4.default;
	exports.EAN5 = _EAN6.default;
	exports.EAN2 = _EAN8.default;
	exports.UPC = _UPC2.default;
	exports.UPCE = _UPCE2.default;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _constants = __webpack_require__(111);
	
	var _EAN2 = __webpack_require__(112);
	
	var _EAN3 = _interopRequireDefault(_EAN2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode
	
	// Calculate the checksum digit
	// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
	var checksum = function checksum(number) {
		var res = number.substr(0, 12).split('').map(function (n) {
			return +n;
		}).reduce(function (sum, a, idx) {
			return idx % 2 ? sum + a * 3 : sum + a;
		}, 0);
	
		return (10 - res % 10) % 10;
	};
	
	var EAN13 = function (_EAN) {
		_inherits(EAN13, _EAN);
	
		function EAN13(data, options) {
			_classCallCheck(this, EAN13);
	
			// Add checksum if it does not exist
			if (data.search(/^[0-9]{12}$/) !== -1) {
				data += checksum(data);
			}
	
			// Adds a last character to the end of the barcode
			var _this = _possibleConstructorReturn(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));
	
			_this.lastChar = options.lastChar;
			return _this;
		}
	
		_createClass(EAN13, [{
			key: 'valid',
			value: function valid() {
				return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
			}
		}, {
			key: 'leftText',
			value: function leftText() {
				return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
			}
		}, {
			key: 'leftEncode',
			value: function leftEncode() {
				var data = this.data.substr(1, 6);
				var structure = _constants.EAN13_STRUCTURE[this.data[0]];
				return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
			}
		}, {
			key: 'rightText',
			value: function rightText() {
				return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
			}
		}, {
			key: 'rightEncode',
			value: function rightEncode() {
				var data = this.data.substr(7, 6);
				return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
			}
	
			// The "standard" way of printing EAN13 barcodes with guard bars
	
		}, {
			key: 'encodeGuarded',
			value: function encodeGuarded() {
				var data = _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);
	
				// Extend data with left digit & last character
				if (this.options.displayValue) {
					data.unshift({
						data: '000000000000',
						text: this.text.substr(0, 1),
						options: { textAlign: 'left', fontSize: this.fontSize }
					});
	
					if (this.options.lastChar) {
						data.push({
							data: '00'
						});
						data.push({
							data: '00000',
							text: this.options.lastChar,
							options: { fontSize: this.fontSize }
						});
					}
				}
	
				return data;
			}
		}]);
	
		return EAN13;
	}(_EAN3.default);
	
	exports.default = EAN13;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// Standard start end and middle bits
	var SIDE_BIN = exports.SIDE_BIN = '101';
	var MIDDLE_BIN = exports.MIDDLE_BIN = '01010';
	
	var BINARIES = exports.BINARIES = {
		'L': [// The L (left) type of encoding
		'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
		'G': [// The G type of encoding
		'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
		'R': [// The R (right) type of encoding
		'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
		'O': [// The O (odd) encoding for UPC-E
		'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
		'E': [// The E (even) encoding for UPC-E
		'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
	};
	
	// Define the EAN-2 structure
	var EAN2_STRUCTURE = exports.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];
	
	// Define the EAN-5 structure
	var EAN5_STRUCTURE = exports.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];
	
	// Define the EAN-13 structure
	var EAN13_STRUCTURE = exports.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(111);
	
	var _encoder = __webpack_require__(113);
	
	var _encoder2 = _interopRequireDefault(_encoder);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Base class for EAN8 & EAN13
	var EAN = function (_Barcode) {
		_inherits(EAN, _Barcode);
	
		function EAN(data, options) {
			_classCallCheck(this, EAN);
	
			// Make sure the font is not bigger than the space between the guard bars
			var _this = _possibleConstructorReturn(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));
	
			_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;
	
			// Make the guard bars go down half the way of the text
			_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
			return _this;
		}
	
		_createClass(EAN, [{
			key: 'encode',
			value: function encode() {
				return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
			}
		}, {
			key: 'leftText',
			value: function leftText(from, to) {
				return this.text.substr(from, to);
			}
		}, {
			key: 'leftEncode',
			value: function leftEncode(data, structure) {
				return (0, _encoder2.default)(data, structure);
			}
		}, {
			key: 'rightText',
			value: function rightText(from, to) {
				return this.text.substr(from, to);
			}
		}, {
			key: 'rightEncode',
			value: function rightEncode(data, structure) {
				return (0, _encoder2.default)(data, structure);
			}
		}, {
			key: 'encodeGuarded',
			value: function encodeGuarded() {
				var textOptions = { fontSize: this.fontSize };
				var guardOptions = { height: this.guardHeight };
	
				return [{ data: _constants.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants.SIDE_BIN, options: guardOptions }];
			}
		}, {
			key: 'encodeFlat',
			value: function encodeFlat() {
				var data = [_constants.SIDE_BIN, this.leftEncode(), _constants.MIDDLE_BIN, this.rightEncode(), _constants.SIDE_BIN];
	
				return {
					data: data.join(''),
					text: this.text
				};
			}
		}]);
	
		return EAN;
	}(_Barcode3.default);
	
	exports.default = EAN;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _constants = __webpack_require__(111);
	
	// Encode data string
	var encode = function encode(data, structure, separator) {
		var encoded = data.split('').map(function (val, idx) {
			return _constants.BINARIES[structure[idx]];
		}).map(function (val, idx) {
			return val ? val[data[idx]] : '';
		});
	
		if (separator) {
			var last = data.length - 1;
			encoded = encoded.map(function (val, idx) {
				return idx < last ? val + separator : val;
			});
		}
	
		return encoded.join('');
	};
	
	exports.default = encode;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _EAN2 = __webpack_require__(112);
	
	var _EAN3 = _interopRequireDefault(_EAN2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// http://www.barcodeisland.com/ean8.phtml
	
	// Calculate the checksum digit
	var checksum = function checksum(number) {
		var res = number.substr(0, 7).split('').map(function (n) {
			return +n;
		}).reduce(function (sum, a, idx) {
			return idx % 2 ? sum + a : sum + a * 3;
		}, 0);
	
		return (10 - res % 10) % 10;
	};
	
	var EAN8 = function (_EAN) {
		_inherits(EAN8, _EAN);
	
		function EAN8(data, options) {
			_classCallCheck(this, EAN8);
	
			// Add checksum if it does not exist
			if (data.search(/^[0-9]{7}$/) !== -1) {
				data += checksum(data);
			}
	
			return _possibleConstructorReturn(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
		}
	
		_createClass(EAN8, [{
			key: 'valid',
			value: function valid() {
				return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum(this.data);
			}
		}, {
			key: 'leftText',
			value: function leftText() {
				return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
			}
		}, {
			key: 'leftEncode',
			value: function leftEncode() {
				var data = this.data.substr(0, 4);
				return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
			}
		}, {
			key: 'rightText',
			value: function rightText() {
				return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
			}
		}, {
			key: 'rightEncode',
			value: function rightEncode() {
				var data = this.data.substr(4, 4);
				return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
			}
		}]);
	
		return EAN8;
	}(_EAN3.default);
	
	exports.default = EAN8;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(111);
	
	var _encoder = __webpack_require__(113);
	
	var _encoder2 = _interopRequireDefault(_encoder);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/EAN_5#Encoding
	
	var checksum = function checksum(data) {
		var result = data.split('').map(function (n) {
			return +n;
		}).reduce(function (sum, a, idx) {
			return idx % 2 ? sum + a * 9 : sum + a * 3;
		}, 0);
		return result % 10;
	};
	
	var EAN5 = function (_Barcode) {
		_inherits(EAN5, _Barcode);
	
		function EAN5(data, options) {
			_classCallCheck(this, EAN5);
	
			return _possibleConstructorReturn(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
		}
	
		_createClass(EAN5, [{
			key: 'valid',
			value: function valid() {
				return this.data.search(/^[0-9]{5}$/) !== -1;
			}
		}, {
			key: 'encode',
			value: function encode() {
				var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
				return {
					data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
					text: this.text
				};
			}
		}]);
	
		return EAN5;
	}(_Barcode3.default);
	
	exports.default = EAN5;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(111);
	
	var _encoder = __webpack_require__(113);
	
	var _encoder2 = _interopRequireDefault(_encoder);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/EAN_2#Encoding
	
	var EAN2 = function (_Barcode) {
		_inherits(EAN2, _Barcode);
	
		function EAN2(data, options) {
			_classCallCheck(this, EAN2);
	
			return _possibleConstructorReturn(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
		}
	
		_createClass(EAN2, [{
			key: 'valid',
			value: function valid() {
				return this.data.search(/^[0-9]{2}$/) !== -1;
			}
		}, {
			key: 'encode',
			value: function encode() {
				// Choose the structure based on the number mod 4
				var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
				return {
					// Start bits + Encode the two digits with 01 in between
					data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
					text: this.text
				};
			}
		}]);
	
		return EAN2;
	}(_Barcode3.default);
	
	exports.default = EAN2;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.checksum = checksum;
	
	var _encoder = __webpack_require__(113);
	
	var _encoder2 = _interopRequireDefault(_encoder);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
	
	var UPC = function (_Barcode) {
		_inherits(UPC, _Barcode);
	
		function UPC(data, options) {
			_classCallCheck(this, UPC);
	
			// Add checksum if it does not exist
			if (data.search(/^[0-9]{11}$/) !== -1) {
				data += checksum(data);
			}
	
			var _this = _possibleConstructorReturn(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));
	
			_this.displayValue = options.displayValue;
	
			// Make sure the font is not bigger than the space between the guard bars
			if (options.fontSize > options.width * 10) {
				_this.fontSize = options.width * 10;
			} else {
				_this.fontSize = options.fontSize;
			}
	
			// Make the guard bars go down half the way of the text
			_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
			return _this;
		}
	
		_createClass(UPC, [{
			key: "valid",
			value: function valid() {
				return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
			}
		}, {
			key: "encode",
			value: function encode() {
				if (this.options.flat) {
					return this.flatEncoding();
				} else {
					return this.guardedEncoding();
				}
			}
		}, {
			key: "flatEncoding",
			value: function flatEncoding() {
				var result = "";
	
				result += "101";
				result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
				result += "01010";
				result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
				result += "101";
	
				return {
					data: result,
					text: this.text
				};
			}
		}, {
			key: "guardedEncoding",
			value: function guardedEncoding() {
				var result = [];
	
				// Add the first digit
				if (this.displayValue) {
					result.push({
						data: "00000000",
						text: this.text.substr(0, 1),
						options: { textAlign: "left", fontSize: this.fontSize }
					});
				}
	
				// Add the guard bars
				result.push({
					data: "101" + (0, _encoder2.default)(this.data[0], "L"),
					options: { height: this.guardHeight }
				});
	
				// Add the left side
				result.push({
					data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
					text: this.text.substr(1, 5),
					options: { fontSize: this.fontSize }
				});
	
				// Add the middle bits
				result.push({
					data: "01010",
					options: { height: this.guardHeight }
				});
	
				// Add the right side
				result.push({
					data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
					text: this.text.substr(6, 5),
					options: { fontSize: this.fontSize }
				});
	
				// Add the end bits
				result.push({
					data: (0, _encoder2.default)(this.data[11], "R") + "101",
					options: { height: this.guardHeight }
				});
	
				// Add the last digit
				if (this.displayValue) {
					result.push({
						data: "00000000",
						text: this.text.substr(11, 1),
						options: { textAlign: "right", fontSize: this.fontSize }
					});
				}
	
				return result;
			}
		}]);
	
		return UPC;
	}(_Barcode3.default);
	
	// Calulate the checksum digit
	// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
	
	
	function checksum(number) {
		var result = 0;
	
		var i;
		for (i = 1; i < 11; i += 2) {
			result += parseInt(number[i]);
		}
		for (i = 0; i < 11; i += 2) {
			result += parseInt(number[i]) * 3;
		}
	
		return (10 - result % 10) % 10;
	}
	
	exports.default = UPC;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _encoder = __webpack_require__(113);
	
	var _encoder2 = _interopRequireDefault(_encoder);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	var _UPC = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
	//
	// UPC-E documentation:
	// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E
	
	var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];
	
	var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];
	
	var UPCE = function (_Barcode) {
		_inherits(UPCE, _Barcode);
	
		function UPCE(data, options) {
			_classCallCheck(this, UPCE);
	
			var _this = _possibleConstructorReturn(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
			// Code may be 6 or 8 digits;
			// A 7 digit code is ambiguous as to whether the extra digit
			// is a UPC-A check or number system digit.
	
	
			_this.isValid = false;
			if (data.search(/^[0-9]{6}$/) !== -1) {
				_this.middleDigits = data;
				_this.upcA = expandToUPCA(data, "0");
				_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
				_this.isValid = true;
			} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
				_this.middleDigits = data.substring(1, data.length - 1);
				_this.upcA = expandToUPCA(_this.middleDigits, data[0]);
	
				if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
					_this.isValid = true;
				} else {
					// checksum mismatch
					return _possibleConstructorReturn(_this);
				}
			} else {
				return _possibleConstructorReturn(_this);
			}
	
			_this.displayValue = options.displayValue;
	
			// Make sure the font is not bigger than the space between the guard bars
			if (options.fontSize > options.width * 10) {
				_this.fontSize = options.width * 10;
			} else {
				_this.fontSize = options.fontSize;
			}
	
			// Make the guard bars go down half the way of the text
			_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
			return _this;
		}
	
		_createClass(UPCE, [{
			key: 'valid',
			value: function valid() {
				return this.isValid;
			}
		}, {
			key: 'encode',
			value: function encode() {
				if (this.options.flat) {
					return this.flatEncoding();
				} else {
					return this.guardedEncoding();
				}
			}
		}, {
			key: 'flatEncoding',
			value: function flatEncoding() {
				var result = "";
	
				result += "101";
				result += this.encodeMiddleDigits();
				result += "010101";
	
				return {
					data: result,
					text: this.text
				};
			}
		}, {
			key: 'guardedEncoding',
			value: function guardedEncoding() {
				var result = [];
	
				// Add the UPC-A number system digit beneath the quiet zone
				if (this.displayValue) {
					result.push({
						data: "00000000",
						text: this.text[0],
						options: { textAlign: "left", fontSize: this.fontSize }
					});
				}
	
				// Add the guard bars
				result.push({
					data: "101",
					options: { height: this.guardHeight }
				});
	
				// Add the 6 UPC-E digits
				result.push({
					data: this.encodeMiddleDigits(),
					text: this.text.substring(1, 7),
					options: { fontSize: this.fontSize }
				});
	
				// Add the end bits
				result.push({
					data: "010101",
					options: { height: this.guardHeight }
				});
	
				// Add the UPC-A check digit beneath the quiet zone
				if (this.displayValue) {
					result.push({
						data: "00000000",
						text: this.text[7],
						options: { textAlign: "right", fontSize: this.fontSize }
					});
				}
	
				return result;
			}
		}, {
			key: 'encodeMiddleDigits',
			value: function encodeMiddleDigits() {
				var numberSystem = this.upcA[0];
				var checkDigit = this.upcA[this.upcA.length - 1];
				var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
				return (0, _encoder2.default)(this.middleDigits, parity);
			}
		}]);
	
		return UPCE;
	}(_Barcode3.default);
	
	function expandToUPCA(middleDigits, numberSystem) {
		var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
		var expansion = EXPANSIONS[lastUpcE];
	
		var result = "";
		var digitIndex = 0;
		for (var i = 0; i < expansion.length; i++) {
			var c = expansion[i];
			if (c === 'X') {
				result += middleDigits[digitIndex++];
			} else {
				result += c;
			}
		}
	
		result = '' + numberSystem + result;
		return '' + result + (0, _UPC.checksum)(result);
	}
	
	exports.default = UPCE;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ITF14 = exports.ITF = undefined;
	
	var _ITF = __webpack_require__(120);
	
	var _ITF2 = _interopRequireDefault(_ITF);
	
	var _ITF3 = __webpack_require__(122);
	
	var _ITF4 = _interopRequireDefault(_ITF3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ITF = _ITF2.default;
	exports.ITF14 = _ITF4.default;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(121);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ITF = function (_Barcode) {
		_inherits(ITF, _Barcode);
	
		function ITF() {
			_classCallCheck(this, ITF);
	
			return _possibleConstructorReturn(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
		}
	
		_createClass(ITF, [{
			key: 'valid',
			value: function valid() {
				return this.data.search(/^([0-9]{2})+$/) !== -1;
			}
		}, {
			key: 'encode',
			value: function encode() {
				var _this2 = this;
	
				// Calculate all the digit pairs
				var encoded = this.data.match(/.{2}/g).map(function (pair) {
					return _this2.encodePair(pair);
				}).join('');
	
				return {
					data: _constants.START_BIN + encoded + _constants.END_BIN,
					text: this.text
				};
			}
	
			// Calculate the data of a number pair
	
		}, {
			key: 'encodePair',
			value: function encodePair(pair) {
				var second = _constants.BINARIES[pair[1]];
	
				return _constants.BINARIES[pair[0]].split('').map(function (first, idx) {
					return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
				}).join('');
			}
		}]);
	
		return ITF;
	}(_Barcode3.default);
	
	exports.default = ITF;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var START_BIN = exports.START_BIN = '1010';
	var END_BIN = exports.END_BIN = '11101';
	
	var BINARIES = exports.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ITF2 = __webpack_require__(120);
	
	var _ITF3 = _interopRequireDefault(_ITF2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Calculate the checksum digit
	var checksum = function checksum(data) {
		var res = data.substr(0, 13).split('').map(function (num) {
			return parseInt(num, 10);
		}).reduce(function (sum, n, idx) {
			return sum + n * (3 - idx % 2 * 2);
		}, 0);
	
		return Math.ceil(res / 10) * 10 - res;
	};
	
	var ITF14 = function (_ITF) {
		_inherits(ITF14, _ITF);
	
		function ITF14(data, options) {
			_classCallCheck(this, ITF14);
	
			// Add checksum if it does not exist
			if (data.search(/^[0-9]{13}$/) !== -1) {
				data += checksum(data);
			}
			return _possibleConstructorReturn(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
		}
	
		_createClass(ITF14, [{
			key: 'valid',
			value: function valid() {
				return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
			}
		}]);
	
		return ITF14;
	}(_ITF3.default);
	
	exports.default = ITF14;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MSI1110 = exports.MSI1010 = exports.MSI11 = exports.MSI10 = exports.MSI = undefined;
	
	var _MSI = __webpack_require__(124);
	
	var _MSI2 = _interopRequireDefault(_MSI);
	
	var _MSI3 = __webpack_require__(125);
	
	var _MSI4 = _interopRequireDefault(_MSI3);
	
	var _MSI5 = __webpack_require__(127);
	
	var _MSI6 = _interopRequireDefault(_MSI5);
	
	var _MSI7 = __webpack_require__(128);
	
	var _MSI8 = _interopRequireDefault(_MSI7);
	
	var _MSI9 = __webpack_require__(129);
	
	var _MSI10 = _interopRequireDefault(_MSI9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MSI = _MSI2.default;
	exports.MSI10 = _MSI4.default;
	exports.MSI11 = _MSI6.default;
	exports.MSI1010 = _MSI8.default;
	exports.MSI1110 = _MSI10.default;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
	// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup
	
	var MSI = function (_Barcode) {
		_inherits(MSI, _Barcode);
	
		function MSI(data, options) {
			_classCallCheck(this, MSI);
	
			return _possibleConstructorReturn(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
		}
	
		_createClass(MSI, [{
			key: "encode",
			value: function encode() {
				// Start bits
				var ret = "110";
	
				for (var i = 0; i < this.data.length; i++) {
					// Convert the character to binary (always 4 binary digits)
					var digit = parseInt(this.data[i]);
					var bin = digit.toString(2);
					bin = addZeroes(bin, 4 - bin.length);
	
					// Add 100 for every zero and 110 for every 1
					for (var b = 0; b < bin.length; b++) {
						ret += bin[b] == "0" ? "100" : "110";
					}
				}
	
				// End bits
				ret += "1001";
	
				return {
					data: ret,
					text: this.text
				};
			}
		}, {
			key: "valid",
			value: function valid() {
				return this.data.search(/^[0-9]+$/) !== -1;
			}
		}]);
	
		return MSI;
	}(_Barcode3.default);
	
	function addZeroes(number, n) {
		for (var i = 0; i < n; i++) {
			number = "0" + number;
		}
		return number;
	}
	
	exports.default = MSI;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _MSI2 = __webpack_require__(124);
	
	var _MSI3 = _interopRequireDefault(_MSI2);
	
	var _checksums = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MSI10 = function (_MSI) {
		_inherits(MSI10, _MSI);
	
		function MSI10(data, options) {
			_classCallCheck(this, MSI10);
	
			return _possibleConstructorReturn(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums.mod10)(data), options));
		}
	
		return MSI10;
	}(_MSI3.default);
	
	exports.default = MSI10;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.mod10 = mod10;
	exports.mod11 = mod11;
	function mod10(number) {
		var sum = 0;
		for (var i = 0; i < number.length; i++) {
			var n = parseInt(number[i]);
			if ((i + number.length) % 2 === 0) {
				sum += n;
			} else {
				sum += n * 2 % 10 + Math.floor(n * 2 / 10);
			}
		}
		return (10 - sum % 10) % 10;
	}
	
	function mod11(number) {
		var sum = 0;
		var weights = [2, 3, 4, 5, 6, 7];
		for (var i = 0; i < number.length; i++) {
			var n = parseInt(number[number.length - 1 - i]);
			sum += weights[i % weights.length] * n;
		}
		return (11 - sum % 11) % 11;
	}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _MSI2 = __webpack_require__(124);
	
	var _MSI3 = _interopRequireDefault(_MSI2);
	
	var _checksums = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MSI11 = function (_MSI) {
		_inherits(MSI11, _MSI);
	
		function MSI11(data, options) {
			_classCallCheck(this, MSI11);
	
			return _possibleConstructorReturn(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums.mod11)(data), options));
		}
	
		return MSI11;
	}(_MSI3.default);
	
	exports.default = MSI11;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _MSI2 = __webpack_require__(124);
	
	var _MSI3 = _interopRequireDefault(_MSI2);
	
	var _checksums = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MSI1010 = function (_MSI) {
		_inherits(MSI1010, _MSI);
	
		function MSI1010(data, options) {
			_classCallCheck(this, MSI1010);
	
			data += (0, _checksums.mod10)(data);
			data += (0, _checksums.mod10)(data);
			return _possibleConstructorReturn(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
		}
	
		return MSI1010;
	}(_MSI3.default);
	
	exports.default = MSI1010;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _MSI2 = __webpack_require__(124);
	
	var _MSI3 = _interopRequireDefault(_MSI2);
	
	var _checksums = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MSI1110 = function (_MSI) {
		_inherits(MSI1110, _MSI);
	
		function MSI1110(data, options) {
			_classCallCheck(this, MSI1110);
	
			data += (0, _checksums.mod11)(data);
			data += (0, _checksums.mod10)(data);
			return _possibleConstructorReturn(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
		}
	
		return MSI1110;
	}(_MSI3.default);
	
	exports.default = MSI1110;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pharmacode = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
	// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf
	
	var pharmacode = function (_Barcode) {
		_inherits(pharmacode, _Barcode);
	
		function pharmacode(data, options) {
			_classCallCheck(this, pharmacode);
	
			var _this = _possibleConstructorReturn(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));
	
			_this.number = parseInt(data, 10);
			return _this;
		}
	
		_createClass(pharmacode, [{
			key: "encode",
			value: function encode() {
				var z = this.number;
				var result = "";
	
				// http://i.imgur.com/RMm4UDJ.png
				// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
				while (!isNaN(z) && z != 0) {
					if (z % 2 === 0) {
						// Even
						result = "11100" + result;
						z = (z - 2) / 2;
					} else {
						// Odd
						result = "100" + result;
						z = (z - 1) / 2;
					}
				}
	
				// Remove the two last zeroes
				result = result.slice(0, -2);
	
				return {
					data: result,
					text: this.text
				};
			}
		}, {
			key: "valid",
			value: function valid() {
				return this.number >= 3 && this.number <= 131070;
			}
		}]);
	
		return pharmacode;
	}(_Barcode3.default);
	
	exports.pharmacode = pharmacode;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.codabar = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
	// http://www.barcodeisland.com/codabar.phtml
	
	var codabar = function (_Barcode) {
		_inherits(codabar, _Barcode);
	
		function codabar(data, options) {
			_classCallCheck(this, codabar);
	
			if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
				data = "A" + data + "A";
			}
	
			var _this = _possibleConstructorReturn(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));
	
			_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
			return _this;
		}
	
		_createClass(codabar, [{
			key: "valid",
			value: function valid() {
				return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
			}
		}, {
			key: "encode",
			value: function encode() {
				var result = [];
				var encodings = this.getEncodings();
				for (var i = 0; i < this.data.length; i++) {
					result.push(encodings[this.data.charAt(i)]);
					// for all characters except the last, append a narrow-space ("0")
					if (i !== this.data.length - 1) {
						result.push("0");
					}
				}
				return {
					text: this.text,
					data: result.join('')
				};
			}
		}, {
			key: "getEncodings",
			value: function getEncodings() {
				return {
					"0": "101010011",
					"1": "101011001",
					"2": "101001011",
					"3": "110010101",
					"4": "101101001",
					"5": "110101001",
					"6": "100101011",
					"7": "100101101",
					"8": "100110101",
					"9": "110100101",
					"-": "101001101",
					"$": "101100101",
					":": "1101011011",
					"/": "1101101011",
					".": "1101101101",
					"+": "1011011011",
					"A": "1011001001",
					"B": "1001001011",
					"C": "1010010011",
					"D": "1010011001"
				};
			}
		}]);
	
		return codabar;
	}(_Barcode3.default);
	
	exports.codabar = codabar;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CODE93FullASCII = exports.CODE93 = undefined;
	
	var _CODE = __webpack_require__(133);
	
	var _CODE2 = _interopRequireDefault(_CODE);
	
	var _CODE93FullASCII = __webpack_require__(135);
	
	var _CODE93FullASCII2 = _interopRequireDefault(_CODE93FullASCII);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CODE93 = _CODE2.default;
	exports.CODE93FullASCII = _CODE93FullASCII2.default;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(134);
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
	// https://en.wikipedia.org/wiki/Code_93#Detailed_outline
	
	var CODE93 = function (_Barcode) {
		_inherits(CODE93, _Barcode);
	
		function CODE93(data, options) {
			_classCallCheck(this, CODE93);
	
			return _possibleConstructorReturn(this, (CODE93.__proto__ || Object.getPrototypeOf(CODE93)).call(this, data, options));
		}
	
		_createClass(CODE93, [{
			key: 'valid',
			value: function valid() {
				return (/^[0-9A-Z\-. $/+%]+$/.test(this.data)
				);
			}
		}, {
			key: 'encode',
			value: function encode() {
				var symbols = this.data.split('').flatMap(function (c) {
					return _constants.MULTI_SYMBOLS[c] || c;
				});
				var encoded = symbols.map(function (s) {
					return CODE93.getEncoding(s);
				}).join('');
	
				// Compute checksum symbols
				var csumC = CODE93.checksum(symbols, 20);
				var csumK = CODE93.checksum(symbols.concat(csumC), 15);
	
				return {
					text: this.text,
					data:
					// Add the start bits
					CODE93.getEncoding('\xff') +
					// Add the encoded bits
					encoded +
					// Add the checksum
					CODE93.getEncoding(csumC) + CODE93.getEncoding(csumK) +
					// Add the stop bits
					CODE93.getEncoding('\xff') +
					// Add the termination bit
					'1'
				};
			}
	
			// Get the binary encoding of a symbol
	
		}], [{
			key: 'getEncoding',
			value: function getEncoding(symbol) {
				return _constants.BINARIES[CODE93.symbolValue(symbol)];
			}
	
			// Get the symbol for a symbol value
	
		}, {
			key: 'getSymbol',
			value: function getSymbol(symbolValue) {
				return _constants.SYMBOLS[symbolValue];
			}
	
			// Get the symbol value of a symbol
	
		}, {
			key: 'symbolValue',
			value: function symbolValue(symbol) {
				return _constants.SYMBOLS.indexOf(symbol);
			}
	
			// Calculate a checksum symbol
	
		}, {
			key: 'checksum',
			value: function checksum(symbols, maxWeight) {
				var csum = symbols.slice().reverse().reduce(function (sum, symbol, idx) {
					var weight = idx % maxWeight + 1;
					return sum + CODE93.symbolValue(symbol) * weight;
				}, 0);
	
				return CODE93.getSymbol(csum % 47);
			}
		}]);
	
		return CODE93;
	}(_Barcode3.default);
	
	exports.default = CODE93;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// The position in the array is the (checksum) value
	var SYMBOLS = exports.SYMBOLS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '-', '.', ' ', '$', '/', '+', '%',
	// Only used for csum and multi-symbols character encodings
	'($)', '(%)', '(/)', '(+)',
	// Start/Stop
	'\xff'];
	
	// Order matches SYMBOLS array
	var BINARIES = exports.BINARIES = ['100010100', '101001000', '101000100', '101000010', '100101000', '100100100', '100100010', '101010000', '100010010', '100001010', '110101000', '110100100', '110100010', '110010100', '110010010', '110001010', '101101000', '101100100', '101100010', '100110100', '100011010', '101011000', '101001100', '101000110', '100101100', '100010110', '110110100', '110110010', '110101100', '110100110', '110010110', '110011010', '101101100', '101100110', '100110110', '100111010', '100101110', '111010100', '111010010', '111001010', '101101110', '101110110', '110101110', '100100110', '111011010', '111010110', '100110010', '101011110'];
	
	// Multi-symbol characters (Full ASCII Code 93)
	var MULTI_SYMBOLS = exports.MULTI_SYMBOLS = {
		'\x00': ['(%)', 'U'],
		'\x01': ['($)', 'A'],
		'\x02': ['($)', 'B'],
		'\x03': ['($)', 'C'],
		'\x04': ['($)', 'D'],
		'\x05': ['($)', 'E'],
		'\x06': ['($)', 'F'],
		'\x07': ['($)', 'G'],
		'\x08': ['($)', 'H'],
		'\x09': ['($)', 'I'],
		'\x0a': ['($)', 'J'],
		'\x0b': ['($)', 'K'],
		'\x0c': ['($)', 'L'],
		'\x0d': ['($)', 'M'],
		'\x0e': ['($)', 'N'],
		'\x0f': ['($)', 'O'],
		'\x10': ['($)', 'P'],
		'\x11': ['($)', 'Q'],
		'\x12': ['($)', 'R'],
		'\x13': ['($)', 'S'],
		'\x14': ['($)', 'T'],
		'\x15': ['($)', 'U'],
		'\x16': ['($)', 'V'],
		'\x17': ['($)', 'W'],
		'\x18': ['($)', 'X'],
		'\x19': ['($)', 'Y'],
		'\x1a': ['($)', 'Z'],
		'\x1b': ['(%)', 'A'],
		'\x1c': ['(%)', 'B'],
		'\x1d': ['(%)', 'C'],
		'\x1e': ['(%)', 'D'],
		'\x1f': ['(%)', 'E'],
		'!': ['(/)', 'A'],
		'"': ['(/)', 'B'],
		'#': ['(/)', 'C'],
		'&': ['(/)', 'F'],
		'\'': ['(/)', 'G'],
		'(': ['(/)', 'H'],
		')': ['(/)', 'I'],
		'*': ['(/)', 'J'],
		',': ['(/)', 'L'],
		':': ['(/)', 'Z'],
		';': ['(%)', 'F'],
		'<': ['(%)', 'G'],
		'=': ['(%)', 'H'],
		'>': ['(%)', 'I'],
		'?': ['(%)', 'J'],
		'@': ['(%)', 'V'],
		'[': ['(%)', 'K'],
		'\\': ['(%)', 'L'],
		']': ['(%)', 'M'],
		'^': ['(%)', 'N'],
		'_': ['(%)', 'O'],
		'`': ['(%)', 'W'],
		'a': ['(+)', 'A'],
		'b': ['(+)', 'B'],
		'c': ['(+)', 'C'],
		'd': ['(+)', 'D'],
		'e': ['(+)', 'E'],
		'f': ['(+)', 'F'],
		'g': ['(+)', 'G'],
		'h': ['(+)', 'H'],
		'i': ['(+)', 'I'],
		'j': ['(+)', 'J'],
		'k': ['(+)', 'K'],
		'l': ['(+)', 'L'],
		'm': ['(+)', 'M'],
		'n': ['(+)', 'N'],
		'o': ['(+)', 'O'],
		'p': ['(+)', 'P'],
		'q': ['(+)', 'Q'],
		'r': ['(+)', 'R'],
		's': ['(+)', 'S'],
		't': ['(+)', 'T'],
		'u': ['(+)', 'U'],
		'v': ['(+)', 'V'],
		'w': ['(+)', 'W'],
		'x': ['(+)', 'X'],
		'y': ['(+)', 'Y'],
		'z': ['(+)', 'Z'],
		'{': ['(%)', 'P'],
		'|': ['(%)', 'Q'],
		'}': ['(%)', 'R'],
		'~': ['(%)', 'S'],
		'\x7f': ['(%)', 'T']
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CODE2 = __webpack_require__(133);
	
	var _CODE3 = _interopRequireDefault(_CODE2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
	// https://en.wikipedia.org/wiki/Code_93#Full_ASCII_Code_93
	
	var CODE93FullASCII = function (_CODE) {
		_inherits(CODE93FullASCII, _CODE);
	
		function CODE93FullASCII(data, options) {
			_classCallCheck(this, CODE93FullASCII);
	
			return _possibleConstructorReturn(this, (CODE93FullASCII.__proto__ || Object.getPrototypeOf(CODE93FullASCII)).call(this, data, options));
		}
	
		_createClass(CODE93FullASCII, [{
			key: 'valid',
			value: function valid() {
				return (/^[\x00-\x7f]+$/.test(this.data)
				);
			}
		}]);
	
		return CODE93FullASCII;
	}(_CODE3.default);
	
	exports.default = CODE93FullASCII;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GenericBarcode = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Barcode2 = __webpack_require__(100);
	
	var _Barcode3 = _interopRequireDefault(_Barcode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GenericBarcode = function (_Barcode) {
		_inherits(GenericBarcode, _Barcode);
	
		function GenericBarcode(data, options) {
			_classCallCheck(this, GenericBarcode);
	
			return _possibleConstructorReturn(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
		}
	
		// Return the corresponding binary numbers for the data provided
	
	
		_createClass(GenericBarcode, [{
			key: "encode",
			value: function encode() {
				return {
					data: "10101010101010101010101010101010101010101",
					text: this.text
				};
			}
	
			// Resturn true/false if the string provided is valid for this encoder
	
		}, {
			key: "valid",
			value: function valid() {
				return true;
			}
		}]);
	
		return GenericBarcode;
	}(_Barcode3.default);
	
	exports.GenericBarcode = GenericBarcode;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (old, replaceObj) {
	  return _extends({}, old, replaceObj);
	};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = linearizeEncodings;
	
	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	
	function linearizeEncodings(encodings) {
		var linearEncodings = [];
		function nextLevel(encoded) {
			if (Array.isArray(encoded)) {
				for (var i = 0; i < encoded.length; i++) {
					nextLevel(encoded[i]);
				}
			} else {
				encoded.text = encoded.text || "";
				encoded.data = encoded.data || "";
				linearEncodings.push(encoded);
			}
		}
		nextLevel(encodings);
	
		return linearEncodings;
	}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = fixOptions;
	
	
	function fixOptions(options) {
		// Fix the margins
		options.marginTop = options.marginTop || options.margin;
		options.marginBottom = options.marginBottom || options.margin;
		options.marginRight = options.marginRight || options.margin;
		options.marginLeft = options.marginLeft || options.margin;
	
		return options;
	}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
	/* global HTMLCanvasElement */
	/* global SVGElement */
	
	var _getOptionsFromElement = __webpack_require__(141);
	
	var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);
	
	var _renderers = __webpack_require__(144);
	
	var _renderers2 = _interopRequireDefault(_renderers);
	
	var _exceptions = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Takes an element and returns an object with information about how
	// it should be rendered
	// This could also return an array with these objects
	// {
	//   element: The element that the renderer should draw on
	//   renderer: The name of the renderer
	//   afterRender (optional): If something has to done after the renderer
	//     completed, calls afterRender (function)
	//   options (optional): Options that can be defined in the element
	// }
	
	function getRenderProperties(element) {
		// If the element is a string, query select call again
		if (typeof element === "string") {
			return querySelectedRenderProperties(element);
		}
		// If element is array. Recursivly call with every object in the array
		else if (Array.isArray(element)) {
				var returnArray = [];
				for (var i = 0; i < element.length; i++) {
					returnArray.push(getRenderProperties(element[i]));
				}
				return returnArray;
			}
			// If element, render on canvas and set the uri as src
			else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
					return newCanvasRenderProperties(element);
				}
				// If SVG
				else if (element && element.nodeName && element.nodeName.toLowerCase() === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.SVGRenderer
						};
					}
					// If canvas (in browser)
					else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
							return {
								element: element,
								options: (0, _getOptionsFromElement2.default)(element),
								renderer: _renderers2.default.CanvasRenderer
							};
						}
						// If canvas (in node)
						else if (element && element.getContext) {
								return {
									element: element,
									renderer: _renderers2.default.CanvasRenderer
								};
							} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
								return {
									element: element,
									renderer: _renderers2.default.ObjectRenderer
								};
							} else {
								throw new _exceptions.InvalidElementException();
							}
	}
	
	function querySelectedRenderProperties(string) {
		var selector = document.querySelectorAll(string);
		if (selector.length === 0) {
			return undefined;
		} else {
			var returnArray = [];
			for (var i = 0; i < selector.length; i++) {
				returnArray.push(getRenderProperties(selector[i]));
			}
			return returnArray;
		}
	}
	
	function newCanvasRenderProperties(imgElement) {
		var canvas = document.createElement('canvas');
		return {
			element: canvas,
			options: (0, _getOptionsFromElement2.default)(imgElement),
			renderer: _renderers2.default.CanvasRenderer,
			afterRender: function afterRender() {
				imgElement.setAttribute("src", canvas.toDataURL());
			}
		};
	}
	
	exports.default = getRenderProperties;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _optionsFromStrings = __webpack_require__(142);
	
	var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);
	
	var _defaults = __webpack_require__(143);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getOptionsFromElement(element) {
		var options = {};
		for (var property in _defaults2.default) {
			if (_defaults2.default.hasOwnProperty(property)) {
				// jsbarcode-*
				if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
					options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
				}
	
				// data-*
				if (element.hasAttribute("data-" + property.toLowerCase())) {
					options[property] = element.getAttribute("data-" + property.toLowerCase());
				}
			}
		}
	
		options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");
	
		// Since all atributes are string they need to be converted to integers
		options = (0, _optionsFromStrings2.default)(options);
	
		return options;
	}
	
	exports.default = getOptionsFromElement;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = optionsFromStrings;
	
	// Convert string to integers/booleans where it should be
	
	function optionsFromStrings(options) {
		var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
	
		for (var intOption in intOptions) {
			if (intOptions.hasOwnProperty(intOption)) {
				intOption = intOptions[intOption];
				if (typeof options[intOption] === "string") {
					options[intOption] = parseInt(options[intOption], 10);
				}
			}
		}
	
		if (typeof options["displayValue"] === "string") {
			options["displayValue"] = options["displayValue"] != "false";
		}
	
		return options;
	}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var defaults = {
		width: 2,
		height: 100,
		format: "auto",
		displayValue: true,
		fontOptions: "",
		font: "monospace",
		text: undefined,
		textAlign: "center",
		textPosition: "bottom",
		textMargin: 2,
		fontSize: 20,
		background: "#ffffff",
		lineColor: "#000000",
		margin: 10,
		marginTop: undefined,
		marginBottom: undefined,
		marginLeft: undefined,
		marginRight: undefined,
		valid: function valid() {}
	};
	
	exports.default = defaults;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _canvas = __webpack_require__(145);
	
	var _canvas2 = _interopRequireDefault(_canvas);
	
	var _svg = __webpack_require__(147);
	
	var _svg2 = _interopRequireDefault(_svg);
	
	var _object = __webpack_require__(148);
	
	var _object2 = _interopRequireDefault(_object);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _merge = __webpack_require__(137);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _shared = __webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CanvasRenderer = function () {
		function CanvasRenderer(canvas, encodings, options) {
			_classCallCheck(this, CanvasRenderer);
	
			this.canvas = canvas;
			this.encodings = encodings;
			this.options = options;
		}
	
		_createClass(CanvasRenderer, [{
			key: "render",
			value: function render() {
				// Abort if the browser does not support HTML5 canvas
				if (!this.canvas.getContext) {
					throw new Error('The browser does not support canvas.');
				}
	
				this.prepareCanvas();
				for (var i = 0; i < this.encodings.length; i++) {
					var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);
	
					this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
					this.drawCanvasText(encodingOptions, this.encodings[i]);
	
					this.moveCanvasDrawing(this.encodings[i]);
				}
	
				this.restoreCanvas();
			}
		}, {
			key: "prepareCanvas",
			value: function prepareCanvas() {
				// Get the canvas context
				var ctx = this.canvas.getContext("2d");
	
				ctx.save();
	
				(0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
				var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
				var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);
	
				this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;
	
				this.canvas.height = maxHeight;
	
				// Paint the canvas
				ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
				if (this.options.background) {
					ctx.fillStyle = this.options.background;
					ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
				}
	
				ctx.translate(this.options.marginLeft, 0);
			}
		}, {
			key: "drawCanvasBarcode",
			value: function drawCanvasBarcode(options, encoding) {
				// Get the canvas context
				var ctx = this.canvas.getContext("2d");
	
				var binary = encoding.data;
	
				// Creates the barcode out of the encoded binary
				var yFrom;
				if (options.textPosition == "top") {
					yFrom = options.marginTop + options.fontSize + options.textMargin;
				} else {
					yFrom = options.marginTop;
				}
	
				ctx.fillStyle = options.lineColor;
	
				for (var b = 0; b < binary.length; b++) {
					var x = b * options.width + encoding.barcodePadding;
	
					if (binary[b] === "1") {
						ctx.fillRect(x, yFrom, options.width, options.height);
					} else if (binary[b]) {
						ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
					}
				}
			}
		}, {
			key: "drawCanvasText",
			value: function drawCanvasText(options, encoding) {
				// Get the canvas context
				var ctx = this.canvas.getContext("2d");
	
				var font = options.fontOptions + " " + options.fontSize + "px " + options.font;
	
				// Draw the text if displayValue is set
				if (options.displayValue) {
					var x, y;
	
					if (options.textPosition == "top") {
						y = options.marginTop + options.fontSize - options.textMargin;
					} else {
						y = options.height + options.textMargin + options.marginTop + options.fontSize;
					}
	
					ctx.font = font;
	
					// Draw the text in the correct X depending on the textAlign option
					if (options.textAlign == "left" || encoding.barcodePadding > 0) {
						x = 0;
						ctx.textAlign = 'left';
					} else if (options.textAlign == "right") {
						x = encoding.width - 1;
						ctx.textAlign = 'right';
					}
					// In all other cases, center the text
					else {
							x = encoding.width / 2;
							ctx.textAlign = 'center';
						}
	
					ctx.fillText(encoding.text, x, y);
				}
			}
		}, {
			key: "moveCanvasDrawing",
			value: function moveCanvasDrawing(encoding) {
				var ctx = this.canvas.getContext("2d");
	
				ctx.translate(encoding.width, 0);
			}
		}, {
			key: "restoreCanvas",
			value: function restoreCanvas() {
				// Get the canvas context
				var ctx = this.canvas.getContext("2d");
	
				ctx.restore();
			}
		}]);
	
		return CanvasRenderer;
	}();
	
	exports.default = CanvasRenderer;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getTotalWidthOfEncodings = exports.calculateEncodingAttributes = exports.getBarcodePadding = exports.getEncodingHeight = exports.getMaximumHeightOfEncodings = undefined;
	
	var _merge = __webpack_require__(137);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getEncodingHeight(encoding, options) {
		return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
	}
	
	function getBarcodePadding(textWidth, barcodeWidth, options) {
		if (options.displayValue && barcodeWidth < textWidth) {
			if (options.textAlign == "center") {
				return Math.floor((textWidth - barcodeWidth) / 2);
			} else if (options.textAlign == "left") {
				return 0;
			} else if (options.textAlign == "right") {
				return Math.floor(textWidth - barcodeWidth);
			}
		}
		return 0;
	}
	
	function calculateEncodingAttributes(encodings, barcodeOptions, context) {
		for (var i = 0; i < encodings.length; i++) {
			var encoding = encodings[i];
			var options = (0, _merge2.default)(barcodeOptions, encoding.options);
	
			// Calculate the width of the encoding
			var textWidth;
			if (options.displayValue) {
				textWidth = messureText(encoding.text, options, context);
			} else {
				textWidth = 0;
			}
	
			var barcodeWidth = encoding.data.length * options.width;
			encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));
	
			encoding.height = getEncodingHeight(encoding, options);
	
			encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
		}
	}
	
	function getTotalWidthOfEncodings(encodings) {
		var totalWidth = 0;
		for (var i = 0; i < encodings.length; i++) {
			totalWidth += encodings[i].width;
		}
		return totalWidth;
	}
	
	function getMaximumHeightOfEncodings(encodings) {
		var maxHeight = 0;
		for (var i = 0; i < encodings.length; i++) {
			if (encodings[i].height > maxHeight) {
				maxHeight = encodings[i].height;
			}
		}
		return maxHeight;
	}
	
	function messureText(string, options, context) {
		var ctx;
	
		if (context) {
			ctx = context;
		} else if (typeof document !== "undefined") {
			ctx = document.createElement("canvas").getContext("2d");
		} else {
			// If the text cannot be messured we will return 0.
			// This will make some barcode with big text render incorrectly
			return 0;
		}
		ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;
	
		// Calculate the width of the encoding
		var measureTextResult = ctx.measureText(string);
		if (!measureTextResult) {
			// Some implementations don't implement measureText and return undefined.
			// If the text cannot be measured we will return 0.
			// This will make some barcode with big text render incorrectly
			return 0;
		}
		var size = measureTextResult.width;
		return size;
	}
	
	exports.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
	exports.getEncodingHeight = getEncodingHeight;
	exports.getBarcodePadding = getBarcodePadding;
	exports.calculateEncodingAttributes = calculateEncodingAttributes;
	exports.getTotalWidthOfEncodings = getTotalWidthOfEncodings;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _merge = __webpack_require__(137);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _shared = __webpack_require__(146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var svgns = "http://www.w3.org/2000/svg";
	
	var SVGRenderer = function () {
		function SVGRenderer(svg, encodings, options) {
			_classCallCheck(this, SVGRenderer);
	
			this.svg = svg;
			this.encodings = encodings;
			this.options = options;
			this.document = options.xmlDocument || document;
		}
	
		_createClass(SVGRenderer, [{
			key: "render",
			value: function render() {
				var currentX = this.options.marginLeft;
	
				this.prepareSVG();
				for (var i = 0; i < this.encodings.length; i++) {
					var encoding = this.encodings[i];
					var encodingOptions = (0, _merge2.default)(this.options, encoding.options);
	
					var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);
	
					this.setGroupOptions(group, encodingOptions);
	
					this.drawSvgBarcode(group, encodingOptions, encoding);
					this.drawSVGText(group, encodingOptions, encoding);
	
					currentX += encoding.width;
				}
			}
		}, {
			key: "prepareSVG",
			value: function prepareSVG() {
				// Clear the SVG
				while (this.svg.firstChild) {
					this.svg.removeChild(this.svg.firstChild);
				}
	
				(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
				var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
				var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);
	
				var width = totalWidth + this.options.marginLeft + this.options.marginRight;
				this.setSvgAttributes(width, maxHeight);
	
				if (this.options.background) {
					this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
				}
			}
		}, {
			key: "drawSvgBarcode",
			value: function drawSvgBarcode(parent, options, encoding) {
				var binary = encoding.data;
	
				// Creates the barcode out of the encoded binary
				var yFrom;
				if (options.textPosition == "top") {
					yFrom = options.fontSize + options.textMargin;
				} else {
					yFrom = 0;
				}
	
				var barWidth = 0;
				var x = 0;
				for (var b = 0; b < binary.length; b++) {
					x = b * options.width + encoding.barcodePadding;
	
					if (binary[b] === "1") {
						barWidth++;
					} else if (barWidth > 0) {
						this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
						barWidth = 0;
					}
				}
	
				// Last draw is needed since the barcode ends with 1
				if (barWidth > 0) {
					this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
				}
			}
		}, {
			key: "drawSVGText",
			value: function drawSVGText(parent, options, encoding) {
				var textElem = this.document.createElementNS(svgns, 'text');
	
				// Draw the text if displayValue is set
				if (options.displayValue) {
					var x, y;
	
					textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);
	
					if (options.textPosition == "top") {
						y = options.fontSize - options.textMargin;
					} else {
						y = options.height + options.textMargin + options.fontSize;
					}
	
					// Draw the text in the correct X depending on the textAlign option
					if (options.textAlign == "left" || encoding.barcodePadding > 0) {
						x = 0;
						textElem.setAttribute("text-anchor", "start");
					} else if (options.textAlign == "right") {
						x = encoding.width - 1;
						textElem.setAttribute("text-anchor", "end");
					}
					// In all other cases, center the text
					else {
							x = encoding.width / 2;
							textElem.setAttribute("text-anchor", "middle");
						}
	
					textElem.setAttribute("x", x);
					textElem.setAttribute("y", y);
	
					textElem.appendChild(this.document.createTextNode(encoding.text));
	
					parent.appendChild(textElem);
				}
			}
		}, {
			key: "setSvgAttributes",
			value: function setSvgAttributes(width, height) {
				var svg = this.svg;
				svg.setAttribute("width", width + "px");
				svg.setAttribute("height", height + "px");
				svg.setAttribute("x", "0px");
				svg.setAttribute("y", "0px");
				svg.setAttribute("viewBox", "0 0 " + width + " " + height);
	
				svg.setAttribute("xmlns", svgns);
				svg.setAttribute("version", "1.1");
	
				svg.setAttribute("style", "transform: translate(0,0)");
			}
		}, {
			key: "createGroup",
			value: function createGroup(x, y, parent) {
				var group = this.document.createElementNS(svgns, 'g');
				group.setAttribute("transform", "translate(" + x + ", " + y + ")");
	
				parent.appendChild(group);
	
				return group;
			}
		}, {
			key: "setGroupOptions",
			value: function setGroupOptions(group, options) {
				group.setAttribute("style", "fill:" + options.lineColor + ";");
			}
		}, {
			key: "drawRect",
			value: function drawRect(x, y, width, height, parent) {
				var rect = this.document.createElementNS(svgns, 'rect');
	
				rect.setAttribute("x", x);
				rect.setAttribute("y", y);
				rect.setAttribute("width", width);
				rect.setAttribute("height", height);
	
				parent.appendChild(rect);
	
				return rect;
			}
		}]);
	
		return SVGRenderer;
	}();
	
	exports.default = SVGRenderer;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ObjectRenderer = function () {
		function ObjectRenderer(object, encodings, options) {
			_classCallCheck(this, ObjectRenderer);
	
			this.object = object;
			this.encodings = encodings;
			this.options = options;
		}
	
		_createClass(ObjectRenderer, [{
			key: "render",
			value: function render() {
				this.object.encodings = this.encodings;
			}
		}]);
	
		return ObjectRenderer;
	}();
	
	exports.default = ObjectRenderer;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvalidInputException = function (_Error) {
		_inherits(InvalidInputException, _Error);
	
		function InvalidInputException(symbology, input) {
			_classCallCheck(this, InvalidInputException);
	
			var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));
	
			_this.name = "InvalidInputException";
	
			_this.symbology = symbology;
			_this.input = input;
	
			_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
			return _this;
		}
	
		return InvalidInputException;
	}(Error);
	
	var InvalidElementException = function (_Error2) {
		_inherits(InvalidElementException, _Error2);
	
		function InvalidElementException() {
			_classCallCheck(this, InvalidElementException);
	
			var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));
	
			_this2.name = "InvalidElementException";
			_this2.message = "Not supported type to render on";
			return _this2;
		}
	
		return InvalidElementException;
	}(Error);
	
	var NoElementException = function (_Error3) {
		_inherits(NoElementException, _Error3);
	
		function NoElementException() {
			_classCallCheck(this, NoElementException);
	
			var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));
	
			_this3.name = "NoElementException";
			_this3.message = "No element to render on.";
			return _this3;
		}
	
		return NoElementException;
	}(Error);
	
	exports.InvalidInputException = InvalidInputException;
	exports.InvalidElementException = InvalidElementException;
	exports.NoElementException = NoElementException;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*eslint no-console: 0 */
	
	var ErrorHandler = function () {
		function ErrorHandler(api) {
			_classCallCheck(this, ErrorHandler);
	
			this.api = api;
		}
	
		_createClass(ErrorHandler, [{
			key: "handleCatch",
			value: function handleCatch(e) {
				// If babel supported extending of Error in a correct way instanceof would be used here
				if (e.name === "InvalidInputException") {
					if (this.api._options.valid !== this.api._defaults.valid) {
						this.api._options.valid(false);
					} else {
						throw e.message;
					}
				} else {
					throw e;
				}
	
				this.api.render = function () {};
			}
		}, {
			key: "wrapBarcodeCall",
			value: function wrapBarcodeCall(func) {
				try {
					var result = func.apply(undefined, arguments);
					this.api._options.valid(true);
					return result;
				} catch (e) {
					this.handleCatch(e);
	
					return this.api;
				}
			}
		}]);
	
		return ErrorHandler;
	}();
	
	exports.default = ErrorHandler;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _remainScrollAfterCtaAction = __webpack_require__(73);
	
	var _remainScrollAfterCtaAction2 = _interopRequireDefault(_remainScrollAfterCtaAction);
	
	var _born = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var account = __webpack_require__(89),
	    bonusProductsView = __webpack_require__(63),
	
	// quickview = require('../quickview'),
	cartStoreInventory = __webpack_require__(152),
	    addToCart = __webpack_require__(72),
	    bornModules = __webpack_require__(3).default,
	    minicart = __webpack_require__(62),
	    page = __webpack_require__(58),
	    tooltip = __webpack_require__(47),
	    stickySummary = __webpack_require__(74),
	    customTooltip = __webpack_require__(80);
	
	var chatWidgetExist = false;
	
	function invalidateFormFields() {
	    var $cartForm = $('.js-cart-form'),
	        $jsErrorFields = $cartForm.find('.js-field-error');
	
	    if ($jsErrorFields.length > 0) {
	        $jsErrorFields.each(function () {
	            var $errorField = $(this).html().trim();
	
	            if ($errorField.length > 0) {
	                var $inputField = $(this).parent().parent().find('.selectric');
	                if ($inputField.length > 0) {
	                    $inputField.addClass('error');
	                }
	            }
	        });
	    }
	}
	
	function loadMiniCart() {
	    return new Promise(function (resolve) {
	        $.ajax({
	            url: Urls.miniCartShow,
	            type: 'GET'
	        }).done(function (response) {
	            minicart.replaceContent(response);
	        }).fail(function () {
	            page.refresh();
	        }).always(function () {
	            resolve();
	        });
	    });
	}
	
	//Common function to handle promo code UI
	function togglePromoCodeInterface($coupapplied) {
	    var closeCouponEntry = function closeCouponEntry(e) {
	        var $toggleEle = $('.order__summary__coupon__title,.promo_title,.order__summary__coupon__entry');
	        if ($(e.target).hasClass('coupon--active-overlay')) {
	            togglePromoCodeInterface(false);
	            $toggleEle.removeClass('toggle--active');
	            $(".order__summary__coupon__entry .error-message").text('');
	            $('input[name$="_couponCode"]').trigger('blur');
	        }
	    };
	    if ($(window).width() <= 767) {
	        if ($coupapplied === true) {
	            $('html,body').addClass('cancel-scroll');
	            $(".promo_title").parents('.cart-coupon-code').addClass('apply--promo-wrapper');
	            $(".js-cart-summary").addClass('apply--promo-codeopen');
	            $(".coupon--active-overlay").show();
	            $(window).on("click", closeCouponEntry);
	        } else {
	            $('html,body').removeClass('cancel-scroll');
	            $(".promo_title").parents('.cart-coupon-code').removeClass('apply--promo-wrapper');
	            $(".js-cart-summary").removeClass('apply--promo-codeopen');
	            $(".coupon--active-overlay").hide();
	        }
	        (0, _born.toggleChatWidget)(false);
	    }
	    $('input[name$="_couponCode"]').focus();
	}
	
	/**
	 * @private
	 * @function
	 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
	 */
	function initializeEvents() {
	    $('#cart-table').on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
	        e.preventDefault();
	        bonusProductsView.show(this.href);
	    });
	
	    // override enter key for coupon code entry
	    $('form input[name$="_couponCode"]').on('keydown', function (e) {
	        if (e.which === 13 && $(this).val().length === 0) {
	            return false;
	        }
	    });
	
	    //to prevent multiple submissions of the form when removing a product from the cart
	    var removeItemEvent = false;
	
	    (0, _remainScrollAfterCtaAction2.default)($('button[name$="deleteProduct"]'));
	
	    $('button[name$="deleteProduct"]').on('click', function (e) {
	        if (removeItemEvent) {
	            e.preventDefault();
	        } else {
	            removeItemEvent = true;
	        }
	    });
	
	    var addToCartCallback = function addToCartCallback() {
	        return new Promise(function (resolve) {
	            loadMiniCart().then(function () {
	                bornModules.selectTags.init();
	                bornModules.modalToggle.init();
	                bornModules.toggle.init();
	                invalidateFormFields();
	                resolve();
	            });
	        });
	    };
	
	    addToCart(addToCartCallback);
	
	    $("#main").on('click', '.js-cart-summary .promo_title', function (e) {
	        togglePromoCodeInterface(true);
	    });
	    $('#main').on('click', '#add-coupon', function () {
	        var couponText = $('input[name$="_couponCode"]').val().trim();
	        if (couponText.length) {
	            $(this).css('pointer-events', 'none');
	        }
	    });
	    var allowFormSubmit = true;
	    $('#main').on('keypress', '#coupon-form .coupon_txtbox', function (e) {
	        if (e.keyCode == 13 && !allowFormSubmit) {
	            e.preventDefault();
	        }
	    });
	    $('#main').on('submit', '#coupon-form', function (e) {
	        allowFormSubmit = false;
	        var couponCodeObj = $('input[name$="_couponCode"]');
	        if (couponCodeObj.length > 0) {
	            if (couponCodeObj.val().trim() == '') {
	                e.preventDefault();
	                couponCodeObj.addClass('error');
	            } else {
	                couponCodeObj.removeClass('error');
	            }
	        }
	    });
	
	    (0, _born.initCartCloseButton)();
	
	    if (typeof zE !== 'undefined' && !!zE) {
	        zE(function () {
	            zE.hide();
	        });
	    }
	
	    if ($(".order__summary__coupon__entry").hasClass('toggle--active')) {
	        var $target = $(".order__summary__coupon__entry .error-message").text();
	        $target != "" ? togglePromoCodeInterface(true) : togglePromoCodeInterface(false);
	    }
	
	    $(document).ready(function () {
	        var cartLimitInterval = 0;
	        var cartInterval = setInterval(function () {
	            if ((0, _born.checkChatWidget)() || cartLimitInterval > 5) {
	                clearInterval(cartInterval);
	                chatWidgetExist = true;
	                (0, _born.toggleChatWidget)(false);
	            }
	            cartLimitInterval += 1;
	        }, 70);
	        $('.js-header-search-trigger, .header__mobile-trigger').on('click', function () {
	            if ($(window).width() <= 767) {
	                $('#cart-summary, .payment-modes').toggleClass('hidden');
	            }
	        });
	        $('.search-titlebar-mobile .close-icon').on('click', function () {
	            $('#cart-summary, .payment-modes').removeClass('hidden');
	        });
	    });
	
	    window.addEventListener('load', function () {
	        var cartLimitInterval = 0;
	        var cartInterval = setInterval(function () {
	            (0, _born.toggleChatWidget)(false);
	            if (cartLimitInterval >= 8) {
	                clearInterval(cartInterval);
	                (0, _born.toggleChatWidget)(false);
	            }
	            cartLimitInterval += 1;
	        }, 1500);
	    });
	    (0, _born.initReplaceContent)('.bag-return');
	
	    $('#TabbyPromoInstallments,#TabbyPromoInstallmentCopy').on('click', function () {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            "event": 'custom_event',
	            "eventCategory": 'cart_page',
	            "eventAction": 'cart_about_tabby',
	            "eventLabel": 'cart about tabby click',
	            "country": window.GlobalAttributes.COUNTRY,
	            "language": window.GlobalAttributes.LANGUAGE,
	            "screenName": 'Cart page',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.order__summary__coupon__title').on('click', function () {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        if ($('.order__summary__coupon__title').hasClass('toggle--active')) {
	            dataLayer.push({
	                "event": 'custom_event',
	                "eventCategory": 'cart_page',
	                "eventAction": 'cart_promocode_click',
	                "eventLabel": 'cart promocode click',
	                "country": window.GlobalAttributes.COUNTRY,
	                "language": window.GlobalAttributes.LANGUAGE,
	                "screenName": 'Cart page',
	                "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	                "userId": user.user_id != '' ? user.user_id : ''
	            });
	        }
	    });
	}
	
	exports.init = function () {
	    invalidateFormFields();
	    initializeEvents();
	
	    if (SitePreferences.STORE_PICKUP) {
	        cartStoreInventory.init();
	    }
	
	    account.initCartLogin();
	    tooltip.init();
	    customTooltip.initShippingFeeCustomToolTipEvents();
	};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inventory = __webpack_require__(70);
	
	var cartInventory = {
	    setSelectedStore: function setSelectedStore(storeId) {
	        var $selectedStore = $('.store-tile.' + storeId),
	            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
	            storeAddress = $selectedStore.find('.store-address').html(),
	            storeStatus = $selectedStore.find('.store-status').data('status'),
	            storeStatusText = $selectedStore.find('.store-status').text();
	        this.selectedStore = storeId;
	
	        $lineItem.find('.instore-delivery .selected-store-address').data('storeId', storeId).attr('data-store-id', storeId).html(storeAddress);
	        $lineItem.find('.instore-delivery .selected-store-availability').data('status', storeStatus).attr('data-status', storeStatus).text(storeStatusText);
	        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
	    },
	    cartSelectStore: function cartSelectStore(selectedStore) {
	        var self = this;
	        inventory.getStoresInventory(this.uuid).then(function (stores) {
	            inventory.selectStoreDialog({
	                stores: stores,
	                selectedStoreId: selectedStore,
	                selectedStoreText: Resources.SELECTED_STORE,
	                continueCallback: function continueCallback() {},
	                selectStoreCallback: self.setSelectedStore.bind(self)
	            });
	        }).done();
	    },
	    setDeliveryOption: function setDeliveryOption(value, storeId) {
	        // set loading state
	        $('.item-delivery-options').addClass('loading').children().hide();
	
	        var data = {
	            plid: this.uuid,
	            storepickup: value === 'store' ? true : false
	        };
	        if (value === 'store') {
	            data.storepickup = true;
	            data.storeid = storeId;
	        } else {
	            data.storepickup = false;
	        }
	        $.ajax({
	            url: Urls.setStorePickup,
	            data: data,
	            success: function success() {
	                // remove loading state
	                $('.item-delivery-options').removeClass('loading').children().show();
	            }
	        });
	    },
	    init: function init() {
	        var self = this;
	        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
	            e.preventDefault();
	            self.uuid = $(this).data('uuid');
	            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
	            if (!User.zip) {
	                inventory.zipPrompt(function () {
	                    self.cartSelectStore(selectedStore);
	                });
	            } else {
	                self.cartSelectStore(selectedStore);
	            }
	        });
	        $('.item-delivery-options .delivery-option').on('click', function () {
	            // reset the uuid
	            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
	            self.uuid = $(this).closest('.cart-row').data('uuid');
	            self.setDeliveryOption($(this).val(), selectedStore);
	        });
	    }
	};
	
	module.exports = cartInventory;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var address = __webpack_require__(154),
	    billing = __webpack_require__(156),
	    multiship = __webpack_require__(158),
	    shipping = __webpack_require__(155),
	    tooltip = __webpack_require__(80);
	
	/**
	 * @function Initializes the page events depending on the checkout stage (shipping/billing)
	 */
	exports.init = function () {
	    address.init();
	    if ($('.checkout-shipping').length > 0) {
	        shipping.init();
	    } else if ($('.checkout-multi-shipping').length > 0) {
	        multiship.init();
	    } else {
	        billing.init();
	    }
	
	    //if on the order review page and there are products that are not available diable the submit order button
	    if ($('.order-summary-footer').length > 0) {
	        if ($('.notavailable').length > 0) {
	            $('.order-summary-footer .submit-order .button').attr('disabled', 'disabled');
	        }
	    }
	    $('#main').on('submit', '.submit-order', function () {
	        // Clone approach is needed for Safari
	        var $placeOrder = $('.js-place-order'),
	            $placeOrderClone = $placeOrder.clone().addClass('button--inactive');
	
	        $placeOrder.after($placeOrderClone);
	        $placeOrder.remove();
	    });
	
	    $('#main').on('click', '.js-place-order', function (e) {
	        if ($(this).hasClass('button--inactive')) {
	            e.preventDefault();
	        }
	    });
	    tooltip.initShippingFeeCustomToolTipEvents();
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15),
	    shipping = __webpack_require__(155),
	    dynamicAddress = __webpack_require__(92),
	    addressUtil = __webpack_require__(94);
	
	/**
	 * @function
	 * @description Selects the first address from the list of addresses
	 */
	exports.init = function () {
	    var $form = $('.address'),
	        $addressList = $('input[name$="_addressList"]');
	    // select address from list
	    $($addressList, $form).on('change', function () {
	
	        if ($('input[name$="_saveBillingAddress"]').val() == "1") {
	            $('input[name$="_addressList"]').prop('checked', false);
	        }
	
	        var selected = $('input[name$="_addressList"]:checked');
	        var selectedAddress = $(selected).data('address');
	
	        if (!selectedAddress) {
	            return;
	        }
	
	        selectedAddress['phone--dummy'] = selectedAddress.phone;
	
	        //If the dynamic fields container is present, run fillAddressFields after new format is in place.
	        if (document.querySelector('.order--checkout__dynamic-fields')) {
	            dynamicAddress.getAddressFields(selectedAddress.countryCode, '.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm, util.fillAddressFields.bind(this, selectedAddress, $form));
	        } else {
	            util.fillAddressFields(selectedAddress, $form);
	            addressUtil.updateFields();
	        }
	
	        shipping.updateShippingMethodList();
	        // re-validate the form
	        // var validator = $form.validate({
	        //     ignore: '[name*="paymentMethods"]'
	        // });
	
	        // $form.validate().form();
	    });
	    $(function () {
	        if ($('input[name$="_saveBillingAddress"]').val() == "1") {
	            $('input[name$="_addressList"]').prop('checked', false);
	        } else {
	            var unsaveddAddress = $('[id$="_unsavedAddressBook"]').is(':checked');
	            if (!unsaveddAddress) {
	                $addressList.trigger('change');
	            }
	        }
	    });
	};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _billing = __webpack_require__(156);
	
	var ajax = __webpack_require__(42),
	    formPrepare = __webpack_require__(93),
	    progress = __webpack_require__(43),
	    tooltip = __webpack_require__(47),
	    util = __webpack_require__(15),
	    bornModules = __webpack_require__(3).default,
	    dynamicAddress = __webpack_require__(92),
	    addressUtil = __webpack_require__(94),
	    page = __webpack_require__(58),
	    login = __webpack_require__(91);
	
	var shippingMethods;
	/**
	 * @function
	 * @description Initializes gift message box, if shipment is gift
	 */
	function giftMessageBox() {
	    if ($('textarea[name$="_shippingAddress_giftMessage"]').val() != '' && $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true') {
	        $('textarea[name$="_shippingAddress_giftMessage"]').val('');
	    }
	    // show gift message box, if shipment is gift
	    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
	}
	
	function toggleGiftMessageBox() {
	    $('#giftMsgToggleTrigger').on('click', function () {
	        $('input[name$="_shippingAddress_isGift"]:not(:checked)').trigger('click');
	        if (!$('.gift-message-text').hasClass('hidden')) {
	            var user = dataLayer.find(function (o) {
	                return o.user != null;
	            }).user;
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'checkout_page',
	                'eventAction': 'checkout_gift_message_click',
	                'eventLabel': 'checkout gift message click',
	                'country': window.GlobalAttributes.COUNTRY,
	                'language': window.GlobalAttributes.LANGUAGE,
	                'screenName': 'Checkout Page',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        }
	    });
	}
	
	/**
	 * @function
	 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
	 */
	function updateSummary(paymentMethod, page) {
	    var $summary = $('#secondary.summary');
	    // indicate progress
	    progress.show($summary);
	    var updateSummaryUrl = Urls.summaryRefreshURL;
	    if (paymentMethod !== undefined && paymentMethod !== null) {
	        updateSummaryUrl = updateSummaryUrl + '?paymentMethod=' + paymentMethod;
	    }
	    var resolve;
	    var promise = new Promise(function (res, reject) {
	        resolve = res;
	    });
	    // load the updated summary area
	    $summary.load(updateSummaryUrl, function () {
	        // hide edit shipping method link
	        $summary.fadeIn('fast');
	        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
	        $summary.find('.order-totals-table .order-shipping .label a').hide();
	        bornModules.toggle.init();
	        // toggleSummaryMobileView();
	        // initCouponAction('billing');
	        paymentMethod == 'DW_COD' ? toggleGiftCertificateSection(false) : toggleGiftCertificateSection(true);
	        paymentMethod == 'CHECKOUTCOM_APPLE_PAY' ? toggleApplePayGiftCertificateSection(false) : toggleApplePayGiftCertificateSection(true);
	        resolve();
	    });
	    return promise;
	}
	
	function toggleGiftCertificateSection(status) {
	    if (SitePreferences.DISABLE_GC_AND_COD_COMBO) {
	        !status ? $('.gift-promo-toggle').hide() : $('.gift-promo-toggle').show();
	    }
	}
	function toggleApplePayGiftCertificateSection(status) {
	    !status ? $('.gift-promo-toggle').hide() : $('.gift-promo-toggle').show();
	}
	
	/**
	 * Sets form data if available on the sessionStorage object, then clears it.
	 * @return {[type]} [description]
	 */
	function resetShippingFormData() {
	    var parsedData = JSON.parse(window.sessionStorage.getItem('shippingFormData')),
	        shippingFieldID = 'shippingAddress_addressFields';
	    if (!parsedData) {
	        return;
	    }
	
	    parsedData.forEach(function (storedField) {
	        if (storedField.name.indexOf(shippingFieldID) !== -1) {
	            var fieldEl = document.querySelector('[name="' + storedField.name + '"]');
	
	            if (fieldEl !== undefined && fieldEl != null) {
	                fieldEl.value = storedField.value;
	                if (fieldEl.nodeName === 'SELECT') {
	                    $(fieldEl).trigger('change');
	                }
	                $(fieldEl).trigger('change');
	            }
	        }
	    });
	
	    window.sessionStorage.removeItem('shippingFormData');
	}
	
	$('.packaging-option').on('change', function () {
	    var attribute = $(this).find('input').attr('value'),
	        price = $('.signature-price').data('signature');
	
	    $.ajax({
	        dataType: 'json',
	        contentType: 'application/json',
	        url: Urls.handlePackagingPriceSelection,
	        type: 'POST',
	        data: JSON.stringify({
	            attribute: attribute,
	            price: price
	        })
	    }).always(function () {
	        updateSummary();
	    });
	});
	
	/**
	 * @function
	 * @description Helper method which constructs a URL for an AJAX request using the
	 * entered address information as URL request parameters.
	 */
	function getShippingMethodURL(url, extraParams) {
	    var $form = $('.address');
	    var address3 = $form.find('input[name$="_address3"]').length > 0 ? $form.find('input[name$="_address3"]').val() : '';
	    var params = {
	        address1: $form.find('input[name$="_address1"]').val(),
	        address2: $form.find('input[name$="_address2"]').val(),
	        address3: address3,
	        countryCode: $form.find('[id$="_country"]').val(),
	        stateCode: $form.find('[id$="_state"]').val(),
	        postalCode: $form.find('input[name$="_postal"]').val(),
	        city: $form.find('[name$="_city"]').val()
	    };
	    return util.appendParamsToUrl(url, $.extend(params, extraParams));
	}
	
	/**
	 * @function
	 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
	 * @param
	 */
	function selectShippingMethod(shippingMethodID) {
	    // nothing entered
	    if (!shippingMethodID) {
	        return;
	    }
	    // attempt to set shipping method
	    var url = getShippingMethodURL(Urls.selectShippingMethodsList, { shippingMethodID: shippingMethodID });
	    ajax.getJson({
	        url: url,
	        callback: function callback(data) {
	            updateSummary();
	            if (!data || !data.shippingMethodID) {
	                window.alert('Couldn\'t select shipping method.');
	                return false;
	            }
	            // display promotion in UI and update the summary section,
	            // if some promotions were applied
	            $('.shippingpromotions').empty();
	
	            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
	            //     var len = data.shippingPriceAdjustments.length;
	            //     for (var i=0; i < len; i++) {
	            //         var spa = data.shippingPriceAdjustments[i];
	            //     }
	            // }
	        }
	    });
	}
	
	/**
	 * @function
	 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
	 * based on the merchandise in the cart and the currently entered shipping address
	 * (the address may be only partially entered).  If the list of applicable shipping methods
	 * has changed because new address information has been entered, then issue another AJAX
	 * request which updates the currently selected shipping method (if needed) and also updates
	 * the UI.
	 */
	function updateShippingMethodList() {
	    var $shippingMethodList = $('#shipping-method-list');
	    if (!$shippingMethodList || $shippingMethodList.length === 0) {
	        return;
	    }
	    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
	
	    ajax.getJson({
	        url: url,
	        callback: function callback(data) {
	            if (!data) {
	                console.error('Couldn\'t get list of applicable shipping methods.');
	                return false;
	            }
	            if (shippingMethods && shippingMethods.toString() === data.toString()) {
	                // No need to update the UI.  The list has not changed.
	                return true;
	            }
	
	            // We need to update the UI.  The list has changed.
	            // Cache the array of returned shipping methods.
	            shippingMethods = data;
	            // indicate progress
	            progress.show($shippingMethodList);
	
	            // load the shipping method form
	            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
	
	            $shippingMethodList.load(smlUrl, function () {
	                $shippingMethodList.fadeIn('fast');
	                // rebind the radio buttons onclick function to a handler.
	                $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
	                    selectShippingMethod($(this).val());
	                });
	
	                // update the summary
	                updateSummary();
	                progress.hide();
	                // tooltip.init();
	                //if nothing is selected in the shipping methods select the first one
	                if ($shippingMethodList.find('.input-control:checked').length === 0) {
	                    var $sameday = $shippingMethodList.find('#shipping-method-SAMEDAY');
	                    if ($sameday.length) {
	                        $sameday.click();
	                    } else {
	                        $shippingMethodList.find('.input-control:first').prop('checked', 'checked');
	                    }
	                }
	            });
	        }
	    });
	}
	
	/**
	 * Syncs the useAsBillingAddress checkboxes to allow display under "Saved Addresses" as well.
	 * @return {[type]} [description]
	 */
	function setupUseAsBilling() {
	    var useAsBillingChecks = document.querySelectorAll('[name*="useAsBillingAddress"]');
	
	    [].forEach.call(useAsBillingChecks, function (el) {
	        el.addEventListener('change', syncUseAsBilling);
	    });
	}
	
	function syncUseAsBilling(evt) {
	    var useAsBillingChecks = document.querySelectorAll('[name*="useAsBillingAddress"]');
	
	    [].forEach.call(useAsBillingChecks, function (el) {
	        el.checked = this.checked;
	    }.bind(this));
	}
	
	function isVisibleSavedAddress() {
	    var $isVisible = $('.order--checkout--limit').is(':visible');
	    if ($isVisible) {
	        formPrepare.validateForm();
	    }
	}
	
	function cleanAddressForm() {
	    $('input[name$="_firstName"]').val('');
	    $('input[name$="_lastName"]').val('');
	    $('input[name$="_phone"]').val('');
	    $('input[name$="_phone--dummy"]').val('');
	    $('input[name$="_emailAddress"]').val('');
	    $('input[name$="_address1"]').val('');
	    $('input[name$="_address2"]').val('');
	    $('input[name$="_address3"]').val('');
	    $('input[name$="_zoneNumber"]').val('');
	    $('input[name$="_unitNumber"]').val('');
	    $('input[name$="_streetNumber"]').val('');
	    $('input[name$="_buildingNumber"]').val('');
	
	    var countryEl = $('[name$="_country"]');
	    if (countryEl && countryEl.length > 0 && countryEl.val() == 'kw' && !addressUtil.isDependentAddress()) {
	        $('select[name$="_area"]').val("").trigger("change");
	        $('select[name$="_district"]').val("").trigger("change");
	        $('select[name$="_area"]').parents('.field-wrapper').siblings('.error').remove();
	        $('select[name$="_district"]').parents('.field-wrapper').siblings('.error').remove();
	    } else {
	        $('select[name$="_city"]').val("").trigger("change");
	        $('select[name$="_area"]').val("").trigger("change");
	        $('select[name$="_district"]').val("").trigger("change");
	        $('select[name$="_city"]').parents('.field-wrapper').siblings('.error').remove();
	        $('select[name$="_area"]').parents('.field-wrapper').siblings('.error').remove();
	        $('select[name$="_district"]').parents('.field-wrapper').siblings('.error').remove();
	    }
	}
	
	function detectEditChanges() {
	    var $form = $('.address');
	    $('.js-us-different-address').on('click', isVisibleSavedAddress).on('click', function () {
	        $form.find('[id$="_editAddressBook"]').prop('checked', false);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', true);
	        $form.find('input[name$="_addressList"]').prop('checked', false);
	        $('.custom-address-modal').removeClass('update').addClass('new');
	        $('.custom-address-modal .custom-address').removeClass('hidden');
	        $('.saved-address .js-edit').addClass('hidden');
	        cleanAddressForm();
	        initializeAddressType();
	    });
	    $('.js-us-saved-address').on('click', isVisibleSavedAddress).on('click', function (e) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        $form.find('[id$="_editAddressBook"]').prop('checked', false);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
	        $form.find('input[name$="_addressList"]').prop('checked', false);
	        formPrepare.validateForm();
	        $('.saved-address .js-edit').removeClass('hidden');
	    });
	    $('.js-edit').on('click', function () {
	        $form.find('[id$="_editAddressBook"]').prop('checked', true);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
	        addressUtil.initGovernateEvents();
	        addressUtil.updateGovernateInfo();
	        formPrepare.validateForm();
	        $($(this).data('toggler')).addClass('toggle--active');
	        $('.custom-address-modal').removeClass('new').addClass('update');
	        $('.custom-address-modal .custom-address').removeClass('hidden');
	        scrollHere($('.custom-address-modal').first());
	    });
	}
	
	function scrollHere(element) {
	    $([document.documentElement, document.body]).animate({
	        scrollTop: element.offset().top
	    }, 500);
	}
	
	function isAddressSelected() {
	    var $radiobuttons = $('input[name$="_addressList"]'),
	        $submit = $('[type="submit"]');
	
	    var addressBookIdValue = $(this).data('address').ID;
	    setUpAddressId(addressBookIdValue);
	
	    for (var i = 0; i < $radiobuttons.length; i++) {
	        if ($radiobuttons[i].type === 'radio' && $radiobuttons[i].checked) {
	            $submit.prop('disabled', false);
	            break;
	        } else {
	            $submit.prop('disabled', true);
	        }
	    }
	}
	
	function setUpAddressId(addressBookIdValue) {
	    var $addressBookId = $('.address').find('[id$="_addressBookId"]');
	    if ($addressBookId && addressBookIdValue) {
	        $addressBookId.val(addressBookIdValue);
	    }
	}
	
	function listenLoginModalClickaway() {
	    var $modalWrapper = $('#loginModal');
	    $('#continueAsGuest').on('click', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        $modalWrapper.removeClass('active');
	        $('html, body').removeClass('no-scroll');
	        history.pushState({}, '', Urls.shipping);
	    });
	    $('[id$="loginCloseBtn"]').on('click', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        $modalWrapper.removeClass('active');
	        $('html, body').removeClass('no-scroll');
	        history.pushState({}, '', Urls.shipping);
	    });
	}
	
	function triggerMobBack() {
	    $('.address-back.shipping').on('click', function () {
	        $('.js-us-saved-address').first().trigger('click');
	    });
	}
	
	function selectAddressType() {
	    var $addressType = $('select[name$="_addressType"]');
	    $('.address-type-selector').on('click', '.address-type.selectable:not(.active)', function () {
	        $('.address-type-selector .address-type.active').removeClass('active');
	        $addressType.val($(this).data('value'));
	        $(this).addClass('active');
	    });
	}
	
	function savedAddressClickHandle() {
	    $('.saved-address-preview').on('click', function () {
	        var _this = this;
	
	        var isChecked = false;
	        $('.saved-address-preview').find('input').each(function (i, ele) {
	            isChecked = $(ele).prop('checked');
	            return !isChecked;
	        });
	        if (!isChecked) {
	            $('.js-us-saved-address').trigger('click');
	            setTimeout(function () {
	                $(_this).find('input').prop('checked', true);
	            }, 0);
	        }
	    });
	}
	
	function heightAdjustOnCartOpen() {
	    $('#mini-cart-toggler').on('click', function () {
	        var heightToSet = $('#secondary').height();
	        $('#checkoutSpacer.shipping').height(heightToSet - 40).toggleClass('hidden');
	    });
	}
	
	$(document).ready(function () {
	    if (typeof zE !== 'undefined' && !!zE) {
	        zE(function () {
	            zE.hide();
	        });
	    }
	    $('#loginModalform').length && $('body').addClass('guest-checkout');
	    $('.new-address:not(.guest-address-modal)').length && $('body').addClass('user-checkout-no-saved');
	});
	function loginModalInit() {
	    var $loginForm = $('#loginModalform');
	    var $submit = $loginForm.find('[name$="_login_login"]');
	    $loginForm.length && $('#loginModal').hasClass('active') && $('html, body').addClass('no-scroll');
	    $($submit).on('click', function (e) {
	        sendLoginButtonEvent();
	        if (!$loginForm.valid()) {
	            return;
	        }
	        e.preventDefault();
	        var data = $loginForm.serialize();
	        data += '&' + $submit.attr('name') + '=';
	        if (data.indexOf('ajax') === -1) {
	            data += '&format=ajax';
	        }
	        $.ajax({
	            type: 'POST',
	            url: $loginForm.attr('action'),
	            data: data,
	            beforeSend: function beforeSend() {
	                $loginForm.find('.show-response').html('');
	            },
	            success: function success(response) {
	                if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
	                    page.redirect(Urls.csrffailed);
	                } else if (response.error !== undefined) {
	                    if (response.verifyEmail !== undefined) {
	                        page.redirect(Urls.accountverify + '&email=' + encodeURIComponent(response.customeremail));
	                    }
	                    showAjaxError($loginForm, '<div class="error-form">' + response.message + '</div>');
	                    userLoginFailedEvent(response.message, window.GlobalAttributes.country, window.GlobalAttributes.locale);
	                    if (response.showCaptcha !== undefined && response.showCaptcha) {
	                        window.SessionAttributes.SHOW_CAPTCHA = true;
	                        __webpack_require__(88)();
	                    }
	                } else if (response.success !== undefined) {
	                    sessionStorage.setItem('loginBtnClick', true);
	                    page.redirect(Urls.shipping);
	                }
	            },
	            failure: function failure() {
	                showAjaxError($loginForm, Resources.SERVER_ERROR);
	            }
	        });
	    });
	    $('#btnModalRegister').on('click', function () {
	        $('.registerModalForm').removeClass('hidden');
	        $('#loginModalform').addClass('hidden');
	        $('#btnModalRegister').addClass('active');
	        $('#btnModalLogin').removeClass('active');
	    });
	    $('#btnModalLogin').on('click', function () {
	        $('#loginModalform').removeClass('hidden');
	        $('.registerModalForm').addClass('hidden');
	        $('#btnModalLogin').addClass('active');
	        $('#btnModalRegister').removeClass('active');
	    });
	    var switchToScreen2 = function switchToScreen2() {
	        $('.login-modal.screen-1').addClass('hidden');
	        $('.login-modal.screen-2').removeClass('hidden');
	    };
	    $('#screen1Login').on('click', switchToScreen2);
	    $('.goto-register').on('click', function () {
	        switchToScreen2();
	        $('#btnModalRegister').trigger('click');
	    });
	    (0, _billing.initCouponAction)('shipping');
	}
	
	function showAjaxError(form, msg) {
	    form.find('.show-response').html(msg);
	}
	function initializeAddressType() {
	    var $addressType = $('select[name$="_addressType"]');
	    $('.address-type-selector .address-type.active').removeClass('active');
	    $addressType.val('home');
	    $(".address-type.selectable[data-value=home]").addClass('active');
	}
	
	function hideAddressSuggestionOnScroll() {
	    $('.custom-address-modal').on('scroll', function () {
	        var $container = $('.pac-container');
	        if ($container.is(':visible')) {
	            $container.css('display', 'none');
	        }
	    }).on('click', '.pac-target-input', function () {
	        var $container = $('.pac-container');
	        var elementOffset = $('.pac-target-input').offset().top;
	        if ($container.is(':parent') && !$container.is(':visible')) {
	            $container.css({
	                'display': 'block',
	                'top': elementOffset + 50
	            });
	        }
	    });
	}
	
	function loginPopupGAEvents() {
	    var user = dataLayer.find(function (o) {
	        return o.user != null;
	    }).user;
	
	    $('.login-modal-wrapper .login-modal .screen-1--body #screen1Login').on('click', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': 'checkout_login',
	            'eventLabel': 'checkout login click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.login-modal-wrapper .login-modal .screen-1--body .goto-register').on('click', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': 'checkout_register_now_click',
	            'eventLabel': 'checkout register now click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.login-modal-wrapper .login-modal .screen-1--body #continueAsGuest').on('click', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': 'checkout_continue_as_guest',
	            'eventLabel': 'checkout continue as guest',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('.js-us-different-address').on('click', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': 'chkout_add_new_shipping_address_click ',
	            'eventLabel': 'checkout add new shipping address click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.order--checkout--limit').find('.save-btn').on('click', function (e) {
	        var isValid = $('#dwfrm_singleshipping_shippingAddress').valid();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': isValid ? 'checkout_add_new_shipping_address_pass' : 'checkout_add_new_shipping_address_fail',
	            'eventLabel': isValid ? 'checkout add new shipping address success' : 'checkout add new shipping address failed',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	}
	
	exports.init = function () {
	    //addressFields on the name has been changed to shippingaddress 
	    //cause we're not using isdynamicform on the checkout.
	    var shippingFields = 'input[name$="_address1"], input[name$="_address2"], input[name$="_address3"], [name$="_states_state"], [name$="_city"], input[name$="_zip"], input[name$="_postal"]';
	    var addressBookIdValue = $('input[name$="_addressList"]:checked').length > 0 ? $('input[name$="_addressList"]:checked').data('address').ID : '';
	    formPrepare.init({
	        continueSelector: '[name$="shippingAddress_save"]',
	        formSelector: '[id$="singleshipping_shippingAddress"]'
	    });
	    $(document).ready(function () {
	        if ($('.is-guest-user').length > 0) {
	            resetShippingFormData();
	        }
	    });
	    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
	
	    $('.payment-method-options').on('click', isVisibleSavedAddress);
	
	    $('.address').on('change', shippingFields, updateShippingMethodList);
	    $('.address').on('change', shippingFields, formPrepare.validateForm);
	    $('input[name$="_addressList"]').on('click', isAddressSelected);
	    tooltip.init();
	    giftMessageBox();
	    toggleGiftMessageBox();
	    updateShippingMethodList();
	    setupUseAsBilling();
	    dynamicAddress.init('.order--checkout__dynamic-form');
	    detectEditChanges();
	    setUpAddressId(addressBookIdValue);
	    listenLoginModalClickaway();
	    selectAddressType();
	    savedAddressClickHandle();
	    heightAdjustOnCartOpen();
	    // toggleSummaryMobileView();
	    triggerMobBack();
	    hideAddressSuggestionOnScroll();
	
	    $('.positivenumber').on('input', function (e) {
	        this.value = this.value.replace(/\D/g, '');
	    });
	
	    loginModalInit();
	    login.passwordResetPopup();
	    loginPopupGAEvents();
	    login.initLoginActionEvents();
	};
	
	exports.updateShippingMethodList = updateShippingMethodList;
	exports.updateSummary = updateSummary;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _born = __webpack_require__(10);
	
	var ajax = __webpack_require__(42),
	    formPrepare = __webpack_require__(93),
	    giftcard = __webpack_require__(157),
	    util = __webpack_require__(15),
	    shipping = __webpack_require__(155),
	    dynamicAddress = __webpack_require__(92),
	    progress = __webpack_require__(43),
	    bornModules = __webpack_require__(3).default,
	    addressUtil = __webpack_require__(94),
	    _ = __webpack_require__(7);
	
	var isFormElFound = false;
	var addressToEdit = null;
	
	/**
	 * @function
	 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
	 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
	 */
	function setCCFields(data) {
	    var $creditCard = $('[data-method="CREDIT_CARD"]');
	    $creditCard.find('input[name$="cardPaymentForm_owner"]').val(data.holder).trigger('change');
	    $creditCard.find('input[name$="_type"]').val(data.type).trigger('change');
	    $creditCard.find('input[name*="_cardPaymentForm_number"]').val(data.maskedNumber).trigger('change');
	    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
	    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
	    $creditCard.find('input[name*="cardPaymentForm_cvn"]').val('').trigger('change');
	    formPrepare.validateForm();
	}
	
	function cleanCardForm() {
	    var $creditCard = $('[data-method="CREDIT_CARD"]').trigger('change');
	    $creditCard.find('input[name$="cardPaymentForm_owner"]').val('').trigger('change');
	    $creditCard.find('input[name*="_cardPaymentForm_number"]').val('').trigger('change');
	    $creditCard.find('[name$="_cardPaymentForm_expiration_month"]').val('').trigger('change');
	    $creditCard.find('[name$="_year"]').val('').trigger('change');
	
	    if ($('#dw_cardTypeDone').length > 0) {
	        $('#dw_cardTypeDone').find('img').hide();
	        $('#default_thumb').show();
	    }
	    $creditCard.find('[id$="cardPaymentForm_type"]').val('');
	    $creditCard.find('[name$="_saveCard"]')[0].checked = false;
	    $creditCard.find('input[name$="cardPaymentForm_cardToken"]').val('');
	    if ($('.cvn input[name*="cardPaymentForm_cvn"]').length <= 0) {
	        $('input[name*="cardPaymentForm_cvn"]').removeClass('error').insertAfter('.cvn .field-wrapper label');
	    }
	    $creditCard.find('input[name*="cardPaymentForm_cvn"]').val('').trigger('change');
	    formPrepare.validateForm();
	}
	
	function cleanAddressForm() {
	    $('input[name$="_firstName"]').val('');
	    $('input[name$="_lastName"]').val('');
	    $('input[name$="_phone"]').val('');
	    $('input[name$="_address1"]').val('');
	    $('input[name$="_address2"]').val('');
	    $('input[name$="_address3"]').val('');
	    $('input[name$="_postal"]').val('');
	    var countryEl = $('[name$="_country"]');
	    if (countryEl && countryEl.length > 0) {
	        if (countryEl.val() == 'kw' && !addressUtil.isDependentAddress()) {
	            return;
	        }
	    }
	    $('input[name$="_city"]').val('');
	}
	
	/**
	 * @function
	 * @description Updates the credit card form with the attributes of a given card
	 * @param {String} cardID the credit card ID of a given card
	 */
	function populateCreditCardForm(cardID) {
	    // load card details
	    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
	    ajax.getJson({
	        url: url,
	        callback: function callback(data) {
	            if (!data) {
	                window.alert(Resources.CC_LOAD_ERROR);
	                return false;
	            }
	            setCCFields(data);
	        }
	    });
	}
	
	/**
	 * @function
	 * @description Changes the payment method form depending on the passed paymentMethodID
	 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
	 */
	function updatePaymentMethod(paymentMethodID) {
	    var $paymentMethods = $('.payment-method');
	    $paymentMethods.removeClass('payment-method-expanded');
	
	    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + paymentMethodID + '"]');
	    if ($selectedPaymentMethod.length === 0) {
	        // Select the active method if it is present in template
	        $selectedPaymentMethod = $('[data-method="CustomObject"], [data-method="Custom"]');
	    }
	    $selectedPaymentMethod.addClass('payment-method-expanded');
	
	    // ensure checkbox of payment method is checked
	    $('.payment-method-options').val() != paymentMethodID && $('.payment-method-options').val(paymentMethodID).change().selectric('refresh');
	
	    if (paymentMethodID == 'CHECKOUTCOM_APM') {
	        resetAPMPaymentMethod();
	    }
	
	    if (paymentMethodID === 'CHECKOUTCOM_APPLE_PAY' && window.innerWidth >= 768) {
	        $('#submit-order').addClass('hidden');
	        $('.billing-address-form-wrapper').addClass('hidden');
	    } else {
	        $('#submit-order').removeClass('hidden');
	        $('.billing-address-form-wrapper').removeClass('hidden');
	    }
	    if (paymentMethodID === 'CHECKOUTCOM_APPLE_PAY' && window.innerWidth < 768) {
	        $('#ckoApplePayButton').addClass('apple-pay-button-checkout-hidden');
	        $('#submit-order').addClass('hidden');
	        $('.billing-address-form-wrapper').addClass('hidden');
	        $('#applePayDummyBtn').removeClass('hidden').on('click.triggerApplePay', function () {
	            $('#ckoApplePayButton').trigger('click');
	        });
	    } else if ($('.apple-pay-button-checkout-hidden').length) {
	        $('#ckoApplePayButton').removeClass('apple-pay-button-checkout-hidden');
	        $('#submit-order').removeClass('hidden');
	        $('.billing-address-form-wrapper').removeClass('hidden');
	        $('#applePayDummyBtn').addClass('hidden').off('click.triggerApplePay');
	    }
	    formPrepare.validateForm();
	
	    if (paymentMethodID === 'DW_COD') {
	        $(document).trigger('checkformbutton');
	    }
	}
	
	function getBEErrorEl($field) {
	    return $field.find('.error-message').length ? $field.find('.error-message') : $('<p class="form-caption error-message"></p>').insertAfter($field.find('input'));
	}
	/**
	 * Stores form data for later usage on page refresh.
	 * @param  {[type]} $form [description]
	 * @return {[type]}       [description]
	 */
	function storeShippingFormData($form) {
	    window.sessionStorage.setItem('shippingFormData', JSON.stringify($form.serializeArray()));
	}
	
	function processPromoEntry(e, options, param, page) {
	    e.preventDefault();
	
	    if (page === undefined) {
	        page = 'billing';
	    }
	
	    var $promoField;
	    if (param == 'coupon' || page == 'shipping') {
	        $promoField = $('.order__summary__coupon');
	    } else {
	        $promoField = $('.order--checkout__' + options.type);
	    }
	
	    if (param === 'coupon' && $('.is-guest-user').length > 0) {
	        var $closestShippingForm = $('[id$="singleshipping_shippingAddress"]');
	        storeShippingFormData($closestShippingForm);
	    }
	
	    var $error = getBEErrorEl($promoField);
	
	    if (options.code.length === 0) {
	        $promoField.addClass('error');
	        $error.html(options.missingError);
	
	        return;
	    }
	
	    var url = util.appendParamsToUrl(options.controller, options.params);
	
	    $.getJSON(url, function (data) {
	        var fail = false;
	        var msg = '';
	        var dataMsg;
	
	        if (!data) {
	            msg = Resources.BAD_RESPONSE;
	            fail = true;
	        } else if (!data.success) {
	            dataMsg = 'alreadyAppliedMsg' in data && data.alreadyAppliedMsg ? data.alreadyAppliedMsg : data.message;
	            msg = dataMsg.split('<').join('&lt;').split('>').join('&gt;');
	            fail = true;
	        }
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        if (fail) {
	            $promoField.addClass('error');
	            $error.html(msg);
	            if (param === "coupon" && options.operation === 'addCoupon') {
	                var hasData = dataLayer.find(function (o) {
	                    return o.bag != null;
	                }) != null;
	                var basketID;
	                if (hasData) {
	                    var bag = dataLayer.find(function (o) {
	                        return o.bag != null;
	                    }).bag;
	                    basketID = bag.id;
	                }
	                var coupon = {
	                    "country": data.country,
	                    "language": data.language,
	                    "appAzadea_platform": appAzadea_platform,
	                    "coupon_code": data.CouponCode,
	                    "cart_id": basketID
	                };
	                dataLayer.push({ 'apply_coupon_code_failed': coupon });
	                dataLayer.push({ 'event': 'moengageGoToBagEvent' });
	
	                dataLayer.push({
	                    'event': 'custom_event',
	                    'eventCategory': 'checkout_page',
	                    'eventAction': 'checkout_apply_code',
	                    'eventLabel': 'checkout apply code click - Invalid', // Valid or Invalid    
	                    'coupon': data.CouponCode,
	                    'country': window.GlobalAttributes.COUNTRY,
	                    'language': window.GlobalAttributes.LANGUAGE,
	                    'screenName': 'Checkout Page',
	                    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                    'userId': user.user_id != '' ? user.user_id : ''
	                });
	            }
	            if (param == 'giftcert') {
	                dataLayer.push({
	                    'event': 'custom_event',
	                    'eventCategory': 'checkout_page',
	                    'eventAction': 'checkout_redeem_gift_card_failed',
	                    'eventLabel': 'checkout redeem gift card failed',
	                    'country': window.GlobalAttributes.COUNTRY,
	                    'language': window.GlobalAttributes.LANGUAGE,
	                    'screenName': 'Checkout Page',
	                    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                    'userId': user.user_id != '' ? user.user_id : ''
	                });
	            }
	            return;
	        }
	
	        if (data.success) {
	            //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
	            //this will force a page refresh to display the coupon message based on a parameter message	
	            // if( data.baskettotal <= 0 || !data.baskettotal) {
	            var $closestForm = $promoField.closest('form');
	            if (param !== "giftcert" && param !== "coupon") {
	                storeFormData($closestForm);
	            }
	
	            if (param == 'giftcert') {
	                dataLayer.push({
	                    'event': 'custom_event',
	                    'eventCategory': 'checkout_page',
	                    'eventAction': 'checkout_redeem_gift_card_success',
	                    'eventLabel': 'checkout redeem gift card success',
	                    'country': window.GlobalAttributes.COUNTRY,
	                    'language': window.GlobalAttributes.LANGUAGE,
	                    'screenName': 'Checkout Page',
	                    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                    'userId': user.user_id != '' ? user.user_id : ''
	                });
	            }
	
	            if (param == "coupon") {
	                dataLayer.push({
	                    'event': 'custom_event',
	                    'eventCategory': 'checkout_page',
	                    'eventAction': 'checkout_apply_code',
	                    'eventLabel': 'checkout apply code click - Valid', // Valid or Invalid    
	                    'coupon': data.CouponCode,
	                    'country': window.GlobalAttributes.COUNTRY,
	                    'language': window.GlobalAttributes.LANGUAGE,
	                    'screenName': 'Checkout Page',
	                    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                    'userId': user.user_id != '' ? user.user_id : ''
	                });
	            }
	
	            if (param == "giftcert" || param == "coupon") {
	                if (param == "coupon") {
	                    localStorage.setItem("isCouponApplied", true);
	                }
	                setPromoSession(param);
	            }
	
	            //to handle 3ds back
	            if (SitePreferences.IS_3DS_ENABLED && (param == "giftcert" || param == "coupon") && page == 'billing') {
	                var url = util.appendParamToURL(Urls.billing).split("?")[0];
	                window.location.assign(url);
	            } else if ((param == "giftcert" || param == "coupon") && page == 'billing') {
	                var url = util.appendParamToURL(Urls.billing).split("?")[0];
	                window.location.assign(url);
	            } else if (param == "coupon" && page == 'shipping') {
	                var url = Urls.shipping;
	                window.location.assign(url);
	            } else {
	                window.location.assign($closestForm.attr('action'));
	            }
	            if (param === "coupon" && (options.operation === 'addCoupon' || options.operation === 'removeCoupon')) {
	                var hasData = dataLayer.find(function (o) {
	                    return o.bag != null;
	                }) != null;
	                var basketID;
	                if (hasData) {
	                    var bag = dataLayer.find(function (o) {
	                        return o.bag != null;
	                    }).bag;
	                    basketID = bag.id;
	                }
	                var coupon = {
	                    "country": data.country,
	                    "language": data.language,
	                    "appAzadea_platform": appAzadea_platform,
	                    "coupon_code": data.CouponCode,
	                    "cart_id": basketID
	                };
	                if (options.operation === 'addCoupon') {
	                    dataLayer.push({ 'apply_coupon_code': coupon });
	                } else if (options.operation === 'removeCoupon') {
	                    dataLayer.push({ 'remove_coupon_code': coupon });
	                }
	
	                dataLayer.push({ 'event': 'moengageGoToBagEvent' });
	            }
	        }
	
	        // $('.order--checkout__'+ options.type +'__msgs').append(data.message + '<br />');
	
	        // shipping.updateSummary();
	    });
	}
	
	/**
	 * Stores form data for later usage on page refresh.
	 * @param  {[type]} $form [description]
	 * @return {[type]}       [description]
	 */
	function storeFormData($form) {
	    window.sessionStorage.setItem('billingFormData', JSON.stringify($form.serializeArray()));
	}
	
	/**
	 * Sets form data if available on the sessionStorage object, then clears it.
	 * @return {[type]} [description]
	 */
	function resetFormData() {
	    var parsedData = JSON.parse(window.sessionStorage.getItem('billingFormData')),
	        billingFieldID = 'billingAddress_addressFields',
	        billingSaveToggleField = 'saveBillingAddress',
	        addToAddressID = 'addToAddressBook',
	        addressList = 'addressList';
	    if (!parsedData) {
	        return;
	    }
	
	    /*reset all checked address*/
	    $('input[id$="_addToAddressBook"]:checked').prop('checked', false);
	
	    parsedData.forEach(function (storedField) {
	        if (storedField.name.indexOf(billingFieldID) !== -1 || storedField.name.indexOf(billingSaveToggleField) !== -1 || storedField.name.indexOf(addToAddressID) !== -1) {
	            var fieldEl = document.querySelector('[name="' + storedField.name + '"]');
	
	            if (fieldEl !== undefined && fieldEl != null) {
	                fieldEl.value = storedField.value;
	                if (fieldEl.nodeName === 'SELECT') {
	                    $(fieldEl).trigger('change');
	                }
	                if (storedField.name.indexOf(addToAddressID) !== -1 && storedField.value == 'true') {
	                    $('input[id$="_addToAddressBook"]').prop('checked', true);
	                }
	                $(fieldEl).trigger('change');
	            }
	        }
	        if (storedField.name.indexOf(addressList) !== -1) {
	            var fieldEl = document.querySelector('[name="' + storedField.name + '"]');
	            $('input[name="' + fieldEl.name + '"][value="' + storedField.value + '"]').prop('checked', true);
	        }
	    });
	
	    window.sessionStorage.removeItem('billingFormData');
	}
	
	function disableButtonAfterSubmit() {
	    var $form = $('.checkout-billing');
	
	    $form.on('submit', function () {
	        $('#submit-order').attr('disabled', true);
	    });
	}
	
	function detectEditChanges() {
	    var $form = $('.address');
	
	    $('.js-us-different-address ').on('click', function () {
	        $form.find('[id$="_editAddressBook"]').prop('checked', false);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', true);
	    });
	
	    $('.js-us-saved-address').on('click', function () {
	        $form.find('[id$="_editAddressBook"]').prop('checked', false);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
	    });
	
	    $('.js-edit').on('click', function () {
	        $form.find('[id$="_editAddressBook"]').prop('checked', true);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
	        addressUtil.initGovernateEvents();
	        addressUtil.updateGovernateInfo();
	        addressToEdit = $(this).parent();
	        $('.custom-address').removeClass('hidden');
	        $('.js-use-different').addClass('hidden');
	        scrollHere($('.js-address').first());
	    });
	}
	
	// Detect phone changes for the validator-check in formPrepare
	function detectPhoneChanges() {
	    var $dummyPhoneField = $('input[name$=_addressFields_phone--dummy]');
	    var $phoneField = $('input[name$=_addressFields_phone]');
	    $phoneField.val($dummyPhoneField.val());
	
	    $dummyPhoneField.on('change', function () {
	        $phoneField.val($dummyPhoneField.val());
	    });
	}
	
	//Toggle Use Saved Card or Use Different Card
	function resetUseSavedCardOrDifferentCard() {
	    var $errorForm = $('.order--checkout__ccmethod').find('.error-message');
	    if (!$('.order--checkout__ccmethod').hasClass('toggle--active')) {
	        if ($.trim($errorForm.html()) != '' && $('.billing-error').length <= 0) {
	            if ($("span").hasClass('js-reset-validation') && $("span").hasClass('js-clean-form')) {
	                $('.order--checkout__ccmethod').addClass('toggle--active');
	                $('.form-row.cta.cta--underlined.txt--upper').addClass('toggle--active');
	                $('.order--checkout__ccnew').addClass('toggle--active');
	            }
	        }
	    }
	    if ($('.billing-error').length > 0 && $.trim($('.billing-error').html()) != '') {
	        $('.required.error').removeClass('error');
	        $errorForm.remove();
	    }
	}
	
	/**
	 * @function
	 * @description loads billing address, Gift Certificates, Coupon and Payment methods
	 */
	exports.init = function () {
	    var $checkoutForm = $('.checkout-billing');
	    var $addGiftCert = $('#add-giftcert');
	    var $giftCertCode = $('input[name$="_giftCertCode"]');
	    var $addCoupon = $('#add-coupon');
	    var $couponCode = $('input[name$="_couponCode"]');
	    var $selectPaymentMethod = $('.payment-method-options');
	    var selectedPaymentMethod = $selectPaymentMethod.val();
	    var $usedASavedCardClean = $('.js-clean-form');
	    var $resetValidation = $('.js-reset-validation');
	    var $unclickAddress = $('.js-use-different');
	    var $errorForm = $('.order--checkout__ccmethod').find('.error-form');
	    var $deleteCoupon = $('.remove-coupon');
	
	    var billingFields = addressUtil.getAddressFields();
	    //$('.address').on('change', billingFields, formPrepare.validateForm);
	
	    resetFormData();
	    formPrepare.validateForm();
	    resetUseSavedCardOrDifferentCard();
	
	    dynamicAddress.init('.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm);
	
	    formPrepare.init({
	        formSelector: 'form[id$="billing"]',
	        continueSelector: '[name$="billing_save"]'
	    });
	    // Refill billing form with default data if customer decides to use saved address
	    $('.js-us-saved-address').on('click', function () {
	        var $form = $('.address');
	        var selectedAddress = $('input[name$="_addressList"]:checked').data('address');
	        $('input[name$="_saveBillingAddress"]').val(0);
	        if (selectedAddress) {
	            util.fillAddressFields(selectedAddress, $form);
	        } else {
	            cleanAddressForm();
	            formPrepare.validateForm();
	        }
	        $form.find('input[name$="_addressList"]').prop('checked', false);
	        $form.find('[id$="_unsavedAddressBook"]').prop('checked', false);
	        formPrepare.validateForm();
	    });
	
	    // default payment method to 'CREDIT_CARD'
	    updatePaymentMethod(selectedPaymentMethod ? selectedPaymentMethod : 'CREDIT_CARD');
	    $('.payment-method-options').on('change', function () {
	        var paymentMethod = $(this).val();
	        if (paymentMethod === 'PayPal') {
	            $('input[name$="_paypalIsChecked"]').prop('checked', true);
	            $('input[name$="_paypalIsChecked"]').val('true');
	            progress.show();
	            $('.converted').removeAttr('hidden');
	            setTimeout(function () {
	                progress.hide();
	            }, 300);
	        } else if (paymentMethod == 'CHECKOUTCOM_APM') {
	            resetAPMPaymentMethod();
	        } else {
	            resetPaymentMethods();
	        }
	        if ($('.knet-error-details').length > 0) {
	            $('.knet-error-details').empty();
	        }
	        updatePaymentMethod($(this).val());
	        if (paymentMethod === 'DW_COD') {
	            $(document).trigger('checkformbutton');
	        }
	    });
	
	    // select credit card from list
	    $('[id$="ckoCreditCardList"]').on('change', function () {
	        var cardUUID = $(this).val();
	        localStorage.setItem("cardUUID", cardUUID);
	        if (!cardUUID) {
	            return;
	        }
	
	        if ($('input[id$="ckoCreditCardList"]:checked').length > 0) {
	            var saveCardWrapEl = $('input[id$="ckoCreditCardList"]:checked').parent();
	            if (saveCardWrapEl.length > 0 && saveCardWrapEl.attr('id') !== undefined) {
	                $('.cvv-wrapper').addClass('hide-error');
	                var $cvEle = $('input[name*="cardPaymentForm_cvn"]');
	                $cvEle.insertAfter('#' + saveCardWrapEl.attr('id') + ' .cvv-wrapper label');
	                $cvEle.removeClass('error').on('keyup', _.debounce(function () {
	                    return $cvEle.trigger('change');
	                }, 200)).focus();
	                setTimeout(function () {
	                    $('.cvv-wrapper').removeClass('hide-error').find('span.error').remove();
	                }, 1000);
	            }
	            if ($('.order--checkout__ccmethod').hasClass('toggle--active')) {
	                $('.order--checkout__ccmethod').removeClass('toggle--active');
	            }
	        }
	
	        populateCreditCardForm(cardUUID);
	
	        // remove server side error
	        $('.required.error').removeClass('error');
	        $('.error-message:not(.code-error--message)').remove();
	        if ($errorForm) {
	            $errorForm.hide();
	        }
	    });
	
	    $('[id$="ckoCreditCardList"]:checked').trigger('change');
	
	    $('#check-giftcert').on('click', function (e) {
	        e.preventDefault();
	        var $balance = $('.balance'),
	            $giftCert = $('.order--checkout__giftcert'),
	            $error = getBEErrorEl($giftCert);
	
	        if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
	            $giftCert.addClass('error');
	            $error.html(Resources.GIFT_CERT_MISSING);
	            $balance.html('');
	            return;
	        }
	
	        resetGiftBalanceMessage();
	
	        giftcard.checkBalance($giftCertCode.val(), function (data) {
	            if ($giftCert.hasClass('error')) {
	                $giftCert.removeClass('error');
	            }
	            if (!data || !data.giftCertificate) {
	                $giftCert.addClass('error');
	                $error.html(Resources.GIFT_CERT_INVALID);
	
	                return;
	            }
	            $balance.html(Resources.GIFT_CERT_BALANCE + ' ' + data.giftCertificate.balance).removeClass('error').addClass('success');
	        });
	    });
	
	    $addGiftCert.on('click', function (e) {
	        var code = $giftCertCode.val(),
	            options = {
	            type: 'giftcert',
	            missingError: Resources.GIFT_CERT_MISSING,
	            code: code,
	            controller: Urls.redeemGiftCert,
	            params: { giftCertCode: code, format: 'ajax' }
	        };
	        resetGiftBalanceMessage();
	        processPromoEntry(e, options, "giftcert");
	    });
	
	    initCouponAction('billing');
	
	    // trigger events on enter
	    $couponCode.on('keydown', function (e) {
	        if (e.which === 13) {
	            e.preventDefault();
	            $addCoupon.click();
	        }
	    });
	    $giftCertCode.on('keydown', function (e) {
	        if (e.which === 13) {
	            e.preventDefault();
	            $addGiftCert.click();
	        }
	    });
	
	    $usedASavedCardClean.on('click', function () {
	        if ($('input[id$="-ckoCreditCardList"]:checked')) {
	            $('input[id$="-ckoCreditCardList"]:checked').prop('checked', false);
	            cleanCardForm();
	        }
	    });
	    $unclickAddress.on('click', function () {
	        if ($('input[name$="_addressList"]:checked')) {
	            $('input[name$="_addressList"]:checked').prop('checked', false);
	            $('[id$="_unsavedAddressBook"]').prop('checked', true);
	            formPrepare.validateForm();
	        }
	        $('input[name$="_addressList"]:checked').prop('checked', false);
	        $('input[name$="_saveBillingAddress"]').val(1);
	        $('.js-edit').addClass('hidden');
	        $('.custom-address, .saved-address').addClass('active');
	    });
	    $resetValidation.on('click', function () {
	        $('input[id$="-ckoCreditCardList"]:checked').prop('checked', false);
	        cleanCardForm();
	        if ($errorForm) {
	            $errorForm.hide();
	        }
	
	        $('form[id$="billing"]').validate().resetForm();
	    });
	
	    $('.giftcertificate-remove').on('click', function (e) {
	        setPromoSession('giftcert');
	        var $closestForm = $(this).closest('form');
	        storeFormData($closestForm);
	    });
	
	    disableButtonAfterSubmit();
	    detectEditChanges();
	    detectPhoneChanges();
	
	    $(document).ready(function () {
	        var limitInterval = 0;
	        var billingFormInterval = setInterval(function () {
	            var formErrors = $('.form-row.error');
	            var promoItemEl = getPromoItemEl();
	            if (formErrors.length > 0 || promoItemEl || limitInterval > 9) {
	                clearInterval(billingFormInterval);
	                scrollToErrorForm();
	            }
	            limitInterval += 1;
	        }, 70);
	    });
	
	    $(document).on('checkoutPaymentSelection', function () {
	        formPrepare.validateForm();
	    });
	    $(document).on('change', '#selectedPaymentOption', function () {
	        var _this = this;
	
	        formPrepare.validateForm();
	        shipping.updateSummary($(this).val()).then(function () {
	            toggleSummaryMobileView();
	            initCouponAction('billing');
	            checkIfFooterReachedScreen();
	            hideStickyOnInput();
	            expandSticky();
	            updateGiftCertRemainingBalance();
	            if ($(_this).val() === 'DW_COD') {
	                $(document).trigger('checkformbutton');
	            }
	        });
	    });
	};
	function updateGiftCertRemainingBalance() {
	    var balanceText = $('.order-value').text();
	    $('.remainingAmount').html(balanceText);
	}
	exports.processPromoEntry = processPromoEntry;
	exports.initCouponAction = initCouponAction;
	exports.toggleSummaryMobileView = toggleSummaryMobileView;
	function initCouponAction(page) {
	    $('#add-coupon').on('click', function (e) {
	        var couponCodeObj = $('input[name$="_couponCode"]');
	        if (couponCodeObj.length > 0) {
	            if (couponCodeObj.val().trim() == '') {
	                e.preventDefault();
	                couponCodeObj.addClass('error');
	                return;
	            } else {
	                couponCodeObj.removeClass('error');
	            }
	        }
	
	        var code = couponCodeObj.val(),
	            options = {
	            type: 'coupon',
	            missingError: Resources.COUPON_CODE_MISSING,
	            code: code,
	            controller: Urls.addCoupon,
	            params: { couponCode: code, format: 'ajax' },
	            operation: 'addCoupon'
	        };
	
	        processPromoEntry(e, options, "coupon", page);
	    });
	
	    $('.remove-coupon').on('click', function (e) {
	        var code = $(this).attr("data-code"),
	            options = {
	            type: 'coupon',
	            code: code,
	            controller: Urls.deleteCoupon,
	            params: { couponCode: code, format: 'ajax' },
	            operation: 'removeCoupon'
	        };
	
	        processPromoEntry(e, options, "coupon", page);
	    });
	}
	
	function resetPaymentMethods() {
	    $('.converted').attr('hidden', 'true');
	    $('input[name$="_paypalIsChecked"]').prop('checked', false);
	    $('input[name$="_paypalIsChecked"]').val('false');
	    if ($('input[name$="apm_list"]').length > 0) {
	        $('input[name$="apm_list"]').prop('checked', false);
	    }
	}
	
	function resetAPMPaymentMethod() {
	    var el = $('input[name$="apm_list"]');
	    if (el.length > 0) {
	        var isChecked = $('input[name$="apm_list"]:checked');
	        if (isChecked.length <= 0) {
	            el.first().prop('checked', true);
	            $('.cko-apm-accordion').trigger('click');
	        }
	    }
	}
	function resetGiftBalanceMessage() {
	    var el = $('form[id$="_billing"] .balance');
	    if (el.length > 0) {
	        el.html('');
	    }
	}
	$(document).ready(function () {
	    var isCouponApplied = localStorage.getItem("isCouponApplied");
	    if (isCouponApplied == 'true') {
	        var uuid = localStorage.getItem("cardUUID");
	        if (uuid != "" && uuid != null) {
	            $('input[value="' + uuid + '"]').prop('checked', true);
	        }
	    }
	    localStorage.setItem("isCouponApplied", false);
	    localStorage.setItem("cardUUID", "");
	});
	
	window.addEventListener('load', function () {
	    if (isFormElFound === false) {
	        scrollToErrorForm();
	    }
	    addressUtil.initGovernateEvents();
	
	    $('.positivenumber').on('input', function (e) {
	        this.value = this.value.replace(/\D/g, '');
	    });
	    formPrepare.validateForm();
	    initPaymentmethodSelection();
	});
	function initPaymentmethodSelection() {
	    var paymentElement = $('#selectedPaymentOption');
	    if (paymentElement.length == 1 && paymentElement.val() == 'DW_COD') {
	        paymentElement.trigger('change');
	    }
	}
	function scrollToErrorForm() {
	    var formErrors = $('.form-row.error,.billing-error');
	    var scrollToTopEl = 50;
	    isFormElFound = true;
	    if (window.innerWidth < _born.breakpoints.mobile) {
	        scrollToTopEl = 80;
	    }
	    if (formErrors.length > 0) {
	        $('body, html').animate({
	            scrollTop: $(formErrors[0]).offset().top - scrollToTopEl
	        }, 0);
	    } else {
	        var itemEl = getPromoItemEl();
	        if (getPromoSession()) {
	            if (itemEl && itemEl.length > 0 && !itemEl.hasClass('order--checkout__giftcert')) {
	                $('body, html').animate({
	                    scrollTop: itemEl.offset().top - scrollToTopEl
	                }, 0);
	            }
	            resetPromoSession();
	        }
	    }
	}
	function setPromoSession(type) {
	    localStorage.setItem("promoAppliedItem", type);
	}
	
	function getPromoSession() {
	    return localStorage.getItem("promoAppliedItem");
	}
	
	function resetPromoSession() {
	    if (getPromoSession()) {
	        localStorage.removeItem("promoAppliedItem");
	    }
	}
	
	function getPromoItemEl() {
	    if (getPromoSession()) {
	        var item = getPromoSession();
	        if (item) {
	            var itemEl = $('.order--checkout__' + item).length > 0 ? $('.order--checkout__' + item) : $('.' + item);
	            if (itemEl && itemEl.length > 0) {
	                return itemEl;
	            }
	        }
	    }
	
	    return false;
	}
	
	function toggleBackToSavedCards() {
	    $('.saved-card-layout label').on('click', function () {
	        if ($('.js-clean-form').first().parent().hasClass('toggle--active')) {
	            $('.js-clean-form').trigger('click');
	        }
	    });
	}
	
	function clearAddressForm() {
	    $(':input', '.custom-address.billing-page, .order--checkout__form__section.no-saved.billing-page').not(':button, :submit, :reset, :hidden,.country-selection-option').val('').prop('checked', false).prop('selected', false);
	    $('.custom-address .selectric-wrapper select').not('.country').prop('selectedIndex', 0).selectric('refresh');
	    $('select.select2-option').val('').trigger('change').parents('.field-wrapper').siblings('.error').remove();
	}
	
	function toggleBillingAndShippingAddress() {
	    var $addressPreview = $('.address-preview');
	    var $guestAddress = $('.guest-address');
	    var $savedAddress = $('.saved-address');
	    var $customAddress = $('.custom-address');
	    var $addressFieldWoSaved = $('.order--checkout__form__section.no-saved');
	
	    var taskForGuest = function taskForGuest() {
	        if (!$addressPreview.hasClass('hidden') || !$guestAddress.hasClass('hidden')) {
	            $addressPreview.addClass('hidden');
	            $guestAddress.addClass('hidden');
	        } else if ($addressPreview.hasClass('hidden') && $guestAddress.hasClass('hidden')) {
	            $addressPreview.removeClass('hidden');
	        }
	    };
	    function taskForUser() {
	        if ($savedAddress.length == 0 && $addressFieldWoSaved.length) {
	            if ($addressPreview.hasClass('hidden') && $addressFieldWoSaved.hasClass('hidden')) {
	                $addressPreview.removeClass('hidden');
	            } else if (!$addressPreview.hasClass('hidden') || !$addressFieldWoSaved.hasClass('hidden')) {
	                $addressPreview.addClass('hidden');
	                $addressFieldWoSaved.addClass('hidden');
	            }
	        } else if (!$addressPreview.hasClass('hidden') || !$savedAddress.hasClass('hidden')) {
	            $addressPreview.addClass('hidden');
	            $savedAddress.addClass('hidden');
	            $customAddress.addClass('hidden');
	        } else if ($addressPreview.hasClass('hidden') && $savedAddress.hasClass('hidden')) {
	            $addressPreview.removeClass('hidden');
	        }
	    }
	
	    $('#shippingBillingSame').on('change', function () {
	        if ($guestAddress.length) {
	            taskForGuest();
	        } else if ($savedAddress.length || $addressFieldWoSaved.length) {
	            taskForUser();
	        }
	        if ($(this).prop('checked')) {
	            // If Shipping Same as Billing , Copy Shipping address to BIlling
	            var selectorEl = $('select#countrySelectorList :selected');
	            var currentCountry = selectorEl.length > 0 ? selectorEl.data('country') : false;
	            if (!currentCountry) {
	                currentCountry = (0, _born.readCookie)('preferredCountry');
	            }
	            if (currentCountry) {
	                var country = currentCountry.toLowerCase();
	                if (country) {
	                    var $form = $('.billing-address-form-wrapper');
	                    dynamicAddress.getAddressFields(country, '.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm, fillBillingAddressFields.bind($form));
	                }
	            }
	        }
	    });
	
	    $addressPreview.on('click', '.change-address', function () {
	        $addressPreview.addClass('hidden');
	        if ($guestAddress.length) {
	            setTimeout(function () {
	                clearAddressForm();
	            }, 0);
	            $guestAddress.removeClass('hidden');
	        } else if ($savedAddress.length) {
	            $savedAddress.removeClass('hidden');
	            if ($('input[id$="_unsavedAddressBook"]').prop('checked')) {
	                $('.js-use-different').addClass('hidden');
	                $('.custom-address').removeClass('hidden');
	            } else {
	                $('.js-use-different').removeClass('hidden');
	            }
	        } else if ($addressFieldWoSaved.length) {
	            setTimeout(function () {
	                clearAddressForm();
	            }, 0);
	            $addressFieldWoSaved.removeClass('hidden');
	        }
	    });
	
	    $('.js-use-different').on('click', function () {
	        $customAddress.removeClass('hidden');
	        clearAddressForm();
	        $(this).addClass('hidden');
	    });
	
	    $('.js-us-saved-address.billing-page').on('click', function () {
	        $customAddress.addClass('hidden');
	        $('.js-use-different').removeClass('hidden');
	        $('.js-edit').removeClass('hidden');
	        $('.custom-address, .saved-address').removeClass('active');
	        setTimeout(function () {
	            addressToEdit && addressToEdit.trigger('click');
	            addressToEdit = null;
	        }, 0);
	    });
	    var validateFields = function validateFields(adrsType) {
	        var isValid = false;
	        $(adrsType).find('input').each(function (i, ele) {
	            isValid = $(ele).valid();
	            return isValid;
	        });
	        return isValid;
	    };
	    $('.address-actions .btn-save').on('click', function () {
	        var name = '',
	            address = '',
	            adrsType = '.guest-address';
	        if ($(this).hasClass('is-authed')) {
	            adrsType = '.custom-address';
	            if ($('.custom-address').length == 0) {
	                adrsType = '.address-fieldset.no-saved';
	            }
	        }
	        if (!validateFields(adrsType)) {
	            return;
	        }
	        name = $(adrsType + ' .field-firstname').val() + ' ' + $(adrsType + ' .field-lastname').val();
	        address = jQuery.makeArray($(adrsType + ' .field-addressline').find('input.input-text,.input-select').map(function (index, it) {
	            return $(it).val().toString();
	        }));
	        address = address.filter(function (el) {
	            return el != "";
	        });
	        $('.address-preview .address-preview--fullname').html(name);
	        $('.address-preview .address-preview--addressline').html(address.join(', '));
	        $guestAddress.addClass('hidden');
	        $customAddress.addClass('hidden');
	        $(adrsType).addClass('hidden');
	        $savedAddress.addClass('hidden');
	        $addressPreview.removeClass('hidden');
	    });
	
	    $('.address-actions .btn-cancel').on('click', function () {
	        $guestAddress.addClass('hidden');
	        $addressFieldWoSaved.addClass('hidden');
	        if (!$(this).hasClass('is-authed') || $savedAddress.length == 0 && $addressFieldWoSaved.length) {
	            $addressPreview.removeClass('hidden');
	            var countrySelector = document.querySelector('[id$="_country"]');
	            if (countrySelector) {
	                var country = countrySelector.value;
	                if (country) {
	                    var $form = $('.billing-address-form-wrapper');
	                    dynamicAddress.getAddressFields(country, '.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm, fillBillingAddressFields.bind($form));
	                }
	            }
	        }
	    });
	    function fillBillingAddressFields() {
	        var $form = this;
	        var url = window.Urls.getShippingAddress;
	        ajax.getJson({
	            url: url,
	            callback: function callback(data) {
	                util.fillAddressFields(data.address, $form);
	                updateAddressPlaceHolder();
	            }
	        });
	    }
	    function updateAddressPlaceHolder() {
	        var name = '',
	            address = '',
	            adrsType = '.guest-address';
	        if ($(this).hasClass('is-authed')) {
	            adrsType = '.custom-address';
	        }
	        if (!validateFields(adrsType)) {
	            return;
	        }
	        name = $(adrsType + ' .field-firstname').val() + ' ' + $(adrsType + ' .field-lastname').val();
	        address = jQuery.makeArray($(adrsType + ' .field-addressline').find('input.input-text,.input-select').map(function (index, it) {
	            return $(it).val().toString();
	        }));
	        address = address.filter(function (el) {
	            return el != "";
	        });
	        $('.address-preview .address-preview--fullname').html(name);
	        $('.address-preview .address-preview--addressline').html(address.join(', '));
	    }
	
	    $('.saved-address-preview').on('click', function () {
	        var _this2 = this;
	
	        var isChecked = false;
	        $('.saved-address-preview').find('input').each(function (i, ele) {
	            isChecked = $(ele).prop('checked');
	            return !isChecked;
	        });
	        if (!isChecked) {
	            $('.js-us-saved-address').trigger('click');
	            setTimeout(function () {
	                $(_this2).find('input').prop('checked', true);
	            }, 0);
	        }
	    });
	}
	
	function toggleSummaryMobileView() {
	    $('.showsum_title').on('click', function () {
	        $(this).toggleClass('toggle--active');
	        var rows = $('.order-totals-table > .order__summary__row');
	        var freeShipping = $('.free_shipping');
	        if (rows.css('display') == 'none') {
	            rows.css('display', 'flex');
	        } else {
	            rows.hide();
	        }
	        if (freeShipping.length && freeShipping.css('display') == 'none') {
	            freeShipping.css('display', 'block');
	        } else {
	            freeShipping.hide();
	        }
	    });
	}
	
	function heightAdjustOnCartOpen() {
	    $('#mini-cart-toggler').on('click', function () {
	        var heightToSet = $('#secondary').height();
	        $('#checkoutSpacer.billing-page').height(heightToSet - 40).toggleClass('hidden');
	    });
	}
	
	function triggerMobBack() {
	    $('.address-back.billing').on('click', function () {
	        if ($('.js-us-saved-address').length > 0) $('.js-us-saved-address').first().trigger('click');else $('.btn-cancel').first().trigger('click');
	    });
	}
	
	function scrollHere(element) {
	    $([document.documentElement, document.body]).animate({
	        scrollTop: element.offset().top
	    }, 500);
	}
	
	function validatePhone() {
	    var replaceTexts = function replaceTexts(ele) {
	        ele.val(ele.val().replace(/[^0-9 ]/gm, ''));
	    };
	    $("input[id$='addressFields_phone']").on('input', function () {
	        replaceTexts($(this));
	    }).on('paste', function () {
	        replaceTexts($(this));
	    });
	}
	
	function checkIfFooterReachedScreen() {
	    if ($('.pt_checkout').length <= 0) {
	        return;
	    }
	    var isEventActive = false;
	
	    var elToHide = $('.checkout-order-totals.mini-view,.form-row-button,#submit-order,.payment-modes-wrapper,#applePayDummyBtn');
	    var doShowOrHide = function doShowOrHide() {
	        elToHide = $('.checkout-order-totals.mini-view,.form-row-button,#submit-order,.payment-modes-wrapper,#applePayDummyBtn');
	        var screenOffset = $(window).scrollTop();
	        if (screenOffset + $(window).height() > $(document).height() - 75) {
	            !$('.order__summary__coupon__entry').hasClass('toggle--active') && elToHide.hide(500);
	        } else if (elToHide.css('display') === 'none') {
	            elToHide.show(500);
	        }
	    };
	    var bindScrollEvent = function bindScrollEvent() {
	        $(window).on('scroll.webScrollEvent', doShowOrHide);
	        isEventActive = true;
	    };
	    var unBindScrollEvent = function unBindScrollEvent() {
	        $(window).off('scroll.webScrollEvent');
	        isEventActive = false;
	    };
	    $(window).on('resize', function () {
	        if ($(window).width() <= 767) {
	            !isEventActive && bindScrollEvent();
	        } else {
	            isEventActive && unBindScrollEvent();
	            elToHide.show();
	        }
	    });
	    if ($(window).width() <= 767) {
	        doShowOrHide();
	    }
	}
	
	function hideStickyOnInput() {
	    if ($('.pt_checkout').length <= 0) {
	        return;
	    }
	    var inputs = $('input[type=text], input[type=password], input[type=email], input[type=tel], textarea').not(".login-modal--input input, input[id$='_couponCode']");
	    var isEventActive = false;
	    var minimize = function minimize() {
	        $('.mini-view, .form-row-button .button, .order--checkout__footer.input-list .button, .payment-modes-wrapper').addClass('minimize');
	    };
	    var bindEvent = function bindEvent() {
	        inputs.on('focus.inputFocusEvent', function () {
	            minimize();
	            $([document.documentElement, document.body]).animate({
	                scrollTop: $(this).offset().top - 100
	            }, 200);
	        });
	        $('body').on('click.select2FocusEvent', '.select2.select2-container', minimize);
	        isEventActive = true;
	    };
	    var unbindEvent = function unbindEvent() {
	        inputs.off('focus.inputFocusEvent');
	        $('body').off('focus.select2FocusEvent');
	        isEventActive = false;
	    };
	    var bindOrUnbindEvent = function bindOrUnbindEvent() {
	        if ($(window).width() <= 767) {
	            !isEventActive && bindEvent();
	        } else {
	            isEventActive && unbindEvent();
	        }
	    };
	    bindOrUnbindEvent();
	    $(window).on('resize', bindOrUnbindEvent);
	}
	
	function expandSticky() {
	    var unhide = function unhide() {
	        $('.mini-view, .form-row-button .button,.order--checkout__footer.input-list .button, .payment-modes-wrapper').removeClass('minimize');
	    };
	    $('.form-row-button .button, .order--checkout__footer.input-list .button').on('enabled', unhide);
	    $('.unhide-arrow').on('click', unhide);
	}
	
	function hideAddressSuggestionOnScroll() {
	    $('.address-fieldset').on('scroll', function () {
	        var $container = $('.pac-container');
	        if ($container.is(':visible')) {
	            $container.css('display', 'none');
	        }
	    }).on('click', '.pac-target-input', function () {
	        var $container = $('.pac-container');
	        var elementOffset = $('.pac-target-input').offset().top;
	        if ($container.is(':parent') && !$container.is(':visible')) {
	            $container.css({
	                'display': 'block',
	                'top': elementOffset + 50
	            });
	        }
	    });
	}
	
	function billingGAEvents() {
	    var user = dataLayer.find(function (o) {
	        return o.user != null;
	    }).user;
	    $('.gift-promo-toggle').find('.order--checkout__form__title').on('click', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': 'checkout_redeem_gift_card_click',
	            'eventLabel': 'checkout redeem gift card click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	    $('#check-giftcert').on('click', function (e) {
	        var giftCert = $('#dwfrm_billing_giftCertCode').val();
	        if (giftCert != '') {
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'checkout_page',
	                'eventAction': 'chk_redeem_gift_card_check_balance',
	                'eventLabel': 'checkout redeem gift card check balance click',
	                'country': window.GlobalAttributes.COUNTRY,
	                'language': window.GlobalAttributes.LANGUAGE,
	                'screenName': 'Checkout Page',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        }
	    });
	    $("#coupon-form-summary .promo_title").on('click', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'checkout_page',
	            'eventAction': 'checkout_promo_code_click',
	            'eventLabel': 'checkout promo code click',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Checkout Page',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	}
	
	$(document).ready(function () {
	
	    var setInputReadOnly = function setInputReadOnly() {
	        $('.select2-option').select2({
	            sorter: function sorter(data) {
	                var defOption = false;
	                if (data.length > 0) {
	                    defOption = data.splice(data.findIndex(function (e) {
	                        return e.id === "";
	                    }), 1);
	                    if (defOption && defOption.length > 0) {
	                        defOption = defOption[0];
	                    } else {
	                        defOption = false;
	                    }
	                }
	                var optionData = data.sort(function (a, b) {
	                    return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
	                });
	                if (defOption) {
	                    optionData.unshift(defOption);
	                }
	                return optionData;
	            }
	        }).on('select2:open', function (e) {
	            $('.select2-search input').attr('readonly', true).blur();
	
	            $('.select2-search input').on('click', function () {
	                $(this).attr('readonly', false).focus();
	            });
	        });
	    };
	
	    if (!navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
	        setInputReadOnly();
	        $('select.country-selection-option').on('change', function () {
	            setTimeout(setInputReadOnly, 1000);
	        });
	    }
	
	    if (typeof zE !== 'undefined' && !!zE) {
	        zE(function () {
	            zE.hide();
	        });
	    }
	
	    toggleBillingAndShippingAddress();
	    toggleBackToSavedCards();
	    toggleSummaryMobileView();
	    heightAdjustOnCartOpen();
	    triggerMobBack();
	    validatePhone();
	    checkIfFooterReachedScreen();
	    hideStickyOnInput();
	    expandSticky();
	    hideAddressSuggestionOnScroll();
	    billingGAEvents();
	    $(document).trigger('initinfobip');
	    $('form[id*="billing"] input[type="submit"]').on('enabled', function () {
	        $(document).trigger('checkformbutton');
	    });
	});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ajax = __webpack_require__(42),
	    util = __webpack_require__(15);
	/**
	 * @function
	 * @description Load details to a given gift certificate
	 * @param {String} id The ID of the gift certificate
	 * @param {Function} callback A function to called
	 */
	exports.checkBalance = function (id, callback) {
	    // load gift certificate details
	    var url = util.appendParamToURL(Urls.giftCardCheckBalance, 'giftCertificateID', id);
	
	    ajax.getJson({
	        url: url,
	        callback: callback
	    });
	};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var address = __webpack_require__(154),
	    formPrepare = __webpack_require__(93),
	    dialog = __webpack_require__(46),
	    util = __webpack_require__(15),
	    validator = __webpack_require__(56);
	
	/**
	 * @function
	 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
	 */
	function initMultiGiftMessageBox() {
	    $.each($('.item-list'), function () {
	        var $this = $(this);
	        var $giftMessage = $this.find('.gift-message-text');
	
	        //handle initial load
	        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
	
	        //set event listeners
	        $this.on('change', function () {
	            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
	        });
	    });
	}
	
	/**
	 * @function
	 * @description capture add edit adddress form events
	 */
	function addEditAddress(target) {
	    var $addressForm = $('form[name$="multishipping_editAddress"]'),
	        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
	        $addressList = $addressForm.find('.address-list'),
	        add = true,
	        originalUUID,
	        resetOptionValue = false,
	        selectedAddressUUID = $(target).parent().siblings('.select-address').val();
	
	    $addressDropdown.on('change', function (e) {
	        e.preventDefault();
	
	        var selectedAddress = $addressList.find('select').val();
	        if (selectedAddress !== 'newAddress') {
	            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
	                return add.UUID === selectedAddress;
	            })[0];
	            add = false;
	            resetOptionValue = false;
	            // proceed to fill the form with the selected address
	            util.fillAddressFields(selectedAddress, $addressForm);
	        } else if (selectedAddress === 'newAddress') {
	            add = true;
	            resetOptionValue = true;
	            $addressForm.find('.input-text, .input-select').val('');
	        } else {
	            //reset the form if the value of the option is not a UUID
	            $addressForm.find('.input-text, .input-select').val('');
	        }
	    });
	
	    $addressForm.on('click', '.cancel', function (e) {
	        e.preventDefault();
	        dialog.close();
	    });
	
	    $addressForm.on('submit', function (e) {
	        e.preventDefault();
	        if (!$addressForm.valid()) {
	            return false;
	        }
	
	        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
	            if (!response.success) {
	                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
	                return;
	            }
	            $('#multiaddresserror').toggleClass('hidden', response.success);
	
	            var address = response.address,
	                $shippingAddress = $(target).closest('.shippingaddress'),
	                $select = $shippingAddress.find('.select-address'),
	                $selected = $select.find('option:selected'),
	                newOption = '<option value="' + address.UUID + '">' + (address.ID ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' + address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode + '</option>';
	            dialog.close();
	
	            if (address.UUID !== originalUUID) {
	                resetOptionValue = true;
	            }
	
	            if (add) {
	                $('.shippingaddress select').removeClass('no-option').append(newOption);
	                $('.no-address').hide();
	            } else {
	                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
	            }
	            // if there's no previously selected option, select it
	            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
	                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
	            }
	        });
	    });
	
	    //preserve the uuid of the option for the hop up form
	    if (selectedAddressUUID) {
	        //update the form with selected address
	        $addressList.find('option').each(function () {
	            //check the values of the options
	            if ($(this).attr('value') === selectedAddressUUID) {
	                $(this).prop('selected', 'selected');
	                $addressDropdown.trigger('change');
	            }
	        });
	        originalUUID = selectedAddressUUID;
	    }
	
	    validator.init();
	}
	
	/**
	 * @function
	 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
	 */
	exports.init = function () {
	    initMultiGiftMessageBox();
	    if ($('.cart-row .shippingaddress .select-address').length > 0) {
	        formPrepare.init({
	            continueSelector: '[name$="addressSelection_save"]',
	            formSelector: '[id$="multishipping_addressSelection"]'
	        });
	    }
	    $('.edit-address').on('click', 'span', function (e) {
	        dialog.open({ url: this.attributes.href.value, options: { open: function open() {
	                    address.init();
	                    addEditAddress(e.target);
	                } } });
	    });
	};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _born = __webpack_require__(10);
	
	var _plp = __webpack_require__(49);
	
	var _offertimer = __webpack_require__(41);
	
	var compareWidget = __webpack_require__(160),
	    productTile = __webpack_require__(66),
	    progress = __webpack_require__(43),
	    util = __webpack_require__(15),
	    bornModules = __webpack_require__(3).default,
	    bornPages = __webpack_require__(26).default,
	    moduleViews = __webpack_require__(16).default;
	
	
	var previousToggleRefinementEl = false;
	var previousToggleSeoCatEl = false;
	var wrapEvents = false;
	var categoryBrandRefinement = false;
	
	function infiniteScroll() {
	    // getting the hidden div, which is the placeholder for the next page
	    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
	    // get url hidden in DOM
	    var gridUrl = loadingPlaceHolder.attr('data-grid-url');
	    sessionStorage.scrollPos = $(window).scrollTop();
	
	    if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
	        // switch state to 'loading'
	        // - switches state, so the above selector is only matching once
	        // - shows loading indicator
	        loadingPlaceHolder.attr('data-loading-state', 'loading');
	        loadingPlaceHolder.addClass('loading');
	
	        var tileCount = $('div.search-result-content .product-grid .product-grid__item').length;
	        if (SitePreferences.LISTING_HYBRID_PAGINATION) {
	            gridUrl = util.appendParamToURL(gridUrl, 'count', tileCount);
	        }
	        // named wrapper function, which can either be called, if cache is hit,
	        // or ajax repsonse is received
	        var fillEndlessScrollChunk = function fillEndlessScrollChunk(html) {
	            var $htmlChildren = $(html).children();
	            loadingPlaceHolder.removeClass('loading');
	            loadingPlaceHolder.attr('data-loading-state', 'loaded');
	            $('div.search-result-content .search-result-items').append($htmlChildren);
	            $('div.search-result-content').append($(html).closest('.infinite-scroll-placeholder'));
	            if (loadingPlaceHolder.attr('data-last-load') == "true" && $('.pagination').length > 0) {
	                $('.pagination').removeClass('hidden');
	            }
	            var scripts = $(html).filter('.gtm-plp-data');
	            eval(scripts.first().text());
	        };
	
	        $.ajax({
	            type: 'GET',
	            dataType: 'html',
	            url: gridUrl,
	            success: function success(response) {
	                fillEndlessScrollChunk(response);
	                // put response into cache
	                try {
	                    //sessionStorage['scroll-cache_' + gridUrl] = $('#search-result-items').html();
	                    var $slickSizeSliders = $('#search-result-items .product__sizes.slick-initialized');
	                    $slickSizeSliders.each(function (index, tile) {
	                        var $carousel = $(tile);
	                        $carousel.filter('.slick-initialized').slick('unslick');
	                    });
	                    sessionStorage['cache-path'] = window.location.pathname;
	                    sessionStorage['scroll-cache'] = $('#search-result-items').html();
	                } catch (e) {
	                    //console.log(e);
	                    // nothing to catch in case of out of memory of session
	                    // storage
	                    // it will fall back to load via ajax
	                }
	                productTile.init();
	                bornModules.carousel.init();
	                initTileSliders();
	                bornModules.productRating.init();
	                //var stateObj = {results: 'scroll-cache_' + gridUrl};
	                var stateObj = { results: 'scroll-cache' };
	                window.history.replaceState(stateObj, gridUrl, window.location.href);
	                window.addEventListener('popstate', function (event) {
	                    window.history.pushState(stateObj, gridUrl, window.location.href);
	                });
	                //window.history.pushState(stateObj, gridUrl, window.location.href);
	            }
	        });
	    }
	}
	
	function infiniteScrollOld(e, loadNextPage, repeatCount) {
	    // getting the hidden div, which is the placeholder for the next page
	    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]')[0];
	    if (loadingPlaceHolder && (loadNextPage || util.elementInViewport(loadingPlaceHolder, 250))) {
	        // get url hidden in DOM
	        var gridUrl = loadingPlaceHolder.getAttribute('data-grid-url');
	
	        // switch state to 'loading'
	        // - switches state, so the above selector is only matching once
	        // - shows loading indicator
	        loadingPlaceHolder.setAttribute('data-loading-state', 'loading');
	        loadingPlaceHolder.classList.add('loading');
	
	        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
	        var fillEndlessScrollChunk = function fillEndlessScrollChunk(html) {
	            loadingPlaceHolder.classList.remove('loading');
	            loadingPlaceHolder.setAttribute('data-loading-state', 'loaded');
	            $('.search-result-content').append(html);
	        };
	
	        var scrollCallback = function scrollCallback(response) {
	            fillEndlessScrollChunk(response);
	            productTile.init();
	            initTileSliders();
	
	            //Call is already running once, so only run again if counter is over 1
	            if (!util.isMobile() && repeatCount > 1) {
	                infiniteScroll(false, true, repeatCount - 1);
	            }
	            //Check if count is down to 1.
	            //Not using just 'else' cause repeatCount can be 'undefined'
	            else if (repeatCount === 1) {
	                    scrollToPrevPos();
	                }
	            window.scrollTo(window.scrollX, window.scrollY + 1);
	        };
	
	        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
	        // it was removed to temporarily address RAP-2649
	        if (sessionStorage && sessionStorage['scroll-cache_' + gridUrl]) {
	            scrollCallback(sessionStorage['scroll-cache_' + gridUrl]);
	        } else {
	            $.ajax({
	                type: 'GET',
	                dataType: 'html',
	                url: gridUrl,
	                success: function success(response) {
	                    try {
	                        if (sessionStorage['scroll-cache_' + gridUrl]) {
	                            sessionStorage['scroll-cache_' + gridUrl] = response;
	                        } else {
	                            sessionStorage.setItem('scroll-cache_' + gridUrl, response);
	                        }
	                    } catch (err) {
	                        /* We can add error handling here for local storage quota overflow error which blocks page infinite scrolling 
	                        after ~ 500-600 products loaded */
	                    }
	                    scrollCallback(response);
	                }
	            });
	        }
	    }
	}
	
	function initTileSliders() {
	    var $tileSliders = $('.results-container .product__link:not(.slick-slider)');
	
	    $tileSliders.each(function (index, tile) {
	        tile.slickInitialSlide = moduleViews.getIndex;
	    });
	
	    bornModules.carousel.init('.product__sizes[data-slick]');
	}
	
	/**
	 * Helps browsers re-position user at previous location.
	 */
	function scrollToPrevPos() {
	    window.scrollTo(0, getStoredData() ? getStoredData().posY : 0);
	
	    //Clear data after scroll is succesfull
	    sessionStorage.removeItem('pageData');
	}
	
	function getStoredData() {
	    return JSON.parse(sessionStorage.getItem('pageData'));
	}
	
	function setupInfinitePositioning() {
	    var pageStoredData = getStoredData();
	
	    if (!util.isMobile() && isSameCurrency() && pageStoredData && pageStoredData.searchURL === window.location.href) {
	        infiniteScroll(false, true, pageStoredData.currentPage);
	    }
	
	    window.addEventListener('unload', function () {
	        var grids = document.querySelectorAll('.product-grid'),
	            currentPage,
	            currentCurrency = document.querySelectorAll('.product-grid')[0].getAttribute('data-current-currency');
	
	        [].forEach.call(grids, function (grid) {
	            if (util.elementInViewport(grid, 0)) {
	                currentPage = parseInt(grid.getAttribute('data-current-page'));
	            }
	        });
	
	        //If on first page, don't do any session storing
	        if (currentPage > 0) {
	            var pageData = {
	                posY: window.pageYOffset,
	                searchURL: window.location.href,
	                currentPage: currentPage
	            };
	
	            sessionStorage.setItem('pageData', JSON.stringify(pageData));
	            sessionStorage.setItem('currency', currentCurrency);
	            // this.scrollTo(0, pageData.posY);
	        }
	    });
	}
	
	function cancelEmptySearch() {
	    var searchForm = document.querySelector('.cancel-empty-search');
	
	    if (searchForm) {
	        searchForm.addEventListener('submit', function (e) {
	            if (!this.querySelector('input[name="q"]').value.trim()) {
	                e.preventDefault();
	            }
	        });
	    }
	}
	
	/**
	 * @private
	 * @function
	 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
	 */
	function updateProductListing(url, toggleLinks, isBrowserBackButton, replaceSection, addVisii) {
	    var pageType = null;
	    var urlParams = { 'format': 'ajax' };
	    if (replaceSection === undefined) {
	        replaceSection = '#main';
	    } else {
	        pageType = 'brandPage';
	        urlParams.pageType = pageType;
	    }
	    if (!url) {
	        //|| url === window.location.href
	        return;
	    }
	    progress.show($('.search-result-content'));
	    if ($('#categoryBrandRefinementMob').length > 0) {
	        categoryBrandRefinement = $('.refinement__categorybrandrefinement:last');
	        $('.refinement__categorybrandrefinement').remove();
	    }
	
	    $(replaceSection).load(util.appendParamsToUrl(url, urlParams), function () {
	
	        updateCategoryRefinement(replaceSection);
	
	        compareWidget.init();
	        productTile.init();
	        bornModules.toggle.init();
	        bornModules.overlayToggle.init();
	        bornModules.gridViewType.init();
	        //bornModules.bornLazy.init();
	        bornModules.selectTags.init();
	        bornModules.carousel.init();
	        bornModules.productRating.init();
	        bornPages['.pt_product-search-result'].init();
	        initTileSliders();
	
	        // toggle filter
	        var flag = false;
	        toggleLinks.forEach(function (toggleLink) {
	            // matchedLink = possible link that match the link clicked
	            var matchedLink = document.getElementById(toggleLink.id);
	            if (matchedLink) {
	                if (!matchedLink.toggle) {
	                    flag = true;
	                } else {
	                    matchedLink.toggle.contentEl.showContent();
	                }
	            }
	        });
	
	        if (flag) {
	            (0, _born.toggleOverlay)();
	            document.documentElement.classList.remove('cancel-scroll');
	        }
	        enablePLPSeoToggle();
	        triggerStickyOpen();
	        var $filterElements = $(".refinements__filtercontainer .refinement");
	        if (previousToggleRefinementEl && previousToggleRefinementEl.length > 0) {
	            var scrollToggleID = previousToggleRefinementEl.attr('id');
	            var scrollToggleEl = scrollToggleID ? $('#main').find('#' + scrollToggleID) : false;
	            if (scrollToggleEl && scrollToggleEl.length > 0) {
	                document.getElementById(scrollToggleID).scrollIntoView({ block: "center" });
	                if (window.innerWidth < _born.breakpoints.mobile) renderfilterView(scrollToggleEl, $filterElements);
	                if (scrollToggleEl.parents('#brand_category_list').length > 0 && $('#categoryBrandRefinementMob').length > 0) {
	                    $('.refinement__categorybrandrefinement:last').click();
	                } else if (window.selectedStickyFilter == null && window.filteroverlay === true) {
	                    $(".refinements__filtercontainer").addClass('toggle--active');
	                    (0, _born.getSelectedfilterlabels)();
	                }
	                (0, _plp.setFilterScrollPosition)();
	                (0, _plp.setOverlayInnerScroll)(scrollToggleID, "overlay");
	            } else if (window.selectedStickyFilter == null && window.filteroverlay === true) {
	                //Clear All scenario with data selected
	                $(".refinements__filtercontainer,.refinement-wrapper").addClass('toggle--active');
	                if (previousToggleRefinementEl.hasClass('refinement__web_clearfilter')) {
	                    if (window.innerWidth < _born.breakpoints.mobile) {
	                        var $firstEleView = $(".refinements__filtercontainer .refinement:first");
	                        $firstEleView = $firstEleView.children().length > 0 ? $firstEleView : $firstEleView.next();
	                        (0, _born.setdefaultFilteractive)($filterElements, $firstEleView);
	                    } else {
	                        $filterElements.removeClass('toggle--active');
	                        $filterElements.find('.toggle__link').removeClass('toggle--active');
	                        $filterElements.find('.toggle__content').removeClass('toggle--active');
	                    }
	                } else {
	                    if (window.innerWidth < _born.breakpoints.mobile) (0, _born.getSelectedFilterCount)();else (0, _born.getSelectedfilterlabels)();
	                }
	                scrollToggleEl.length == 0 ? (0, _born.toggleOverlay)() : "";
	            }
	            (0, _born.checkTypeRefinement)();
	            previousToggleRefinementEl = false;
	        }
	        if (window.innerWidth < _born.breakpoints.mobile) {
	            if (previousToggleSeoCatEl && previousToggleSeoCatEl.length > 0) {
	                if (previousToggleSeoCatEl.hasClass('toggle--active')) {
	                    addToggleActive();
	                } else {
	                    removeToggleActive();
	                }
	                previousToggleSeoCatEl = false;
	            }
	        }
	        window.scrollTo(0, 0);
	        progress.hide();
	        if (!isBrowserBackButton && $('.refinement-wrapper').length && pageType != 'brandPage') {
	            history.pushState(undefined, '', url);
	        }
	        if (typeof addVisii != 'undefined' && addVisii) {
	            addVisiiAttributesToWindow();
	        }
	        handlePLPGAEvents();
	    });
	}
	
	function updateCategoryRefinement(replaceSection) {
	    if (window.innerWidth <= _born.breakpoints.mobile) {
	        try {
	            if (categoryBrandRefinement && categoryBrandRefinement.length > 0) {
	                if ($('#categoryBrandRefinementMob').length <= 0) {
	                    $('body').append(categoryBrandRefinement);
	                    $('#categoryBrandRefinementMob').hide();
	                    brandLHNMobileBackAction();
	                    $('#categoryBrandRefinementMob #typerefinementToggle').removeAttr('data-initialized');
	                }
	                var refinementsEls = $('.refinements');
	                if (refinementsEls.length > 1) {
	                    $('.refinements:first').remove();
	                }
	                var searchCountsEl = $('.search-product-count');
	                if (searchCountsEl.length > 1) {
	                    $('.search-product-count:first').remove();
	                }
	                var wrapElName = replaceSection + " .refinement-toggle-hgt .refinement__all__toggle";
	                if ($(wrapElName).find('.refinements').length <= 0) {
	                    wrapElName = "#main .refinement-toggle-hgt .refinement__all__toggle";
	                }
	                if ($('#categoryBrandRefinementMob').length > 0) {
	                    $("#categoryBrandRefinementMob").prependTo(wrapElName);
	                    $('#categoryBrandRefinementMob #typerefinementToggle').removeAttr('data-initialized');
	                    $("#categoryRefinement").remove();
	                }
	
	                $('.refinement__all__toggle #categoryBrandRefinementMob').show();
	                bornModules.toggle.init();
	                bornModules.overlayToggle.init();
	            }
	        } catch (e) {}
	    }
	}
	function renderfilterView($specificEle, $generic) {
	    if (window.selectedStickyFilter == null && window.filteroverlay === true) {
	        $(".refinements__filtercontainer,.refinement-wrapper").addClass('toggle--active');
	        var $eleParent = $specificEle.closest('.refinement');
	        var eleSelectedCount = $eleParent.find("a.refinement__link.checked").length;
	        eleSelectedCount > 0 ? $eleParent.addClass('activefilter') : $eleParent.removeClass('activefilter');
	        (0, _born.getSelectedFilterCount)();
	        (0, _born.setdefaultFilteractive)($generic, $eleParent);
	    }
	}
	
	function triggerStickyOpen() {
	
	    var propagationHandler = function propagationHandler(e) {
	        e.stopImmediatePropagation();
	        e.stopPropagation();
	        var $toggledElements = $('.web-sort-by-toggle,.web-sort-by-filter,.refinement__static-filter');
	        if ($toggledElements.hasClass('toggle--active')) {
	            $toggledElements.removeClass('toggle--active');
	            //avoid sort menu closing, if clicked inside the menu
	            $('#main').off('click', '.web-sort-by-toggle,.web-sort-by-filter', function (e) {
	                return e.stopPropagation();
	            });
	            $(window).off('click', propagationHandler);
	            $('body').removeClass('cancel-scroll');
	        }
	        (0, _plp.saveStickyToggleState)();
	    };
	
	    if (window.selectedStickyFilter != null) {
	        var $allFilters = $('.refinement__static-filter:not(.refinement__sorts)');
	        var $ele = $('#' + window.selectedStickyFilter);
	        $allFilters.removeClass('toggle--active');
	        $ele.addClass('toggle--active').find('.web-sort-by-toggle, .web-sort-by-filter, .toggle__link, .toggle__content').addClass('toggle--active');
	        (0, _plp.setOverlayInnerScroll)(window.selectedStickyFilter, "plp");
	    }
	    $('#main').on('click', '.web-sort-by-toggle,.web-sort-by-filter', function (e) {
	        return e.stopPropagation();
	    });
	    $(window).on('click', propagationHandler);
	}
	
	/**
	 * @private
	 * @function
	 * @description Initializes events for the following elements:<br/>
	 * <p>refinement blocks</p>
	 * <p>updating grid: refinements, pagination, breadcrumb</p>
	 * <p>item click</p>
	 * <p>sorting changes</p>
	 */
	function initializeEvents() {
	    var $main = $('#main');
	    // compare checked
	    $main.on('click', 'input[type="checkbox"].compare-check', function () {
	        var cb = $(this);
	        var tile = cb.closest('.product-tile');
	
	        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
	        var itemImg = tile.find('.product-image a img').first();
	        func({
	            itemid: tile.data('itemid'),
	            uuid: tile[0].id,
	            img: itemImg,
	            cb: cb
	        });
	    });
	
	    // handle toggle refinement blocks
	    // $main.on('click', '.refinement h3', function () {
	    //     $(this).toggleClass('expanded')
	    //     .siblings('ul').toggle();
	    // });
	
	    $main.on('click', '.brandplpsearchresult .refinement-wrapper a:not(#brand_category_list a),.brandplpsearchresult .pagination a,.refinement-wrapper #brand_category_list a, .brandplpsearchresult .refinement__static-filter a,.brandplpsearchresult .breadcrumb-refinement-value a, .filter-badge a, .clear-filter-btn-container a', function (e) {
	        if ($(this).parent().hasClass('unselectable')) {
	            return;
	        }
	        if ($(this).hasClass('brand-link') && !$(this).hasClass('active')) {
	            $(this).parents('.category-list.last-child').siblings('.last-child').find('a.category-click.active').removeClass('active');
	            $(this).addClass('active');
	        }
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        e.stopPropagation();
	        previousToggleRefinementEl = $(this);
	        previousToggleSeoCatEl = $('#catseotext-wrapper');
	        updateProductListing(this.href, getToggledRefinements(), false, '#productGridContainer');
	        (0, _plp.PLPCategoryToggle)();
	    });
	
	    // handle events for updating grid
	    $main.on('click', '.refinement-wrapper a:not(#brand_category_list a), .pagination a, .refinement__static-filter:not(.refinement__sorts) a,.breadcrumb-refinement-value a', function (e) {
	        // don't intercept for category and folder refinements, as well as unselectable
	        //$(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 ||
	        if ($(this).parent().hasClass('unselectable')) {
	            return;
	        }
	        e.preventDefault();
	        previousToggleRefinementEl = $(this);
	        previousToggleSeoCatEl = $('#catseotext-wrapper');
	        if ($(this).hasClass('category-click')) {
	            var addVisii = true;
	            updateProductListing(this.href, getToggledRefinements(), undefined, undefined, addVisii);
	        } else {
	            updateProductListing(this.href, getToggledRefinements());
	        }
	    });
	
	    // handle events item click. append params.
	    $main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
	        var a = $(this);
	        // get current page refinement values
	        var wl = window.location;
	
	        var qsParams = wl.search.length > 1 ? util.getQueryStringParams(wl.search.substr(1)) : {};
	        var hashParams = wl.hash.length > 1 ? util.getQueryStringParams(wl.hash.substr(1)) : {};
	
	        // merge hash params with querystring params
	        var params = $.extend(hashParams, qsParams);
	        if (!params.start) {
	            params.start = 0;
	        }
	        // get the index of the selected item and save as start parameter
	        var tile = a.closest('.product-tile');
	        var idx = tile.data('idx') ? +tile.data('idx') : 0;
	
	        // convert params.start to integer and add index
	        params.start = +params.start + (idx + 1);
	        // set the hash and allow normal action to continue
	        a[0].hash = $.param(params);
	    });
	
	    // handle sorting change
	    $main.on('change', '.sort-by select', function (e) {
	        e.preventDefault();
	        updateProductListing($(this).find('option:selected').val(), getToggledRefinements());
	    }).on('change', '.items-per-page select', function () {
	        var refineUrl = $(this).find('option:selected').val();
	        if (refineUrl === 'INFINITE_SCROLL') {
	            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
	        } else {
	            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
	            updateProductListing(refineUrl, getToggledRefinements());
	        }
	    });
	
	    //handle back button functionality
	    // bug: https://github.com/visionmedia/page.js/issues/213
	    // workaround for IOS is below
	    if (util.isSafari()) {
	        $(window).one('popstate', function () {
	            $(window).on('popstate', function (event) {
	                updateProductListing(window.location.href, getToggledRefinements(), true);
	            });
	        });
	    } else {
	        $(window).on('popstate', function (event) {
	            updateProductListing(window.location.href, getToggledRefinements(), true);
	        });
	    }
	
	    if (window.innerWidth < _born.breakpoints.mobile) {
	        // $main.on('click', '.refinement-wrapper-hgt .toggle__link:not(".refinement__all"), .refinement-wrapper-hgt .refinement__link', function () {
	        //     this.scrollIntoView({block : "center"});
	        // });
	
	        $main.on('click', '.refinement-wrapper-hgt .refinement__clear', function () {
	            var nearToggle = $(this).closest('.toggle__link');
	            if (nearToggle && nearToggle.length > 0) {
	                previousToggleRefinementEl = nearToggle;
	                previousToggleSeoCatEl = $('#catseotext-wrapper');
	            }
	        });
	    }
	}
	
	function enablePLPSeoToggle() {
	    var initWrappEL = $("#catseotext-wrapper");
	    bornModules.toggle.init('#catseotext-wrapper');
	    if (initWrappEL.length > 0) {
	        wrapEvents = jQuery._data(initWrappEL[0])["events"];
	        if (wrapEvents && wrapEvents.click !== undefined) {
	            wrapEvents = wrapEvents["click"][0].handler;
	        } else {
	            wrapEvents = false;
	        }
	    }
	
	    if (window.innerWidth < _born.breakpoints.mobile) {
	        removeToggleActive();
	    } else {
	        initWrappEL.off('click');
	        addToggleActive();
	    }
	}
	
	function removeToggleActive() {
	    $('#refine-catseotexthead').find("div").removeClass("toggle--active");
	}
	
	function addToggleActive() {
	    var seoWrappEL = $('#catseotext-wrapper');
	    if (seoWrappEL.length > 0) {
	        if (seoWrappEL.not('.toggle--active')) {
	            seoWrappEL.addClass('toggle--active');
	            var targetEl = seoWrappEL.data('toggle-target');
	            if (targetEl) {
	                $(targetEl).addClass('toggle--active');
	            }
	        }
	    }
	}
	
	function isSameCurrency() {
	    var currentCurrency = document.querySelectorAll('.product-grid')[0].getAttribute('data-current-currency'),
	        previousCurrency = sessionStorage.getItem('currency');
	    if (currentCurrency == previousCurrency) {
	        return true;
	    } else {
	        return false;
	    }
	}
	
	//Get all toggled refinements
	function getToggledRefinements() {
	    return [].slice.call(document.querySelectorAll('.product-search-main .toggle--active[data-toggle-target]'));
	}
	
	exports.init = function () {
	    // Load window.history if history state is found
	    if (window.history.state != null) {
	        if (sessionStorage['cache-path'] === window.location.pathname) {
	            $('#search-result-items').html(sessionStorage[window.history.state.results]);
	            var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-last-load="true"]');
	            if (loadingPlaceHolder.length > 0 && $('.pagination').length > 0) {
	                $('.pagination').removeClass('hidden');
	            }
	            $(window).scrollTop(sessionStorage.scrollPos || 0);
	        }
	    }
	    compareWidget.init();
	    if (!util.isMobile() && !SitePreferences.LISTING_HYBRID_PAGINATION && SitePreferences.LISTING_INFINITE_SCROLL) {
	        $(window).on('scroll', infiniteScroll);
	        setupInfinitePositioning();
	    } else if (SitePreferences.LISTING_HYBRID_PAGINATION) {
	        $(window).on('scroll', infiniteScroll);
	    } else {
	        $(window).on('scroll', function () {
	            //set scroll position in session storage
	            sessionStorage.scrollPos = $(window).scrollTop();
	        });
	        $(window).onload = function () {
	            window.scrollTop(sessionStorage.scrollPos || 0);
	        };
	    }
	    productTile.init();
	    initTileSliders();
	    cancelEmptySearch();
	    initializeEvents();
	    brandLHNMobileBackAction();
	    handlePLPGAEvents();
	    handlePLPFilterEvents();
	    bornModules.productRating.init();
	    (0, _offertimer.categoryOfferTimer)();
	};
	
	function brandLHNMobileBackAction() {
	    $('#categoryBrandRefinementMob .sub-level-wrapper .go-back').on('click', function (event) {
	        event.stopPropagation();
	        //$(event.currentTarget).closest('li.expandable.active').removeClass('active').find('.refinement-link:first').addClass('active');
	        $(this).closest('li.expandable.active').removeClass('active').addClass('active-rm').find('.refinement-link:first').addClass('active-rp');
	        $('.active-rm').find('.active').addClass('active-rp');
	        $('#categoryBrandRefinementMob .category-level-1').find('li.expandable:not(.active-rm)').removeClass('active');
	        $('#categoryBrandRefinementMob .category-level-1').find('.expandable:not(.active-rm)').find('a.active').removeClass('active');
	        $('#categoryBrandRefinementMob .category-level-1').find('.active-rp').removeClass('active-rp').addClass('active');
	    });
	}
	
	window.addEventListener('load', function () {
	    if (wrapEvents === false) {
	        enablePLPSeoToggle();
	    }
	    var catRefEl = $('#categoryBrandRefinementMob');
	    if (catRefEl.length > 0) {
	        categoryBrandRefinement = catRefEl;
	    }
	});
	
	$(document).ready(function () {
	    var setIntervalCount = 0;
	    var catgrySeoInterval = setInterval(function () {
	        var objEl = $('#catseotext-wrapper');
	        var checkExist = objEl.length > 0 && objEl.data('initialized');
	        if (checkExist || setIntervalCount > 5) {
	            clearInterval(catgrySeoInterval);
	            enablePLPSeoToggle();
	        }
	        setIntervalCount += 1;
	    }, 300);
	    addVisiiAttributesToWindow();
	});
	function addVisiiAttributesToWindow() {
	    var catList = $('#productRootCategoryList').length > 0 ? $('#productRootCategoryList').data('categorylist') : null;
	    if (catList) {
	        var keys = Object.keys(catList);
	        for (var i = 0; i < keys.length; i++) {
	            window[keys[i]] = catList[keys[i]];
	        }
	    }
	}
	function handlePLPGAEvents() {
	    var user = dataLayer.find(function (o) {
	        return o.user != null;
	    }).user;
	    $('.refinement__web--sortby .refinement--link').on('click', function () {
	        dataLayer.push({
	            "event": 'custom_event',
	            "eventCategory": 'filter',
	            "eventAction": 'filter_selection',
	            "eventLabel": 'filter-sort',
	            "filter": $(this).text(),
	            "country": window.GlobalAttributes.COUNTRY,
	            "language": window.GlobalAttributes.LANGUAGE,
	            "screenName": 'PLP',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.product-grid-container .sticky-filters-wrapper .refinement__static-filter:not(.refinement__sorts) .refinement--link').on('click', function () {
	        var filterLabel = $(this).closest('form').find('.toggle-label') ? $(this).closest('form').find('.toggle-label').text() : '';
	        var filterValue = $(this).find('.refinement-text') ? $(this).find('.refinement-text').text() : '';
	        dataLayer.push({
	            "event": 'custom_event',
	            "eventCategory": 'filter',
	            "eventAction": 'filter_selection',
	            "eventLabel": 'filter-' + filterLabel,
	            "filter": filterValue,
	            "country": window.GlobalAttributes.COUNTRY,
	            "language": window.GlobalAttributes.LANGUAGE,
	            "screenName": 'PLP',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    var queryParams = util.getQueryStringParams(window.location.search.substring(1));
	    if (Object.keys(queryParams).length == 2 && queryParams.q && queryParams.lang) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var query_param = new URLSearchParams(window.location.search).get('q');
	        if ($('#search-result-items').children().length === 0) {
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'search',
	                'eventAction': 'no_search_result',
	                'eventLabel': 'no search result',
	                'searchTerm': query_param,
	                'country': window.GlobalAttributes.COUNTRY,
	                'language': window.GlobalAttributes.LANGUAGE,
	                'screenName': 'Search',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        } else {
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'search',
	                'eventAction': 'search_result',
	                'eventLabel': 'search result',
	                'searchTerm': query_param,
	                'country': window.GlobalAttributes.COUNTRY,
	                'language': window.GlobalAttributes.LANGUAGE,
	                'screenName': 'Search',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        }
	    }
	}
	
	function handlePLPFilterEvents() {
	    var user = dataLayer.find(function (o) {
	        return o.user != null;
	    }).user;
	    $('body').on('click', '.refinements__filter_actions .filterapply,.refinements__filter_actions .filterapply--mob', function () {
	        var $selectedFilterEl = $('.badge-overflow-limit .filter-badge');
	        var selectedFilterArray = [];
	        if ($selectedFilterEl.length > 0) {
	            $selectedFilterEl.each(function (key, val) {
	                var filterElement = $(val);
	                if (filterElement) {
	                    selectedFilterArray.push(filterElement.text());
	                }
	            });
	            var selectedFilters = selectedFilterArray.join('|');
	        }
	        var $selectedFilters = $('.refinement__all__toggle .toggle--nb .toggle__link.toggle--active .toggle__name');
	        var selecterFilterNamesArray = [];
	        if ($selectedFilters.length > 0) {
	            $selectedFilters.each(function (key, val) {
	                var filterElement = $(val);
	                if (filterElement) {
	                    selecterFilterNamesArray.push(filterElement.attr('title'));
	                }
	            });
	            var selectedFilterNames = selecterFilterNamesArray.join(',');
	        }
	        dataLayer.push({
	            "event": 'custom_event',
	            "eventCategory": 'filter',
	            "eventAction": 'filter_apply',
	            "eventLabel": 'filter-' + selectedFilterNames,
	            "filter": selectedFilters,
	            "country": window.GlobalAttributes.COUNTRY,
	            "language": window.GlobalAttributes.LANGUAGE,
	            "screenName": 'PLP',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('body').on('click', '.refinements__filtercontainer .refinement__web_clearfilter, .refinement__selected-filters .clear-filter-btn', function () {
	        var $selectedFilterEl = $('.badge-overflow-limit .filter-badge');
	        var selectedFilterArray = [];
	        if ($selectedFilterEl.length > 0) {
	            $selectedFilterEl.each(function (key, val) {
	                var filterElement = $(val);
	                if (filterElement) {
	                    selectedFilterArray.push(filterElement.text());
	                }
	            });
	            var selectedFilters = selectedFilterArray.join('|');
	        }
	        dataLayer.push({
	            "event": 'custom_event',
	            "eventCategory": 'filter',
	            "eventAction": 'filter_clear_all',
	            "eventLabel": 'filter clear all',
	            "filter": selectedFilters,
	            "country": window.GlobalAttributes.COUNTRY,
	            "language": window.GlobalAttributes.LANGUAGE,
	            "screenName": 'PLP',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    });
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var page = __webpack_require__(58),
	    util = __webpack_require__(15),
	    TPromise = __webpack_require__(30);
	
	var _currentCategory = '',
	    MAX_ACTIVE = 6;
	
	/**
	 * @private
	 * @function
	 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
	 */
	function refreshContainer() {
	    var $compareContainer = $('.compare-items');
	    var $compareItems = $compareContainer.find('.compare-item');
	    var numActive = $compareItems.filter('.active').length;
	
	    if (numActive < 2) {
	        $('#compare-items-button').attr('disabled', 'disabled');
	    } else {
	        $('#compare-items-button').removeAttr('disabled');
	    }
	
	    $compareContainer.toggle(numActive > 0);
	}
	/**
	 * @private
	 * @function
	 * @description Adds an item to the compare container and refreshes it
	 */
	function addToList(data) {
	    // get the first compare-item not currently active
	    var $item = $('.compare-items .compare-item').not('.active').first(),
	        $productTile = $('#' + data.uuid);
	
	    if ($item.length === 0) {
	        if ($productTile.length > 0) {
	            $productTile.find('.compare-check')[0].checked = false;
	        }
	        window.alert(Resources.COMPARE_ADD_FAIL);
	        return;
	    }
	
	    // if already added somehow, return
	    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
	        return;
	    }
	    // set as active item
	    $item.addClass('active').attr('data-uuid', data.uuid).attr('data-itemid', data.itemid).data('uuid', data.uuid).data('itemid', data.itemid).append($(data.img).clone().addClass('compare-item-image'));
	}
	/**
	 * @private
	 * @function
	 * description Removes an item from the compare container and refreshes it
	 */
	function removeFromList($item) {
	    if ($item.length === 0) {
	        return;
	    }
	    // remove class, data and id from item
	    $item.removeClass('active').removeAttr('data-uuid').removeAttr('data-itemid').data('uuid', '').data('itemid', '')
	    // remove the image
	    .find('.compare-item-image').remove();
	}
	
	function addProductAjax(args) {
	    var promise = new TPromise(function (resolve, reject) {
	        $.ajax({
	            url: Urls.compareAdd,
	            data: {
	                pid: args.itemid,
	                category: _currentCategory
	            },
	            dataType: 'json'
	        }).done(function (response) {
	            if (!response || !response.success) {
	                reject(new Error(Resources.COMPARE_ADD_FAIL));
	            } else {
	                resolve(response);
	            }
	        }).fail(function (jqxhr, status, err) {
	            reject(new Error(err));
	        });
	    });
	    return promise;
	}
	
	function removeProductAjax(args) {
	    var promise = new TPromise(function (resolve, reject) {
	        $.ajax({
	            url: Urls.compareRemove,
	            data: {
	                pid: args.itemid,
	                category: _currentCategory
	            },
	            dataType: 'json'
	        }).done(function (response) {
	            if (!response || !response.success) {
	                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
	            } else {
	                resolve(response);
	            }
	        }).fail(function (jqxhr, status, err) {
	            reject(new Error(err));
	        });
	    });
	    return promise;
	}
	
	function shiftImages() {
	    return new TPromise(function (resolve) {
	        var $items = $('.compare-items .compare-item');
	        $items.each(function (i, item) {
	            var $item = $(item);
	            // last item
	            if (i === $items.length - 1) {
	                return removeFromList($item);
	            }
	            var $next = $items.eq(i + 1);
	            if ($next.hasClass('active')) {
	                // remove its own image
	                $next.find('.compare-item-image').detach().appendTo($item);
	                $item.addClass('active').attr('data-uuid', $next.data('uuid')).attr('data-itemid', $next.data('itemid')).data('uuid', $next.data('uuid')).data('itemid', $next.data('itemid'));
	            }
	        });
	        resolve();
	    });
	}
	
	/**
	 * @function
	 * @description Adds product to the compare table
	 */
	function addProduct(args) {
	    var promise;
	    var $items = $('.compare-items .compare-item');
	    var $cb = $(args.cb);
	    var numActive = $items.filter('.active').length;
	    if (numActive === MAX_ACTIVE) {
	        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
	            $cb[0].checked = false;
	            return;
	        }
	
	        // remove product using id
	        var $firstItem = $items.first();
	        promise = removeItem($firstItem).then(function () {
	            return shiftImages();
	        });
	    } else {
	        promise = TPromise.resolve(0);
	    }
	    return promise.then(function () {
	        return addProductAjax(args).then(function () {
	            addToList(args);
	            if ($cb && $cb.length > 0) {
	                $cb[0].checked = true;
	            }
	            refreshContainer();
	        });
	    }).then(null, function () {
	        if ($cb && $cb.length > 0) {
	            $cb[0].checked = false;
	        }
	    });
	}
	
	/**
	 * @function
	 * @description Removes product from the compare table
	 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
	 */
	function removeProduct(args) {
	    var $cb = args.cb ? $(args.cb) : null;
	    return removeProductAjax(args).then(function () {
	        var $item = $('[data-uuid="' + args.uuid + '"]');
	        removeFromList($item);
	        if ($cb && $cb.length > 0) {
	            $cb[0].checked = false;
	        }
	        refreshContainer();
	    }, function () {
	        if ($cb && $cb.length > 0) {
	            $cb[0].checked = true;
	        }
	    });
	}
	
	function removeItem($item) {
	    var uuid = $item.data('uuid'),
	        $productTile = $('#' + uuid);
	    return removeProduct({
	        itemid: $item.data('itemid'),
	        uuid: uuid,
	        cb: $productTile.length === 0 ? null : $productTile.find('.compare-check')
	    });
	}
	
	/**
	 * @private
	 * @function
	 * @description Initializes the DOM-Object of the compare container
	 */
	function initializeDom() {
	    var $compareContainer = $('.compare-items');
	    _currentCategory = $compareContainer.data('category') || '';
	    var $active = $compareContainer.find('.compare-item').filter('.active');
	    $active.each(function () {
	        var $productTile = $('#' + $(this).data('uuid'));
	        if ($productTile.length === 0) {
	            return;
	        }
	        $productTile.find('.compare-check')[0].checked = true;
	    });
	    // set container state
	    refreshContainer();
	}
	
	/**
	 * @private
	 * @function
	 * @description Initializes the events on the compare container
	 */
	function initializeEvents() {
	    // add event to buttons to remove products
	    $('.compare-item').on('click', '.compare-item-remove', function () {
	        removeItem($(this).closest('.compare-item'));
	    });
	
	    // Button to go to compare page
	    $('#compare-items-button').on('click', function () {
	        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
	    });
	
	    // Button to clear all compared items
	    // rely on refreshContainer to take care of hiding the container
	    $('#clear-compared-items').on('click', function () {
	        $('.compare-items .active').each(function () {
	            removeItem($(this));
	        });
	    });
	}
	
	exports.init = function () {
	    initializeDom();
	    initializeEvents();
	};
	
	exports.addProduct = addProduct;
	exports.removeProduct = removeProduct;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var overlayVideo = __webpack_require__(162);
	
	exports.init = function () {
	    /** Initialize home page video overlay close and detach on click */
	    var params = {
	        containerSelector: '.js-home-video-container',
	        closeButtonSelector: '.js-home-video-container-close'
	    };
	
	    overlayVideo(params);
	
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	        $(function () {
	            $("img.hme-unveil-carousel:not(.unveil-loaded)").unveil(100, function () {
	                $(this).addClass('unveil-loaded');
	            });
	        });
	    }
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @function init Used to display & control overlay video on home page
	 * @param {Object} params
	 * @param {String} params.containerSelector
	 * @param {String} params.closeButtonSelector
	 **/
	module.exports = function init(params) {
	    var _ = __webpack_require__(7),
	        defaultOptions = {
	        closeButtonSelector: '.js-home-video-container-close',
	        containerSelector: '.js-home-video-container'
	    };
	
	    _.extend(defaultOptions, params);
	
	    $(document).ready(function () {
	        var $container = $(defaultOptions.containerSelector),
	            util = __webpack_require__(15),
	            $video = $container.find('video'),
	            video = $video[0],
	            $closeButton = $container.find(defaultOptions.closeButtonSelector);
	
	        if ($container && $container.length && $video && $video.length) {
	            var closeVideo = function closeVideo() {
	                $closeButton.detach();
	                $('body').removeClass('m-fixed');
	                $container.removeClass('homepage-hero-video');
	                $('.slick-slider').slick('refresh');
	                if (util.isMobile()) {
	                    setTimeout(function () {
	                        $container.detach();
	                    }, 350);
	                } else {
	                    $container.detach();
	                }
	            };
	
	            $video.bind('click ended', closeVideo);
	            $closeButton.bind('click', closeVideo);
	
	            $video.bind('canplaythrough', function () {
	                $container.removeClass('h-hidden');
	                video.play();
	            });
	        }
	    });
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _remainScrollAfterCtaAction = __webpack_require__(73);
	
	var _remainScrollAfterCtaAction2 = _interopRequireDefault(_remainScrollAfterCtaAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addProductToCart = __webpack_require__(72),
	    page = __webpack_require__(58),
	    login = __webpack_require__(91),
	    util = __webpack_require__(15);
	
	(0, _remainScrollAfterCtaAction2.default)($('button.delete-item'));
	
	exports.init = function () {
	    addProductToCart();
	    $('#editAddress').on('change', function () {
	        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
	    });
	
	    //add js logic to remove the , from the qty feild to pass regex expression on client side
	    $('.option-quantity-desired input').on('focusout', function () {
	        $(this).val($(this).val().replace(',', ''));
	    });
	
	    login.init();
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _born = __webpack_require__(10);
	
	var Utils = _interopRequireWildcard(_born);
	
	var _module = __webpack_require__(18);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _validator = __webpack_require__(56);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addSignupHandler() {
	    var form = $('.js-signup-subscribe'),
	        subFormSettings = $.extend(true, { submitHandler: sendSignupRequest }, _validator2.default.settings),
	        ref = $(form).find('[name$=ref]').val();
	
	    _validator2.default.initForm(form, subFormSettings);
	
	    var page = {
	        type: "Sign Up",
	        breadcrumb: ["Home", "Sign Up"]
	    };
	
	    if (ref && ref != 'stringEmpty') {
	        page.page_ref = ref;
	    }
	
	    _module2.default.pushData(page, 'page');
	}
	
	function sendSignupRequest(form) {
	
	    _module2.default.pushData('mail_signup: ' + window.Resources['NOSTOCK_SIGNUP']);
	
	    return true;
	}
	
	function initEventHandlers() {
	    addSignupHandler();
	};
	
	exports.init = function () {
	    initEventHandlers();
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _born = __webpack_require__(10);
	
	var Utils = _interopRequireWildcard(_born);
	
	var _module = __webpack_require__(18);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _validator = __webpack_require__(56);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var progress = __webpack_require__(43),
	    page = __webpack_require__(58),
	    util = __webpack_require__(15);
	
	var SIGNUP_DETAILS = '.js-subscribersignup__details';
	
	function addSignupHandler() {
	    var form = $('.js-subscribersignup'),
	        subFormSettings = $.extend(true, { submitHandler: sendSignupRequest }, _validator2.default.settings),
	        ref = $(form).find('[name$=ref]').val();
	
	    _validator2.default.initForm(form, subFormSettings);
	
	    var page = {
	        type: "Newsletter",
	        breadcrumb: ["Home", "Newsletter", "Subscribe"]
	    };
	
	    if (ref && ref != 'stringEmpty') {
	        page.page_ref = ref;
	    }
	
	    _module2.default.pushData(page, 'page');
	}
	
	function sendSignupRequest(form) {
	    progress.show($(SIGNUP_DETAILS));
	    _module2.default.pushData('mail_signup: ' + window.Resources['SUBSCRIBE_SIGNUP']);
	
	    return true;
	}
	
	function initEventHandlers() {
	    addSignupHandler();
	};
	
	function genderSelectionCheckmarkToggle() {
	    $('.form-gender-radio').each(function () {
	        if ($(this).is(':checked')) {
	            $(this).parent().addClass('selected');
	        }
	    });
	    $('.form-gender-radio').on('change', function () {
	        $('.form-gender-selection-radio').removeClass('selected');
	        $(this).parent().addClass('selected');
	    });
	}
	
	exports.init = function () {
	    initEventHandlers();
	    genderSelectionCheckmarkToggle();
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var account = __webpack_require__(89);
	
	// can be used not only for Locale but for other cookie values as well
	function getCookieByName(name) {
	  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	  if (match) return match[2];
	}
	
	var currentLocale = getCookieByName('preferredLocale');
	
	function replaceUrl() {
	  var currentCountry = '';
	  if (window.GlobalAttributes !== undefined && window.GlobalAttributes.COUNTRY !== undefined) {
	    currentCountry = window.GlobalAttributes.COUNTRY.toLowerCase();
	    if (currentCountry != '' && currentCountry != 'ae') {
	      currentCountry = currentCountry + '/';
	    } else {
	      currentCountry = '';
	    }
	  }
	  window.history.pushState(null, '', '/' + currentCountry + currentLocale + '/' + 'order-confirmation');
	}
	
	function orderConfirmationGAEvents() {
	  var user = dataLayer.find(function (o) {
	    return o.user != null;
	  }).user;
	  $('.order-confirmation--content').find('.view-order-details').on('click', function (e) {
	    dataLayer.push({
	      'event': 'custom_event',
	      'eventCategory': 'thank_you_page',
	      'eventAction': 'thank_you_view_order_click',
	      'eventLabel': 'thank you view order click',
	      'country': window.GlobalAttributes.COUNTRY,
	      'language': window.GlobalAttributes.LANGUAGE,
	      'screenName': 'Thank you screen',
	      'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	      'userId': user.user_id != '' ? user.user_id : ''
	    });
	  });
	  $('.order-confirmation--content').find('.continue-btn').on('click', function (e) {
	    dataLayer.push({
	      'event': 'custom_event',
	      'eventCategory': 'thank_you_page',
	      'eventAction': 'thank_you_shop_now_click',
	      'eventLabel': 'thank you shop now click',
	      'country': window.GlobalAttributes.COUNTRY,
	      'language': window.GlobalAttributes.LANGUAGE,
	      'screenName': 'Thank you screen',
	      'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	      'userId': user.user_id != '' ? user.user_id : ''
	    });
	  });
	}
	
	exports.init = function () {
	  replaceUrl();
	  account.customerInterestsOnChangeEvent();
	  orderConfirmationGAEvents();
	};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module = __webpack_require__(18);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initEventHandlers() {
	    var page = {
	        type: "Newsletter",
	        breadcrumb: ["Home", "Newsletter", "Thankyou"]
	    };
	
	    _module2.default.pushData(page, 'page');
	    var user = dataLayer.find(function (o) {
	        return o.user != null;
	    }).user;
	    dataLayer.push({
	        'event': 'custom_event',
	        'eventCategory': 'footer_navigation',
	        'eventAction': 'newsletter_signup',
	        'eventLabel': 'newsletter_signup success',
	        'country': window.GlobalAttributes.COUNTRY,
	        'language': window.GlobalAttributes.LANGUAGE,
	        'screenName': 'Footer navigation',
	        'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	        'userId': user.user_id != '' ? user.user_id : ''
	    });
	};
	
	exports.init = function () {
	    initEventHandlers();
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _born = __webpack_require__(10);
	
	var Utils = _interopRequireWildcard(_born);
	
	var _module = __webpack_require__(18);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _validator = __webpack_require__(56);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var progress = __webpack_require__(43);
	
	var SIGNUP_DETAILS = '.js-brandcampaign-signup';
	
	var $signupBlock = $(SIGNUP_DETAILS),
	    $form = $signupBlock.find('form');
	
	function addSignupHandler() {
	    var subFormSettings = $.extend(true, { submitHandler: sendSignupRequest }, _validator2.default.settings),
	        ref = $form.find('[name$=ref]').val();
	
	    _validator2.default.initForm($form, subFormSettings);
	
	    var page = {
	        type: "Campaign",
	        breadcrumb: ['Home', 'Campaign', 'Alamodist']
	    };
	
	    if (ref && ref != 'stringEmpty') {
	        page.page_ref = ref;
	    }
	
	    _module2.default.pushData(page, 'page');
	}
	
	function sendSignupRequest() {
	    progress.show($(SIGNUP_DETAILS));
	    $.ajax({
	        url: _util2.default.ajaxUrl($form.attr('action')),
	        data: $form.serialize(),
	        complete: function complete(response) {
	            showConfirmationScreen();
	            _module2.default.pushData('mail_signup: ' + window.Resources['BRAND_SIGNUP']);
	        }
	    });
	
	    return false;
	}
	
	function showConfirmationScreen() {
	    var $signupBlock = $form.parents().find('.js-brandcampaign-signup');
	
	    if (SitePreferences.BRANDSIGNUP_CONFIRMATION_COLOR) {
	        $signupBlock.css('color', '#' + SitePreferences.BRANDSIGNUP_CONFIRMATION_COLOR);
	    }
	
	    $signupBlock.html(SitePreferences.BRANDSIGNUP_CONFIRMATION);
	
	    if (_util2.default.isMobile()) {
	        window.scrollTo(0, $signupBlock.offset().top - $('.header__main').height());
	    }
	
	    progress.hide();
	}
	
	function initEventHandlers() {
	    addSignupHandler();
	};
	
	exports.init = function () {
	    initEventHandlers();
	};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(15);
	var addToCart = __webpack_require__(72);
	
	var magazine = {
		/**
	  * @private
	  * @function
	  * @description init events for the Magazine Pages
	  */
		init: function init() {
			initializeEvents();
			addToCart();
		}
	};
	
	function enableCartButton(obj) {
		var container = obj.closest('.product__images__container');
		var btn = container.find('button[type="button"]');
		btn.removeAttr('disabled');
		if (!btn.hasClass('out-stk-btn')) {
			changeCartButtonText(btn, Resources.ADD_TO_CART_BUTTON);
		}
	}
	
	function updateCartButtonText(obj, text) {
		var container = obj.closest('.product__images__container');
		var btn = container.find('button[type="button"]');
		if (btn !== undefined) {
			changeCartButtonText(btn, text);
		}
	}
	
	function disableCartButton(obj) {
		var container = $('.magazine-article__section');
		var btn = container.find('button[type="button"].btn-add-to-bag');
		btn.attr('disabled', true);
		container.find('.add-to-bag, .inacactive-cart-btn').removeClass('active');
		if (!btn.hasClass('out-stk-btn')) {
			changeCartButtonText(btn, Resources.ADD_TO_CART_BUTTON);
		}
	}
	
	function resetCartForm() {
		var bagForm = $('.magazine-article  .pdpForm');
		bagForm[0].reset();
	
		return bagForm;
	}
	
	function changeCartButtonText(btn, text) {
		btn.html(text);
		btn.attr('title', text);
	}
	
	function initializeEvents() {
		var $mainClass = $('body');
	
		// Toggle Product ID to hidden Fields
		$mainClass.on('click', '.add-to-bag:not(.active)', function () {
			var bagForm = resetCartForm();
			var currentObj = $(this);
			var url = currentObj.data('link');
			disableCartButton(currentObj);
			$.ajax({
				type: 'POST',
				url: util.ajaxUrl(url),
				success: function success(response) {
					if (response.pid) {
						if (response.inStock === true) {
							currentObj.addClass('active');
							bagForm.find('input[name="Quantity"]').val(1);
							bagForm.find('input[name="pid"]').val(response.pid);
							enableCartButton(currentObj);
						} else {
							updateCartButtonText(currentObj, Resources.OUT_OF_STOCK);
						}
					}
				}
			});
		});
	
		$mainClass.on('click', '.btn-direct-to-bag', function () {
			var bagForm = resetCartForm();
			var currentObj = $(this);
			var pid = currentObj.data('product');
			var wrapDom = currentObj.closest('.section-add-to-bag');
			if (pid && wrapDom.length > 0) {
				bagForm.find('input[name="Quantity"]').val(1);
				bagForm.find('input[name="pid"]').val(pid);
				enableCartButton(currentObj);
				wrapDom.find('.link-add-to-bag').click();
			}
		});
	
		$mainClass.on('click', '.inacactive-cart-btn', function (e) {
			e.preventDefault();
			e.stopPropagation();
			var currentObj = $(this);
			disableCartButton(currentObj);
			currentObj.addClass('active');
			updateCartButtonText(currentObj, Resources.OUT_OF_STOCK);
		});
	
		// Toggle Product tile on mobile
		$mainClass.on('click', '.mod-product-button-toggle', function () {
			var parent = $(this).closest('.magazine_container');
			var imgContainerClass = 'product__magazine_images__container';
			var imgQuickviewClass = 'product__magazine--quickview';
			var baseimgClass = '.product__images__container';
	
			if (parent.find(baseimgClass).hasClass(imgContainerClass)) {
				parent.find(baseimgClass).removeClass(imgContainerClass + ' ' + imgQuickviewClass);
				toggleMagazineButtonClass(parent, 'off');
			} else {
				reinitSlickContainer(parent);
				parent.find('.product__images__container').addClass(imgContainerClass + ' ' + imgQuickviewClass);
				toggleMagazineButtonClass(parent, 'on');
			}
		});
	}
	
	function reinitSlickContainer(obj) {
		var sizeContainer = obj.find('.product__sizes');
		sizeContainer.attr("style", "display: inline-block !important;");
		var prevBtn = obj.find('.slick-prev');
		var baseWidth = 25;
		if (prevBtn.length > 0) {
			if (!prevBtn.hasClass('slick-prev-clicked')) {
				updateSlickItem(sizeContainer, baseWidth);
				prevBtn.click().addClass('slick-prev-clicked');
			}
		} else {
			updateSlickItem(sizeContainer, baseWidth, false);
		}
	}
	
	function toggleMagazineButtonClass(obj, type) {
		var baseButtonClass = 'mod-product-button-toggle';
		if (type == 'on') {
			obj.find('.' + baseButtonClass).addClass(baseButtonClass + '--close');
		} else {
			obj.find('.' + baseButtonClass).removeClass(baseButtonClass + '--close');
		}
	}
	
	function updateSlickItem(sizeContainer, baseWidth, nextSlide) {
		var items = sizeContainer.find('li.product__sizes__item');
		var length = items.length;
		if (nextSlide === undefined) {
			nextSlide = true;
		}
		if (nextSlide || length == 2 || length == 3) {
			sizeContainer.find('.slick-track').css("width", baseWidth * length + "px");
			items.each(function (key, item) {
				$(item).css("width", baseWidth + "px");
			});
		}
	}
	
	module.exports = magazine;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _storelocator = __webpack_require__(45);
	
	var appointmentInfo = {}; //Object to hold the selected Store,time & Date
	var userPastOverlayScrollPos = [0, 0];
	var appointmentDefaults = {
	    datelimit: 30,
	    storeopentime: '10:00',
	    storeclosetime: '22:00',
	    timeinterval: 30
	};
	
	var langSelected = $('html').attr('lang');
	var slickrtlAttr = langSelected == 'ar' ? true : false;
	var initTimeLoaded = false;
	
	//Overlay Scroll Fix in IOS
	function scrollLockIos(state) {
	    if (state === true) {
	        userPastOverlayScrollPos = [self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft, self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop];
	        $('html').addClass('cancel-scroll noscrollios');
	        $('body').addClass('cancel-scroll');
	    } else {
	        $('html').removeClass('cancel-scroll noscrollios');
	        $('body').removeClass('cancel-scroll');
	        window.scrollTo(userPastOverlayScrollPos[0], userPastOverlayScrollPos[1]);
	    }
	}
	
	function initializeEvents() {
	    //Store Selection Click - Navigate to Scheduler page
	    $(document).on('click', '.storelist_wa', function () {
	        var target = $(".storelist_wa").find('.checkbox.checked');
	        target.removeClass('checked');
	        $(".storelist_wa").removeClass('active-store');
	        appointmentInfo = {};
	        var store_info = $(this).find('.store_details_bkapp').val();
	        appointmentInfo.storedetails = store_info;
	        $('input[name$="storeappointment_storeAddress"]').val(store_info);
	        $(this).addClass('active-store');
	        if ($(this).data('storeid')) {
	            $('input[name$="storeappointment_storeID"]').val($(this).data('storeid'));
	        }
	        showTimeSlot();
	        goToPageTop();
	    });
	
	    //Progress Bar click for Stage 1 and Stage 2 for back Navigation
	    $(document).on("click", ".progress-bar__step", function () {
	        var curEle = $(this);
	        if (curEle.hasClass('active') && !curEle.hasClass('current')) {
	            $(".bkappstages").addClass('hdStage');
	            var slickdateEl = $('.schdate-scrollable-cta');
	            if (slickdateEl.hasClass('slick-initialized')) {
	                $('.schdate-scrollable-cta').slick('unslick');
	            }
	            var slickTimeEl = $('.schtime-scrollable-cta');
	            if (slickTimeEl.hasClass('slick-initialized')) {
	                $('.schtime-scrollable-cta').slick('unslick');
	            }
	
	            $(".progress-bar__step").removeClass('active current');
	            if (curEle.hasClass('step-1')) {
	                curEle.addClass("active current");
	                $(".progress-bar__expandable").removeClass('stage-2 stage-3');
	                $(".bookappointment_store").removeClass('hdStage');
	            } else if (curEle.hasClass('step-2')) {
	                $(".progress-bar__expandable").removeClass('stage-3').addClass('stage-2');
	                curEle.addClass("active current");
	                $(".step-1").addClass("active");
	                $(".bookappointment_scheduler").removeClass('hdStage');
	                getDatelist();
	                getTimeSlots();
	                $(".dayslot-item.selected").length > 0 ? $(".dayslot-item.selected").trigger('click') : "";
	                //Update the selected timeslot
	                if (appointmentInfo.appointmenttime !== "undefined" && appointmentInfo.appointmenttime !== "null") {
	                    $(".timeslot-item.slotdisabled").length != $(".timeslot-item").length ? $(".timeslot-item[data-slot='" + appointmentInfo.appointmenttime + "']").addClass('selected') : "";
	                }
	            }
	        }
	    });
	
	    //Day Selection of the Scheduler
	    $(document).on("click", ".dayslot-item", function () {
	        $(".dayslot-item,.timeslot-item").removeClass('selected');
	        $(this).addClass('selected');
	        var dateSelected = $(this).find(".sch_date").val();
	        appointmentInfo.appointmentdate = dateSelected;
	        appointmentInfo.dateheader = $(this).attr('id');
	        var date = getFormattedDate(dateSelected);
	        $('input[name$="storeappointment_date"]').val(date);
	        if (datesAreOnSameDay(new Date(dateSelected), new Date())) {
	            checkTimeSlotRange();
	        } else {
	            $(".timeslot-item").removeClass('slotdisabled');
	            $(".schtime-scrollable-cta").slick("slickGoTo", 0);
	        }
	    });
	
	    //TimeSlot Selection - navigate to appointment form
	    $(document).on("click", ".timeslot-item", function () {
	        if (!$(this).hasClass('slotdisabled')) {
	            $(".timeslot-item").removeClass('selected');
	            $(this).addClass('selected');
	            var selected_timeslot = $(this).attr('data-slot');
	            appointmentInfo.appointmenttime = selected_timeslot;
	            $('input[name$="storeappointment_time"]').val(selected_timeslot);
	            checkIfSlotExpired();
	        }
	    });
	
	    //User Submit Appointment form
	    $(document).on("click", "#book_appointment_btn", function () {
	        appointmentInfo = {}; // Clear on  Submission	
	        $(".bkappstages,.bookappointment_stage_ct").addClass('hdStage');
	        $(".bookappointment_completed_ct").removeClass('hdStage');
	    });
	
	    //Slot Modal Close Action
	    $(document).on("click", ".slot_expiry_btn", function () {
	        $(".slot_expiry_modal").addClass('modal-hide');
	        scrollLockIos(false);
	        $("body").removeClass('cancel-scroll');
	    });
	
	    (0, _storelocator.initStoreAppointment)();
	
	    $(document).ready(function () {
	        var limitInterval = 0;
	        var timeSlotInterval = setInterval(function () {
	            var timeEl = activateTimeSlot();
	            if (timeEl) {
	                initTimeLoaded = true;
	            }
	            if (timeEl || limitInterval > 5) {
	                clearInterval(timeSlotInterval);
	            }
	            limitInterval += 1;
	        }, 100);
	    });
	}
	
	window.addEventListener('load', function () {
	    if (!initTimeLoaded) {
	        activateTimeSlot();
	    }
	});
	
	function activateTimeSlot() {
	    if ($('.step-2').hasClass('current active') && $('.active-store').length > 0) {
	        $('.active-store').trigger('click');
	        return true;
	    }
	}
	
	function goToPageTop() {
	    var scrollTop = $('.bookappointment_Info').offset().top - 40;
	    $('html, body').animate({
	        scrollTop: scrollTop
	    }, 1000);
	}
	
	function showTimeSlot() {
	    $('.active-store').find('.checkbox').addClass('checked');
	    $(".bookappointment_store").addClass('hdStage');
	    $(".bookappointment_scheduler").removeClass('hdStage');
	    $(".progress-bar__step").removeClass('current');
	    $(".progress-bar__step.step-2").addClass('active current');
	    $(".progress-bar__expandable").addClass('stage-2');
	    getDatelist();
	    getTimeSlots();
	}
	
	//Generate Day Scheduler
	var getDatelist = function getDatelist() {
	    var tmp = '';
	    var weekdays = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
	    var monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	    var startDate = new Date();
	    for (var i = 0; i < appointmentDefaults.datelimit; i++) {
	        var d = startDate.addDays(i);
	        tmp += '<div class="content-items dayslot-item" id="sch-date-header-' + i + '">\n\t\t\t\t<div class="sch-day">' + weekdays[d.getDay()] + '</div>\n\t\t\t\t<div class="sch-date">' + d.getDate() + '</div>\n\t\t\t\t<div class="sch-month">' + monthName[d.getMonth()] + '</div>\n\t\t\t\t<input type="hidden" class="sch_date" value="' + d + '" /></div>';
	    }
	    $(".schdate-scrollable-cta").html(tmp);
	    $(".schdate-scrollable-cta").slick({
	        "slidesToShow": 7,
	        "arrows": true,
	        "slidesToScroll": 7,
	        "infinite": false,
	        "variableWidth": false,
	        "rtl": slickrtlAttr,
	        "responsive": [{ "breakpoint": 1025, "settings": { "slidesToShow": 3, "slidesToScroll": 3, "arrows": true } }, { "breakpoint": 768, "settings": { "slidesToShow": 3.5, "slidesToScroll": 3, "arrows": false, "dots": false, "variableWidth": true } }]
	    });
	    // Reinitialize the slick selected element on progress bar back  navigation
	    if (appointmentInfo.dateheader !== "undefined" && appointmentInfo.dateheader !== "null") {
	        $("#" + appointmentInfo.dateheader).addClass('selected');
	    }
	};
	
	//Check if the user selected timeslot expired due to inactivity and show modal to update the selection
	var checkIfSlotExpired = function checkIfSlotExpired() {
	    var dateSelected = $(".dayslot-item.selected").find(".sch_date").val();
	    if (datesAreOnSameDay(new Date(dateSelected), new Date())) {
	        var targetSlot = $(".timeslot-item.selected");
	        var slot = targetSlot.attr('data-slot').split(' - ');
	        if (checkCurrentTimeSlot(slot[0], slot[1]) == true) {
	            $(".slot_expiry_modal").removeClass('modal-hide');
	            scrollLockIos(true);
	            targetSlot.addClass('current slotdisabled').removeClass('selected');
	        } else {
	            navigateToAppointmentForm();
	        }
	    } else {
	        navigateToAppointmentForm();
	    }
	};
	
	function navigateToAppointmentForm() {
	    $(".bkappstages").addClass('hdStage');
	    $(".bookappointment_usr_form").removeClass('hdStage');
	    $(".progress-bar__step").removeClass('current');
	    $(".progress-bar__step.step-3").addClass('active current');
	    $(".progress-bar__expandable").addClass('stage-3').removeClass('stage-2');
	    goToPageTop();
	}
	
	function parseTime(s) {
	    var c = s.split(':');
	    return parseInt(c[0]) * 60 + parseInt(c[1]);
	}
	
	function convertHours(mins) {
	    var hour = Math.floor(mins / 60);
	    var mins = mins % 60;
	    var converted = pad(hour, 2) + ':' + pad(mins, 2);
	    return converted;
	}
	
	function pad(str, max) {
	    str = str.toString();
	    return str.length < max ? pad("0" + str, max) : str;
	}
	
	//Calculate timeslots
	function calculate_time_slot(start_time, end_time) {
	    var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "30";
	
	    var i, formatted_time;
	    var time_slots = new Array();
	    var range_arr = new Array();
	    for (var i = start_time; i <= end_time; i = i + interval) {
	        formatted_time = convertHours(i);
	        time_slots.push(formatted_time);
	    }
	    var slotlength = time_slots.length;
	    for (var i = 0; i < slotlength; i++) {
	        if (i != slotlength) {
	            range_arr.push(time_slots[i] + ' - ' + time_slots[i + 1]);
	        }
	    }
	    range_arr.pop();
	    return range_arr;
	}
	
	//Check if the user selected is current day
	var datesAreOnSameDay = function datesAreOnSameDay(first, second) {
	    return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
	};
	
	//Generate Timeslots
	var getTimeSlots = function getTimeSlots() {
	    var tmp = '';
	    var timeslots = calculate_time_slot(parseTime(appointmentDefaults.storeopentime), parseTime(appointmentDefaults.storeclosetime), appointmentDefaults.timeinterval);
	    $.each(timeslots, function (idx, value) {
	        tmp += '<div class="content-items timeslot-item slotdisabled" data-slot="' + value + '">' + value + '</div>';
	    });
	    $(".schtime-scrollable-cta").html(tmp);
	    $(".schtime-scrollable-cta").slick({
	        "slidesToShow": 7,
	        "arrows": true,
	        "slidesToScroll": 7,
	        "infinite": false,
	        "variableWidth": false,
	        "rtl": slickrtlAttr,
	        "responsive": [{ "breakpoint": 1025, "settings": { "slidesToShow": 4, "slidesToScroll": 4, "arrows": true } }, { "breakpoint": 768, "settings": { "slidesToShow": 3.5, "slidesToScroll": 3, "arrows": false, "dots": false, "variableWidth": true } }]
	    });
	};
	
	//Style the current timeslot
	function checkTimeSlotRange() {
	    var dt = new Date();
	    var storeOpenHr = appointmentDefaults.storeopentime.split(":")[0];
	    if (dt.getHours() >= storeOpenHr) {
	        $(".timeslot-item").addClass('slotdisabled');
	        $(".timeslot-item").each(function (key, value) {
	            var curItem = $(this);
	            var slot = curItem.attr('data-slot').split(' - ');
	            if (checkCurrentTimeSlot(slot[0], slot[1]) == true) {
	                curItem.addClass('current');
	                $(".schtime-scrollable-cta").slick("slickGoTo", key);
	            }
	        });
	        $(".timeslot-item.current").nextAll().removeClass('slotdisabled');
	    } else {
	        $(".timeslot-item").removeClass('slotdisabled');
	    }
	}
	
	//Get the current timeslot marked
	var checkCurrentTimeSlot = function checkCurrentTimeSlot(startTime, endTime) {
	    var dt = new Date(Date.now());
	    var now = dt.getHours() + ":" + dt.getMinutes();
	
	    var selectedTimeSeconds = now.substring(0, 5) + ':00';
	    var startTimeSeconds = startTime.substring(0, 5) + ':00';
	    var endTimeSeconds = endTime.substring(0, 5) + ':00';
	
	    var selectedTimeSecondsParsed = hmsToSecondsOnly(selectedTimeSeconds);
	    var startTimeSecondsParsed = hmsToSecondsOnly(startTimeSeconds);
	    var endTimeSecondssParsed = hmsToSecondsOnly(endTimeSeconds);
	    if (selectedTimeSecondsParsed >= startTimeSecondsParsed && selectedTimeSecondsParsed <= endTimeSecondssParsed) {
	        return true;
	    }
	};
	
	var hmsToSecondsOnly = function hmsToSecondsOnly(str) {
	    var p = str.split(':'),
	        s = 0,
	        m = 1;
	    while (p.length > 0) {
	        s += m * parseInt(p.pop(), 10);
	        m *= 60;
	    }
	    return s;
	};
	
	Date.prototype.addDays = function (days) {
	    var date = new Date(this.valueOf());
	    date.setDate(date.getDate() + days);
	    return date;
	};
	
	function getFormattedDate(date) {
	    try {
	        var dt = new Date(date);
	        var month = '' + (dt.getMonth() + 1),
	            day = '' + dt.getDate(),
	            year = dt.getFullYear();
	        if (month.length < 2) month = '0' + month;
	        if (day.length < 2) day = '0' + day;
	        return [year, month, day].join('-');
	    } catch (e) {
	        return '';
	    }
	}
	
	exports.init = function () {
	    initializeEvents();
	};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var formPrepare = __webpack_require__(93);
	var progress = __webpack_require__(43);
	
	function updateStoreData(init) {
		if (window.brandStores === undefined) {
			return;
		}
	
		if (init === undefined) {
			init = false;
		}
		var brandValue = getBrandSelectorEl();
		if (!brandValue) {
			return;
		}
	
		var storeList;
		storeList = window.brandStores[brandValue.value];
	
		if (storeList === undefined || storeList.stores === undefined) {
			if (init == true) {
				var storeSelector = getStoreSelectorEl();
				$(storeSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_BRAND_FIRST + '">' + Resources.SELECT_BRAND_FIRST + '</option>');
			}
			return;
		}
	
		var storeSelector = getStoreSelectorEl();
		var lists = storeList.stores;
		$(brandValue).trigger('blur');
		if (storeSelector && lists.length > 0) {
			storeSelector = getStoreSelectorEl();
			$(storeSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_QR_STORE + '">' + Resources.SELECT_QR_STORE + '</option>');
			for (var i = 0; i < lists.length; i++) {
				if (lists[i] && lists[i].trim()) {
					$(storeSelector).append('<option class="select-option" label="' + lists[i] + '">' + lists[i] + '</option>');
				}
			}
			$(storeSelector).trigger('change');
		} else {
			removeStoreSelector();
			$(storeSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_BRAND_FIRST + '">' + Resources.SELECT_BRAND_FIRST + '</option>');
		}
		updateFields();
	}
	function updateFields() {
		var brandSelector = getBrandSelectorEl();
		var storeSelector = getStoreSelectorEl();
		if (brandSelector) {
			$(brandSelector).trigger('blur');
			if (storeSelector) {
				$(storeSelector).trigger('blur');
			}
			formPrepare.validateForm();
		}
	}
	function removeStoreSelector(init) {
		if (init === undefined) {
			init = false;
		}
		var storeSelector = getStoreSelectorEl();
		if (storeSelector && storeSelector.length > 0) {
			if (!$(storeSelector).hasClass('select2-option')) {
				$(storeSelector).selectric('init');
			}
			$(storeSelector).empty();
			$(storeSelector).trigger('blur');
		}
	}
	
	function getBrandSelectorEl() {
		return document.querySelector('[id$="_storeqr_brand"]');
	}
	
	function getStoreSelectorEl() {
		return document.querySelector('[id$="_storeqr_store"]');
	}
	
	function updateBrandStore(init) {
		var brand = getBrandSelectorEl();
		if (!brand) {
			return;
		}
	
		if (window.brandStores !== undefined) {
			removeStoreSelector(init);
			updateStoreData(init);
			return;
		}
	}
	
	function afterSuccess(response, init) {
		if (response && response.status !== undefined && response.status == true) {
			window.brandStores = response.list;
			updateBrandStore(init);
		}
	}
	
	exports.init = function () {
		var brandSelector = getBrandSelectorEl();
		if (brandSelector) {
			var initBrandValue = brandSelector.value;
			var brandSelectorEl = $(brandSelector);
	
			brandSelectorEl.on('change', function (e) {
				e.stopPropagation();
				if (initBrandValue != $(this).val()) {
					updateBrandStore();
					initBrandValue = $(this).val();
				}
			});
			updateBrandStore(true);
		}
		initStoreField();
	};
	
	function initStoreField() {
		var storeSelector = getStoreSelectorEl();
		if (storeSelector) {
			$(storeSelector).on('change', function (e) {
				e.stopPropagation();
				$(this).trigger('blur');
				formPrepare.validateForm();
			});
		}
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.init = init;
	
	var _lazypictureload = __webpack_require__(48);
	
	var _lazypictureload2 = _interopRequireDefault(_lazypictureload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
	        var lazyLoadConfig = { observerId: 'pt_blog-result', preloadExpandBy: 100 };
	        _lazypictureload2.default.init(lazyLoadConfig);
	    }
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var header = __webpack_require__(174);
	var footer = __webpack_require__(190);
	var subscribe = __webpack_require__(191);
	var account = __webpack_require__(192);
	// const search = require('./sections/header/search');
	var cartsummary = __webpack_require__(193);
	
	header.init();
	footer.init();
	subscribe.init();
	account.init();
	// search.init();
	cartsummary.init();

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var search = __webpack_require__(175);
	/* eslint-disable */
	function init() {
	    // Header Scrolled
	    $(window).on('scroll', function () {
	        if ($(this).scrollTop() > 0) {
	            $('#boggiHeader').addClass('scrolled');
	        } else {
	            // Remove the 'scrolled' class from the header
	            $('#boggiHeader').removeClass('scrolled');
	        }
	    });
	    // Opening Navbar
	    $('.navbar-toggler-button').on('click', function () {
	        $('.navbar-brand').addClass('open');
	        $('.navbar-items').addClass('open');
	        $('.order__cols').css('display', 'none');
	        $('.icon--bag').css('z-index', '-1');
	        $('.minicart__trigger').css('z-index', '-1');
	        $('body').css('overflow', 'hidden');
	        $('html').css('overflow', 'hidden');
	    });
	
	    // Opening Navbar Item
	    $('.navbar-item > a.non-clickable').on('click', function (e) {
	        if ($(window).width() < 992) {
	            e.preventDefault();
	            // Setting the selected title instead of navbrand
	            $('.navbar-selected-title').text(this.innerText).addClass('bt-d-block').removeClass('bt-d-none');
	            $('.navbar-brand').addClass('bt-d-none').removeClass('bt-d-block');
	            var menu = $(this).next('.menu-container');
	            if (menu.hasClass('hide')) {
	                menu.addClass('bt-d-flex'); // Show as flex
	                $('.navbar-items').css('overflow', 'hidden');
	            } else {
	                menu.addClass('hide'); // Hide
	                $('.navbar-items').css('overflow', 'auto');
	            }
	            // Optionally, close other open menus (if needed)
	            $('.menu-container').not(menu).addClass('bt-d-none');
	        }
	    });
	
	    // Back to the Main Menu
	    $('.navbar-slide-out-render').on('click', function () {
	        $('.menu-container').addClass('hide').removeClass('bt-d-flex');
	        $('.navbar-items').css('overflow', 'auto');
	        // Setting navbrand to default and removing the title
	        $('.navbar-selected-title').addClass('bt-d-none').removeClass('bt-d-block');
	        $('.navbar-brand').addClass('bt-d-block').removeClass('bt-d-none');
	    });
	    // Closing NavBar
	    $('#navbar-trigger-close').on('click', function () {
	        $('.navbar-brand').removeClass('open');
	        $('.navbar-items').removeClass('open');
	        $('.menu-container').addClass('hide').removeClass('bt-d-flex');
	        $('.navbar-selected-title').addClass('bt-d-none').removeClass('bt-d-block');
	        $('.navbar-brand').addClass('bt-d-block').removeClass('bt-d-none');;
	        $('.order__cols').css('display', 'block');
	        $('.icon--bag').css('z-index', '0');
	        $('.minicart__trigger').css('z-index', '5');
	        $('body').css('overflow', 'auto');
	        $('html').css('overflow', 'auto');
	        $('.navbar-items').css('overflow', 'auto');
	    });
	
	    $('#m-wishlist-show, #l-wishlist-show').click(function (event) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_wishlist_click',
	            'eventLabel': 'top navigation wishlist click',
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.level-1-category').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var level1Cat = $(this).text().trim();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation',
	            'eventLabel': level1Cat,
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $('.level-2-category').on('click', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var level1Cat = $(this).closest('.navbar-item').find('.level-1-category').text().trim();
	        var level2Cat = $(this).text().trim();
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation',
	            'eventLabel': level1Cat + ' > ' + level2Cat,
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $(document).on('click', '.l-cart-show, #m-cart-show', function (e) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_bag_click',
	            'eventLabel': 'top navigation bag click',
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    if ($('#boggiHeader').length) {
	        search.init();
	    }
	}
	
	module.exports = {
	    init: init
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable*/
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var debounce = __webpack_require__(176);
	var endpoint = $('.suggestions-wrapper').data('url');
	
	function getSuggestionsWrapper(scope) {
	    return $(scope).siblings('.suggestions-wrapper');
	}
	
	function processResponse(response) {
	    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
	
	    if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== 'object') {
	        $suggestionsWrapper.append(response).show();
	    } else {
	        $suggestionsWrapper.html(response).show();
	    }
	}
	
	function getSuggestions(scope, e) {
	    $.ajax({
	        context: scope,
	        url: endpoint + encodeURIComponent($(scope).val()),
	        method: 'GET',
	        success: processResponse,
	        error: function error() {
	            console.error('Error fetching suggestions.');
	        }
	    });
	}
	
	function init() {
	    var $modal = $('#search-modal');
	
	    $('.search-icon').click(function (event) {
	        event.preventDefault();
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        var searchObj = $('body').find('input[name="q"]');
	
	        if ($modal.hasClass('bt-d-none')) {
	            $modal.removeClass('bt-d-none');
	            var modalOffsetTop = $modal.offset().top;
	            var scrollTop = $(window).scrollTop();
	            if (modalOffsetTop < scrollTop) {
	                $('html, body').animate({
	                    scrollTop: modalOffsetTop - 105
	                }, 500);
	            }
	
	            $('.header__search__input').focus();
	
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'search',
	                'eventAction': 'go_to_search',
	                'eventLabel': 'go to search', //click text
	                'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	                'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	                'screenName': 'Search',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        } else {
	            $modal.addClass('bt-d-none');
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'search',
	                'eventAction': 'cancel_search',
	                'eventLabel': 'cancel search',
	                'searchTerm': searchObj.val() ? searchObj.val().trim() : '',
	                'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	                'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	                'screenName': 'Search',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	            $('.suggestions-wrapper').hide().empty();
	            $('input.header__search__input').val('');
	        }
	        $('.navbar-brand').removeClass('open');
	        $('.navbar-items').removeClass('open');
	    });
	
	    function hideSearchModal(event) {
	        event.preventDefault();
	        $modal.addClass('bt-d-none');
	    }
	    $('.reset-button').click(hideSearchModal);
	
	    $('.header__search__input').on('input focus', debounce(function (event) {
	        event.preventDefault();
	        getSuggestions(this);
	    }, 300));
	
	    // Clear cached suggestions and modal on form reset
	    $('button[type="reset"]').on('click', function () {
	        var searchObj = $('body').find('input[name="q"]');
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'search',
	            'eventAction': 'cancel_search',
	            'eventLabel': 'cancel search',
	            'searchTerm': searchObj.val() ? searchObj.val().trim() : '',
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Search',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	        $('.suggestions-wrapper').hide().empty();
	        $('input.header__search__input').val('');
	    });
	
	    $(document).on('click', '.search-suggestion-result', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'search',
	            'eventAction': 'search_query_suggestion_click',
	            'eventLabel': $(this).text() ? $(this).text().trim() : '',
	            'searchTerm': $(this).text() ? $(this).text().trim() : '',
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Search',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    $(document).on('keydown', '.header__search__input', function (e) {
	        if (e.keyCode == 13) {
	            dataLayer.push({
	                'event': 'custom_event',
	                'eventCategory': 'search',
	                'eventAction': 'search_result',
	                'eventLabel': 'search result',
	                'searchTerm': $(this).val() ? $(this).val().trim() : '',
	                'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	                'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	                'screenName': 'Search',
	                'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	                'userId': user.user_id != '' ? user.user_id : ''
	            });
	        }
	    });
	
	    $(document).on('click', '.header__search__submit', function (e) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'search',
	            'eventAction': 'search_result',
	            'eventLabel': 'search result',
	            'searchTerm': $('.header__search__input').val() ? $('.header__search__input').val().trim() : '',
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Search',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	}
	
	module.exports = {
	    init: init
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(177),
	    now = __webpack_require__(178),
	    toNumber = __webpack_require__(181);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(179);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(180);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(182),
	    isObject = __webpack_require__(177),
	    isSymbol = __webpack_require__(184);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(183);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(185),
	    isObjectLike = __webpack_require__(189);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(186),
	    getRawTag = __webpack_require__(187),
	    objectToString = __webpack_require__(188);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(179);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(186);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	function init() {
	
					var toggleFooterOpen = function toggleFooterOpen(element) {
									var parent = $(element).closest('.boggi_footer_links');
									parent.toggleClass('open');
					};
	
					$('.boggi_footer_links').on('click', function () {
									toggleFooterOpen(this);
					});
	
					$('.boggi_footer_links a').on('click', function (e) {
									dataLayer.push({
													'event': 'custom_event',
													'eventCategory': 'footer_navigation',
													'eventAction': 'footer_navigation_click',
													'eventLabel': $(this).text(),
													'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
													'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
													'screenName': 'Footer navigation',
													'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
													'userId': user.user_id != '' ? user.user_id : ''
									});
					});
	
					$('.social-links a').on('click', function (e) {
									dataLayer.push({
													'event': 'custom_event',
													'eventCategory': 'footer_navigation',
													'eventAction': 'footer_navigation_social_icon',
													'eventLabel': $(this).data('sharing-option'),
													'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
													'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
													'screenName': 'Footer navigation',
													'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
													'userId': user.user_id != '' ? user.user_id : ''
									});
					});
	}
	
	module.exports = {
					init: init
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	
	function subscribeErrorDataLayer(errorText) {
	    if (errorText.length > 0) {
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'footer_navigation',
	            'eventAction': 'newsletter_failed',
	            'eventLabel': 'newsletter failed',
	            'failedReason': errorText,
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Footer navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    }
	}
	
	function subscribeSuccessDataLayer() {
	    dataLayer.push({
	        'event': 'custom_event',
	        'eventCategory': 'footer_navigation',
	        'eventAction': 'newsletter_signup',
	        'eventLabel': 'newsletter_signup success',
	        'country': window.GlobalAttributes.COUNTRY,
	        'language': window.GlobalAttributes.LANGUAGE,
	        'screenName': 'Footer navigation',
	        'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	        'userId': user.user_id != '' ? user.user_id : ''
	    });
	}
	
	function init() {
	
	    // Get the popup
	    var $popup = $("#subscribePopup");
	
	    // Get the button that opens the popup
	    var $openPopup = $("#subscribeBtn");
	
	    // Get the <span> element that closes the popup
	    var $closePopup = $("#subscribeClosePopup");
	
	    // When the user clicks the button, open the popup
	    $openPopup.on("click", function () {
	        $popup.css("display", "flex");
	    });
	
	    // When the user clicks on <span> (x), close the popup
	    $closePopup.on("click", function () {
	        $popup.hide();
	        $('.subscribe-title').show();
	        $('.footer__subscribe').show();
	        $('.subscribe__success').addClass('hidden');
	        $('form.footer__subscribe__form')[0].reset();
	    });
	
	    // When the user clicks anywhere outside of the popup, close it
	    $(window).on("click", function (event) {
	        if ($(event.target).is($popup)) {
	            $popup.hide();
	            $('.subscribe-title').show();
	            $('.footer__subscribe').show();
	            $('.subscribe__success').addClass('hidden');
	            $('form.footer__subscribe__form')[0].reset();
	        }
	    });
	
	    $(document).on('submit', 'form.footer__subscribe__form.subscribe--form', function (e) {
	        e.preventDefault();
	        $('#form-subscribe-error').text('');
	        $('span#dwfrm_moengage_emailsignup_email-error').text('');
	        var form = $(this);
	        var url = form.attr('action');
	        $.ajax({
	            url: url,
	            type: 'post',
	            dataType: 'json',
	            data: form.serialize(),
	            success: function success(data) {
	                //eslint-disable-next-line
	                $('.loader').hide();
	                if (!data.success) {
	                    $('#form-subscribe-error').text(data.msg);
	                    subscribeErrorDataLayer(data.msg);
	                } else {
	                    $('.subscribe-title').hide();
	                    $('.footer__subscribe').hide();
	                    $('.subscribe__success').removeClass('hidden');
	                    subscribeSuccessDataLayer();
	                }
	            },
	            error: function error(data) {} });
	        return false;
	    });
	
	    var inputTimeout = void 0;
	    $(document).on('blur', 'input#dwfrm_moengage_emailsignup_email', function () {
	        clearTimeout(inputTimeout);
	        inputTimeout = setTimeout(function () {
	            if ($('span#dwfrm_moengage_emailsignup_email-error').text().trim().length > 0) {
	                subscribeErrorDataLayer($('span#dwfrm_moengage_emailsignup_email-error').text().trim());
	            }
	        }, 1000);
	    });
	}
	module.exports = {
	    init: init
	};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	function init() {
	    var $modal = $('#account-modal');
	
	    // Toggle modal visibility on account icon click
	    $('#account-icon, #m-account-show').click(function (event) {
	        if ($(this).attr('id') === 'account-icon') {
	            event.preventDefault(); // Prevent default action if necessary
	            $modal.toggle();
	        }
	
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'top_navigation',
	            'eventAction': 'top_navigation_account_click',
	            'eventLabel': 'Signin/Register',
	            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
	            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
	            'screenName': 'Top navigation',
	            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	            'userId': user.user_id != '' ? user.user_id : ''
	        });
	    });
	
	    // Close modal when clicking outside
	    $(document).click(function (event) {
	        if (!$(event.target).closest('#account-icon, #account-modal').length) {
	            $modal.hide();
	        }
	    });
	
	    //header account logout click
	    $('.header-logout').click(function (event) {
	        var user = dataLayer.find(function (o) {
	            return o.user != null;
	        }).user;
	        dataLayer.push({
	            'event': 'custom_event',
	            'eventCategory': 'my_account',
	            'eventAction': 'logout',
	            'eventLabel': 'logout',
	            'country': window.GlobalAttributes.COUNTRY,
	            'language': window.GlobalAttributes.LANGUAGE,
	            'screenName': 'Top navigation',
	            "userType": user.user_id != '' ? 'logged-in' : 'logged-out',
	            "userId": user.user_id != '' ? user.user_id : ''
	        });
	    });
	}
	
	module.exports = {
	    init: init
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	function init() {
	    var $cartsummary = $('#cart-summary');
	    var $paymentmodes = $('.payment-modes');
	    $(window).on('scroll', function () {
	        var scrollTop = $(this).scrollTop();
	        var docHeight = $(document).height();
	        var windowHeight = $(this).height();
	        if (scrollTop + windowHeight >= docHeight - 10) {
	            $cartsummary.addClass('bt-d-none');
	            $paymentmodes.addClass('bt-d-none');
	        } else {
	            $cartsummary.removeClass('bt-d-none');
	            $paymentmodes.removeClass('bt-d-none');
	        }
	    });
	}
	
	module.exports = {
	    init: init
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var checkoutMain = __webpack_require__(195);
	
	checkoutMain.init();

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	"use strict";
	
	/* eslint-disable */
	function init() {
	
		$("#header-promo-banner").slick({
			autoplay: true,
			autoplaySpeed: 5000
		});
	}
	
	module.exports = {
		init: init
	};

/***/ })
]);


// WEBPACK FOOTER //
// app.min.js